import hn from "p-memoize";
import { filters as ro, helpers as to, render as io, getConfig as no } from "squirrelly";
import fo from "cross-fetch";
function Ho({ canvas: s, scenes: y, currentTime: G }) {
  if (y && s) {
    const O = y.scenes.filter(({ start: w, duration: _ }) => G >= w && G <= w + _);
    if (O.length <= 0)
      return;
    const N = s.getContext("2d");
    if (N) {
      const w = y.transitionDuration, _ = Math.max(...y.scenes.map(({ start: Y, duration: U }) => Y + U));
      N.globalCompositeOperation = "lighter", N.clearRect(0, 0, s.width, s.height), O.forEach(({ start: Y, duration: U, draw: b, transitionCanvas: Q }) => {
        if (N.globalAlpha = 1, Q.width = Q.height = 0, Q.width = s.width, Q.height = s.height, Q.getContext("2d")) {
          const l0 = Y + U, Z0 = Y === 0, j = l0 === _;
          b({
            currentTime: G,
            canvas: Q
          }), !Z0 && G >= Y && G <= Y + w / 2 ? N.globalAlpha = Math.max(0, Math.min(1, (G - Y) / (w / 2))) : !j && G >= l0 - w / 2 && G <= l0 && (N.globalAlpha = Math.max(0, Math.min(1, (l0 - G) / (w / 2)))), N.drawImage(Q, 0, 0, s.width, s.height);
        }
      });
    }
  }
}
function oo(s) {
  if (typeof s == "string") {
    const [y, G] = s.split(":");
    return Math.min(parseFloat(y), parseFloat(G));
  }
  return s;
}
function uo(s) {
  if (typeof s == "string") {
    const [y, G] = s.split(":"), O = parseFloat(y), N = parseFloat(G);
    return O / N;
  }
  return s;
}
function so({ resolution: s, aspectRatio: y }) {
  const G = oo(s), O = uo(y), N = O >= 1, w = Math.min(
    N ? G * O : G / O,
    G
  ), _ = Math.max(
    N ? G * O : G / O,
    G
  );
  return {
    resolution: G,
    aspectRatio: O,
    height: N ? w : _,
    width: N ? _ : w
  };
}
function ao({ format: s, resolution: y, aspectRatio: G, sourceWidth: O, sourceHeight: N }) {
  const { width: w, height: _ } = so({ resolution: y, aspectRatio: G }), Y = O / N, U = G > Y;
  let b = 1;
  if (s === "letterbox" || s === "letterbox-video")
    b = U ? _ / N : w / O;
  else if (s === "squarebox") {
    const j = Math.min(_, w);
    b = O >= N ? j / N : j / O;
  } else
    s === "crop" && (b = U ? w / O : _ / N);
  const Q = w / b, o0 = _ / b, l0 = (O - Q) / 2, Z0 = (N - o0) / 2;
  return {
    sx: l0,
    sy: Z0,
    sWidth: Q,
    sHeight: o0,
    scale: b
  };
}
function Ar({ source: s, sx: y, sy: G, sw: O, sh: N, dx: w, dy: _, dw: Y, dh: U }) {
  const b = (s == null ? void 0 : s.naturalWidth) ?? (s == null ? void 0 : s.videoWidth) ?? (s == null ? void 0 : s.width), Q = (s == null ? void 0 : s.naturalHeight) ?? (s == null ? void 0 : s.videoHeight) ?? (s == null ? void 0 : s.height);
  y = y ?? 0, G = G ?? 0, O = O ?? b, N = N ?? Q, O < 0 && (y += O, O = Math.abs(O)), N < 0 && (G += N, N = Math.abs(N)), Y < 0 && (w += Y, Y = Math.abs(Y)), U < 0 && (_ += U, U = Math.abs(U));
  const o0 = Math.max(y, 0), l0 = Math.min(y + O, b), Z0 = Math.max(G, 0), j = Math.min(G + N, Q), i2 = Y / O, k0 = U / N;
  return [
    s,
    o0,
    Z0,
    l0 - o0,
    j - Z0,
    y < 0 ? w - y * i2 : w,
    G < 0 ? _ - G * k0 : _,
    (l0 - o0) * i2,
    (j - Z0) * k0
  ];
}
function on({
  context: s,
  source: y,
  crop: G,
  format: O = "letterbox",
  posX: N,
  posY: w,
  drawAreaWidth: _,
  drawAreaHeight: Y,
  sourceWidth: U,
  sourceHeight: b,
  cropCanvas: Q,
  letterboxCanvas: o0
}) {
  const { x: l0, y: Z0, width: j, height: i2 } = G ?? {}, k0 = U * (l0 ?? 0), k2 = b * (Z0 ?? 0), c0 = U * Math.min(1 - (l0 ?? 0), j ?? 1), S0 = b * Math.min(1 - (Z0 ?? 0), i2 ?? 1), n2 = Q.getContext("2d");
  if (n2) {
    Q.width = c0, Q.height = S0;
    const E0 = Ar({
      source: y,
      sx: k0,
      sy: k2,
      sw: c0,
      sh: S0,
      dx: 0,
      dy: 0,
      dw: c0,
      dh: S0
    });
    n2.drawImage(...E0);
  }
  const U0 = c0 / S0, { sx: _0, sy: A0, sWidth: F0, sHeight: r2, scale: L0 } = ao({
    resolution: Math.min(_, Y),
    aspectRatio: _ / Y,
    format: O,
    sourceWidth: c0,
    sourceHeight: S0
  }), D0 = Q && typeof s.filter < "u";
  if (O === "letterbox" || O === "squarebox" || O === "letterbox-video" && !D0) {
    if (_0 < 0) {
      const E0 = Math.abs(_0) * L0;
      s.fillStyle = "black", s.beginPath(), s.rect(N, w, E0, Y), s.rect(N + _ - E0, w, E0, Y), s.fill(), s.closePath();
    }
    if (A0 < 0) {
      const E0 = Math.abs(A0) * L0;
      s.fillStyle = "black", s.beginPath(), s.rect(N, w, _, E0), s.rect(N, w + Y - E0, _, E0), s.fill(), s.closePath();
    }
  }
  if (O === "letterbox-video" && D0) {
    const E0 = o0.getContext("2d");
    if (E0) {
      o0.width = c0, o0.height = S0, s.save(), s.globalCompositeOperation = "destination-out", s.fillRect(N, w, _, Y);
      const m2 = Ar({
        source: Q,
        sx: _0,
        sy: A0,
        sw: F0,
        sh: r2,
        dx: N,
        dy: w,
        dw: _,
        dh: Y
      });
      s.globalCompositeOperation = "source-over", s.drawImage(...m2), E0.save();
      const d2 = 1.2, w0 = -(c0 * d2 - c0) / 2, T0 = -(S0 * d2 - S0) / 2, y0 = Math.min(c0 / 20, S0 / 20);
      if (E0.filter = `blur(${y0}px) brightness(20%)`, E0.translate(w0, T0), E0.scale(d2, d2), E0.drawImage(Q, 0, 0, c0, S0), E0.restore(), s.globalCompositeOperation = "destination-over", _0 < 0) {
        const O0 = _ / U0, t2 = Y / O0, V2 = Ar({
          source: o0,
          sy: (1 - t2) * S0 / 2,
          sh: t2 * S0,
          dx: N,
          dy: w,
          dw: _,
          dh: Y
        });
        s.drawImage(...V2);
      }
      if (A0 < 0) {
        const O0 = Y * U0, t2 = _ / O0, V2 = Ar({
          source: o0,
          sx: (1 - t2) * c0 / 2,
          sw: t2 * c0,
          dx: N,
          dy: w,
          dw: _,
          dh: Y
        });
        s.drawImage(...V2);
      }
      s.restore();
    }
  } else {
    const E0 = Ar({
      source: Q,
      sx: _0,
      sy: A0,
      sw: F0,
      sh: r2,
      dx: N,
      dy: w,
      dw: _,
      dh: Y
    });
    s.drawImage(...E0);
  }
  const c2 = _0 * -1 * L0, s2 = A0 * -1 * L0, P0 = _ - c2 * 2, a2 = Y - s2 * 2;
  return {
    dx: c2,
    dy: s2,
    dw: P0,
    dh: a2
  };
}
const lo = (s, y, G, O) => {
  if (G === "length" || G === "prototype" || G === "arguments" || G === "caller")
    return;
  const N = Object.getOwnPropertyDescriptor(s, G), w = Object.getOwnPropertyDescriptor(y, G);
  !ko(N, w) && O || Object.defineProperty(s, G, w);
}, ko = function(s, y) {
  return s === void 0 || s.configurable || s.writable === y.writable && s.enumerable === y.enumerable && s.configurable === y.configurable && (s.writable || s.value === y.value);
}, co = (s, y) => {
  const G = Object.getPrototypeOf(y);
  G !== Object.getPrototypeOf(s) && Object.setPrototypeOf(s, G);
}, Ao = (s, y) => `/* Wrapped ${s}*/
${y}`, ho = Object.getOwnPropertyDescriptor(Function.prototype, "toString"), po = Object.getOwnPropertyDescriptor(Function.prototype.toString, "name"), wo = (s, y, G) => {
  const O = G === "" ? "" : `with ${G.trim()}() `, N = Ao.bind(null, O, y.toString());
  Object.defineProperty(N, "name", po), Object.defineProperty(s, "toString", { ...ho, value: N });
};
function vo(s, y, { ignoreNonConfigurable: G = !1 } = {}) {
  const { name: O } = s;
  for (const N of Reflect.ownKeys(y))
    lo(s, y, N, G);
  return co(s, y), wo(s, y, O), s;
}
const mo = /* @__PURE__ */ new WeakMap(), un = /* @__PURE__ */ new WeakMap();
function pn(s, { cacheKey: y, cache: G = /* @__PURE__ */ new Map(), maxAge: O } = {}) {
  if (O === 0)
    return s;
  if (typeof O == "number") {
    if (O > 2147483647)
      throw new TypeError("The `maxAge` option cannot exceed 2147483647.");
    if (O < 0)
      throw new TypeError("The `maxAge` option should not be a negative number.");
  }
  const N = function(...w) {
    var b;
    const _ = y ? y(w) : w[0], Y = G.get(_);
    if (Y)
      return Y.data;
    const U = s.apply(this, w);
    if (G.set(_, {
      data: U,
      maxAge: O ? Date.now() + O : Number.POSITIVE_INFINITY
    }), typeof O == "number" && O !== Number.POSITIVE_INFINITY) {
      const Q = setTimeout(() => {
        G.delete(_);
      }, O);
      (b = Q.unref) == null || b.call(Q);
      const o0 = un.get(s) ?? /* @__PURE__ */ new Set();
      o0.add(Q), un.set(s, o0);
    }
    return U;
  };
  return vo(N, s, {
    ignoreNonConfigurable: !0
  }), mo.set(N, G), N;
}
function sn({ context: s, word: y, maxW: G = 1 / 0 }) {
  const O = [], N = s.measureText(y);
  if (N.width < G)
    return [{ text: y, metrics: N }];
  for (let w = 0; w < y.length; w++) {
    const _ = O[O.length - 1], Y = ((_ == null ? void 0 : _.text) ?? "") + y[w], U = s.measureText(Y);
    U.width < G ? O[_ ? O.length - 1 : 0] = {
      text: Y,
      metrics: U
    } : O.push({ text: y[w], metrics: s.measureText(y[w]) });
  }
  return O;
}
const an = pn(
  ({ font: s, scale: y, context: G, maxW: O, maxH: N, text: w, minSize: _, maxSize: Y }) => {
    var b, Q;
    let U = 0;
    if (Y) {
      U = (_ ?? 0) * y;
      let l0 = 0;
      for (; Y * y > U + 1; ) {
        U += 1;
        const Z0 = Jr({ context: G, font: s, fontSize: U, text: w, maxW: O });
        if (l0 = Z0.reduce((j, i2) => (i2.metrics.width > j && (j = i2.metrics.width), j), 0), l0 > O || Z0.length * U > N) {
          U -= 1;
          break;
        }
      }
    } else
      U = parseFloat(((Q = (b = s.match(Qr)) == null ? void 0 : b.groups) == null ? void 0 : Q.value) ?? "0") * y;
    return U;
  },
  {
    cacheKey: ([{ font: s, text: y, minSize: G, maxSize: O, scale: N, maxW: w, maxH: _ }]) => `${s}_${y}_${G}_${O}_${N}_${w}_${_}`
  }
);
function go(s) {
  return s && s.__esModule && Object.prototype.hasOwnProperty.call(s, "default") ? s.default : s;
}
var B0 = {}, Pt = {}, p0 = {};
Object.defineProperty(p0, "__esModule", {
  value: !0
});
p0.default = p0.Wrap = p0.Unit = p0.PrintOptions = p0.PositionType = p0.Overflow = p0.NodeType = p0.MeasureMode = p0.LogLevel = p0.Justify = p0.Gutter = p0.FlexDirection = p0.ExperimentalFeature = p0.Errata = p0.Edge = p0.Display = p0.Direction = p0.Dimension = p0.Align = void 0;
let ve = /* @__PURE__ */ function(s) {
  return s[s.Auto = 0] = "Auto", s[s.FlexStart = 1] = "FlexStart", s[s.Center = 2] = "Center", s[s.FlexEnd = 3] = "FlexEnd", s[s.Stretch = 4] = "Stretch", s[s.Baseline = 5] = "Baseline", s[s.SpaceBetween = 6] = "SpaceBetween", s[s.SpaceAround = 7] = "SpaceAround", s;
}({});
p0.Align = ve;
let Tt = /* @__PURE__ */ function(s) {
  return s[s.Width = 0] = "Width", s[s.Height = 1] = "Height", s;
}({});
p0.Dimension = Tt;
let xr = /* @__PURE__ */ function(s) {
  return s[s.Inherit = 0] = "Inherit", s[s.LTR = 1] = "LTR", s[s.RTL = 2] = "RTL", s;
}({});
p0.Direction = xr;
let Ot = /* @__PURE__ */ function(s) {
  return s[s.Flex = 0] = "Flex", s[s.None = 1] = "None", s;
}({});
p0.Display = Ot;
let oe = /* @__PURE__ */ function(s) {
  return s[s.Left = 0] = "Left", s[s.Top = 1] = "Top", s[s.Right = 2] = "Right", s[s.Bottom = 3] = "Bottom", s[s.Start = 4] = "Start", s[s.End = 5] = "End", s[s.Horizontal = 6] = "Horizontal", s[s.Vertical = 7] = "Vertical", s[s.All = 8] = "All", s;
}({});
p0.Edge = oe;
let pr = /* @__PURE__ */ function(s) {
  return s[s.None = 0] = "None", s[s.StretchFlexBasis = 1] = "StretchFlexBasis", s[s.All = 2147483647] = "All", s[s.Classic = 2147483646] = "Classic", s;
}({});
p0.Errata = pr;
let Mr = /* @__PURE__ */ function(s) {
  return s[s.WebFlexBasis = 0] = "WebFlexBasis", s[s.AbsolutePercentageAgainstPaddingEdge = 1] = "AbsolutePercentageAgainstPaddingEdge", s[s.FixJNILocalRefOverflows = 2] = "FixJNILocalRefOverflows", s;
}({});
p0.ExperimentalFeature = Mr;
let wr = /* @__PURE__ */ function(s) {
  return s[s.Column = 0] = "Column", s[s.ColumnReverse = 1] = "ColumnReverse", s[s.Row = 2] = "Row", s[s.RowReverse = 3] = "RowReverse", s;
}({});
p0.FlexDirection = wr;
let Xr = /* @__PURE__ */ function(s) {
  return s[s.Column = 0] = "Column", s[s.Row = 1] = "Row", s[s.All = 2] = "All", s;
}({});
p0.Gutter = Xr;
let He = /* @__PURE__ */ function(s) {
  return s[s.FlexStart = 0] = "FlexStart", s[s.Center = 1] = "Center", s[s.FlexEnd = 2] = "FlexEnd", s[s.SpaceBetween = 3] = "SpaceBetween", s[s.SpaceAround = 4] = "SpaceAround", s[s.SpaceEvenly = 5] = "SpaceEvenly", s;
}({});
p0.Justify = He;
let ze = /* @__PURE__ */ function(s) {
  return s[s.Error = 0] = "Error", s[s.Warn = 1] = "Warn", s[s.Info = 2] = "Info", s[s.Debug = 3] = "Debug", s[s.Verbose = 4] = "Verbose", s[s.Fatal = 5] = "Fatal", s;
}({});
p0.LogLevel = ze;
let Hr = /* @__PURE__ */ function(s) {
  return s[s.Undefined = 0] = "Undefined", s[s.Exactly = 1] = "Exactly", s[s.AtMost = 2] = "AtMost", s;
}({});
p0.MeasureMode = Hr;
let Vt = /* @__PURE__ */ function(s) {
  return s[s.Default = 0] = "Default", s[s.Text = 1] = "Text", s;
}({});
p0.NodeType = Vt;
let zr = /* @__PURE__ */ function(s) {
  return s[s.Visible = 0] = "Visible", s[s.Hidden = 1] = "Hidden", s[s.Scroll = 2] = "Scroll", s;
}({});
p0.Overflow = zr;
let Ur = /* @__PURE__ */ function(s) {
  return s[s.Static = 0] = "Static", s[s.Relative = 1] = "Relative", s[s.Absolute = 2] = "Absolute", s;
}({});
p0.PositionType = Ur;
let Yr = /* @__PURE__ */ function(s) {
  return s[s.Layout = 1] = "Layout", s[s.Style = 2] = "Style", s[s.Children = 4] = "Children", s;
}({});
p0.PrintOptions = Yr;
let vr = /* @__PURE__ */ function(s) {
  return s[s.Undefined = 0] = "Undefined", s[s.Point = 1] = "Point", s[s.Percent = 2] = "Percent", s[s.Auto = 3] = "Auto", s;
}({});
p0.Unit = vr;
let Dr = /* @__PURE__ */ function(s) {
  return s[s.NoWrap = 0] = "NoWrap", s[s.Wrap = 1] = "Wrap", s[s.WrapReverse = 2] = "WrapReverse", s;
}({});
p0.Wrap = Dr;
const yo = {
  ALIGN_AUTO: ve.Auto,
  ALIGN_FLEX_START: ve.FlexStart,
  ALIGN_CENTER: ve.Center,
  ALIGN_FLEX_END: ve.FlexEnd,
  ALIGN_STRETCH: ve.Stretch,
  ALIGN_BASELINE: ve.Baseline,
  ALIGN_SPACE_BETWEEN: ve.SpaceBetween,
  ALIGN_SPACE_AROUND: ve.SpaceAround,
  DIMENSION_WIDTH: Tt.Width,
  DIMENSION_HEIGHT: Tt.Height,
  DIRECTION_INHERIT: xr.Inherit,
  DIRECTION_LTR: xr.LTR,
  DIRECTION_RTL: xr.RTL,
  DISPLAY_FLEX: Ot.Flex,
  DISPLAY_NONE: Ot.None,
  EDGE_LEFT: oe.Left,
  EDGE_TOP: oe.Top,
  EDGE_RIGHT: oe.Right,
  EDGE_BOTTOM: oe.Bottom,
  EDGE_START: oe.Start,
  EDGE_END: oe.End,
  EDGE_HORIZONTAL: oe.Horizontal,
  EDGE_VERTICAL: oe.Vertical,
  EDGE_ALL: oe.All,
  ERRATA_NONE: pr.None,
  ERRATA_STRETCH_FLEX_BASIS: pr.StretchFlexBasis,
  ERRATA_ALL: pr.All,
  ERRATA_CLASSIC: pr.Classic,
  EXPERIMENTAL_FEATURE_WEB_FLEX_BASIS: Mr.WebFlexBasis,
  EXPERIMENTAL_FEATURE_ABSOLUTE_PERCENTAGE_AGAINST_PADDING_EDGE: Mr.AbsolutePercentageAgainstPaddingEdge,
  EXPERIMENTAL_FEATURE_FIX_JNILOCAL_REF_OVERFLOWS: Mr.FixJNILocalRefOverflows,
  FLEX_DIRECTION_COLUMN: wr.Column,
  FLEX_DIRECTION_COLUMN_REVERSE: wr.ColumnReverse,
  FLEX_DIRECTION_ROW: wr.Row,
  FLEX_DIRECTION_ROW_REVERSE: wr.RowReverse,
  GUTTER_COLUMN: Xr.Column,
  GUTTER_ROW: Xr.Row,
  GUTTER_ALL: Xr.All,
  JUSTIFY_FLEX_START: He.FlexStart,
  JUSTIFY_CENTER: He.Center,
  JUSTIFY_FLEX_END: He.FlexEnd,
  JUSTIFY_SPACE_BETWEEN: He.SpaceBetween,
  JUSTIFY_SPACE_AROUND: He.SpaceAround,
  JUSTIFY_SPACE_EVENLY: He.SpaceEvenly,
  LOG_LEVEL_ERROR: ze.Error,
  LOG_LEVEL_WARN: ze.Warn,
  LOG_LEVEL_INFO: ze.Info,
  LOG_LEVEL_DEBUG: ze.Debug,
  LOG_LEVEL_VERBOSE: ze.Verbose,
  LOG_LEVEL_FATAL: ze.Fatal,
  MEASURE_MODE_UNDEFINED: Hr.Undefined,
  MEASURE_MODE_EXACTLY: Hr.Exactly,
  MEASURE_MODE_AT_MOST: Hr.AtMost,
  NODE_TYPE_DEFAULT: Vt.Default,
  NODE_TYPE_TEXT: Vt.Text,
  OVERFLOW_VISIBLE: zr.Visible,
  OVERFLOW_HIDDEN: zr.Hidden,
  OVERFLOW_SCROLL: zr.Scroll,
  POSITION_TYPE_STATIC: Ur.Static,
  POSITION_TYPE_RELATIVE: Ur.Relative,
  POSITION_TYPE_ABSOLUTE: Ur.Absolute,
  PRINT_OPTIONS_LAYOUT: Yr.Layout,
  PRINT_OPTIONS_STYLE: Yr.Style,
  PRINT_OPTIONS_CHILDREN: Yr.Children,
  UNIT_UNDEFINED: vr.Undefined,
  UNIT_POINT: vr.Point,
  UNIT_PERCENT: vr.Percent,
  UNIT_AUTO: vr.Auto,
  WRAP_NO_WRAP: Dr.NoWrap,
  WRAP_WRAP: Dr.Wrap,
  WRAP_WRAP_REVERSE: Dr.WrapReverse
};
var Ro = yo;
p0.default = Ro;
Object.defineProperty(Pt, "__esModule", {
  value: !0
});
Pt.default = Wo;
var Pe = Eo(p0);
function wn(s) {
  if (typeof WeakMap != "function")
    return null;
  var y = /* @__PURE__ */ new WeakMap(), G = /* @__PURE__ */ new WeakMap();
  return (wn = function(O) {
    return O ? G : y;
  })(s);
}
function Eo(s, y) {
  if (!y && s && s.__esModule)
    return s;
  if (s === null || typeof s != "object" && typeof s != "function")
    return { default: s };
  var G = wn(y);
  if (G && G.has(s))
    return G.get(s);
  var O = {}, N = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var w in s)
    if (w !== "default" && Object.prototype.hasOwnProperty.call(s, w)) {
      var _ = N ? Object.getOwnPropertyDescriptor(s, w) : null;
      _ && (_.get || _.set) ? Object.defineProperty(O, w, _) : O[w] = s[w];
    }
  return O.default = s, G && G.set(s, O), O;
}
function Wo(s) {
  function y(N, w, _) {
    const Y = N[w];
    N[w] = function() {
      for (var U = arguments.length, b = new Array(U), Q = 0; Q < U; Q++)
        b[Q] = arguments[Q];
      return _.call(this, Y, ...b);
    };
  }
  for (const N of ["setPosition", "setMargin", "setFlexBasis", "setWidth", "setHeight", "setMinWidth", "setMinHeight", "setMaxWidth", "setMaxHeight", "setPadding"]) {
    const w = {
      [Pe.Unit.Point]: s.Node.prototype[N],
      [Pe.Unit.Percent]: s.Node.prototype[`${N}Percent`],
      [Pe.Unit.Auto]: s.Node.prototype[`${N}Auto`]
    };
    y(s.Node.prototype, N, function(_) {
      for (var Y = arguments.length, U = new Array(Y > 1 ? Y - 1 : 0), b = 1; b < Y; b++)
        U[b - 1] = arguments[b];
      const Q = U.pop();
      let o0, l0;
      if (Q === "auto")
        o0 = Pe.Unit.Auto, l0 = void 0;
      else if (typeof Q == "object")
        o0 = Q.unit, l0 = Q.valueOf();
      else if (o0 = typeof Q == "string" && Q.endsWith("%") ? Pe.Unit.Percent : Pe.Unit.Point, l0 = parseFloat(Q), !Number.isNaN(Q) && Number.isNaN(l0))
        throw new Error(`Invalid value ${Q} for ${N}`);
      if (!w[o0])
        throw new Error(`Failed to execute "${N}": Unsupported unit '${Q}'`);
      return l0 !== void 0 ? w[o0].call(this, ...U, l0) : w[o0].call(this, ...U);
    });
  }
  function G(N) {
    return s.MeasureCallback.implement({
      measure: function() {
        const {
          width: w,
          height: _
        } = N(...arguments);
        return {
          width: w ?? NaN,
          height: _ ?? NaN
        };
      }
    });
  }
  y(s.Node.prototype, "setMeasureFunc", function(N, w) {
    return w ? N.call(this, G(w)) : this.unsetMeasureFunc();
  });
  function O(N) {
    return s.DirtiedCallback.implement({
      dirtied: N
    });
  }
  return y(s.Node.prototype, "setDirtiedFunc", function(N, w) {
    N.call(this, O(w));
  }), y(s.Config.prototype, "free", function() {
    s.Config.destroy(this);
  }), y(s.Node, "create", (N, w) => w ? s.Node.createWithConfig(w) : s.Node.createDefault()), y(s.Node.prototype, "free", function() {
    s.Node.destroy(this);
  }), y(s.Node.prototype, "freeRecursive", function() {
    for (let N = 0, w = this.getChildCount(); N < w; ++N)
      this.getChild(0).freeRecursive();
    this.free();
  }), y(s.Node.prototype, "calculateLayout", function(N) {
    let w = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : NaN, _ = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : NaN, Y = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : Pe.Direction.LTR;
    return N.call(this, w, _, Y);
  }), {
    Config: s.Config,
    Node: s.Node,
    ...Pe.default
  };
}
var vn = { exports: {} };
(function(s, y) {
  var G = (() => {
    var O = typeof document < "u" && document.currentScript ? document.currentScript.src : void 0;
    return function(N) {
      N = N || {};
      var w;
      w || (w = typeof N < "u" ? N : {});
      var _, Y;
      w.ready = new Promise(function(k, c) {
        _ = k, Y = c;
      });
      var U = Object.assign({}, w), b = "";
      typeof document < "u" && document.currentScript && (b = document.currentScript.src), O && (b = O), b.indexOf("blob:") !== 0 ? b = b.substr(0, b.replace(/[?#].*/, "").lastIndexOf("/") + 1) : b = "";
      var Q = w.print || console.log.bind(console), o0 = w.printErr || console.warn.bind(console);
      Object.assign(w, U), U = null;
      var l0;
      w.wasmBinary && (l0 = w.wasmBinary), w.noExitRuntime;
      function Z0() {
        this.buffer = new ArrayBuffer(a2 / 65536 * 65536);
      }
      function j() {
      }
      function i2(k) {
        this.exports = // EMSCRIPTEN_START_ASM
        function(v) {
          function R(h2) {
            return h2.set = function(m0, _2) {
              this[m0] = _2;
            }, h2.get = function(m0) {
              return this[m0];
            }, h2;
          }
          for (var E, x = new Uint8Array(123), z = 25; z >= 0; --z)
            x[48 + z] = 52 + z, x[65 + z] = z, x[97 + z] = 26 + z;
          x[43] = 62, x[47] = 63;
          function I(h2, m0, _2) {
            for (var Z2, P, K2 = 0, t = m0, X = _2.length, je = m0 + (X * 3 >> 2) - (_2[X - 2] == "=") - (_2[X - 1] == "="); K2 < X; K2 += 4)
              Z2 = x[_2.charCodeAt(K2 + 1)], P = x[_2.charCodeAt(K2 + 2)], h2[t++] = x[_2.charCodeAt(K2)] << 2 | Z2 >> 4, t < je && (h2[t++] = Z2 << 4 | P >> 2), t < je && (h2[t++] = P << 6 | x[_2.charCodeAt(K2 + 3)]);
          }
          function q(h2) {
            I(E, 1024, "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"), I(E, 4338, "wH8DAAAAAADAfwAAAABpaQB2AHZp"), I(E, 4368, "exsAAHkbAAC5GwAAsxsAALkbAACzGwAAaWlpZmlmaQCsGwAAfBsAAHZpaQB9GwAAwBsAAGlpaQ=="), I(E, 4432, "xwAAAMgAAADJ"), I(E, 4452, "xwAAAMoAAADLAAAArBs="), I(E, 4480, "exsAALkbAACzGwAAuRsAALMbAADAGwAAuxsAAMAbAABpaWlpAAAAAKwbAACRGwAArBsAAJMbAACUGwAAwBs="), I(E, 4552, "zAAAAM0AAADO"), I(E, 4572, "zAAAAM8AAADLAAAAlxsAAKwbAACXGw=="), I(E, 4608, "rBsAAJcbAACzGwAArRsAAHZpaWlpAAAArBsAAJcbAAC5GwAAdmlpZgAAAACsGwAAlxsAAK0bAAB2aWlpAAAAAKwbAACXGwAAsxsAAK0bAACYGwAAsxsAAK0bAACYGwAAsxsAAJgbAABpAGRpaQB2aWlkAACcGwAAnBsAAJcbAACsGwAAnBsAAKwbAACcGwAAmxsAAKwbAACcGwAAsxsAAKwbAACcGwAAsxsAALobAAB2aWlpZAAAAKwbAACcGwAAuhsAALMbAACdGwAAmhsAAJ0bAACzGwAAmhsAAJ0bAAC6GwAAnRsAALobAACdGwAAsxsAAGRpaWkAAAAAuRsAAJwbAACzGwAAZmlpaQAAAACsGwAAnBsAAJwbAAC0GwAArBsAAJwbAACcGwAAtBsAAJ0bAACcGwAAnBsAAJwbAACcGwAAtBsAAK0bAACcGwAArBsAAJwbAACtGwAArBsAAJwbAAB5GwAArBsAAJwbAACRGwAArRsAAJ0bAAAAAAAArBsAAJwbAAC6GwAAuhsAALMbAAB2aWlkZGkAAJkbAACdGw=="), I(E, 5040, "GQAKABkZGQAAAAAFAAAAAAAACQAAAAALAAAAAAAAAAAZABEKGRkZAwoHAAEACQsYAAAJBgsAAAsABhkAAAAZGRk="), I(E, 5121, "DgAAAAAAAAAAGQAKDRkZGQANAAACAAkOAAAACQAOAAAO"), I(E, 5179, "DA=="), I(E, 5191, "EwAAAAATAAAAAAkMAAAAAAAMAAAM"), I(E, 5237, "EA=="), I(E, 5249, "DwAAAAQPAAAAAAkQAAAAAAAQAAAQ"), I(E, 5295, "Eg=="), I(E, 5307, "EQAAAAARAAAAAAkSAAAAAAASAAASAAAaAAAAGhoa"), I(E, 5362, "GgAAABoaGgAAAAAAAAk="), I(E, 5411, "FA=="), I(E, 5423, "FwAAAAAXAAAAAAkUAAAAAAAUAAAU"), I(E, 5469, "Fg=="), I(E, 5481, "FQAAAAAVAAAAAAkWAAAAAAAWAAAWAAAwMTIzNDU2Nzg5QUJDREVG"), I(E, 5556, "1Q=="), I(E, 5596, "//////////8="), I(E, 5664, "8B8BAAAAAAAF"), I(E, 5684, "0A=="), I(E, 5708, "0QAAANIAAADUGw=="), I(E, 5732, "Ag=="), I(E, 5748, "//////////8="), I(E, 5816, "BQ=="), I(E, 5828, "0w=="), I(E, 5852, "0QAAANQAAADoGwAAAAQ="), I(E, 5876, "AQ=="), I(E, 5892, "/////wo="), I(E, 5960, "1g==");
          }
          var K = new ArrayBuffer(16), i0 = new Int32Array(K), u0 = new Float32Array(K), G0 = new Float64Array(K);
          function R0(h2) {
            return i0[h2];
          }
          function J(h2, m0) {
            i0[h2] = m0;
          }
          function g2() {
            return G0[0];
          }
          function R2(h2) {
            G0[0] = h2;
          }
          function V0() {
            throw new Error("abort");
          }
          function A2(h2) {
            u0[2] = h2;
          }
          function n0() {
            return u0[2];
          }
          function Sr(h2) {
            var m0 = h2.a, _2 = m0.a, Z2 = _2.buffer;
            _2.grow = eo;
            var P = new Int8Array(Z2), K2 = new Int16Array(Z2), t = new Int32Array(Z2), X = new Uint8Array(Z2), je = new Uint16Array(Z2), jt = new Uint32Array(Z2), A = new Float32Array(Z2), Q0 = new Float64Array(Z2), J0 = Math.imul, f = Math.fround, $0 = Math.abs, H2 = Math.clz32, jn = Math.min, $n = Math.max, s0 = NaN, $t = 1 / 0, D = m0.b, y2 = m0.c, ke = m0.d, ce = m0.e, Ze = m0.f, $e = m0.g, fr = m0.h, Tr = m0.i, ft = m0.j, ot = m0.k, ut = m0.l, Kt = m0.m, qt = m0.n, bt = m0.o, ei = m0.p, ri = m0.q, Kn = m0.r, qn = m0.s, bn = m0.t, e1 = m0.u, r1 = m0.v, t1 = m0.w, i1 = m0.x, n1 = m0.y, f1 = m0.z, o1 = m0.A, u1 = m0.B, s1 = m0.C, a1 = m0.D, H = 73712, G2 = 0;
            function ti(e, r, i, n, o, u, a, l, h, g, S, F, Z, T) {
              var p = 0, m = f(0), d = 0, W = f(0), V = 0, C = f(0), L = 0, M = f(0), $ = 0, r0 = 0, t0 = f(0), f0 = 0, a0 = 0, h0 = f(0), N0 = f(0), M0 = f(0), z0 = f(0), Y0 = 0, j0 = f(0), q0 = f(0), o2 = 0, u2 = 0, v2 = f(0), E2 = 0, W2 = 0, N2 = 0, O2 = 0, F2 = f(0), P2 = 0, D2 = 0, Q2 = 0, te = 0, ie = f(0), ne = 0, fe = 0, Ae = 0, he = 0, pe = f(0), Oe = 0, Ve = 0, Ce = 0, Ie = f(0), Be = 0, Fe = f(0), sr = 0, ar = f(0), lr = f(0), kr = f(0), cr = 0, _r = f(0), Rt = 0, Et = f(0), Wt = f(0), Nt = f(0), Zt = f(0), Gt = 0, qi = 0, bi = 0, en = 0, rn = 0, tn = 0, nn = 0, fn = 0, b0 = 0, e2 = f(0), tr = f(0);
              p = H - 384 | 0, H = p;
              e: {
                i: {
                  t: {
                    if (!(o && r != r)) {
                      if (!(u && i != i)) {
                        if (d = (h ? 0 : 4) + S | 0, t[d >> 2] = t[d >> 2] + 1, d = t[e + 24 >> 2] & 3, Rt = (n | 0) <= 1 ? 1 : n, O2 = d || Rt, P[e + 300 | 0] = X[e + 300 | 0] & 252 | O2 & 3, d = e + 252 | 0, n = ((O2 | 0) != 1) << 3, Oe = (O2 | 0) == 2 ? 3 : 2, C = d0(e, Oe, a), A[d + n >> 2] = C, V = d, d = ((O2 | 0) == 1) << 3, N0 = C0(e, Oe, a), A[V + d >> 2] = N0, M = d0(e, 0, a), A[e + 256 >> 2] = M, z0 = C0(e, 0, a), A[e + 264 >> 2] = z0, V = e + 268 | 0, b0 = V + n | 0, e2 = W0(e, Oe), A[b0 >> 2] = e2, b0 = d + V | 0, e2 = I0(e, Oe), A[b0 >> 2] = e2, m = W0(e, 0), A[e + 272 >> 2] = m, j0 = I0(e, 0), A[e + 280 >> 2] = j0, V = n, n = e + 284 | 0, b0 = V + n | 0, e2 = X0(e, Oe, a), A[b0 >> 2] = e2, b0 = n + d | 0, e2 = H0(e, Oe, a), A[b0 >> 2] = e2, W = X0(e, 0, a), A[e + 288 >> 2] = W, t0 = H0(e, 0, a), A[e + 296 >> 2] = t0, C = f(C + N0), N0 = f(M + z0), n = t[e + 8 >> 2], n) {
                          M = f(f(f(A[e + 284 >> 2] + A[e + 292 >> 2]) + A[e + 268 >> 2]) + A[e + 276 >> 2]), i = f(u ? i - N0 : s0), m = f(f(W + t0) + m), W = f(o ? r - C : s0), r = W;
                          r: {
                            if (r != r)
                              break r;
                            if (r = f(W - M), r != r) {
                              r = f(0);
                              break r;
                            }
                            r = g0(r, f(0));
                          }
                          C = f(m + j0), m = i;
                          r: {
                            if (i != i)
                              break r;
                            if (m = f(i - C), m != m) {
                              m = f(0);
                              break r;
                            }
                            m = g0(m, f(0));
                          }
                          if (!((o | 0) != 1 | (u | 0) != 1)) {
                            r = K0(e, 2, W, a), n = r != r, m = f(f(X0(e, 2, a) + W0(e, 2)) + f(H0(e, 2, a) + I0(e, 2)));
                            r: {
                              if (!(n | m != m)) {
                                r = g0(r, m);
                                break r;
                              }
                              r = n ? m : r;
                            }
                            A[e + 516 >> 2] = r, r = K0(e, 0, i, l), n = r != r, i = f(f(X0(e, 0, a) + W0(e, 0)) + f(H0(e, 0, a) + I0(e, 0)));
                            r: {
                              if (!(n | i != i)) {
                                r = g0(r, i);
                                break r;
                              }
                              r = n ? i : r;
                            }
                            A[e + 520 >> 2] = r;
                            break e;
                          }
                          r: {
                            if (X[e + 4 | 0] & 16) {
                              e0[n | 0](p + 24 | 0, e, r, o, m, u, 0);
                              break r;
                            }
                            e0[n | 0](p + 24 | 0, e, r, o, m, u);
                          }
                          t[S + 20 >> 2] = t[S + 20 >> 2] + 1, n = (T << 2) + S | 0, t[n + 24 >> 2] = t[n + 24 >> 2] + 1, r = f(M + A[p + 24 >> 2]), r = K0(e, 2, o ? (o | 0) == 2 ? r : W : r, a), n = r != r, m = f(f(X0(e, 2, a) + W0(e, 2)) + f(H0(e, 2, a) + I0(e, 2)));
                          r: {
                            if (!(n | m != m)) {
                              r = g0(r, m);
                              break r;
                            }
                            r = n ? m : r;
                          }
                          A[e + 516 >> 2] = r, r = f(C + A[p + 28 >> 2]), r = K0(e, 0, u ? (u | 0) == 2 ? r : i : r, l), n = r != r, i = f(f(X0(e, 0, a) + W0(e, 0)) + f(H0(e, 0, a) + I0(e, 0)));
                          r: {
                            if (!(n | i != i)) {
                              r = g0(r, i);
                              break r;
                            }
                            r = n ? i : r;
                          }
                          A[e + 520 >> 2] = r;
                          break e;
                        }
                        if (n = t[e + 556 >> 2], T = t[e + 560 >> 2], (n | 0) == (T | 0)) {
                          N0 = f(i - N0), r = K0(e, 2, o & -3 ? f(r - C) : f(f(f(A[e + 284 >> 2] + A[e + 292 >> 2]) + A[e + 268 >> 2]) + A[e + 276 >> 2]), a), n = r != r, i = f(f(X0(e, 2, a) + W0(e, 2)) + f(H0(e, 2, a) + I0(e, 2)));
                          r: {
                            if (!(n | i != i)) {
                              r = g0(r, i);
                              break r;
                            }
                            r = n ? i : r;
                          }
                          A[e + 516 >> 2] = r, r = K0(e, 0, u & -3 ? N0 : f(f(f(W + t0) + m) + j0), l), n = r != r, i = f(f(X0(e, 0, a) + W0(e, 0)) + f(H0(e, 0, a) + I0(e, 0)));
                          r: {
                            if (!(n | i != i)) {
                              r = g0(r, i);
                              break r;
                            }
                            r = n ? i : r;
                          }
                          A[e + 520 >> 2] = r;
                          break e;
                        }
                        r: {
                          if (h || (m = f(r - C), W = f(i - N0), !(!(!(m <= f(0)) | (o | 0) != 2) & m == m | !(!(W <= f(0)) | (u | 0) != 2) & W == W) & ((o | 0) != 1 | (u | 0) != 1)))
                            break r;
                          r = K0(e, 2, m != m || (o | 0) == 2 && m < f(0) ? f(0) : m, a), n = r != r, i = f(f(X0(e, 2, a) + W0(e, 2)) + f(H0(e, 2, a) + I0(e, 2)));
                          n: {
                            if (!(n | i != i)) {
                              r = g0(r, i);
                              break n;
                            }
                            r = n ? i : r;
                          }
                          A[e + 516 >> 2] = r, r = K0(e, 0, W != W || (u | 0) == 2 && W < f(0) ? f(0) : W, l), n = r != r, i = f(f(X0(e, 0, a) + W0(e, 0)) + f(H0(e, 0, a) + I0(e, 0)));
                          n: {
                            if (!(n | i != i)) {
                              r = g0(r, i);
                              break n;
                            }
                            r = n ? i : r;
                          }
                          A[e + 520 >> 2] = r;
                          break e;
                        }
                        for (o2 = T - n | 0, te = o2 >> 2; d = t[n >> 2], t[d + 552 >> 2] != (e | 0) && (V = t[e + 568 >> 2], d = wi(t[V >> 2], X[V + 8 | 0], d, e, $, 0), t[n >> 2] = d, t[d + 552 >> 2] = e), $ = $ + 1 | 0, n = n + 4 | 0, (T | 0) != (n | 0); )
                          ;
                        P[e + 300 | 0] = X[e + 300 | 0] & 251, $ = 3, E2 = t[e + 24 >> 2], n = E2 >>> 2 & 3;
                        r: {
                          n: {
                            f: {
                              if ((O2 | 0) == 2) {
                                T = 0;
                                o:
                                  switch (n - 2 | 0) {
                                    case 0:
                                      break r;
                                    case 1:
                                      break o;
                                    default:
                                      break f;
                                  }
                                $ = 2;
                                break r;
                              }
                              if ($ = 2, T = 0, n >>> 0 > 1)
                                break n;
                            }
                            T = $;
                          }
                          $ = n;
                        }
                        Et = f(r - C), ie = f(f(X0(e, $, a) + W0(e, $)) + f(H0(e, $, a) + I0(e, $))), j0 = f(X0(e, T, a) + W0(e, T)), F2 = f(j0 + f(H0(e, T, a) + I0(e, T))), P2 = $ >>> 0 > 1, M = ui(e, 0, Et, P2 ? ie : F2, a), Wt = f(i - N0), q0 = ui(e, 1, Wt, P2 ? F2 : ie, l), z0 = P2 ? q0 : M, N0 = P2 ? M : q0, ne = t[e + 560 >> 2], d = t[e + 556 >> 2], W2 = P2 ? o : u;
                        r: {
                          if ((W2 | 0) != 1)
                            break r;
                          if ((d | 0) == (ne | 0))
                            break t;
                          for (n = d; ; ) {
                            V = t[n >> 2];
                            n: {
                              if (!Zi(V))
                                break n;
                              if (a0 = 0, L)
                                break r;
                              f: {
                                o: {
                                  if (!t[V + 552 >> 2]) {
                                    m = f(0);
                                    break o;
                                  }
                                  if (i = A[V + 32 >> 2], i != i && (m = f(0), i = A[V + 28 >> 2], !(i > f(0))))
                                    break o;
                                  if (m = i, i != i)
                                    break f;
                                }
                                if (f($0(m)) < f(9999999747378752e-20))
                                  break r;
                              }
                              if (r = er(V), r != r) {
                                L = V;
                                break n;
                              }
                              if (L = V, f($0(r)) < f(9999999747378752e-20))
                                break r;
                            }
                            if (a0 = L, n = n + 4 | 0, (ne | 0) == (n | 0))
                              break;
                          }
                        }
                        if ((d | 0) == (ne | 0))
                          break t;
                        for (sr = (O2 | 0) <= 1 ? 1 : O2, Ve = M != M, fe = Ve | (o | 0) != 1, Ae = q0 == q0, Ce = M == M, m = f(0); ; ) {
                          f0 = t[d >> 2], oi(f0), V = t[f0 + 24 >> 2];
                          r: {
                            if (V & 4194304) {
                              if (li(f0, 0), n = X[f0 + 4 | 0], V = n | 1, P[f0 + 4 | 0] = V, !(n & 4))
                                break r;
                              P[f0 + 4 | 0] = V & 251;
                              break r;
                            }
                            if (h && (n = V & 3, vi(f0, n || sr, N0, z0, M), V = t[f0 + 24 >> 2]), (V & 196608) == 131072)
                              break r;
                            n: {
                              if ((f0 | 0) == (a0 | 0)) {
                                t[a0 + 308 >> 2] = 0, t[a0 + 304 >> 2] = Z, i = f(0);
                                break n;
                              }
                              he = t[e + 24 >> 2], n = he >>> 2 & 3;
                              f: {
                                o: {
                                  if ((O2 | 0) != 2)
                                    break o;
                                  L = 3;
                                  u:
                                    switch (n - 2 | 0) {
                                      case 0:
                                        break f;
                                      case 1:
                                        break u;
                                      default:
                                        break o;
                                    }
                                  L = 2;
                                  break f;
                                }
                                L = n;
                              }
                              D2 = L >>> 0 > 1, C = D2 ? M : q0, i = f(0), r = A[f0 + 40 >> 2];
                              f: {
                                o: {
                                  r0 = t[f0 + 40 >> 2];
                                  u: {
                                    if ((r0 | 0) == 2139156720)
                                      break u;
                                    if ((r0 | 0) == 2140081935)
                                      break o;
                                    n = 4336;
                                    s: {
                                      if ((r0 | 0) != 2141891242) {
                                        if (r == r)
                                          break s;
                                        n = 4344;
                                      }
                                      i = A[n >> 2];
                                      a: {
                                        l:
                                          switch (r0 = t[n + 4 >> 2], r0 | 0) {
                                            case 0:
                                            case 3:
                                              break l;
                                            default:
                                              break a;
                                          }
                                        if (r = f(s0), !(A[f0 + 28 >> 2] > f(0)))
                                          break f;
                                        r0 = P[t[f0 + 568 >> 2] + 8 | 0] & 1, n = r0 ? 2143289344 : 0, r0 = r0 ? 3 : 1, i = (J(2, n), n0());
                                      }
                                      switch (r = f(s0), r0 - 1 | 0) {
                                        case 0:
                                          break o;
                                        case 1:
                                          break u;
                                        default:
                                          break f;
                                      }
                                    }
                                    if (i = (J(2, (r0 & -1073741825) + 536870912 | 0), n0()), !(r0 & 1073741824))
                                      break o;
                                  }
                                  r = f(f(C * i) * f(0.009999999776482582));
                                  break f;
                                }
                                r = i;
                              }
                              i = A[f0 + 572 >> 2], r0 = 0;
                              f: {
                                o:
                                  switch (Y0 = t[f0 + 576 >> 2], Y0 | 0) {
                                    case 0:
                                    case 3:
                                      break f;
                                    default:
                                      break o;
                                  }
                                if (W = A[f0 + 572 >> 2], !((Y0 | 0) != 1 | W != W)) {
                                  if (i < f(0))
                                    break f;
                                  r0 = 1;
                                  break f;
                                }
                                if (r0 = 1, (Y0 | 0) != 2 | W != W || (r0 = 0, i < f(0)))
                                  break f;
                                r0 = Ce;
                              }
                              W = A[f0 + 580 >> 2], n = 0;
                              f: {
                                o:
                                  switch (u2 = t[f0 + 584 >> 2], u2 | 0) {
                                    case 0:
                                    case 3:
                                      break f;
                                    default:
                                      break o;
                                  }
                                if (t0 = A[f0 + 580 >> 2], !((u2 | 0) != 1 | t0 != t0)) {
                                  if (W < f(0))
                                    break f;
                                  n = 1;
                                  break f;
                                }
                                if (n = 1, (u2 | 0) != 2 | t0 != t0 || (n = 0, W < f(0)))
                                  break f;
                                n = Ae;
                              }
                              f: {
                                o: {
                                  if (!(r != r | C != C)) {
                                    if (i = A[f0 + 308 >> 2], (!(P[t[f0 + 568 >> 2] + 12 | 0] & 1) | t[f0 + 304 >> 2] == (Z | 0)) & i == i)
                                      break f;
                                    if (i = f(f(X0(f0, L, M) + W0(f0, L)) + f(H0(f0, L, M) + I0(f0, L))), !(i <= r) & r < i)
                                      break o;
                                    i = r;
                                    break o;
                                  }
                                  if (r0 & D2) {
                                    W = f(f(X0(f0, 2, M) + W0(f0, 2)) + f(H0(f0, 2, M) + I0(f0, 2))), r = f(s0);
                                    u:
                                      switch (Y0 - 1 | 0) {
                                        case 1:
                                          i = f(f(M * i) * f(0.009999999776482582));
                                        case 0:
                                          if (r = i, W <= r)
                                            break o;
                                          break;
                                        default:
                                          break u;
                                      }
                                    if (!(r == r | W == W)) {
                                      i = r;
                                      break o;
                                    }
                                    if (r < W) {
                                      i = W;
                                      break o;
                                    }
                                    i = r != r ? W : r;
                                    break o;
                                  }
                                  if (!(D2 | n ^ 1)) {
                                    r = f(f(X0(f0, 0, M) + W0(f0, 0)) + f(H0(f0, 0, M) + I0(f0, 0))), i = f(s0);
                                    u:
                                      switch (u2 - 1 | 0) {
                                        case 1:
                                          W = f(f(q0 * W) * f(0.009999999776482582));
                                        case 0:
                                          if (i = W, r <= i)
                                            break o;
                                          break;
                                        default:
                                          break u;
                                      }
                                    if (i != i & r != r)
                                      break o;
                                    if (r > i) {
                                      i = r;
                                      break o;
                                    }
                                    i = i != i ? r : i;
                                    break o;
                                  }
                                  if (t[p + 360 >> 2] = 2143289344, t[p + 24 >> 2] = 2143289344, N2 = 0, t[p + 356 >> 2] = 0, t[p + 352 >> 2] = 0, t0 = f(d0(f0, 2, M) + C0(f0, 2, M)), h0 = d0(f0, 0, M), M0 = C0(f0, 0, M), C = f(s0), Q2 = 0, r = f(s0), r0) {
                                    u: {
                                      s:
                                        switch (Y0 - 1 | 0) {
                                          case 0:
                                            r = i;
                                            break u;
                                          case 1:
                                            break s;
                                          default:
                                            break u;
                                        }
                                      r = f(f(M * i) * f(0.009999999776482582));
                                    }
                                    t[p + 356 >> 2] = 1, r = f(t0 + r), A[p + 24 >> 2] = r, Q2 = 1;
                                  }
                                  if (h0 = f(h0 + M0), n) {
                                    i = f(s0);
                                    u: {
                                      s:
                                        switch (u2 - 1 | 0) {
                                          case 0:
                                            i = W;
                                            break u;
                                          case 1:
                                            break s;
                                          default:
                                            break u;
                                        }
                                      i = f(f(q0 * W) * f(0.009999999776482582));
                                    }
                                    t[p + 352 >> 2] = 1, C = f(h0 + i), A[p + 360 >> 2] = C, N2 = 1;
                                  }
                                  Y0 = (he & 3145728) == 2097152, u2 = L >>> 0 < 2;
                                  u: {
                                    s: {
                                      a: {
                                        if (!(Y0 & u2)) {
                                          if (Y0 | Ve)
                                            break s;
                                          if (r != r)
                                            break a;
                                          break s;
                                        }
                                        if (Ve | r == r)
                                          break u;
                                      }
                                      Q2 = 2, t[p + 356 >> 2] = 2, A[p + 24 >> 2] = M, r = M;
                                    }
                                    s: {
                                      if (!Y0 || u2) {
                                        if (Y0 | q0 != q0)
                                          break u;
                                        if (C != C)
                                          break s;
                                        break u;
                                      }
                                      if (C == C | q0 != q0)
                                        break u;
                                    }
                                    N2 = 2, t[p + 352 >> 2] = 2, A[p + 360 >> 2] = q0, C = q0;
                                  }
                                  i = A[f0 + 224 >> 2], Y0 = i != i;
                                  u: {
                                    if (Y0)
                                      break u;
                                    s: {
                                      if (!(D2 | (Q2 | 0) != 1)) {
                                        t[p + 352 >> 2] = 1, A[p + 360 >> 2] = h0 + f(f(r - t0) / i);
                                        break s;
                                      }
                                      if (u2 | (N2 | 0) != 1)
                                        break u;
                                      t[p + 356 >> 2] = 1, A[p + 24 >> 2] = f(f(C - h0) * i) + t0;
                                    }
                                    N2 = 1, Q2 = 1;
                                  }
                                  V = V >>> 13 & 7, V = V || he >>> 10 & 7;
                                  u: {
                                    if ((V | 0) == 5 | (Q2 | 0) == 1 | (D2 | (r0 | fe)) | (V | 0) != 4 || (t[p + 356 >> 2] = 1, A[p + 24 >> 2] = M, Y0))
                                      break u;
                                    N2 = 1, t[p + 352 >> 2] = 1, A[p + 360 >> 2] = f(M - t0) / i;
                                  }
                                  u: {
                                    if (u2 | (u | 0) != 1 | q0 != q0 | n | (V | 0) != 4 | (N2 | 0) == 1 || (t[p + 352 >> 2] = 1, A[p + 360 >> 2] = q0, Y0))
                                      break u;
                                    t[p + 356 >> 2] = 1, A[p + 24 >> 2] = f(q0 - h0) * i;
                                  }
                                  if (Ke(f0, 2, M, M, p + 356 | 0, p + 24 | 0), Ke(f0, 0, q0, M, p + 352 | 0, p + 360 | 0), Le(f0, A[p + 24 >> 2], A[p + 360 >> 2], O2, t[p + 356 >> 2], t[p + 352 >> 2], M, q0, 0, 5, g, S, F, Z), r = A[(f0 + (t[(L << 2) + 4320 >> 2] << 2) | 0) + 516 >> 2], n = r != r, i = f(f(X0(f0, L, M) + W0(f0, L)) + f(H0(f0, L, M) + I0(f0, L))), !(n | i != i)) {
                                    i = g0(r, i);
                                    break o;
                                  }
                                  i = n ? i : r;
                                }
                                A[f0 + 308 >> 2] = i;
                              }
                              t[f0 + 304 >> 2] = Z;
                            }
                            m = f(m + f(i + f(d0(f0, $, M) + C0(f0, $, M))));
                          }
                          if (d = d + 4 | 0, (ne | 0) == (d | 0))
                            break;
                        }
                        break i;
                      }
                      t[p >> 2] = 3072, L2(e, p), B2(), V0();
                    }
                    t[p + 16 >> 2] = 3154, L2(e, p + 16 | 0), B2(), V0();
                  }
                  m = f(0);
                }
                r = f(m + f(0)), ar = P2 ? l : a, Ie = P2 ? a : l, o2 >>> 0 >= 5 && (r = f(f(Or(e, $, z0) * f(te - 1 >>> 0)) + r)), n = r > N0, ne = E2 & 786432, Ae = (W2 | 0) == 2 && ne && n ? 1 : W2, f0 = P2 ? u : o, D2 = (f0 | 0) == 1, qi = D2 & (h ^ 1), P2 = $ >>> 0 < 2, bi = f0 & -3, Ve = e + 208 | 0, u = T << 2, u2 = u + 4288 | 0, en = D2 & !ne, rn = (f0 | 0) != 1 | h, d = $ << 2, Q2 = d + 4288 | 0, Ce = d + 4320 | 0, he = z0 == z0, tn = he << 1, Y0 = u + 4320 | 0, nn = !W2 | !n, sr = p + 52 | 0, Nt = Or(e, T, z0), V = 0, n = 0, N2 = 0;
                i: {
                  for (; ; ) {
                    W2 = n, T2(p + 24 | 0, 0, 44), n = t[e + 560 >> 2], u = t[e + 556 >> 2];
                    t: {
                      if ((n | 0) == (u | 0))
                        break t;
                      if (n = n - u | 0, (n | 0) < 0)
                        break i;
                      if (d = ur(p + 360 | 0, n >> 2, 0, sr), n = t[p + 44 >> 2], u = t[p + 48 >> 2] - n | 0, u = Ge(t[p + 364 >> 2] - u | 0, n, u), n = t[p + 44 >> 2], t[p + 364 >> 2] = n, t[p + 44 >> 2] = u, L = t[p + 368 >> 2], r0 = t[p + 372 >> 2], u = t[p + 48 >> 2], t[p + 368 >> 2] = u, a0 = t[p + 52 >> 2], t[p + 48 >> 2] = L, t[p + 52 >> 2] = r0, t[p + 372 >> 2] = a0, t[d >> 2] = n, (n | 0) != (u | 0) && (t[p + 368 >> 2] = u + ((n - u | 0) + 3 & -4)), !n)
                        break t;
                      p2(n);
                    }
                    a0 = t[e + 24 >> 2], n = a0 >>> 2 & 3;
                    t: {
                      r: {
                        if (u = a0 & 3, ((u || Rt) | 0) != 2)
                          break r;
                        L = 3;
                        n:
                          switch (n - 2 | 0) {
                            case 0:
                              break t;
                            case 1:
                              break n;
                            default:
                              break r;
                          }
                        L = 2;
                        break t;
                      }
                      L = n;
                    }
                    m = Or(e, L, M), d = V, r0 = t[e + 560 >> 2], u = t[e + 556 >> 2];
                    t: {
                      if (d >>> 0 >= r0 - u >> 2 >>> 0)
                        break t;
                      for (a0 = a0 & 786432, i = f(0); ; ) {
                        if (r0 - u >> 2 >>> 0 <= d >>> 0)
                          break i;
                        if (n = t[(d << 2) + u >> 2], o2 = t[n + 24 >> 2], !(o2 & 4194304 | (o2 & 196608) == 131072)) {
                          if (t[n + 548 >> 2] = W2, r = d0(n, L, M), W = C0(n, L, M), u = t[p + 24 >> 2], C = (d | 0) == (V | 0) ? f(0) : m, r = f(r + W), W = A[n + 308 >> 2], t0 = K0(n, L, W, Ie), !(!u || !(f(C + f(r + f(i + t0))) > N0) | !a0))
                            break t;
                          if (t[p + 24 >> 2] = u + 1, C = f(C + f(r + t0)), A[p + 28 >> 2] = C + A[p + 28 >> 2], Zi(n)) {
                            r: {
                              if (!t[n + 552 >> 2]) {
                                r = f(0);
                                break r;
                              }
                              if (r = A[n + 32 >> 2], r == r)
                                break r;
                              r = A[n + 28 >> 2], r = r > f(0) ? r : f(0);
                            }
                            A[p + 32 >> 2] = r + A[p + 32 >> 2], b0 = p, e2 = f(A[p + 36 >> 2] - f(er(n) * W)), A[b0 + 36 >> 2] = e2;
                          }
                          u = t[p + 48 >> 2];
                          r: {
                            if ((u | 0) != t[p + 52 >> 2]) {
                              t[u >> 2] = n, t[p + 48 >> 2] = u + 4;
                              break r;
                            }
                            if (u = u - t[p + 44 >> 2] | 0, o2 = u >> 2, r0 = o2 + 1 | 0, r0 >>> 0 >= 1073741824)
                              break i;
                            if (E2 = u >> 1, r0 = ur(p + 360 | 0, u >>> 0 >= 2147483644 ? 1073741823 : r0 >>> 0 < E2 >>> 0 ? E2 : r0, o2, sr), t[t[p + 368 >> 2] >> 2] = n, t[p + 368 >> 2] = t[p + 368 >> 2] + 4, n = t[p + 44 >> 2], u = t[p + 48 >> 2] - n | 0, u = Ge(t[p + 364 >> 2] - u | 0, n, u), n = t[p + 44 >> 2], t[p + 364 >> 2] = n, t[p + 44 >> 2] = u, o2 = t[p + 368 >> 2], E2 = t[p + 372 >> 2], u = t[p + 48 >> 2], t[p + 368 >> 2] = u, fe = t[p + 52 >> 2], t[p + 48 >> 2] = o2, t[p + 52 >> 2] = E2, t[p + 372 >> 2] = fe, t[r0 >> 2] = n, (n | 0) != (u | 0) && (t[p + 368 >> 2] = u + ((n - u | 0) + 3 & -4)), !n)
                              break r;
                            p2(n);
                          }
                          u = t[e + 556 >> 2], r0 = t[e + 560 >> 2], i = f(i + C);
                        }
                        if (d = d + 1 | 0, !(d >>> 0 < r0 - u >> 2 >>> 0))
                          break;
                      }
                    }
                    M0 = A[p + 32 >> 2], !(M0 > f(0)) | !(M0 < f(1)) || (t[p + 32 >> 2] = 1065353216, M0 = f(1)), v2 = A[p + 36 >> 2], !(v2 > f(0)) | !(v2 < f(1)) || (t[p + 36 >> 2] = 1065353216, v2 = f(1)), t[p + 40 >> 2] = d, t0 = A[p + 28 >> 2], L = t[p + 24 >> 2], N2 && p2(N2), W = A[p + 56 >> 2], o2 = t[p + 48 >> 2], N2 = t[p + 44 >> 2];
                    t: {
                      r: {
                        n: {
                          f: {
                            if ((Ae | 0) == 1)
                              break f;
                            i = f(0), r = A[Ve >> 2];
                            o: {
                              u: {
                                n = t[Ve >> 2];
                                s: {
                                  if ((n | 0) == 2139156720)
                                    break s;
                                  if ((n | 0) == 2140081935)
                                    break u;
                                  u = 4336;
                                  a: {
                                    if ((n | 0) != 2141891242) {
                                      if (r == r)
                                        break a;
                                      u = 4344;
                                    }
                                    switch (i = A[u >> 2], r = f(s0), t[u + 4 >> 2] - 1 | 0) {
                                      case 0:
                                        break u;
                                      case 1:
                                        break s;
                                      default:
                                        break o;
                                    }
                                  }
                                  if (i = (J(2, (n & -1073741825) + 536870912 | 0), n0()), !(n & 1073741824))
                                    break u;
                                }
                                r = f(f(i * a) * f(0.009999999776482582));
                                break o;
                              }
                              r = i;
                            }
                            i = f(0), m = A[e + 216 >> 2];
                            o: {
                              u: {
                                n = t[e + 216 >> 2];
                                s: {
                                  if ((n | 0) == 2139156720)
                                    break s;
                                  if ((n | 0) == 2140081935)
                                    break u;
                                  u = 4336;
                                  a: {
                                    if ((n | 0) != 2141891242) {
                                      if (m == m)
                                        break a;
                                      u = 4344;
                                    }
                                    switch (i = A[u >> 2], m = f(s0), t[u + 4 >> 2] - 1 | 0) {
                                      case 0:
                                        break u;
                                      case 1:
                                        break s;
                                      default:
                                        break o;
                                    }
                                  }
                                  if (i = (J(2, (n & -1073741825) + 536870912 | 0), n0()), !(n & 1073741824))
                                    break u;
                                }
                                m = f(f(i * a) * f(0.009999999776482582));
                                break o;
                              }
                              m = i;
                            }
                            i = f(0), C = A[e + 212 >> 2];
                            o: {
                              u: {
                                n = t[e + 212 >> 2];
                                s: {
                                  if ((n | 0) == 2139156720)
                                    break s;
                                  if ((n | 0) == 2140081935)
                                    break u;
                                  u = 4336;
                                  a: {
                                    if ((n | 0) != 2141891242) {
                                      if (C == C)
                                        break a;
                                      u = 4344;
                                    }
                                    switch (i = A[u >> 2], C = f(s0), t[u + 4 >> 2] - 1 | 0) {
                                      case 0:
                                        break u;
                                      case 1:
                                        break s;
                                      default:
                                        break o;
                                    }
                                  }
                                  if (i = (J(2, (n & -1073741825) + 536870912 | 0), n0()), !(n & 1073741824))
                                    break u;
                                }
                                C = f(f(i * l) * f(0.009999999776482582));
                                break o;
                              }
                              C = i;
                            }
                            i = f(0), h0 = A[e + 220 >> 2];
                            o: {
                              u: {
                                n = t[e + 220 >> 2];
                                s: {
                                  if ((n | 0) == 2139156720)
                                    break s;
                                  if ((n | 0) == 2140081935)
                                    break u;
                                  u = 4336;
                                  a: {
                                    if ((n | 0) != 2141891242) {
                                      if (h0 == h0)
                                        break a;
                                      u = 4344;
                                    }
                                    switch (i = A[u >> 2], h0 = f(s0), t[u + 4 >> 2] - 1 | 0) {
                                      case 0:
                                        break u;
                                      case 1:
                                        break s;
                                      default:
                                        break o;
                                    }
                                  }
                                  if (i = (J(2, (n & -1073741825) + 536870912 | 0), n0()), !(n & 1073741824))
                                    break u;
                                }
                                h0 = f(f(i * l) * f(0.009999999776482582));
                                break o;
                              }
                              h0 = i;
                            }
                            if (n = $ >>> 0 > 1, i = f((n ? r : C) - ie), i == i & i > t0 || (i = f((n ? m : h0) - ie), i == i & i < t0))
                              break n;
                            if (P[t[e + 568 >> 2] + 16 | 0] & 1)
                              break f;
                            if (i = t0, !t[e + 552 >> 2] | M0 == f(0))
                              break r;
                            r = A[e + 32 >> 2];
                            o: {
                              u: {
                                if (r == r) {
                                  i = r;
                                  break u;
                                }
                                if (i = A[e + 28 >> 2], !(i > f(0)))
                                  break o;
                              }
                              if (i != i) {
                                i = N0;
                                break r;
                              }
                              r = A[e + 32 >> 2];
                            }
                            if (r != r && (i = t0, r = A[e + 28 >> 2], !(r > f(0))) || (i = N0, r != f(0)))
                              break r;
                            i = t0;
                            break r;
                          }
                          i = N0;
                        }
                        if (i != i)
                          break r;
                        W = f(i - t0);
                        break t;
                      }
                      if (!(t0 < f(0)))
                        break t;
                      W = f(-t0);
                    }
                    if (N0 = i, !qi) {
                      t: {
                        if ((o2 | 0) == (N2 | 0)) {
                          C = f(0);
                          break t;
                        }
                        for (h0 = f(0), u = N2; ; ) {
                          n = t[u >> 2], t0 = A[n + 308 >> 2], i = K0(n, $, t0, Ie);
                          r: {
                            if (W < f(0)) {
                              if (r = f(i * f(-er(n))), !(r > f(0) | r < f(0)))
                                break r;
                              m = f(f(f(W / v2) * r) + i), r = K0(n, $, m, N0), r0 = r != r, C = f(f(X0(n, $, M) + W0(n, $)) + f(H0(n, $, M) + I0(n, $)));
                              n: {
                                if (!(r0 | C != C)) {
                                  r = g0(r, C);
                                  break n;
                                }
                                r = r0 ? C : r;
                              }
                              if (m != m | r != r | r == m)
                                break r;
                              h0 = f(h0 + f(r - i)), v2 = f(f(er(n) * t0) + v2);
                              break r;
                            }
                            if (!(W > f(0)) | !t[n + 552 >> 2] || (m = A[n + 32 >> 2], m != m && (m = A[n + 28 >> 2], !(m > f(0)))) || !(m < f(0) | m > f(0)))
                              break r;
                            C = f(f(f(W / M0) * m) + i), r = K0(n, $, C, N0), r0 = r != r, t0 = f(f(X0(n, $, M) + W0(n, $)) + f(H0(n, $, M) + I0(n, $)));
                            n: {
                              if (!(r0 | t0 != t0)) {
                                r = g0(r, t0);
                                break n;
                              }
                              r = r0 ? t0 : r;
                            }
                            if (C != C | r != r | r == C)
                              break r;
                            M0 = f(M0 - m), h0 = f(h0 + f(r - i));
                          }
                          if (u = u + 4 | 0, (o2 | 0) == (u | 0))
                            break;
                        }
                        for (h0 = f(W - h0), lr = f(h0 / v2), kr = f(h0 / M0), cr = D2 & (nn | !(X[e + 26 | 0] & 12)), fe = !cr, E2 = t[Y0 >> 2], C = f(0), r0 = N2; ; ) {
                          n = t[r0 >> 2], t0 = K0(n, $, A[n + 308 >> 2], Ie);
                          r: {
                            n: {
                              if (h0 < f(0)) {
                                if (m = t0, r = f(m * f(-er(n))), r == f(0))
                                  break r;
                                r = v2 == f(0) ? f(t0 + r) : f(f(lr * r) + t0);
                                break n;
                              }
                              if (m = t0, !(h0 > f(0)) | !t[n + 552 >> 2] || (r = A[n + 32 >> 2], r != r && (r = A[n + 28 >> 2], !(r > f(0)))) || !(r < f(0) | r > f(0)))
                                break r;
                              r = f(f(kr * r) + t0);
                            }
                            if (r = K0(n, $, r, N0), u = r != r, i = f(f(X0(n, $, M) + W0(n, $)) + f(H0(n, $, M) + I0(n, $))), !(u | i != i)) {
                              m = g0(r, i);
                              break r;
                            }
                            m = u ? i : r;
                          }
                          r = d0(n, $, M), i = C0(n, $, M), M0 = d0(n, T, M), _r = C0(n, T, M), i = f(r + i), Zt = f(m + i), A[p + 352 >> 2] = Zt, t[p + 344 >> 2] = 1, M0 = f(M0 + _r), r = A[n + 224 >> 2];
                          r: {
                            if (r == r) {
                              t[p + 348 >> 2] = 1, i = f(Zt - i), A[p + 356 >> 2] = M0 + f(P2 ? i * r : i / r);
                              break r;
                            }
                            n: {
                              if (Be = z0 != z0, Be)
                                break n;
                              a0 = (E2 << 3) + n | 0, r = A[a0 + 572 >> 2];
                              f: {
                                o: {
                                  u: {
                                    s:
                                      switch (u = t[a0 + 576 >> 2], u | 0) {
                                        case 0:
                                        case 3:
                                          break u;
                                        default:
                                          break s;
                                      }
                                    if (i = A[a0 + 572 >> 2], (u | 0) != 1 | i != i)
                                      break o;
                                    if (!(fe | !(r < f(0))))
                                      break f;
                                    break n;
                                  }
                                  if (!cr)
                                    break n;
                                  break f;
                                }
                                if (fe | (!(r < f(0)) | ((u | 0) != 2 | i != i)))
                                  break n;
                              }
                              if (u = t[n + 24 >> 2] >>> 13 & 7, u || (u = t[e + 24 >> 2] >>> 10 & 7), (u | 0) != 4 || (Me(p + 24 | 0, n, T), t[p + 28 >> 2] == 3) || (xe(p + 360 | 0, n, T), t[p + 364 >> 2] == 3))
                                break n;
                              t[p + 348 >> 2] = 1, A[p + 356 >> 2] = z0;
                              break r;
                            }
                            a0 = (E2 << 3) + n | 0, i = A[a0 + 572 >> 2];
                            n: {
                              f: {
                                o: {
                                  u: {
                                    s:
                                      switch (u = t[a0 + 576 >> 2], u | 0) {
                                        case 0:
                                        case 3:
                                          break u;
                                        default:
                                          break s;
                                      }
                                    if (r = A[a0 + 572 >> 2], !((u | 0) != 1 | r != r)) {
                                      if (r = i, r < f(0))
                                        break u;
                                      break n;
                                    }
                                    if ((u | 0) != 2 | r != r)
                                      break o;
                                    if (Be)
                                      break u;
                                    if (!(i < f(0)))
                                      break f;
                                  }
                                  t[p + 348 >> 2] = tn, A[p + 356 >> 2] = z0;
                                  break r;
                                }
                                r = f(s0);
                                o:
                                  switch (u - 1 | 0) {
                                    case 1:
                                      break f;
                                    case 0:
                                      break o;
                                    default:
                                      break n;
                                  }
                                r = i;
                                break n;
                              }
                              r = f(f(z0 * i) * f(0.009999999776482582));
                            }
                            r = f(M0 + r), A[p + 356 >> 2] = r, t[p + 348 >> 2] = (D2 | (u | 0) != 2) & r == r;
                          }
                          Ke(n, $, N0, M, p + 344 | 0, p + 352 | 0), Ke(n, T, z0, M, p + 348 | 0, p + 356 | 0), a0 = (E2 << 3) + n | 0, r = A[a0 + 572 >> 2];
                          r: {
                            n: {
                              f: {
                                o:
                                  switch (u = t[a0 + 576 >> 2], u | 0) {
                                    case 0:
                                    case 3:
                                      break f;
                                    default:
                                      break o;
                                  }
                                if (i = A[a0 + 572 >> 2], !((u | 0) != 1 | i != i)) {
                                  if (r < f(0))
                                    break f;
                                  break n;
                                }
                                if ((u | 0) != 2 | i != i)
                                  break n;
                                if (r < f(0))
                                  break f;
                                if (a0 = 0, he)
                                  break r;
                              }
                              if (a0 = 0, u = t[n + 24 >> 2] >>> 13 & 7, u || (u = t[e + 24 >> 2] >>> 10 & 7), (u | 0) != 4 || (Me(p + 24 | 0, n, T), t[p + 28 >> 2] == 3))
                                break r;
                              xe(p + 360 | 0, n, T), a0 = t[p + 364 >> 2] != 3;
                              break r;
                            }
                            a0 = 0;
                          }
                          r = A[p + 352 >> 2], i = A[p + 356 >> 2], u = $ >>> 0 > 1, M0 = u ? r : i, r = u ? i : r, Be = t[p + 344 >> 2], Gt = t[p + 348 >> 2], fn = u ? Be : Gt, Be = u ? Gt : Be, u = (a0 ^ 1) & h, Le(n, M0, r, X[e + 300 | 0] & 3, fn, Be, M, q0, u, u ? 4 : 7, g, S, F, Z), C = f(C + f(m - t0)), u = X[e + 300 | 0];
                          r: {
                            n: {
                              if (u & 4) {
                                a0 = u & 251;
                                break n;
                              }
                              if (a0 = u & 251, u = 0, !(X[n + 300 | 0] & 4))
                                break r;
                            }
                            u = 4;
                          }
                          if (P[e + 300 | 0] = u | a0, r0 = r0 + 4 | 0, (o2 | 0) == (r0 | 0))
                            break;
                        }
                      }
                      W = f(W - C);
                    }
                    n = X[e + 300 | 0], P[e + 300 | 0] = n & 251 | (W < f(0) ? 4 : n & 4), h0 = f(X0(e, $, a) + W0(e, $)), lr = f(H0(e, $, a) + I0(e, $)), t0 = Or(e, $, a);
                    t: {
                      if (!(!(W > f(0)) | (Ae | 0) != 2)) {
                        C = f(0), i = f(0);
                        r: {
                          n: {
                            n = Ve + (t[Ce >> 2] << 2) | 0, r = A[n >> 2], n = t[n >> 2], u = (n | 0) == 2139156720;
                            f: {
                              if (!u) {
                                if (r0 = (n | 0) == 2140081935, r0)
                                  break n;
                                if (a0 = (n | 0) == 2141891242, a0 | r != r)
                                  break t;
                                if (r0)
                                  break n;
                                if (a0)
                                  break t;
                                if (i = (J(2, (n & -1073741825) + 536870912 | 0), n0()), !(n & 1073741824))
                                  break f;
                              }
                              i = f(f(Ie * i) * f(0.009999999776482582));
                            }
                            if (i != i)
                              break t;
                            i = f(0);
                            f: {
                              if (u)
                                break f;
                              if ((n | 0) == 2140081935)
                                break n;
                              u = 4336;
                              o: {
                                if ((n | 0) != 2141891242) {
                                  if (r == r)
                                    break o;
                                  u = 4344;
                                }
                                switch (i = A[u >> 2], m = f(s0), t[u + 4 >> 2] - 1 | 0) {
                                  case 0:
                                    break n;
                                  case 1:
                                    break f;
                                  default:
                                    break r;
                                }
                              }
                              if (i = (J(2, (n & -1073741825) + 536870912 | 0), n0()), !(n & 1073741824))
                                break n;
                            }
                            m = f(f(Ie * i) * f(0.009999999776482582));
                            break r;
                          }
                          m = i;
                        }
                        if (r = f(f(f(m - h0) - lr) - f(N0 - W)), r != r)
                          break t;
                        C = g0(r, f(0));
                        break t;
                      }
                      C = W;
                    }
                    a0 = d >>> 0 <= V >>> 0;
                    t: {
                      if (!a0) {
                        for (o2 = t[e + 556 >> 2], n = t[e + 560 >> 2] - o2 >> 2, E2 = n >>> 0 < V >>> 0 ? V : n, r0 = 0, n = V; ; ) {
                          if ((n | 0) == (E2 | 0))
                            break i;
                          if (u = t[o2 + (n << 2) >> 2], (t[u + 24 >> 2] & 196608) != 131072 && (fe = p + 24 | 0, Me(fe, u, $), cr = t[p + 28 >> 2], xe(fe, u, $), r0 = (((cr | 0) == 3) + r0 | 0) + (t[p + 28 >> 2] == 3) | 0), n = n + 1 | 0, (d | 0) == (n | 0))
                            break;
                        }
                        if (M0 = f(0), i = t0, r0)
                          break t;
                      }
                      M0 = f(0), r0 = 0, i = t0;
                      r:
                        switch ((t[e + 24 >> 2] >>> 4 & 7) - 1 | 0) {
                          case 0:
                            M0 = f(C * f(0.5));
                            break t;
                          case 1:
                            M0 = C;
                            break t;
                          case 2:
                            if (L >>> 0 < 2)
                              break t;
                            i = f(t0 + f((e2 = f(0), tr = g0(C, f(0)), b0 = C != C, (b0 ? e2 : tr) / f(L - 1 >>> 0))));
                            break t;
                          case 4:
                            M0 = f(C / f(L + 1 >>> 0)), i = f(t0 + M0);
                            break t;
                          case 3:
                            break r;
                          default:
                            break t;
                        }
                      M0 = f(f(C * f(0.5)) / f(L >>> 0)), i = f(f(M0 + M0) + t0);
                    }
                    if (r = f(h0 + M0), W = f(0), o2 = gi(e), a0)
                      i = f(0);
                    else {
                      for (E2 = d - 1 | 0, kr = f(C / f(r0 | 0)), h0 = f(0), m = f(0), n = V; ; ) {
                        if (u = t[e + 556 >> 2], t[e + 560 >> 2] - u >> 2 >>> 0 <= n >>> 0)
                          break i;
                        u = t[u + (n << 2) >> 2], L = u + 228 | 0, S2(p + 24 | 0, L, 320), i = f(i - ((n | 0) == (E2 | 0) ? t0 : f(0))), r0 = t[u + 24 >> 2];
                        t: {
                          if (r0 & 4194304)
                            break t;
                          r: {
                            if ((r0 & 196608) == 131072) {
                              if (!x2(u, $))
                                break r;
                              if (!h)
                                break t;
                              C = Se(u, $, N0), v2 = W0(e, $), _r = d0(u, $, M), A[L + (t[Q2 >> 2] << 2) >> 2] = _r + f(C + v2);
                              break t;
                            }
                            if (Me(p + 360 | 0, u, $), r = f(r + (t[p + 364 >> 2] == 3 ? kr : f(-0))), h && (r0 = L, L = t[Q2 >> 2] << 2, A[r0 + L >> 2] = r + A[L + (p + 24 | 0) >> 2]), xe(p + 360 | 0, u, $), r = f(r + (t[p + 364 >> 2] == 3 ? kr : f(-0))), !rn) {
                              r = f(r + f(f(i + f(d0(u, $, M) + C0(u, $, M))) + A[p + 104 >> 2])), W = z0;
                              break t;
                            }
                            if (L = u + 516 | 0, r = f(r + f(i + f(A[L + (t[Ce >> 2] << 2) >> 2] + f(d0(u, $, M) + C0(u, $, M))))), o2) {
                              C = Vr(u), v2 = d0(u, 0, M), C = f(C + v2), v2 = f(f(A[u + 520 >> 2] + f(d0(u, 0, M) + C0(u, 0, M))) - C), u = h0 != h0;
                              n: {
                                if (!(u | C != C)) {
                                  h0 = g0(h0, C);
                                  break n;
                                }
                                h0 = u ? C : h0;
                              }
                              if (u = m != m, !(u | v2 != v2)) {
                                m = g0(m, v2);
                                break t;
                              }
                              m = u ? v2 : m;
                              break t;
                            }
                            if (C = f(A[L + (t[Y0 >> 2] << 2) >> 2] + f(d0(u, T, M) + C0(u, T, M))), u = W != W, !(C != C | u)) {
                              W = g0(W, C);
                              break t;
                            }
                            W = u ? C : W;
                            break t;
                          }
                          if (!h)
                            break t;
                          u = t[Q2 >> 2] << 2, C = A[u + (p + 24 | 0) >> 2], b0 = u + L | 0, e2 = f(M0 + f(C + W0(e, $))), A[b0 >> 2] = e2;
                        }
                        if (n = n + 1 | 0, (d | 0) == (n | 0))
                          break;
                      }
                      i = f(m + h0);
                    }
                    if (W = o2 ? i : W, C = z0, !bi) {
                      i = K0(e, T, f(F2 + W), ar), n = i != i, m = f(f(X0(e, T, a) + W0(e, T)) + f(H0(e, T, a) + I0(e, T)));
                      t: {
                        if (!(n | m != m)) {
                          i = g0(i, m);
                          break t;
                        }
                        i = n ? m : i;
                      }
                      C = f(i - F2);
                    }
                    i = K0(e, T, f(F2 + (en ? z0 : W)), ar), n = i != i, m = f(f(X0(e, T, a) + W0(e, T)) + f(H0(e, T, a) + I0(e, T)));
                    t: {
                      if (!(n | m != m)) {
                        i = g0(i, m);
                        break t;
                      }
                      i = n ? m : i;
                    }
                    if (m = f(i - F2), !(a0 | !h))
                      for (; ; ) {
                        if (n = t[e + 556 >> 2], t[e + 560 >> 2] - n >> 2 >>> 0 <= V >>> 0)
                          break i;
                        L = t[n + (V << 2) >> 2], n = t[L + 24 >> 2];
                        t: {
                          if (n & 4194304)
                            break t;
                          if ((n & 196608) == 131072) {
                            r: {
                              if (!x2(L, T)) {
                                u = t[u2 >> 2];
                                break r;
                              }
                              if (i = Se(L, T, z0), W = W0(e, T), t0 = d0(L, T, M), u = t[u2 >> 2], i = f(t0 + f(i + W)), A[(L + (u << 2) | 0) + 228 >> 2] = i, i == i)
                                break t;
                            }
                            b0 = L + (u << 2) | 0, e2 = f(W0(e, T) + d0(L, T, M)), A[b0 + 228 >> 2] = e2;
                            break t;
                          }
                          u = n >>> 13 & 7, u || (u = t[e + 24 >> 2] >>> 10 & 7);
                          r: {
                            n: {
                              if ((u | 0) == 5) {
                                u = t[e + 24 >> 2] & 8 ? 5 : 1;
                                break n;
                              }
                              if ((u | 0) != 4 || (Me(p + 24 | 0, L, T), u = 4, t[p + 28 >> 2] == 3) || (xe(p + 360 | 0, L, T), t[p + 364 >> 2] == 3))
                                break n;
                              u = L + (t[Y0 >> 2] << 3) | 0, W = A[u + 572 >> 2];
                              f: {
                                o:
                                  switch (n = t[u + 576 >> 2], n | 0) {
                                    case 0:
                                    case 3:
                                      break f;
                                    default:
                                      break o;
                                  }
                                if (t0 = A[u + 572 >> 2], !((n | 0) != 1 | t0 != t0)) {
                                  if (i = j0, W < f(0))
                                    break f;
                                  break r;
                                }
                                if (i = j0, he & !(W < f(0)) | ((n | 0) != 2 | t0 != t0))
                                  break r;
                              }
                              W = A[(L + (t[Ce >> 2] << 2) | 0) + 516 >> 2], i = m, t0 = A[L + 224 >> 2], t0 == t0 && (i = f(f(d0(L, T, M) + C0(L, T, M)) + f(P2 ? W * t0 : W / t0))), A[p + 360 >> 2] = i, b0 = p, e2 = f(W + f(d0(L, $, M) + C0(L, $, M))), A[b0 + 24 >> 2] = e2, t[p + 356 >> 2] = 1, t[p + 352 >> 2] = 1, Ke(L, $, N0, M, p + 356 | 0, p + 24 | 0), Ke(L, T, z0, M, p + 352 | 0, p + 360 | 0), W = A[p + 360 >> 2], t0 = A[p + 24 >> 2], n = $ >>> 0 > 1, i = n ? W : t0, W = n ? t0 : W, n = (ne | 0) != 0 & (t[e + 24 >> 2] & 896) != 512, Le(L, W, i, O2, !(n & P2 | W != W), (!n | P2) & i == i, M, q0, 1, 2, g, S, F, Z), i = j0;
                              break r;
                            }
                            i = A[(L + (t[Y0 >> 2] << 2) | 0) + 516 >> 2], W = d0(L, T, M), t0 = C0(L, T, M), Me(p + 24 | 0, L, T), W = f(C - f(i + f(W + t0)));
                            n: {
                              if (t[p + 28 >> 2] != 3 || (xe(p + 360 | 0, L, T), t[p + 364 >> 2] != 3))
                                break n;
                              i = f(W * f(0.5)), i = f(j0 + (e2 = f(0), tr = g0(i, f(0)), b0 = i != i, b0 ? e2 : tr));
                              break r;
                            }
                            if (xe(p + 24 | 0, L, T), i = j0, t[p + 28 >> 2] == 3)
                              break r;
                            if (Me(p + 24 | 0, L, T), t[p + 28 >> 2] == 3) {
                              i = f(j0 + (e2 = f(0), tr = g0(W, f(0)), b0 = W != W, b0 ? e2 : tr));
                              break r;
                            }
                            n:
                              switch (u - 1 | 0) {
                                case 1:
                                  i = f(j0 + f(W * f(0.5)));
                                  break r;
                                case 0:
                                  break r;
                                default:
                                  break n;
                              }
                            i = f(j0 + W);
                          }
                          n = L + (t[u2 >> 2] << 2) | 0, A[n + 228 >> 2] = i + f(pe + A[n + 228 >> 2]);
                        }
                        if (V = V + 1 | 0, (V | 0) == (d | 0))
                          break;
                      }
                    i = f((W2 ? Nt : f(0)) + m), n = Fe != Fe, r = f(lr + r);
                    t: {
                      if (!(n | r != r)) {
                        Fe = g0(Fe, r);
                        break t;
                      }
                      Fe = n ? r : Fe;
                    }
                    if (pe = f(pe + i), n = W2 + 1 | 0, V = d, !(te >>> 0 > d >>> 0))
                      break;
                  }
                  t: {
                    if (!h || !ne && !gi(e))
                      break t;
                    h0 = f(0);
                    r: {
                      n: {
                        if (z0 != z0)
                          break n;
                        r = f(z0 - pe);
                        f:
                          switch ((t[e + 24 >> 2] >>> 7 & 7) - 2 | 0) {
                            case 0:
                              j0 = f(j0 + f(r * f(0.5)));
                              break n;
                            case 2:
                              if (!(z0 > pe))
                                break n;
                              h0 = f(r / f(n >>> 0));
                              break n;
                            case 5:
                              if (z0 > pe) {
                                if (j0 = f(j0 + f(r / f(n << 1 >>> 0))), n >>> 0 < 2)
                                  break n;
                                h0 = f(r / f(n >>> 0));
                                break r;
                              }
                              j0 = f(j0 + f(r * f(0.5)));
                              break n;
                            case 4:
                              if (!(z0 > pe) | n >>> 0 < 2)
                                break n;
                              h0 = f(r / f(W2 >>> 0));
                              break r;
                            case 1:
                              break f;
                            default:
                              break n;
                          }
                        j0 = f(j0 + r);
                      }
                      if (!n)
                        break t;
                    }
                    for (r0 = 0, n = 0, u = 0; ; ) {
                      if (W = f(0), i = f(0), r = f(0), m = f(0), d = n, te >>> 0 > n >>> 0) {
                        r: {
                          for (; ; ) {
                            if (u = t[e + 556 >> 2], t[e + 560 >> 2] - u >> 2 >>> 0 <= d >>> 0)
                              break i;
                            V = t[u + (d << 2) >> 2], L = t[V + 24 >> 2];
                            n: {
                              if (L & 4194304 | (L & 196608) == 131072)
                                break n;
                              if (u = d, t[V + 548 >> 2] != (r0 | 0))
                                break r;
                              r = A[(V + (t[Y0 >> 2] << 2) | 0) + 516 >> 2];
                              f: {
                                if (!(r >= f(0)))
                                  break f;
                                if (u = i != i, r = f(r + f(d0(V, T, M) + C0(V, T, M))), !(u | r != r)) {
                                  i = g0(i, r);
                                  break f;
                                }
                                i = u ? r : i;
                              }
                              if (u = L >>> 13 & 7, u || (u = t[e + 24 >> 2] >>> 10 & 7), !(X[e + 24 | 0] & 8) | (u | 0) != 5)
                                break n;
                              r = Vr(V), C = d0(V, 0, M), r = f(r + C), C = f(f(A[V + 520 >> 2] + f(d0(V, 0, M) + C0(V, 0, M))) - r), u = i != i, V = m != m;
                              f: {
                                if (!(V | r != r)) {
                                  m = g0(m, r);
                                  break f;
                                }
                                m = V ? r : m;
                              }
                              V = W != W;
                              f: {
                                if (!(V | C != C)) {
                                  W = g0(W, C);
                                  break f;
                                }
                                W = V ? C : W;
                              }
                              if (r = f(m + W), !(u | r != r)) {
                                i = g0(i, r);
                                break n;
                              }
                              i = u ? r : i;
                            }
                            if (d = d + 1 | 0, (te | 0) == (d | 0))
                              break;
                          }
                          u = te;
                        }
                        r = i;
                      }
                      if (C = f(j0 + (r0 ? Nt : f(0))), i = f(h0 + r), j0 = f(C + i), n >>> 0 < u >>> 0)
                        for (t0 = f(C + m); ; ) {
                          if (d = t[e + 556 >> 2], t[e + 560 >> 2] - d >> 2 >>> 0 <= n >>> 0)
                            break i;
                          V = t[d + (n << 2) >> 2], d = t[V + 24 >> 2];
                          r: {
                            if (d & 4194304 | (d & 196608) == 131072)
                              break r;
                            d = d >>> 13 & 7, d || (d = t[e + 24 >> 2] >>> 10 & 7);
                            n: {
                              f:
                                switch (d - 1 | 0) {
                                  case 4:
                                    if (X[e + 24 | 0] & 8)
                                      break n;
                                  case 0:
                                    r = d0(V, T, M), A[(V + (t[u2 >> 2] << 2) | 0) + 228 >> 2] = C + r;
                                    break r;
                                  case 2:
                                    r = C0(V, T, M), d = V + 228 | 0, A[d + (t[u2 >> 2] << 2) >> 2] = f(j0 - r) - A[(d + (t[Y0 >> 2] << 2) | 0) + 288 >> 2];
                                    break r;
                                  case 1:
                                    d = V + 228 | 0, A[d + (t[u2 >> 2] << 2) >> 2] = C + f(f(i - A[(d + (t[Y0 >> 2] << 2) | 0) + 288 >> 2]) * f(0.5));
                                    break r;
                                  case 3:
                                    break f;
                                  default:
                                    break r;
                                }
                              r = d0(V, T, M), A[(V + (t[u2 >> 2] << 2) | 0) + 228 >> 2] = C + r, L = V + (t[Y0 >> 2] << 3) | 0, r = A[L + 572 >> 2];
                              f: {
                                o:
                                  switch (d = t[L + 576 >> 2], d | 0) {
                                    case 0:
                                    case 3:
                                      break f;
                                    default:
                                      break o;
                                  }
                                if (m = A[L + 572 >> 2], !((d | 0) != 1 | m != m)) {
                                  if (r < f(0))
                                    break f;
                                  break r;
                                }
                                if (he & !(r < f(0)) | ((d | 0) != 2 | m != m))
                                  break r;
                              }
                              f: {
                                if ($ >>> 0 >= 2) {
                                  W = i, r = A[V + 516 >> 2], m = f(r + f(d0(V, $, M) + C0(V, $, M)));
                                  break f;
                                }
                                W = f(A[V + 520 >> 2] + f(d0(V, T, M) + C0(V, T, M))), r = A[V + 516 >> 2], m = i;
                              }
                              f: {
                                o: {
                                  if (!(m != m | r != r)) {
                                    if (f($0(f(m - r))) < f(9999999747378752e-20))
                                      break o;
                                    break f;
                                  }
                                  if (m == m | r == r)
                                    break f;
                                }
                                if (r = A[V + 520 >> 2], d = r != r, !(d | W != W)) {
                                  if (!(f($0(f(W - r))) < f(9999999747378752e-20)))
                                    break f;
                                  break r;
                                }
                                if (W == W)
                                  break f;
                                if (d)
                                  break r;
                              }
                              Le(V, m, W, O2, 1, 1, M, q0, 1, 3, g, S, F, Z);
                              break r;
                            }
                            b0 = V, e2 = f(f(t0 - Vr(V)) + Se(V, 0, z0)), A[b0 + 232 >> 2] = e2;
                          }
                          if (n = n + 1 | 0, (u | 0) == (n | 0))
                            break;
                        }
                      if (d = (r0 | 0) != (W2 | 0), r0 = r0 + 1 | 0, n = u, !d)
                        break;
                    }
                  }
                  L = e + 516 | 0, r = K0(e, 2, Et, a), n = r != r, i = f(f(X0(e, 2, a) + W0(e, 2)) + f(H0(e, 2, a) + I0(e, 2)));
                  t: {
                    if (!(n | i != i)) {
                      r = g0(r, i);
                      break t;
                    }
                    r = n ? i : r;
                  }
                  A[L >> 2] = r, r = K0(e, 0, Wt, l), n = r != r, i = f(f(X0(e, 0, a) + W0(e, 0)) + f(H0(e, 0, a) + I0(e, 0)));
                  t: {
                    if (!(n | i != i)) {
                      r = g0(r, i);
                      break t;
                    }
                    r = n ? i : r;
                  }
                  A[e + 520 >> 2] = r;
                  t: {
                    r: {
                      n: {
                        if (Ae && (n = t[e + 24 >> 2] >>> 20 & 3, (n | 0) == 2 | (Ae | 0) != 2))
                          break n;
                        if (r = K0(e, $, Fe, Ie), n = r != r, i = f(f(X0(e, $, a) + W0(e, $)) + f(H0(e, $, a) + I0(e, $))), !(n | i != i)) {
                          r = g0(r, i);
                          break r;
                        }
                        r = n ? i : r;
                        break r;
                      }
                      if ((Ae | 0) != 2 | (n | 0) != 2)
                        break t;
                      i = f(ie + N0), n = i != i, r = K0(e, $, Fe, Ie);
                      n: {
                        if (!(n | r != r)) {
                          r = wt(i, r);
                          break n;
                        }
                        r = n ? r : i;
                      }
                      if (n = r != r, !(n | ie != ie)) {
                        r = g0(r, ie);
                        break r;
                      }
                      r = n ? ie : r;
                    }
                    A[L + (t[Ce >> 2] << 2) >> 2] = r;
                  }
                  t: {
                    r: {
                      n: {
                        if (f0 && (u = (f0 | 0) != 2, n = t[e + 24 >> 2] >>> 20 & 3, u | (n | 0) == 2))
                          break n;
                        if (r = K0(e, T, f(F2 + pe), ar), n = r != r, i = f(f(X0(e, T, a) + W0(e, T)) + f(H0(e, T, a) + I0(e, T))), !(n | i != i)) {
                          r = g0(r, i);
                          break r;
                        }
                        r = n ? i : r;
                        break r;
                      }
                      if (u | (n | 0) != 2)
                        break t;
                      i = f(F2 + z0), n = i != i, r = K0(e, T, f(F2 + pe), ar);
                      n: {
                        if (!(n | r != r)) {
                          r = wt(i, r);
                          break n;
                        }
                        r = n ? r : i;
                      }
                      if (n = r != r, !(n | F2 != F2)) {
                        r = g0(r, F2);
                        break r;
                      }
                      r = n ? F2 : r;
                    }
                    A[L + (t[Y0 >> 2] << 2) >> 2] = r;
                  }
                  t: {
                    if (!h)
                      break t;
                    if ((t[e + 24 >> 2] & 786432) == 524288)
                      for (u = te >>> 0 <= 1 ? 1 : te, h = t[e + 556 >> 2], V = t[e + 560 >> 2] - h >> 2, n = 0; d = 0, d = n >>> 0 < V >>> 0 ? t[h + (n << 2) >> 2] : d, (t[d + 24 >> 2] & 196608) != 131072 && (d = d + 228 | 0, r0 = d + (t[u2 >> 2] << 2) | 0, a0 = t[Y0 >> 2] << 2, A[r0 >> 2] = f(A[a0 + L >> 2] - A[r0 >> 2]) - A[(d + a0 | 0) + 288 >> 2]), n = n + 1 | 0, (u | 0) != (n | 0); )
                        ;
                    if (u = t[e + 556 >> 2], h = t[e + 560 >> 2], (u | 0) != (h | 0))
                      for (r0 = (($ >>> 0 > 1 ? Ae : o) | 0) != 0; ; ) {
                        o = t[u >> 2];
                        r: {
                          if ((t[o + 24 >> 2] & 4390912) != 131072)
                            break r;
                          m = M, N0 = q0, X[t[e + 568 >> 2] + 12 | 0] & 2 && (N0 = A[e + 520 >> 2], m = A[e + 516 >> 2]), n = t[e + 24 >> 2] >>> 2 & 3;
                          n: {
                            f: {
                              if ((O2 | 0) == 2) {
                                V = 0, d = 3;
                                o:
                                  switch (n - 2 | 0) {
                                    case 0:
                                      break n;
                                    case 1:
                                      break o;
                                    default:
                                      break f;
                                  }
                                d = 2;
                                break n;
                              }
                              if (V = 0, n >>> 0 <= 1)
                                break f;
                              d = n;
                              break n;
                            }
                            d = n, V = Oe;
                          }
                          l = f(d0(o, 2, m) + C0(o, 2, m)), a = d0(o, 0, m), W = C0(o, 0, m), r = A[o + 572 >> 2];
                          n: {
                            f: {
                              o:
                                switch (n = t[o + 576 >> 2], n | 0) {
                                  case 0:
                                  case 3:
                                    break f;
                                  default:
                                    break o;
                                }
                              i = A[o + 572 >> 2];
                              o: {
                                if (!((n | 0) != 1 | i != i)) {
                                  if (i = r, !(r < f(0)))
                                    break o;
                                  break f;
                                }
                                u: {
                                  if (!((n | 0) != 2 | i != i)) {
                                    if (m != m | r < f(0))
                                      break f;
                                    break u;
                                  }
                                  i = f(s0);
                                  s:
                                    switch (n - 1 | 0) {
                                      case 1:
                                        break u;
                                      case 0:
                                        break s;
                                      default:
                                        break o;
                                    }
                                  i = r;
                                  break o;
                                }
                                i = f(f(m * r) * f(0.009999999776482582));
                              }
                              i = f(l + i);
                              break n;
                            }
                            if (i = f(s0), !x2(o, 2) || !Br(o, 2))
                              break n;
                            if (r = K0(o, 2, f(f(A[e + 516 >> 2] - f(W0(e, 2) + I0(e, 2))) - f(Se(o, 2, m) + or(o, 2, m))), m), n = r != r, i = f(f(X0(o, 2, m) + W0(o, 2)) + f(H0(o, 2, m) + I0(o, 2))), !(n | i != i)) {
                              i = g0(r, i);
                              break n;
                            }
                            i = n ? i : r;
                          }
                          W = f(a + W);
                          n: {
                            f: {
                              o: {
                                u: {
                                  s: {
                                    a: {
                                      l: {
                                        a0 = i != i, a = A[o + 580 >> 2];
                                        A: {
                                          k: {
                                            h:
                                              switch (n = t[o + 584 >> 2], n | 0) {
                                                case 0:
                                                case 3:
                                                  break k;
                                                default:
                                                  break h;
                                              }
                                            r = A[o + 580 >> 2];
                                            h: {
                                              if (!((n | 0) != 1 | r != r)) {
                                                if (r = a, !(r < f(0)))
                                                  break h;
                                                break k;
                                              }
                                              v: {
                                                if (!((n | 0) != 2 | r != r)) {
                                                  if (N0 != N0 | a < f(0))
                                                    break k;
                                                  break v;
                                                }
                                                r = f(s0);
                                                m:
                                                  switch (n - 1 | 0) {
                                                    case 1:
                                                      break v;
                                                    case 0:
                                                      break m;
                                                    default:
                                                      break h;
                                                  }
                                                r = a;
                                                break h;
                                              }
                                              r = f(f(N0 * a) * f(0.009999999776482582));
                                            }
                                            r = f(W + r);
                                            break A;
                                          }
                                          k: {
                                            if (x2(o, 0) && Br(o, 0))
                                              break k;
                                            if (r = f(s0), i == i)
                                              break l;
                                            break o;
                                          }
                                          if (r = K0(o, 0, f(f(A[e + 520 >> 2] - f(W0(e, 0) + I0(e, 0))) - f(Se(o, 0, N0) + or(o, 0, N0))), N0), n = r != r, a = f(f(X0(o, 0, m) + W0(o, 0)) + f(H0(o, 0, m) + I0(o, 0))), !(n | a != a)) {
                                            r = g0(r, a);
                                            break A;
                                          }
                                          r = n ? a : r;
                                        }
                                        if ((a0 | 0) == (r != r | 0) || (C = A[o + 224 >> 2], C != C))
                                          break s;
                                        if (i != i) {
                                          i = f(f(f(r - W) * C) + l);
                                          break s;
                                        }
                                        if (r == r)
                                          break s;
                                        break a;
                                      }
                                      if (C = A[o + 224 >> 2], C != C)
                                        break u;
                                    }
                                    r = f(W + f(f(i - l) / C));
                                  }
                                  if (i != i)
                                    break o;
                                  if (r == r)
                                    break n;
                                }
                                n = 0;
                                break f;
                              }
                              n = 1;
                            }
                            a0 = m > f(0), W2 = n & r0 & d >>> 0 < 2, i = W2 && a0 ? m : i, n = n ^ 1, Le(o, i, r, O2, W2 && a0 ? 2 : n, r == r, i, r, 0, 6, g, S, F, Z), i = f(A[o + 516 >> 2] + Hi(o, 2, m)), r = f(A[o + 520 >> 2] + Hi(o, 0, m));
                          }
                          Le(o, i, r, O2, 1, 1, i, r, 1, 1, g, S, F, Z);
                          n: {
                            f: {
                              o: {
                                if (!Br(o, d) || x2(o, d))
                                  break o;
                                n = t[(d << 2) + 4320 >> 2] << 2, r = d >>> 0 < 2 ? N0 : m, r = f(f(f(f(A[n + L >> 2] - A[(n + o | 0) + 516 >> 2]) - I0(e, d)) - C0(o, d, r)) - or(o, d, r));
                                break f;
                              }
                              if (!(x2(o, d) | (t[e + 24 >> 2] & 112) != 16)) {
                                n = t[(d << 2) + 4320 >> 2] << 2, r = f(f(A[n + L >> 2] - A[(n + o | 0) + 516 >> 2]) * f(0.5));
                                break f;
                              }
                              if (!(x2(o, d) | (t[e + 24 >> 2] & 112) != 32)) {
                                n = t[(d << 2) + 4320 >> 2] << 2, r = f(A[n + L >> 2] - A[(n + o | 0) + 516 >> 2]);
                                break f;
                              }
                              if (!(X[t[e + 568 >> 2] + 12 | 0] & 2) || !x2(o, d))
                                break n;
                              r = A[L + (t[(d << 2) + 4320 >> 2] << 2) >> 2], r = f(f(Se(o, d, r) + W0(e, d)) + d0(o, d, r));
                            }
                            A[(o + (t[(d << 2) + 4288 >> 2] << 2) | 0) + 228 >> 2] = r;
                          }
                          n: {
                            f: {
                              if (!Br(o, V) || x2(o, V))
                                break f;
                              n = t[(V << 2) + 4320 >> 2] << 2, r = d >>> 0 < 2 ? m : N0, r = f(f(f(f(A[n + L >> 2] - A[(n + o | 0) + 516 >> 2]) - I0(e, V)) - C0(o, V, r)) - or(o, V, r));
                              break n;
                            }
                            f: {
                              if (x2(o, V) || (n = t[o + 24 >> 2] >>> 13 & 7, n || (n = t[e + 24 >> 2] >>> 10 & 7), (n | 0) != 2))
                                break f;
                              n = t[(V << 2) + 4320 >> 2] << 2, r = f(f(A[n + L >> 2] - A[(n + o | 0) + 516 >> 2]) * f(0.5));
                              break n;
                            }
                            f: {
                              if (x2(o, V))
                                break f;
                              d = t[o + 24 >> 2] >>> 13 & 7, n = t[e + 24 >> 2], d = d || n >>> 10 & 7;
                              o: {
                                if ((d | 0) == 5) {
                                  if ((n & 786432) == 524288)
                                    break o;
                                  break f;
                                }
                                if (((d | 0) == 3 | 0) == ((n & 786432) == 524288 | 0))
                                  break f;
                              }
                              n = t[(V << 2) + 4320 >> 2] << 2, r = f(A[n + L >> 2] - A[(n + o | 0) + 516 >> 2]);
                              break n;
                            }
                            if (!(X[t[e + 568 >> 2] + 12 | 0] & 2) || !x2(o, V))
                              break r;
                            r = A[L + (t[(V << 2) + 4320 >> 2] << 2) >> 2], r = f(f(Se(o, V, r) + W0(e, V)) + d0(o, V, r));
                          }
                          A[(o + (t[(V << 2) + 4288 >> 2] << 2) | 0) + 228 >> 2] = r;
                        }
                        if (u = u + 4 | 0, (h | 0) == (u | 0))
                          break;
                      }
                    if (!((T | $) & 1))
                      break t;
                    for (u = T & 1, h = $ & 1, g = te >>> 0 <= 1 ? 1 : te, S = (T << 2) + 4304 | 0, F = ($ << 2) + 4304 | 0, Z = t[e + 556 >> 2], T = t[e + 560 >> 2] - Z >> 2, e = 0; ; ) {
                      if ((e | 0) == (T | 0))
                        break i;
                      n = t[Z + (e << 2) >> 2];
                      r: {
                        if (X[n + 26 | 0] & 64 || (h && (o = n + 228 | 0, d = t[Ce >> 2] << 2, A[o + (t[F >> 2] << 2) >> 2] = f(A[d + L >> 2] - A[(o + d | 0) + 288 >> 2]) - A[o + (t[Q2 >> 2] << 2) >> 2]), !u))
                          break r;
                        n = n + 228 | 0, o = t[Y0 >> 2] << 2, A[n + (t[S >> 2] << 2) >> 2] = f(A[o + L >> 2] - A[(n + o | 0) + 288 >> 2]) - A[n + (t[u2 >> 2] << 2) >> 2];
                      }
                      if (e = e + 1 | 0, (g | 0) == (e | 0))
                        break;
                    }
                  }
                  if (!N2)
                    break e;
                  p2(N2);
                  break e;
                }
                Ze(), V0();
              }
              H = p + 384 | 0;
            }
            function ii() {
              var e = 0, r = 0;
              $e(7032, 7033, 7034, 0, 4352, 17, 4355, 0, 4355, 0, 2529, 4357, 18), e = B(8), t[e >> 2] = 8, t[e + 4 >> 2] = 1, D(7032, 2922, 6, 4368, 4392, 19, e | 0, 1), $e(7036, 7037, 7038, 7032, 4352, 20, 4352, 21, 4352, 22, 2001, 4357, 23), e = B(4), t[e >> 2] = 24, D(7036, 2359, 2, 4400, 4408, 25, e | 0, 0), ke(7032, 1398, 2, 4412, 4420, 26, 27), ke(7032, 3027, 3, 4500, 4512, 28, 29), $e(7056, 7057, 7058, 0, 4352, 30, 4355, 0, 4355, 0, 2545, 4357, 31), e = B(8), t[e >> 2] = 8, t[e + 4 >> 2] = 1, D(7056, 3293, 2, 4520, 4408, 32, e | 0, 1), $e(7059, 7060, 7061, 7056, 4352, 33, 4352, 34, 4352, 35, 2024, 4357, 36), e = B(4), t[e >> 2] = 37, D(7059, 2359, 2, 4528, 4408, 38, e | 0, 0), ke(7056, 1398, 2, 4536, 4420, 39, 40), ke(7056, 3027, 3, 4500, 4512, 28, 41), $e(7062, 7063, 7064, 0, 4352, 42, 4355, 0, 4355, 0, 2861, 4357, 43), ei(7062, 1, 4584, 4352, 44, 45), ke(7062, 2915, 1, 4584, 4352, 44, 45), ke(7062, 1129, 2, 4588, 4408, 46, 47), e = B(8), t[e + 4 >> 2] = 0, t[e >> 2] = 48, D(7062, 3234, 4, 4608, 4624, 49, e | 0, 0), e = B(8), t[e + 4 >> 2] = 0, t[e >> 2] = 50, D(7062, 1981, 3, 4632, 4644, 51, e | 0, 0), e = B(8), t[e + 4 >> 2] = 0, t[e >> 2] = 52, D(7062, 1952, 3, 4652, 4664, 53, e | 0, 0), e = B(8), t[e + 4 >> 2] = 0, t[e >> 2] = 54, D(7062, 3389, 3, 4672, 4664, 55, e | 0, 0), e = B(8), t[e + 4 >> 2] = 0, t[e >> 2] = 56, D(7062, 1800, 3, 4652, 4664, 53, e | 0, 0), e = B(8), t[e + 4 >> 2] = 0, t[e >> 2] = 57, D(7062, 3264, 3, 4684, 4512, 58, e | 0, 0), e = B(8), t[e + 4 >> 2] = 0, t[e >> 2] = 59, D(7062, 1926, 2, 4696, 4420, 60, e | 0, 0), e = B(8), t[e + 4 >> 2] = 0, t[e >> 2] = 61, D(7062, 3399, 2, 4704, 4420, 62, e | 0, 0), e = B(8), t[e + 4 >> 2] = 0, t[e >> 2] = 63, D(7062, 1785, 2, 4696, 4420, 60, e | 0, 0), ut(7065, 1271, 4712, 64, 4357, 65), rr(1732, 0), rr(1612, 8), rr(2145, 16), rr(2455, 24), rr(2561, 32), rr(1618, 40), ot(7065), ut(7035, 2898, 4712, 66, 4357, 67), Ii(2561, 0), Ii(1618, 8), ot(7035), ut(7066, 2909, 4712, 68, 4357, 69), e = B(4), t[e >> 2] = 8, r = B(4), t[r >> 2] = 8, Tr(7066, 2903, 7098, 4714, 70, e | 0, 7098, 4718, 71, r | 0), e = B(4), t[e >> 2] = 0, r = B(4), t[r >> 2] = 0, Tr(7066, 1607, 7091, 4420, 72, e | 0, 7091, 4664, 73, r | 0), ot(7066), $e(7067, 7068, 7069, 0, 4352, 74, 4355, 0, 4355, 0, 3022, 4357, 75), ei(7067, 1, 4724, 4352, 76, 77), ke(7067, 1593, 1, 4724, 4352, 76, 77), ke(7067, 2851, 2, 4728, 4420, 78, 79), ke(7067, 1129, 2, 4736, 4408, 80, 81), e = B(8), t[e + 4 >> 2] = 0, t[e >> 2] = 82, D(7067, 1753, 2, 4736, 4408, 83, e | 0, 0), e = B(8), t[e + 4 >> 2] = 0, t[e >> 2] = 84, D(7067, 3005, 3, 4744, 4664, 85, e | 0, 0), e = B(8), t[e + 4 >> 2] = 0, t[e >> 2] = 86, D(7067, 2930, 3, 4756, 4664, 87, e | 0, 0), e = B(8), t[e + 4 >> 2] = 0, t[e >> 2] = 88, D(7067, 2335, 4, 4768, 4784, 89, e | 0, 0), e = B(8), t[e + 4 >> 2] = 0, t[e >> 2] = 90, D(7067, 1485, 4, 4768, 4784, 89, e | 0, 0), e = B(8), t[e + 4 >> 2] = 0, t[e >> 2] = 91, D(7067, 1356, 3, 4756, 4664, 87, e | 0, 0), e = B(8), t[e + 4 >> 2] = 0, t[e >> 2] = 92, D(7067, 1818, 3, 4756, 4664, 87, e | 0, 0), e = B(8), t[e + 4 >> 2] = 0, t[e >> 2] = 93, D(7067, 2872, 3, 4756, 4664, 87, e | 0, 0), e = B(8), t[e + 4 >> 2] = 0, t[e >> 2] = 94, D(7067, 2379, 3, 4756, 4664, 87, e | 0, 0), e = B(8), t[e + 4 >> 2] = 0, t[e >> 2] = 95, D(7067, 2164, 3, 4756, 4664, 87, e | 0, 0), e = B(8), t[e + 4 >> 2] = 0, t[e >> 2] = 96, D(7067, 1320, 3, 4756, 4664, 87, e | 0, 0), e = B(8), t[e + 4 >> 2] = 0, t[e >> 2] = 97, D(7067, 2413, 4, 4768, 4784, 89, e | 0, 0), e = B(8), t[e + 4 >> 2] = 0, t[e >> 2] = 98, D(7067, 1504, 4, 4768, 4784, 89, e | 0, 0), e = B(8), t[e + 4 >> 2] = 0, t[e >> 2] = 99, D(7067, 2236, 3, 4756, 4664, 87, e | 0, 0), e = B(8), t[e + 4 >> 2] = 0, t[e >> 2] = 100, D(7067, 1220, 3, 4756, 4664, 87, e | 0, 0), e = B(8), t[e + 4 >> 2] = 0, t[e >> 2] = 101, D(7067, 1137, 3, 4756, 4664, 87, e | 0, 0), e = B(8), t[e + 4 >> 2] = 0, t[e >> 2] = 102, D(7067, 1159, 3, 4792, 4718, 103, e | 0, 0), e = B(8), t[e + 4 >> 2] = 0, t[e >> 2] = 104, D(7067, 1846, 3, 4792, 4718, 103, e | 0, 0), e = B(8), t[e + 4 >> 2] = 0, t[e >> 2] = 105, D(7067, 1465, 3, 4792, 4718, 103, e | 0, 0), e = B(8), t[e + 4 >> 2] = 0, t[e >> 2] = 106, D(7067, 2219, 2, 4736, 4408, 83, e | 0, 0), e = B(8), t[e + 4 >> 2] = 0, t[e >> 2] = 107, D(7067, 1196, 3, 4792, 4718, 103, e | 0, 0), e = B(8), t[e + 4 >> 2] = 0, t[e >> 2] = 108, D(7067, 2501, 3, 4792, 4718, 103, e | 0, 0), e = B(8), t[e + 4 >> 2] = 0, t[e >> 2] = 109, D(7067, 2591, 3, 4792, 4718, 103, e | 0, 0), e = B(8), t[e + 4 >> 2] = 0, t[e >> 2] = 110, D(7067, 1540, 3, 4792, 4718, 103, e | 0, 0), e = B(8), t[e + 4 >> 2] = 0, t[e >> 2] = 111, D(7067, 2250, 2, 4736, 4408, 83, e | 0, 0), e = B(8), t[e + 4 >> 2] = 0, t[e >> 2] = 112, D(7067, 1651, 3, 4792, 4718, 103, e | 0, 0), e = B(8), t[e + 4 >> 2] = 0, t[e >> 2] = 113, D(7067, 1428, 3, 4792, 4718, 103, e | 0, 0), e = B(8), t[e + 4 >> 2] = 0, t[e >> 2] = 114, D(7067, 2205, 2, 4736, 4408, 83, e | 0, 0), e = B(8), t[e + 4 >> 2] = 0, t[e >> 2] = 115, D(7067, 2609, 3, 4792, 4718, 103, e | 0, 0), e = B(8), t[e + 4 >> 2] = 0, t[e >> 2] = 116, D(7067, 1556, 3, 4792, 4718, 103, e | 0, 0), e = B(8), t[e + 4 >> 2] = 0, t[e >> 2] = 117, D(7067, 1671, 3, 4792, 4718, 103, e | 0, 0), e = B(8), t[e + 4 >> 2] = 0, t[e >> 2] = 118, D(7067, 1445, 3, 4792, 4718, 103, e | 0, 0), e = B(8), t[e + 4 >> 2] = 0, t[e >> 2] = 119, D(7067, 2567, 3, 4792, 4718, 103, e | 0, 0), e = B(8), t[e + 4 >> 2] = 0, t[e >> 2] = 120, D(7067, 1521, 3, 4792, 4718, 103, e | 0, 0), e = B(8), t[e + 4 >> 2] = 0, t[e >> 2] = 121, D(7067, 1625, 3, 4792, 4718, 103, e | 0, 0), e = B(8), t[e + 4 >> 2] = 0, t[e >> 2] = 122, D(7067, 1408, 3, 4792, 4718, 103, e | 0, 0), e = B(8), t[e + 4 >> 2] = 0, t[e >> 2] = 123, D(7067, 2305, 3, 4792, 4718, 103, e | 0, 0), e = B(8), t[e + 4 >> 2] = 0, t[e >> 2] = 124, D(7067, 2093, 4, 4768, 4784, 89, e | 0, 0), e = B(8), t[e + 4 >> 2] = 0, t[e >> 2] = 125, D(7067, 2719, 4, 4768, 4784, 89, e | 0, 0), e = B(8), t[e + 4 >> 2] = 0, t[e >> 2] = 126, D(7067, 1575, 4, 4768, 4784, 89, e | 0, 0), e = B(8), t[e + 4 >> 2] = 0, t[e >> 2] = 127, D(7067, 2188, 4, 4768, 4784, 89, e | 0, 0), e = B(8), t[e + 4 >> 2] = 0, t[e >> 2] = 128, D(7067, 2946, 2, 4804, 4420, 129, e | 0, 0), e = B(8), t[e + 4 >> 2] = 0, t[e >> 2] = 130, D(7067, 2347, 3, 4812, 4512, 131, e | 0, 0), e = B(8), t[e + 4 >> 2] = 0, t[e >> 2] = 132, D(7067, 1372, 2, 4804, 4420, 129, e | 0, 0), e = B(8), t[e + 4 >> 2] = 0, t[e >> 2] = 133, D(7067, 1832, 2, 4804, 4420, 129, e | 0, 0), e = B(8), t[e + 4 >> 2] = 0, t[e >> 2] = 134, D(7067, 2885, 2, 4804, 4420, 129, e | 0, 0), e = B(8), t[e + 4 >> 2] = 0, t[e >> 2] = 135, D(7067, 2396, 2, 4804, 4420, 129, e | 0, 0), e = B(8), t[e + 4 >> 2] = 0, t[e >> 2] = 136, D(7067, 2176, 2, 4804, 4420, 129, e | 0, 0), e = B(8), t[e + 4 >> 2] = 0, t[e >> 2] = 137, D(7067, 1338, 2, 4804, 4420, 129, e | 0, 0), e = B(8), t[e + 4 >> 2] = 0, t[e >> 2] = 138, D(7067, 2423, 3, 4812, 4512, 131, e | 0, 0), e = B(8), t[e + 4 >> 2] = 0, t[e >> 2] = 139, D(7067, 1859, 2, 4824, 4420, 140, e | 0, 0), e = B(8), t[e + 4 >> 2] = 0, t[e >> 2] = 141, D(7067, 1208, 2, 4832, 4714, 142, e | 0, 0), e = B(8), t[e + 4 >> 2] = 0, t[e >> 2] = 143, D(7067, 2515, 2, 4832, 4714, 142, e | 0, 0), e = B(8), t[e + 4 >> 2] = 0, t[e >> 2] = 144, D(7067, 2600, 2, 4824, 4420, 140, e | 0, 0), e = B(8), t[e + 4 >> 2] = 0, t[e >> 2] = 145, D(7067, 1661, 2, 4824, 4420, 140, e | 0, 0), e = B(8), t[e + 4 >> 2] = 0, t[e >> 2] = 146, D(7067, 2621, 2, 4824, 4420, 140, e | 0, 0), e = B(8), t[e + 4 >> 2] = 0, t[e >> 2] = 147, D(7067, 1684, 2, 4824, 4420, 140, e | 0, 0), e = B(8), t[e + 4 >> 2] = 0, t[e >> 2] = 148, D(7067, 2579, 2, 4824, 4420, 140, e | 0, 0), e = B(8), t[e + 4 >> 2] = 0, t[e >> 2] = 149, D(7067, 1638, 2, 4824, 4420, 140, e | 0, 0), e = B(8), t[e + 4 >> 2] = 0, t[e >> 2] = 150, D(7067, 2320, 2, 4832, 4714, 142, e | 0, 0), e = B(8), t[e + 4 >> 2] = 0, t[e >> 2] = 151, D(7067, 2103, 3, 4840, 4852, 152, e | 0, 0), e = B(8), t[e + 4 >> 2] = 0, t[e >> 2] = 153, D(7067, 1232, 2, 4804, 4420, 129, e | 0, 0), e = B(8), t[e + 4 >> 2] = 0, t[e >> 2] = 154, D(7067, 1148, 2, 4804, 4420, 129, e | 0, 0), e = B(8), t[e + 4 >> 2] = 0, t[e >> 2] = 155, D(7067, 2730, 3, 4812, 4512, 131, e | 0, 0), e = B(8), t[e + 4 >> 2] = 0, t[e >> 2] = 156, D(7067, 2195, 3, 4860, 4872, 157, e | 0, 0), e = B(8), t[e + 4 >> 2] = 0, t[e >> 2] = 158, D(7067, 3034, 4, 4880, 4624, 159, e | 0, 0), e = B(8), t[e + 4 >> 2] = 0, t[e >> 2] = 160, D(7067, 3055, 3, 4896, 4664, 161, e | 0, 0), e = B(8), t[e + 4 >> 2] = 0, t[e >> 2] = 162, D(7067, 1293, 2, 4908, 4420, 163, e | 0, 0), e = B(8), t[e + 4 >> 2] = 0, t[e >> 2] = 164, D(7067, 1388, 2, 4916, 4420, 165, e | 0, 0), e = B(8), t[e + 4 >> 2] = 0, t[e >> 2] = 166, D(7067, 3046, 3, 4924, 4512, 167, e | 0, 0), e = B(8), t[e + 4 >> 2] = 0, t[e >> 2] = 168, D(7067, 2962, 2, 4936, 4420, 169, e | 0, 0), e = B(8), t[e + 4 >> 2] = 0, t[e >> 2] = 170, D(7067, 2982, 3, 4944, 4664, 171, e | 0, 0), e = B(8), t[e + 4 >> 2] = 0, t[e >> 2] = 172, D(7067, 3357, 3, 4956, 4664, 173, e | 0, 0), e = B(8), t[e + 4 >> 2] = 0, t[e >> 2] = 174, D(7067, 3355, 2, 4736, 4408, 83, e | 0, 0), e = B(8), t[e + 4 >> 2] = 0, t[e >> 2] = 175, D(7067, 3374, 3, 4968, 4664, 176, e | 0, 0), e = B(8), t[e + 4 >> 2] = 0, t[e >> 2] = 177, D(7067, 3372, 2, 4736, 4408, 83, e | 0, 0), e = B(8), t[e + 4 >> 2] = 0, t[e >> 2] = 178, D(7067, 1119, 2, 4736, 4408, 83, e | 0, 0), e = B(8), t[e + 4 >> 2] = 0, t[e >> 2] = 179, D(7067, 1111, 2, 4980, 4420, 180, e | 0, 0), e = B(8), t[e + 4 >> 2] = 0, t[e >> 2] = 181, D(7067, 1244, 5, 4992, 5012, 182, e | 0, 0), e = B(8), t[e + 4 >> 2] = 0, t[e >> 2] = 183, D(7067, 1737, 2, 4832, 4714, 142, e | 0, 0), e = B(8), t[e + 4 >> 2] = 0, t[e >> 2] = 184, D(7067, 1715, 2, 4832, 4714, 142, e | 0, 0), e = B(8), t[e + 4 >> 2] = 0, t[e >> 2] = 185, D(7067, 2149, 2, 4832, 4714, 142, e | 0, 0), e = B(8), t[e + 4 >> 2] = 0, t[e >> 2] = 186, D(7067, 2462, 2, 4832, 4714, 142, e | 0, 0), e = B(8), t[e + 4 >> 2] = 0, t[e >> 2] = 187, D(7067, 2633, 2, 4832, 4714, 142, e | 0, 0), e = B(8), t[e + 4 >> 2] = 0, t[e >> 2] = 188, D(7067, 1697, 2, 4832, 4714, 142, e | 0, 0), e = B(8), t[e + 4 >> 2] = 0, t[e >> 2] = 189, D(7067, 1260, 2, 5020, 4420, 190, e | 0, 0), e = B(8), t[e + 4 >> 2] = 0, t[e >> 2] = 191, D(7067, 2433, 3, 4840, 4852, 152, e | 0, 0), e = B(8), t[e + 4 >> 2] = 0, t[e >> 2] = 192, D(7067, 2113, 3, 4840, 4852, 152, e | 0, 0), e = B(8), t[e + 4 >> 2] = 0, t[e >> 2] = 193, D(7067, 2741, 3, 4840, 4852, 152, e | 0, 0);
            }
            function l1(e, r, i, n, o, u) {
              e = e | 0, r = +r, i = i | 0, n = n | 0, o = o | 0, u = u | 0;
              var a = 0, l = 0, h = 0, g = 0, S = 0, F = 0, Z = 0, T = 0, p = 0, m = 0, d = 0, W = 0, V = 0, C = 0, L = 0, M = 0, $ = 0, r0 = 0, t0 = 0;
              Z = H - 560 | 0, H = Z, t[Z + 44 >> 2] = 0, R2(+r), a = R0(1) | 0, R0(0) | 0;
              e: {
                if ((a | 0) < 0) {
                  V = 1, r0 = 1177, r = -r, R2(+r), a = R0(1) | 0, R0(0) | 0;
                  break e;
                }
                if (o & 2048) {
                  V = 1, r0 = 1180;
                  break e;
                }
                V = o & 1, r0 = V ? 1183 : 1178, t0 = !V;
              }
              e: {
                if ((a & 2146435072) == 2146435072) {
                  a = V + 3 | 0, w2(e, 32, i, a, o & -65537), l2(e, r0, V), n = u & 32, l2(e, r != r ? n ? 2451 : 3459 : n ? 2868 : 3463, 3), w2(e, 32, i, a, o ^ 8192), T = (i | 0) < (a | 0) ? a : i;
                  break e;
                }
                L = Z + 16 | 0;
                i: {
                  t: {
                    r: {
                      if (r = Ri(r, Z + 44 | 0), r = r + r, r != 0) {
                        if (a = t[Z + 44 >> 2], t[Z + 44 >> 2] = a - 1, M = u | 32, (M | 0) != 97)
                          break r;
                        break i;
                      }
                      if (M = u | 32, (M | 0) == 97)
                        break i;
                      S = t[Z + 44 >> 2], F = (n | 0) < 0 ? 6 : n;
                      break t;
                    }
                    S = a - 29 | 0, t[Z + 44 >> 2] = S, r = r * 268435456, F = (n | 0) < 0 ? 6 : n;
                  }
                  for (d = (Z + 48 | 0) + ((S | 0) >= 0 ? 288 : 0) | 0, l = d; r < 4294967296 & r >= 0 ? n = ~~r >>> 0 : n = 0, t[l >> 2] = n, l = l + 4 | 0, r = (r - +(n >>> 0)) * 1e9, r != 0; )
                    ;
                  t: {
                    if ((S | 0) <= 0) {
                      n = S, a = l, h = d;
                      break t;
                    }
                    for (h = d, n = S; ; ) {
                      p = (n | 0) >= 29 ? 29 : n, a = l - 4 | 0;
                      r: {
                        if (h >>> 0 > a >>> 0)
                          break r;
                        for (n = 0; g = t[a >> 2], $ = n, n = p & 31, (p & 63) >>> 0 >= 32 ? (T = g << n, n = 0) : (T = (1 << n) - 1 & g >>> 32 - n, n = g << n), $ = $ + n | 0, g = T + m | 0, n = ai($, n >>> 0 > $ >>> 0 ? g + 1 | 0 : g, 1e9), g = pt(n, G2, -1e9, 0) + $ | 0, t[a >> 2] = g, a = a - 4 | 0, h >>> 0 <= a >>> 0; )
                          ;
                        if (!n)
                          break r;
                        h = h - 4 | 0, t[h >> 2] = n;
                      }
                      for (; a = l, h >>> 0 < a >>> 0 && (l = a - 4 | 0, !t[l >> 2]); )
                        ;
                      if (n = t[Z + 44 >> 2] - p | 0, t[Z + 44 >> 2] = n, l = a, !((n | 0) > 0))
                        break;
                    }
                  }
                  if ((n | 0) < 0)
                    for (C = ((F + 25 >>> 0) / 9 | 0) + 1 | 0, m = (M | 0) == 102; ; ) {
                      n = 0 - n | 0, T = (n | 0) >= 9 ? 9 : n;
                      t: {
                        if (a >>> 0 <= h >>> 0) {
                          l = t[h >> 2];
                          break t;
                        }
                        for (p = 1e9 >>> T | 0, g = -1 << T ^ -1, n = 0, l = h; $ = n, n = t[l >> 2], t[l >> 2] = $ + (n >>> T | 0), n = J0(p, n & g), l = l + 4 | 0, l >>> 0 < a >>> 0; )
                          ;
                        if (l = t[h >> 2], !n)
                          break t;
                        t[a >> 2] = n, a = a + 4 | 0;
                      }
                      if (n = T + t[Z + 44 >> 2] | 0, t[Z + 44 >> 2] = n, h = (!l << 2) + h | 0, l = m ? d : h, a = a - l >> 2 > (C | 0) ? l + (C << 2) | 0 : a, !((n | 0) < 0))
                        break;
                    }
                  n = 0;
                  t: {
                    if (a >>> 0 <= h >>> 0 || (n = J0(d - h >> 2, 9), l = 10, g = t[h >> 2], g >>> 0 < 10))
                      break t;
                    for (; n = n + 1 | 0, l = J0(l, 10), g >>> 0 >= l >>> 0; )
                      ;
                  }
                  if (l = (F - ((M | 0) != 102 ? n : 0) | 0) - ((M | 0) == 103 & (F | 0) != 0) | 0, (l | 0) < (J0(a - d >> 2, 9) - 9 | 0)) {
                    if (p = l + 9216 | 0, g = (p | 0) / 9 | 0, S = ((((S | 0) < 0 ? 4 : 292) + Z | 0) + (g << 2) | 0) - 4048 | 0, l = 10, T = p + J0(g, -9) | 0, (T | 0) <= 7)
                      for (; l = J0(l, 10), T = T + 1 | 0, (T | 0) != 8; )
                        ;
                    p = t[S >> 2], C = (p >>> 0) / (l >>> 0) | 0, m = J0(C, l), g = S + 4 | 0;
                    t: {
                      if ((p | 0) == (m | 0) & (g | 0) == (a | 0))
                        break t;
                      p = p - m | 0;
                      r: {
                        if (!(C & 1) && (r = 9007199254740992, !(P[S - 4 | 0] & 1) | ((l | 0) != 1e9 | h >>> 0 >= S >>> 0)))
                          break r;
                        r = 9007199254740994;
                      }
                      if (W = (a | 0) == (g | 0) ? 1 : 1.5, g = l >>> 1 | 0, W = g >>> 0 > p >>> 0 ? 0.5 : (g | 0) == (p | 0) ? W : 1.5, X[r0 | 0] != 45 | t0 || (W = -W, r = -r), t[S >> 2] = m, r + W == r)
                        break t;
                      if (n = l + m | 0, t[S >> 2] = n, n >>> 0 >= 1e9)
                        for (; t[S >> 2] = 0, S = S - 4 | 0, S >>> 0 < h >>> 0 && (h = h - 4 | 0, t[h >> 2] = 0), n = t[S >> 2] + 1 | 0, t[S >> 2] = n, n >>> 0 > 999999999; )
                          ;
                      if (n = J0(d - h >> 2, 9), l = 10, g = t[h >> 2], g >>> 0 < 10)
                        break t;
                      for (; n = n + 1 | 0, l = J0(l, 10), g >>> 0 >= l >>> 0; )
                        ;
                    }
                    l = S + 4 | 0, a = a >>> 0 > l >>> 0 ? l : a;
                  }
                  for (; g = a, p = a >>> 0 <= h >>> 0, !p && (a = g - 4 | 0, !t[a >> 2]); )
                    ;
                  t: {
                    if ((M | 0) != 103) {
                      S = o & 8;
                      break t;
                    }
                    if (l = F || 1, a = (l | 0) > (n | 0) & (n | 0) > -5, F = (a ? n ^ -1 : -1) + l | 0, u = (a ? -1 : -2) + u | 0, S = o & 8, S)
                      break t;
                    a = -9;
                    r: {
                      if (p || (S = t[g - 4 >> 2], !S) || (T = 10, a = 0, (S >>> 0) % 10 | 0))
                        break r;
                      for (; l = a, a = a + 1 | 0, T = J0(T, 10), !((S >>> 0) % (T >>> 0) | 0); )
                        ;
                      a = l ^ -1;
                    }
                    if (l = J0(g - d >> 2, 9), (u & -33) == 70) {
                      S = 0, a = (a + l | 0) - 9 | 0, a = (a | 0) > 0 ? a : 0, F = (a | 0) > (F | 0) ? F : a;
                      break t;
                    }
                    S = 0, a = ((n + l | 0) + a | 0) - 9 | 0, a = (a | 0) > 0 ? a : 0, F = (a | 0) > (F | 0) ? F : a;
                  }
                  if (T = -1, p = S | F, ((p ? 2147483645 : 2147483646) | 0) < (F | 0))
                    break e;
                  m = (((p | 0) != 0) + F | 0) + 1 | 0, l = u & -33;
                  t: {
                    if ((l | 0) == 70) {
                      if ((m ^ 2147483647) < (n | 0))
                        break e;
                      a = (n | 0) > 0 ? n : 0;
                      break t;
                    }
                    if (a = n >> 31, a = qe((a ^ n) - a | 0, 0, L), (L - a | 0) <= 1)
                      for (; a = a - 1 | 0, P[a | 0] = 48, (L - a | 0) < 2; )
                        ;
                    if (C = a - 2 | 0, P[C | 0] = u, P[a - 1 | 0] = (n | 0) < 0 ? 45 : 43, a = L - C | 0, (a | 0) > (m ^ 2147483647))
                      break e;
                  }
                  if (n = a + m | 0, (n | 0) > (V ^ 2147483647))
                    break e;
                  m = n + V | 0, w2(e, 32, i, m, o), l2(e, r0, V), w2(e, 48, i, m, o ^ 65536);
                  t: {
                    r: {
                      n: {
                        if ((l | 0) == 70) {
                          for (u = Z + 16 | 0, n = u | 8, S = u | 9, l = h >>> 0 > d >>> 0 ? d : h, h = l; ; ) {
                            a = qe(t[h >> 2], 0, S);
                            f: {
                              if ((l | 0) != (h | 0)) {
                                if (Z + 16 >>> 0 >= a >>> 0)
                                  break f;
                                for (; a = a - 1 | 0, P[a | 0] = 48, Z + 16 >>> 0 < a >>> 0; )
                                  ;
                                break f;
                              }
                              if ((a | 0) != (S | 0))
                                break f;
                              P[Z + 24 | 0] = 48, a = n;
                            }
                            if (l2(e, a, S - a | 0), h = h + 4 | 0, !(d >>> 0 >= h >>> 0))
                              break;
                          }
                          if (p && l2(e, 4275, 1), (F | 0) <= 0 | h >>> 0 >= g >>> 0)
                            break n;
                          for (; ; ) {
                            if (a = qe(t[h >> 2], 0, S), a >>> 0 > Z + 16 >>> 0)
                              for (; a = a - 1 | 0, P[a | 0] = 48, Z + 16 >>> 0 < a >>> 0; )
                                ;
                            if (l2(e, a, (F | 0) >= 9 ? 9 : F), a = F - 9 | 0, h = h + 4 | 0, g >>> 0 <= h >>> 0)
                              break r;
                            if (n = (F | 0) > 9, F = a, !n)
                              break;
                          }
                          break r;
                        }
                        f: {
                          if ((F | 0) < 0)
                            break f;
                          for (d = h >>> 0 < g >>> 0 ? g : h + 4 | 0, u = Z + 16 | 0, n = u | 8, g = u | 9, l = h; ; ) {
                            a = qe(t[l >> 2], 0, g), (g | 0) == (a | 0) && (P[Z + 24 | 0] = 48, a = n);
                            o: {
                              if ((l | 0) != (h | 0)) {
                                if (Z + 16 >>> 0 >= a >>> 0)
                                  break o;
                                for (; a = a - 1 | 0, P[a | 0] = 48, Z + 16 >>> 0 < a >>> 0; )
                                  ;
                                break o;
                              }
                              if (l2(e, a, 1), a = a + 1 | 0, !(S | F))
                                break o;
                              l2(e, 4275, 1);
                            }
                            if (u = g - a | 0, l2(e, a, (u | 0) > (F | 0) ? F : u), F = F - u | 0, l = l + 4 | 0, d >>> 0 <= l >>> 0)
                              break f;
                            if (!((F | 0) >= 0))
                              break;
                          }
                        }
                        w2(e, 48, F + 18 | 0, 18, 0), l2(e, C, L - C | 0);
                        break t;
                      }
                      a = F;
                    }
                    w2(e, 48, a + 9 | 0, 9, 0);
                  }
                  w2(e, 32, i, m, o ^ 8192), T = (i | 0) < (m | 0) ? m : i;
                  break e;
                }
                S = (u << 26 >> 31 & 9) + r0 | 0;
                i: {
                  if (n >>> 0 > 11)
                    break i;
                  for (a = 12 - n | 0, W = 16; W = W * 16, a = a - 1 | 0, !!a; )
                    ;
                  if (X[S | 0] == 45) {
                    r = -(W + (-r - W));
                    break i;
                  }
                  r = r + W - W;
                }
                for (d = V | 2, h = u & 32, l = t[Z + 44 >> 2], a = l >> 31, a = qe((a ^ l) - a | 0, 0, L), (L | 0) == (a | 0) && (P[Z + 15 | 0] = 48, a = Z + 15 | 0), F = a - 2 | 0, P[F | 0] = u + 15, P[a - 1 | 0] = (l | 0) < 0 ? 45 : 43, a = o & 8, l = Z + 16 | 0; u = l, $0(r) < 2147483648 ? g = ~~r : g = -2147483648, P[l | 0] = h | X[g + 5504 | 0], r = (r - +(g | 0)) * 16, l = u + 1 | 0, !(a | (n | 0) > 0) & r == 0 | (l - (Z + 16 | 0) | 0) != 1 || (P[u + 1 | 0] = 46, l = u + 2 | 0), r != 0; )
                  ;
                if (T = -1, a = L - F | 0, u = a + d | 0, (2147483645 - u | 0) < (n | 0))
                  break e;
                i: {
                  t: {
                    if (!n || (h = l - (Z + 16 | 0) | 0, (h - 2 | 0) >= (n | 0)))
                      break t;
                    n = n + 2 | 0;
                    break i;
                  }
                  h = l - (Z + 16 | 0) | 0, n = h;
                }
                u = n + u | 0, w2(e, 32, i, u, o), l2(e, S, d), w2(e, 48, i, u, o ^ 65536), l2(e, Z + 16 | 0, h), w2(e, 48, n - h | 0, 0, 0), l2(e, F, a), w2(e, 32, i, u, o ^ 8192), T = (i | 0) < (u | 0) ? u : i;
              }
              return H = Z + 560 | 0, T | 0;
            }
            function ni(e, r, i, n, o, u, a) {
              var l = 0, h = 0, g = 0, S = 0, F = 0, Z = 0, T = 0, p = 0, m = 0, d = 0, W = 0, V = 0, C = 0, L = 0, M = 0, $ = 0, r0 = 0, t0 = 0, f0 = 0, a0 = 0;
              g = H - 80 | 0, H = g, t[g + 76 >> 2] = r, t0 = g + 55 | 0, C = g + 56 | 0;
              e: {
                i: {
                  t: {
                    r: {
                      n:
                        for (; ; ) {
                          if (S = r, (m ^ 2147483647) < (l | 0))
                            break r;
                          m = l + m | 0;
                          f: {
                            o: {
                              u: {
                                if (l = S, h = X[l | 0], h)
                                  for (; ; ) {
                                    s: {
                                      r = h & 255;
                                      a: {
                                        if (!r) {
                                          r = l;
                                          break a;
                                        }
                                        if ((r | 0) != 37)
                                          break s;
                                        for (h = l; ; ) {
                                          if (X[h + 1 | 0] != 37) {
                                            r = h;
                                            break a;
                                          }
                                          if (l = l + 1 | 0, F = X[h + 2 | 0], r = h + 2 | 0, h = r, (F | 0) != 37)
                                            break;
                                        }
                                      }
                                      if (l = l - S | 0, r0 = m ^ 2147483647, (l | 0) > (r0 | 0))
                                        break r;
                                      if (e && l2(e, S, l), l)
                                        continue n;
                                      t[g + 76 >> 2] = r, l = r + 1 | 0, W = -1, h = P[r + 1 | 0], !Pr(h) | X[r + 2 | 0] != 36 || (W = h - 48 | 0, L = 1, l = r + 3 | 0), t[g + 76 >> 2] = l, p = 0, h = P[l | 0], r = h - 32 | 0;
                                      a: {
                                        if (r >>> 0 > 31) {
                                          F = l;
                                          break a;
                                        }
                                        if (F = l, r = 1 << r, !(r & 75913))
                                          break a;
                                        for (; ; ) {
                                          if (F = l + 1 | 0, t[g + 76 >> 2] = F, p = r | p, h = P[l + 1 | 0], r = h - 32 | 0, r >>> 0 >= 32)
                                            break a;
                                          if (l = F, r = 1 << r, !(r & 75913))
                                            break;
                                        }
                                      }
                                      a: {
                                        if ((h | 0) == 42) {
                                          r = P[F + 1 | 0];
                                          l: {
                                            if (!(!Pr(r) | X[F + 2 | 0] != 36)) {
                                              t[((r << 2) + o | 0) - 192 >> 2] = 10, h = F + 3 | 0, L = 1, d = t[((P[F + 1 | 0] << 3) + n | 0) - 384 >> 2];
                                              break l;
                                            }
                                            if (L)
                                              break u;
                                            if (h = F + 1 | 0, !e) {
                                              t[g + 76 >> 2] = h, L = 0, d = 0;
                                              break a;
                                            }
                                            r = t[i >> 2], t[i >> 2] = r + 4, L = 0, d = t[r >> 2];
                                          }
                                          if (t[g + 76 >> 2] = h, (d | 0) >= 0)
                                            break a;
                                          d = 0 - d | 0, p = p | 8192;
                                          break a;
                                        }
                                        if (d = Gi(g + 76 | 0), (d | 0) < 0)
                                          break r;
                                        h = t[g + 76 >> 2];
                                      }
                                      l = 0, T = -1;
                                      a: {
                                        if (X[h | 0] != 46) {
                                          r = h, V = 0;
                                          break a;
                                        }
                                        if (X[h + 1 | 0] == 42) {
                                          r = P[h + 2 | 0];
                                          l: {
                                            if (!(!Pr(r) | X[h + 3 | 0] != 36)) {
                                              t[((r << 2) + o | 0) - 192 >> 2] = 10, r = h + 4 | 0, T = t[((P[h + 2 | 0] << 3) + n | 0) - 384 >> 2];
                                              break l;
                                            }
                                            if (L)
                                              break u;
                                            if (r = h + 2 | 0, T = 0, !e)
                                              break l;
                                            h = t[i >> 2], t[i >> 2] = h + 4, T = t[h >> 2];
                                          }
                                          t[g + 76 >> 2] = r, V = (T ^ -1) >>> 31 | 0;
                                          break a;
                                        }
                                        t[g + 76 >> 2] = h + 1, T = Gi(g + 76 | 0), r = t[g + 76 >> 2], V = 1;
                                      }
                                      for (; ; ) {
                                        if (Z = l, F = 28, M = r, l = P[r | 0], l - 123 >>> 0 < 4294967238)
                                          break t;
                                        if (r = M + 1 | 0, l = X[(l + J0(Z, 58) | 0) + 4975 | 0], !(l - 1 >>> 0 < 8))
                                          break;
                                      }
                                      t[g + 76 >> 2] = r;
                                      a: {
                                        l: {
                                          if ((l | 0) != 27) {
                                            if (!l)
                                              break t;
                                            if ((W | 0) >= 0) {
                                              t[(W << 2) + o >> 2] = l, l = (W << 3) + n | 0, h = t[l + 4 >> 2], t[g + 64 >> 2] = t[l >> 2], t[g + 68 >> 2] = h;
                                              break l;
                                            }
                                            if (!e)
                                              break f;
                                            Ai(g - -64 | 0, l, i, a);
                                            break a;
                                          }
                                          if ((W | 0) >= 0)
                                            break t;
                                        }
                                        if (l = 0, !e)
                                          continue n;
                                      }
                                      h = p & -65537, p = p & 8192 ? h : p, W = 0, $ = 1167, F = C;
                                      a: {
                                        l: {
                                          A: {
                                            k: {
                                              h: {
                                                v: {
                                                  m: {
                                                    c: {
                                                      p: {
                                                        g: {
                                                          w: {
                                                            R: {
                                                              E: {
                                                                y: {
                                                                  W: {
                                                                    d:
                                                                      switch (l = P[M | 0], l = Z && (l & 15) == 3 ? l & -33 : l, l - 88 | 0) {
                                                                        case 11:
                                                                          break a;
                                                                        case 9:
                                                                        case 13:
                                                                        case 14:
                                                                        case 15:
                                                                          break l;
                                                                        case 27:
                                                                          break m;
                                                                        case 12:
                                                                        case 17:
                                                                          break g;
                                                                        case 23:
                                                                          break w;
                                                                        case 0:
                                                                        case 32:
                                                                          break R;
                                                                        case 24:
                                                                          break E;
                                                                        case 22:
                                                                          break y;
                                                                        case 29:
                                                                          break W;
                                                                        case 1:
                                                                        case 2:
                                                                        case 3:
                                                                        case 4:
                                                                        case 5:
                                                                        case 6:
                                                                        case 7:
                                                                        case 8:
                                                                        case 10:
                                                                        case 16:
                                                                        case 18:
                                                                        case 19:
                                                                        case 20:
                                                                        case 21:
                                                                        case 25:
                                                                        case 26:
                                                                        case 28:
                                                                        case 30:
                                                                        case 31:
                                                                          break o;
                                                                        default:
                                                                          break d;
                                                                      }
                                                                    d:
                                                                      switch (l - 65 | 0) {
                                                                        case 0:
                                                                        case 4:
                                                                        case 5:
                                                                        case 6:
                                                                          break l;
                                                                        case 2:
                                                                          break h;
                                                                        case 1:
                                                                        case 3:
                                                                          break o;
                                                                        default:
                                                                          break d;
                                                                      }
                                                                    if ((l | 0) == 83)
                                                                      break v;
                                                                    break o;
                                                                  }
                                                                  h = t[g + 64 >> 2], Z = t[g + 68 >> 2], l = 1167;
                                                                  break p;
                                                                }
                                                                l = 0;
                                                                y:
                                                                  switch (Z & 255) {
                                                                    case 0:
                                                                      t[t[g + 64 >> 2] >> 2] = m;
                                                                      continue n;
                                                                    case 1:
                                                                      t[t[g + 64 >> 2] >> 2] = m;
                                                                      continue n;
                                                                    case 2:
                                                                      S = t[g + 64 >> 2], t[S >> 2] = m, t[S + 4 >> 2] = m >> 31;
                                                                      continue n;
                                                                    case 3:
                                                                      K2[t[g + 64 >> 2] >> 1] = m;
                                                                      continue n;
                                                                    case 4:
                                                                      P[t[g + 64 >> 2]] = m;
                                                                      continue n;
                                                                    case 6:
                                                                      t[t[g + 64 >> 2] >> 2] = m;
                                                                      continue n;
                                                                    case 7:
                                                                      break y;
                                                                    default:
                                                                      continue n;
                                                                  }
                                                                S = t[g + 64 >> 2], t[S >> 2] = m, t[S + 4 >> 2] = m >> 31;
                                                                continue n;
                                                              }
                                                              T = T >>> 0 <= 8 ? 8 : T, p = p | 8, l = 120;
                                                            }
                                                            if (S = C, h = t[g + 64 >> 2], Z = t[g + 68 >> 2], h | Z)
                                                              for (f0 = l & 32; S = S - 1 | 0, P[S | 0] = f0 | X[(h & 15) + 5504 | 0], a0 = !Z & h >>> 0 > 15 | (Z | 0) != 0, M = Z, Z = Z >>> 4 | 0, h = (M & 15) << 28 | h >>> 4, !!a0; )
                                                                ;
                                                            if (!(p & 8) | !(t[g + 64 >> 2] | t[g + 68 >> 2]))
                                                              break c;
                                                            $ = (l >>> 4 | 0) + 1167 | 0, W = 2;
                                                            break c;
                                                          }
                                                          if (l = C, S = t[g + 68 >> 2], Z = S, h = t[g + 64 >> 2], S | h)
                                                            for (; l = l - 1 | 0, P[l | 0] = h & 7 | 48, M = !Z & h >>> 0 > 7 | (Z | 0) != 0, S = Z, Z = S >>> 3 | 0, h = (S & 7) << 29 | h >>> 3, !!M; )
                                                              ;
                                                          if (S = l, !(p & 8))
                                                            break c;
                                                          l = C - S | 0, T = (l | 0) < (T | 0) ? T : l + 1 | 0;
                                                          break c;
                                                        }
                                                        if (h = t[g + 64 >> 2], l = t[g + 68 >> 2], Z = l, (l | 0) < 0) {
                                                          S = 0 - (Z + ((h | 0) != 0) | 0) | 0, Z = S, h = 0 - h | 0, t[g + 64 >> 2] = h, t[g + 68 >> 2] = S, W = 1, l = 1167;
                                                          break p;
                                                        }
                                                        if (p & 2048) {
                                                          W = 1, l = 1168;
                                                          break p;
                                                        }
                                                        W = p & 1, l = W ? 1169 : 1167;
                                                      }
                                                      $ = l, S = qe(h, Z, C);
                                                    }
                                                    if ((T | 0) < 0 && V)
                                                      break r;
                                                    if (p = V ? p & -65537 : p, l = t[g + 64 >> 2], h = t[g + 68 >> 2], !((l | h) != 0 | T)) {
                                                      S = C, T = 0;
                                                      break o;
                                                    }
                                                    l = !(l | h) + (C - S | 0) | 0, T = (l | 0) < (T | 0) ? T : l;
                                                    break o;
                                                  }
                                                  p = 0, V = T >>> 0 >= 2147483647 ? 2147483647 : T, Z = V, F = (Z | 0) != 0;
                                                  m: {
                                                    c: {
                                                      l = t[g + 64 >> 2], S = l || 4277, l = S;
                                                      p: {
                                                        g: {
                                                          w: {
                                                            if (!(l & 3) | !Z)
                                                              break w;
                                                            for (; ; ) {
                                                              if (p = X[l | 0], !p)
                                                                break g;
                                                              if (Z = Z - 1 | 0, F = (Z | 0) != 0, l = l + 1 | 0, !(l & 3))
                                                                break w;
                                                              if (!Z)
                                                                break;
                                                            }
                                                          }
                                                          if (!F)
                                                            break c;
                                                          w: {
                                                            if (!(!X[l | 0] | Z >>> 0 < 4))
                                                              for (; ; ) {
                                                                if (F = t[l >> 2], (F ^ -1) & F - 16843009 & -2139062144)
                                                                  break w;
                                                                if (l = l + 4 | 0, Z = Z - 4 | 0, !(Z >>> 0 > 3))
                                                                  break;
                                                              }
                                                            if (!Z)
                                                              break c;
                                                          }
                                                          F = 0;
                                                          break p;
                                                        }
                                                        F = 1;
                                                      }
                                                      for (; ; ) {
                                                        if (!F) {
                                                          p = X[l | 0], F = 1;
                                                          continue;
                                                        }
                                                        if (!p)
                                                          break m;
                                                        if (l = l + 1 | 0, Z = Z - 1 | 0, !Z)
                                                          break c;
                                                        F = 0;
                                                      }
                                                    }
                                                    l = 0;
                                                  }
                                                  if (l = l ? l - S | 0 : V, F = l + S | 0, (T | 0) >= 0) {
                                                    p = h, T = l;
                                                    break o;
                                                  }
                                                  if (p = h, T = l, X[F | 0])
                                                    break r;
                                                  break o;
                                                }
                                                if (T) {
                                                  h = t[g + 64 >> 2];
                                                  break k;
                                                }
                                                l = 0, w2(e, 32, d, 0, p);
                                                break A;
                                              }
                                              t[g + 12 >> 2] = 0, t[g + 8 >> 2] = t[g + 64 >> 2], h = g + 8 | 0, t[g + 64 >> 2] = h, T = -1;
                                            }
                                            l = 0;
                                            k: {
                                              for (; ; ) {
                                                if (S = t[h >> 2], !S)
                                                  break k;
                                                if (S = Ci(g + 4 | 0, S), F = (S | 0) < 0, !(F | S >>> 0 > T - l >>> 0)) {
                                                  if (h = h + 4 | 0, l = l + S | 0, T >>> 0 > l >>> 0)
                                                    continue;
                                                  break k;
                                                }
                                                break;
                                              }
                                              if (F)
                                                break i;
                                            }
                                            if (F = 61, (l | 0) < 0)
                                              break t;
                                            if (w2(e, 32, d, l, p), !l) {
                                              l = 0;
                                              break A;
                                            }
                                            for (F = 0, h = t[g + 64 >> 2]; ; ) {
                                              if (S = t[h >> 2], !S || (S = Ci(g + 4 | 0, S), F = S + F | 0, F >>> 0 > l >>> 0))
                                                break A;
                                              if (l2(e, g + 4 | 0, S), h = h + 4 | 0, !(l >>> 0 > F >>> 0))
                                                break;
                                            }
                                          }
                                          w2(e, 32, d, l, p ^ 8192), l = (l | 0) < (d | 0) ? d : l;
                                          continue n;
                                        }
                                        if ((T | 0) < 0 && V)
                                          break r;
                                        if (F = 61, l = e0[u | 0](e, Q0[g + 64 >> 3], d, T, p, l) | 0, (l | 0) >= 0)
                                          continue n;
                                        break t;
                                      }
                                      P[g + 55 | 0] = t[g + 64 >> 2], T = 1, S = t0, p = h;
                                      break o;
                                    }
                                    h = X[l + 1 | 0], l = l + 1 | 0;
                                  }
                                if (e)
                                  break e;
                                if (!L)
                                  break f;
                                for (l = 1; ; ) {
                                  if (e = t[(l << 2) + o >> 2], e) {
                                    if (Ai((l << 3) + n | 0, e, i, a), m = 1, l = l + 1 | 0, (l | 0) != 10)
                                      continue;
                                    break e;
                                  }
                                  break;
                                }
                                if (m = 1, l >>> 0 >= 10)
                                  break e;
                                for (; ; ) {
                                  if (t[(l << 2) + o >> 2])
                                    break u;
                                  if (l = l + 1 | 0, (l | 0) == 10)
                                    break;
                                }
                                break e;
                              }
                              F = 28;
                              break t;
                            }
                            if (Z = F - S | 0, T = (T | 0) > (Z | 0) ? T : Z, (T | 0) > (W ^ 2147483647))
                              break r;
                            if (F = 61, h = T + W | 0, l = (h | 0) < (d | 0) ? d : h, (r0 | 0) < (l | 0))
                              break t;
                            w2(e, 32, l, h, p), l2(e, $, W), w2(e, 48, l, h, p ^ 65536), w2(e, 48, T, Z, 0), l2(e, S, Z), w2(e, 32, l, h, p ^ 8192);
                            continue;
                          }
                          break;
                        }
                      m = 0;
                      break e;
                    }
                    F = 61;
                  }
                  t[1781] = F;
                }
                m = -1;
              }
              return H = g + 80 | 0, m;
            }
            function k1(e, r, i, n) {
              e = e | 0, r = +r, i = +i, n = n | 0;
              var o = f(0), u = f(0), a = 0, l = f(0), h = 0, g = f(0), S = 0, F = f(0), Z = 0;
              Z = H + -64 | 0, H = Z, a = t[e >> 2], T2(Z + 8 | 0, 0, 56), t[1755] = t[1755] + 1, oi(a), l = f(r), u = A[a + 572 >> 2];
              e: {
                i: {
                  t:
                    switch (e = t[a + 576 >> 2], e | 0) {
                      case 0:
                      case 3:
                        break i;
                      default:
                        break t;
                    }
                  o = A[a + 572 >> 2];
                  t: {
                    if (!((e | 0) != 1 | o != o)) {
                      if (o = u, !(o < f(0)))
                        break t;
                      break i;
                    }
                    r: {
                      if (!((e | 0) != 2 | o != o)) {
                        if (l != l | u < f(0))
                          break i;
                        break r;
                      }
                      o = f(s0);
                      n:
                        switch (e - 1 | 0) {
                          case 1:
                            break r;
                          case 0:
                            break n;
                          default:
                            break t;
                        }
                      o = u;
                      break t;
                    }
                    o = f(f(u * l) * f(0.009999999776482582));
                  }
                  F = f(o + f(d0(a, 2, l) + C0(a, 2, l))), S = 1;
                  break e;
                }
                o = f(0), u = A[a + 216 >> 2];
                i: {
                  t: {
                    e = t[a + 216 >> 2];
                    r: {
                      n: {
                        if ((e | 0) == 2139156720)
                          break n;
                        if ((e | 0) == 2140081935)
                          break i;
                        S = 4336;
                        f: {
                          if ((e | 0) != 2141891242) {
                            if (u == u)
                              break f;
                            S = 4344;
                          }
                          switch (o = A[S >> 2], t[S + 4 >> 2] - 1 | 0) {
                            case 0:
                              break r;
                            case 1:
                              break n;
                            default:
                              break t;
                          }
                        }
                        if (o = (J(2, (e & -1073741825) + 536870912 | 0), n0()), !(e & 1073741824))
                          break r;
                      }
                      o = f(f(o * l) * f(0.009999999776482582));
                    }
                    if (o != o)
                      break t;
                    o = f(0);
                    r: {
                      if ((e | 0) == 2139156720)
                        break r;
                      if ((e | 0) == 2140081935)
                        break i;
                      h = 4336;
                      n: {
                        if ((e | 0) != 2141891242) {
                          if (u == u)
                            break n;
                          h = 4344;
                        }
                        switch (o = A[h >> 2], F = f(s0), S = 2, t[h + 4 >> 2] - 1 | 0) {
                          case 1:
                            break r;
                          case 0:
                            break i;
                          default:
                            break e;
                        }
                      }
                      if (o = (J(2, (e & -1073741825) + 536870912 | 0), n0()), !(e & 1073741824))
                        break i;
                    }
                    F = f(f(o * l) * f(0.009999999776482582)), S = 2;
                    break e;
                  }
                  S = l == l, F = l;
                  break e;
                }
                S = 2, F = o;
              }
              g = f(i), u = A[a + 580 >> 2];
              e: {
                i: {
                  t:
                    switch (e = t[a + 584 >> 2], e | 0) {
                      case 0:
                      case 3:
                        break i;
                      default:
                        break t;
                    }
                  o = A[a + 580 >> 2];
                  t: {
                    if (!((e | 0) != 1 | o != o)) {
                      if (o = u, !(o < f(0)))
                        break t;
                      break i;
                    }
                    r: {
                      if (!((e | 0) != 2 | o != o)) {
                        if (g != g | u < f(0))
                          break i;
                        break r;
                      }
                      o = f(s0);
                      n:
                        switch (e - 1 | 0) {
                          case 1:
                            break r;
                          case 0:
                            break n;
                          default:
                            break t;
                        }
                      o = u;
                      break t;
                    }
                    o = f(f(u * g) * f(0.009999999776482582));
                  }
                  u = f(o + f(d0(a, 0, l) + C0(a, 0, l))), e = 1;
                  break e;
                }
                o = f(0), u = A[a + 220 >> 2];
                i: {
                  t: {
                    e = t[a + 220 >> 2];
                    r: {
                      n: {
                        if ((e | 0) == 2139156720)
                          break n;
                        if ((e | 0) == 2140081935)
                          break i;
                        h = 4336;
                        f: {
                          if ((e | 0) != 2141891242) {
                            if (u == u)
                              break f;
                            h = 4344;
                          }
                          switch (o = A[h >> 2], t[h + 4 >> 2] - 1 | 0) {
                            case 0:
                              break r;
                            case 1:
                              break n;
                            default:
                              break t;
                          }
                        }
                        if (o = (J(2, (e & -1073741825) + 536870912 | 0), n0()), !(e & 1073741824))
                          break r;
                      }
                      o = f(f(o * g) * f(0.009999999776482582));
                    }
                    if (o != o)
                      break t;
                    o = f(0);
                    r: {
                      if ((e | 0) == 2139156720)
                        break r;
                      if ((e | 0) == 2140081935)
                        break i;
                      h = 4336;
                      n: {
                        if ((e | 0) != 2141891242) {
                          if (u == u)
                            break n;
                          h = 4344;
                        }
                        switch (o = A[h >> 2], u = f(s0), e = 2, t[h + 4 >> 2] - 1 | 0) {
                          case 0:
                            break i;
                          case 1:
                            break r;
                          default:
                            break e;
                        }
                      }
                      if (o = (J(2, (e & -1073741825) + 536870912 | 0), n0()), !(e & 1073741824))
                        break i;
                    }
                    u = f(f(o * g) * f(0.009999999776482582)), e = 2;
                    break e;
                  }
                  e = g == g, u = g;
                  break e;
                }
                e = 2, u = o;
              }
              Le(a, F, u, n, S, e, l, g, 1, 0, t[a + 568 >> 2], Z + 8 | 0, 0, t[1755]) && (vi(a, X[a + 300 | 0] & 3, l, g, l), hi(a, +A[t[a + 568 >> 2] + 20 >> 2], 0, 0)), H = Z - -64 | 0;
            }
            function c1(e, r) {
              e = e | 0, r = r | 0;
              var i = 0, n = f(0), o = 0, u = 0, a = f(0), l = 0, h = 0, g = 0, S = f(0);
              e: {
                h = t[r >> 2], r = t[e >> 2];
                i: {
                  if ((t[h + 24 >> 2] ^ t[r + 24 >> 2]) & 8388607)
                    break i;
                  S = A[h + 40 >> 2], o = t[h + 40 >> 2], n = A[r + 40 >> 2];
                  t: {
                    r: {
                      if (i = t[r + 40 >> 2], (i | 0) != 2139156720) {
                        if (a = f(s0), e = 3, (i | 0) == 2141891242)
                          break t;
                        if ((i | 0) != 2140081935)
                          break r;
                        a = f(0), e = 1;
                        break t;
                      }
                      e = 2;
                      break t;
                    }
                    if (e = 0, n != n)
                      break t;
                    a = (J(2, (i & -1073741825) + 536870912 | 0), n0()), e = i & 1073741824 ? 2 : 1;
                  }
                  t: {
                    r: {
                      if ((o | 0) != 2139156720) {
                        if (n = f(s0), i = 3, (o | 0) == 2141891242)
                          break t;
                        if ((o | 0) != 2140081935)
                          break r;
                        n = f(0), i = 1;
                        break t;
                      }
                      n = f(0), i = 2;
                      break t;
                    }
                    if (i = 0, S != S)
                      break t;
                    n = (J(2, (o & -1073741825) + 536870912 | 0), n0()), i = o & 1073741824 ? 2 : 1;
                  }
                  if ((i | 0) != (e | 0) | !(!e | a != a & n != n | f($0(f(a - n))) < f(9999999747378752e-20)) || (i = r + 44 | 0, u = h + 44 | 0, t[i >> 2] != t[u >> 2]))
                    break i;
                  e = 0;
                  t: {
                    for (; ; ) {
                      if (o = e, e = e + 1 | 0, (e | 0) == 9)
                        break t;
                      if (l = e << 2, t[l + i >> 2] != t[u + l >> 2])
                        break;
                    }
                    if (o >>> 0 < 8)
                      break i;
                  }
                  if (i = r + 80 | 0, u = h + 80 | 0, t[i >> 2] != t[u >> 2])
                    break i;
                  e = 0;
                  t: {
                    for (; ; ) {
                      if (o = e, e = e + 1 | 0, (e | 0) == 9)
                        break t;
                      if (l = e << 2, t[l + i >> 2] != t[u + l >> 2])
                        break;
                    }
                    if (o >>> 0 < 8)
                      break i;
                  }
                  if (i = r + 116 | 0, u = h + 116 | 0, t[i >> 2] != t[u >> 2])
                    break i;
                  e = 0;
                  t: {
                    for (; ; ) {
                      if (o = e, e = e + 1 | 0, (e | 0) == 9)
                        break t;
                      if (l = e << 2, t[l + i >> 2] != t[u + l >> 2])
                        break;
                    }
                    if (o >>> 0 < 8)
                      break i;
                  }
                  if (i = r + 152 | 0, u = h + 152 | 0, t[i >> 2] != t[u >> 2])
                    break i;
                  e = 0;
                  t: {
                    for (; ; ) {
                      if (o = e, e = e + 1 | 0, (e | 0) == 9)
                        break t;
                      if (l = e << 2, t[l + i >> 2] != t[u + l >> 2])
                        break;
                    }
                    if (o >>> 0 < 8)
                      break i;
                  }
                  if (i = r + 188 | 0, u = h + 188 | 0, t[i >> 2] != t[u >> 2])
                    break i;
                  e = 0;
                  t: {
                    for (; ; ) {
                      if (o = e, e = e + 1 | 0, (e | 0) == 3)
                        break t;
                      if (l = e << 2, t[l + i >> 2] != t[u + l >> 2])
                        break;
                    }
                    if (o >>> 0 < 2)
                      break i;
                  }
                  for (l = h + 200 | 0, g = r + 200 | 0, e = 0, o = 1; ; ) {
                    t: {
                      if (e = e << 2, i = t[e + l >> 2], u = t[e + g >> 2], !o)
                        break t;
                      if (o = 0, e = 1, (i | 0) == (u | 0))
                        continue;
                    }
                    break;
                  }
                  if ((i | 0) != (u | 0))
                    break i;
                  for (l = h + 208 | 0, g = r + 208 | 0, e = 0, o = 1; ; ) {
                    t: {
                      if (e = e << 2, i = t[e + l >> 2], u = t[e + g >> 2], !o)
                        break t;
                      if (o = 0, e = 1, (i | 0) == (u | 0))
                        continue;
                    }
                    break;
                  }
                  if ((i | 0) != (u | 0))
                    break i;
                  for (l = h + 216 | 0, g = r + 216 | 0, e = 0, o = 1; ; ) {
                    t: {
                      if (e = e << 2, i = t[e + l >> 2], u = t[e + g >> 2], !o)
                        break t;
                      if (o = 0, e = 1, (i | 0) == (u | 0))
                        continue;
                    }
                    break;
                  }
                  if ((i | 0) != (u | 0) || (a = A[h + 28 >> 2], e = a != a, n = A[r + 28 >> 2], (e | 0) == (n == n | 0) | !(e | n != n) & n != a) || (n = A[r + 32 >> 2], a = A[h + 32 >> 2], (n == n | 0) == (a != a | 0) | n == n & n != a) || (a = A[h + 36 >> 2], e = a != a, n = A[r + 36 >> 2], (e | 0) == (n == n | 0) | !e & n != a))
                    break i;
                  if (e = 0, n = A[r + 224 >> 2], n != n && (e = 1, a = A[h + 224 >> 2], a != a) || (a = n, n = A[h + 224 >> 2], a == n | n != n & e))
                    break e;
                }
                for (S2(r + 24 | 0, h + 24 | 0, 204); ; ) {
                  if (e = X[r + 4 | 0], e & 4)
                    break e;
                  if (P[r + 4 | 0] = e | 4, e = t[r + 20 >> 2], e && e0[e | 0](r), t[r + 308 >> 2] = 2143289344, r = t[r + 552 >> 2], !r)
                    break;
                }
              }
            }
            function A1(e, r) {
              e = e | 0, r = r | 0;
              var i = 0, n = 0, o = 0, u = 0, a = 0, l = 0, h = 0, g = 0, S = 0, F = 0, Z = 0, T = 0, p = 0, m = 0, d = 0, W = 0;
              i = r, r = t[r >> 2] + 7 & -8, t[i >> 2] = r + 16, p = e, h = t[r >> 2], n = t[r + 4 >> 2], e = t[r + 12 >> 2], Z = e, a = H - 32 | 0, H = a, e = e & 2147483647, l = e, o = e - 1006698496 | 0, e = e - 1140785152 | 0, i = t[r + 8 >> 2], r = i;
              e: {
                if ((o | 0) == (e | 0) & r >>> 0 < r >>> 0 | e >>> 0 > o >>> 0) {
                  if (e = i, i = Z << 4 | e >>> 28, r = e << 4 | n >>> 28, e = i, n = n & 268435455, (n | 0) == 134217728 & (h | 0) != 0 | n >>> 0 > 134217728) {
                    e = e + 1073741824 | 0, r = r + 1 | 0, e = r ? e : e + 1 | 0;
                    break e;
                  }
                  if (e = e + 1073741824 | 0, h | (n | 0) != 134217728)
                    break e;
                  n = r & 1, r = n + r | 0, e = r >>> 0 < n >>> 0 ? e + 1 | 0 : e;
                  break e;
                }
                if (!(!r & (l | 0) == 2147418112 ? !(n | h) : l >>> 0 < 2147418112)) {
                  e = i, i = Z << 4 | e >>> 28, r = e << 4 | n >>> 28, e = i & 524287 | 2146959360;
                  break e;
                }
                if (r = 0, e = 2146435072, l >>> 0 > 1140785151 || (e = 0, T = l >>> 16 | 0, T >>> 0 < 15249))
                  break e;
                r = h, e = n, o = Z & 65535 | 65536, l = o, F = i, u = i, g = T - 15233 | 0;
                i: {
                  if (g & 64) {
                    i = r, o = g + -64 | 0, r = o & 31, (o & 63) >>> 0 >= 32 ? (e = i << r, u = 0) : (e = (1 << r) - 1 & i >>> 32 - r | e << r, u = i << r), o = e, r = 0, e = 0;
                    break i;
                  }
                  if (!g)
                    break i;
                  S = u, u = g & 31, (g & 63) >>> 0 >= 32 ? (i = S << u, u = 0) : (i = (1 << u) - 1 & S >>> 32 - u | o << u, u = S << u), o = i, m = u, S = r, i = 64 - g | 0, u = i & 31, (i & 63) >>> 0 >= 32 ? (i = 0, r = e >>> u | 0) : (i = e >>> u | 0, r = ((1 << u) - 1 & e) << 32 - u | S >>> u), u = m | r, o = i | o, r = g & 31, (g & 63) >>> 0 >= 32 ? (i = S << r, r = 0) : (i = (1 << r) - 1 & S >>> 32 - r | e << r, r = S << r), e = i;
                }
                t[a + 16 >> 2] = r, t[a + 20 >> 2] = e, t[a + 24 >> 2] = u, t[a + 28 >> 2] = o, r = 15361 - T | 0;
                i: {
                  if (r & 64) {
                    n = F, r = r + -64 | 0, e = r & 31, (r & 63) >>> 0 >= 32 ? (i = 0, h = l >>> e | 0) : (i = l >>> e | 0, h = ((1 << e) - 1 & l) << 32 - e | n >>> e), n = i, F = 0, l = 0;
                    break i;
                  }
                  if (!r)
                    break i;
                  o = F, e = 64 - r | 0, i = e & 31, (e & 63) >>> 0 >= 32 ? (e = o << i, u = 0) : (e = (1 << i) - 1 & o >>> 32 - i | l << i, u = o << i), o = h, h = r & 31, (r & 63) >>> 0 >= 32 ? (i = 0, o = n >>> h | 0) : (i = n >>> h | 0, o = ((1 << h) - 1 & n) << 32 - h | o >>> h), h = u | o, n = e | i, o = F, i = r & 31, (r & 63) >>> 0 >= 32 ? (e = 0, F = l >>> i | 0) : (e = l >>> i | 0, F = ((1 << i) - 1 & l) << 32 - i | o >>> i), l = e;
                }
                if (t[a >> 2] = h, t[a + 4 >> 2] = n, t[a + 8 >> 2] = F, t[a + 12 >> 2] = l, r = t[a + 8 >> 2], e = t[a + 12 >> 2] << 4 | r >>> 28, r = r << 4, i = t[a >> 2], l = t[a + 4 >> 2], r = l >>> 28 | r, n = l & 268435455, i = i | (t[a + 16 >> 2] | t[a + 24 >> 2] | (t[a + 20 >> 2] | t[a + 28 >> 2])) != 0, (n | 0) == 134217728 & (i | 0) != 0 | n >>> 0 > 134217728) {
                  r = r + 1 | 0, e = r ? e : e + 1 | 0;
                  break e;
                }
                if (i | (n | 0) != 134217728)
                  break e;
                i = r, r = r + (r & 1) | 0, e = i >>> 0 > r >>> 0 ? e + 1 | 0 : e;
              }
              H = a + 32 | 0, J(0, r | 0), J(1, Z & -2147483648 | e), d = p, W = +g2(), Q0[d >> 3] = W;
            }
            function Le(e, r, i, n, o, u, a, l, h, g, S, F, Z, T) {
              var p = f(0), m = 0, d = 0, W = 0, V = 0, C = f(0), L = 0, M = 0, $ = f(0);
              e: {
                if (!(t[e + 312 >> 2] != (T | 0) && X[e + 4 | 0] & 4) && (V = 0, t[e + 316 >> 2] == (n | 0)))
                  break e;
                t[e + 540 >> 2] = -1082130432, t[e + 544 >> 2] = -1082130432, t[e + 532 >> 2] = 0, t[e + 536 >> 2] = 0, t[e + 524 >> 2] = -1082130432, t[e + 528 >> 2] = -1082130432, t[e + 320 >> 2] = 0, V = 1;
              }
              L = Z + 1 | 0;
              e: {
                i: {
                  t: {
                    r: {
                      if (t[e + 8 >> 2]) {
                        if (C = d0(e, 2, a), $ = C0(e, 2, a), p = f(d0(e, 0, a) + C0(e, 0, a)), Z = e + 524 | 0, C = f(C + $), si(o, r, u, i, t[e + 532 >> 2], A[Z >> 2], t[e + 536 >> 2], A[e + 528 >> 2], A[e + 540 >> 2], A[e + 544 >> 2], C, p, S))
                          break t;
                        if (d = t[e + 320 >> 2], !d)
                          break r;
                        for (m = e + 324 | 0; ; ) {
                          if (Z = m + J0(W, 24) | 0, si(o, r, u, i, t[Z + 8 >> 2], A[Z >> 2], t[Z + 12 >> 2], A[Z + 4 >> 2], A[Z + 16 >> 2], A[Z + 20 >> 2], C, p, S))
                            break t;
                          if (W = W + 1 | 0, (d | 0) == (W | 0))
                            break;
                        }
                        break r;
                      }
                      if (!h) {
                        if (M = t[e + 320 >> 2], !M)
                          break r;
                        for (d = e + 324 | 0; ; ) {
                          m = J0(W, 24), Z = m + d | 0, p = A[Z >> 2];
                          n: {
                            f: {
                              if (!(p != p | r != r)) {
                                if (f($0(f(p - r))) < f(9999999747378752e-20))
                                  break f;
                                break n;
                              }
                              if (p == p | r == r)
                                break n;
                            }
                            m = d + m | 0, p = A[m + 4 >> 2];
                            f: {
                              if (!(p != p | i != i)) {
                                if (f($0(f(p - i))) < f(9999999747378752e-20))
                                  break f;
                                break n;
                              }
                              if (p == p | i == i)
                                break n;
                            }
                            if (t[m + 8 >> 2] != (o | 0))
                              break n;
                            if (t[m + 12 >> 2] == (u | 0))
                              break t;
                          }
                          if (W = W + 1 | 0, (M | 0) == (W | 0))
                            break;
                        }
                        break r;
                      }
                      Z = e + 524 | 0, p = A[Z >> 2];
                      n: {
                        if (!(p != p | r != r)) {
                          if (f($0(f(p - r))) < f(9999999747378752e-20))
                            break n;
                          break r;
                        }
                        if (p == p | r == r)
                          break r;
                      }
                      m = t[e + 532 >> 2] == (o | 0) && t[e + 536 >> 2] == (u | 0) ? Z : 0, p = A[e + 528 >> 2], Z = p != p, d = i != i;
                      n: {
                        if (Z | d) {
                          Z = Z & d;
                          break n;
                        }
                        Z = f($0(f(p - i))) < f(9999999747378752e-20);
                      }
                      Z = Z ? m : 0;
                      break t;
                    }
                    ti(e, r, i, n, o, u, a, l, h, S, F, L, T, g), t[e + 316 >> 2] = n;
                    break i;
                  }
                  if (!(!Z | V)) {
                    A[e + 516 >> 2] = A[Z + 16 >> 2], A[e + 520 >> 2] = A[Z + 20 >> 2], n = (h ? 12 : 16) + F | 0, t[n >> 2] = t[n >> 2] + 1;
                    break e;
                  }
                  if (ti(e, r, i, n, o, u, a, l, h, S, F, L, T, g), t[e + 316 >> 2] = n, Z)
                    break e;
                }
                Z = t[e + 320 >> 2], n = Z + 1 | 0, n >>> 0 > jt[F + 8 >> 2] && (t[F + 8 >> 2] = n), (Z | 0) == 8 && (t[e + 320 >> 2] = 0, Z = 0), h ? n = e + 524 | 0 : (t[e + 320 >> 2] = Z + 1, n = (J0(Z, 24) + e | 0) + 324 | 0), t[n + 12 >> 2] = u, t[n + 8 >> 2] = o, A[n + 4 >> 2] = i, A[n >> 2] = r, A[n + 16 >> 2] = A[e + 516 >> 2], A[n + 20 >> 2] = A[e + 520 >> 2], Z = 0;
              }
              e: {
                if (!h || (n = t[e + 520 >> 2], t[e + 244 >> 2] = t[e + 516 >> 2], t[e + 248 >> 2] = n, n = X[e + 4 | 0], o = n | 1, P[e + 4 | 0] = o, !(n & 4)))
                  break e;
                P[e + 4 | 0] = o & 251;
              }
              return t[e + 312 >> 2] = T, !Z | V;
            }
            function st(e) {
              e = e | 0;
              var r = 0, i = 0, n = 0, o = 0, u = 0, a = 0, l = 0, h = 0, g = 0, S = 0, F = 0;
              l = 8;
              e: {
                if (e >>> 0 > 4294967239)
                  break e;
                i: {
                  for (; ; ) {
                    l = l >>> 0 <= 8 ? 8 : l, r = t[1751], u = r, o = t[1750], e = e >>> 0 <= 8 ? 8 : e + 3 & -4;
                    t: {
                      if (e >>> 0 <= 127) {
                        a = (e >>> 3 | 0) - 1 | 0;
                        break t;
                      }
                      if (n = H2(e), a = ((e >>> 29 - n ^ 4) - (n << 2) | 0) + 110 | 0, e >>> 0 <= 4095)
                        break t;
                      n = ((e >>> 30 - n ^ 2) - (n << 1) | 0) + 71 | 0, a = n >>> 0 >= 63 ? 63 : n;
                    }
                    if (i = a & 31, (a & 63) >>> 0 >= 32 ? (n = 0, r = r >>> i | 0) : (n = r >>> i | 0, r = ((1 << i) - 1 & r) << 32 - i | o >>> i), r | n) {
                      for (; ; ) {
                        o = n;
                        t: {
                          if (r | n) {
                            i = n - 1 | 0, h = i + 1 | 0, u = i, i = r - 1 | 0, u = (i | 0) != -1 ? h : u, n = H2(n ^ u), n = (n | 0) == 32 ? H2(r ^ i) + 32 | 0 : n, i = 63 - n | 0, G2 = 0 - (n >>> 0 > 63) | 0;
                            break t;
                          }
                          G2 = 0, i = 64;
                        }
                        u = i, i = u & 31, (u & 63) >>> 0 >= 32 ? (n = 0, r = o >>> i | 0) : (n = o >>> i | 0, r = ((1 << i) - 1 & o) << 32 - i | r >>> i), h = r, a = u + a | 0, i = a << 4, r = t[i + 5976 >> 2], u = i + 5968 | 0;
                        t: {
                          if ((r | 0) != (u | 0)) {
                            if (o = kt(r, l, e), o)
                              break e;
                            o = t[r + 4 >> 2], t[o + 8 >> 2] = t[r + 8 >> 2], t[t[r + 8 >> 2] + 4 >> 2] = o, t[r + 8 >> 2] = u, o = i + 5972 | 0, t[r + 4 >> 2] = t[o >> 2], t[o >> 2] = r, t[t[r + 4 >> 2] + 8 >> 2] = r, a = a + 1 | 0, r = (n & 1) << 31 | h >>> 1, n = n >>> 1 | 0;
                            break t;
                          }
                          g = t[1751], u = a & 63, r = u, o = r & 31, r >>> 0 >= 32 ? (r = 0, i = -1 >>> o | 0) : (r = -1 >>> o | 0, i = r | (1 << o) - 1 << 32 - o), i = i & -2, o = u & 31, u >>> 0 >= 32 ? (r = i << o, i = 0) : (r = (1 << o) - 1 & i >>> 32 - o | r << o, i = i << o), S = i, o = r, u = 0 - a & 63, i = u, r = i & 31, i >>> 0 >= 32 ? (r = -1 << r, i = 0) : (i = -1 << r, r = i | (1 << r) - 1 & -1 >>> 32 - r), F = i & -2, i = u & 31, u >>> 0 >= 32 ? (u = 0, r = r >>> i | 0) : (u = r >>> i | 0, r = ((1 << i) - 1 & r) << 32 - i | F >>> i), r = r | S, G2 = o | u, t[1750] = t[1750] & r, t[1751] = G2 & g, r = h ^ 1;
                        }
                        if (!(r | n))
                          break;
                      }
                      u = t[1751], o = t[1750];
                    }
                    t: {
                      if (o | u) {
                        n = H2(u), i = 63 - ((n | 0) == 32 ? H2(o) + 32 | 0 : n) | 0, r = i << 4, n = t[r + 5976 >> 2];
                        r: {
                          if (!u & o >>> 0 < 1073741824 || (a = 99, r = r + 5968 | 0, (r | 0) == (n | 0)))
                            break r;
                          for (; ; ) {
                            if (!a)
                              break r;
                            if (o = kt(n, l, e), o)
                              break e;
                            if (a = a - 1 | 0, n = t[n + 8 >> 2], (r | 0) == (n | 0))
                              break;
                          }
                          n = r;
                        }
                        if (lt(e + 48 | 0))
                          break t;
                        if (!n || (r = (i << 4) + 5968 | 0, (r | 0) == (n | 0)))
                          break i;
                        for (; ; ) {
                          if (o = kt(n, l, e), o)
                            break e;
                          if (n = t[n + 8 >> 2], (r | 0) == (n | 0))
                            break;
                        }
                        break i;
                      }
                      if (!lt(e + 48 | 0))
                        break i;
                    }
                    if (o = 0, l - 1 & l)
                      break e;
                    if (!(e >>> 0 <= 4294967239))
                      break;
                  }
                  break e;
                }
                o = 0;
              }
              return o | 0;
            }
            function h1(e, r, i) {
              e = e | 0, r = r | 0, i = i | 0;
              var n = 0, o = 0, u = 0, a = 0, l = 0, h = 0, g = 0, S = 0, F = 0, Z = 0;
              l = H - 80 | 0, H = l, e = t[e >> 2];
              e: {
                i: {
                  if (h = t[r >> 2], !t[h + 552 >> 2]) {
                    if (t[e + 8 >> 2])
                      break i;
                    r = t[e + 556 >> 2], a = r + (i << 2) | 0, n = t[e + 560 >> 2], o = e + 564 | 0, u = t[o >> 2];
                    t: {
                      if (n >>> 0 < u >>> 0) {
                        if ((n | 0) == (a | 0)) {
                          t[a >> 2] = h, t[e + 560 >> 2] = a + 4;
                          break t;
                        }
                        if (i = n, r = n - 4 | 0, n >>> 0 > r >>> 0)
                          for (; t[i >> 2] = t[r >> 2], i = i + 4 | 0, r = r + 4 | 0, n >>> 0 > r >>> 0; )
                            ;
                        t[e + 560 >> 2] = i, r = a + 4 | 0, (r | 0) != (n | 0) && (r = n - r | 0, Ge(n - (r & -4) | 0, a, r)), t[a >> 2] = h;
                        break t;
                      }
                      if (n = (n - r >> 2) + 1 | 0, n >>> 0 >= 1073741824)
                        break e;
                      r = u - r | 0, u = r >> 1, o = ur(l + 32 | 0, r >>> 0 >= 2147483644 ? 1073741823 : n >>> 0 < u >>> 0 ? u : n, i, o), i = t[o + 8 >> 2];
                      r: {
                        if ((i | 0) != t[o + 12 >> 2])
                          break r;
                        if (r = t[o + 4 >> 2], n = t[o >> 2], r >>> 0 > n >>> 0) {
                          n = ((r - n >> 2) + 1 | 0) / -2 << 2, g = n + r | 0, u = r, r = i - r | 0, i = Ge(g, u, r) + r | 0, t[o + 8 >> 2] = i, t[o + 4 >> 2] = n + t[o + 4 >> 2];
                          break r;
                        }
                        r = (i | 0) == (n | 0) ? 1 : i - n >> 1, u = ur(l + 56 | 0, r, r >>> 2 | 0, t[o + 16 >> 2]), n = t[u + 8 >> 2], r = t[o + 4 >> 2], i = t[o + 8 >> 2];
                        n: {
                          if ((r | 0) == (i | 0)) {
                            i = n, n = r;
                            break n;
                          }
                          for (i = (i - r | 0) + n | 0; t[n >> 2] = t[r >> 2], r = r + 4 | 0, n = n + 4 | 0, (n | 0) != (i | 0); )
                            ;
                          r = t[o + 8 >> 2], n = t[o + 4 >> 2];
                        }
                        if (g = t[o >> 2], t[o >> 2] = t[u >> 2], t[u >> 2] = g, t[o + 4 >> 2] = t[u + 4 >> 2], t[u + 4 >> 2] = n, t[o + 8 >> 2] = i, t[u + 8 >> 2] = r, S = t[o + 12 >> 2], t[o + 12 >> 2] = t[u + 12 >> 2], t[u + 12 >> 2] = S, (r | 0) != (n | 0) && (t[u + 8 >> 2] = ((n - r | 0) + 3 & -4) + r), !g)
                          break r;
                        p2(g), i = t[o + 8 >> 2];
                      }
                      if (t[i >> 2] = h, t[o + 8 >> 2] = t[o + 8 >> 2] + 4, r = t[e + 556 >> 2], i = a - r | 0, F = o, Z = Ge(t[o + 4 >> 2] - i | 0, r, i), t[F + 4 >> 2] = Z, n = t[e + 560 >> 2] - a | 0, a = Ge(t[o + 8 >> 2], a, n), r = t[e + 556 >> 2], t[e + 556 >> 2] = t[o + 4 >> 2], t[o + 4 >> 2] = r, i = t[e + 560 >> 2], t[e + 560 >> 2] = n + a, t[o + 8 >> 2] = i, n = t[e + 564 >> 2], t[e + 564 >> 2] = t[o + 12 >> 2], t[o >> 2] = r, t[o + 12 >> 2] = n, (r | 0) != (i | 0) && (t[o + 8 >> 2] = i + ((r - i | 0) + 3 & -4)), !r)
                        break t;
                      p2(r);
                    }
                    for (t[h + 552 >> 2] = e; r = X[e + 4 | 0], !!(!(r & 4) && (P[e + 4 | 0] = r | 4, r = t[e + 20 >> 2], r && e0[r | 0](e), t[e + 308 >> 2] = 2143289344, e = t[e + 552 >> 2], e)); )
                      ;
                    H = l + 80 | 0;
                    return;
                  }
                  t[l + 16 >> 2] = 4075, L2(e, l + 16 | 0), B2(), V0();
                }
                t[l >> 2] = 4208, L2(e, l), B2(), V0();
              }
              Ze(), V0();
            }
            function fi(e, r) {
              var i = 0, n = 0;
              for (t[e >> 2] = 0, t[e + 8 >> 2] = 0, t[e + 12 >> 2] = 0, t[e + 16 >> 2] = 0, t[e + 20 >> 2] = 0, t[e + 24 >> 2] = 0, t[e + 36 >> 2] = 2143289344, t[e + 40 >> 2] = 2141891242, t[e + 28 >> 2] = 2143289344, t[e + 32 >> 2] = 2143289344, P[e + 4 | 0] = X[e + 4 | 0] & 128, n = T2(e + 44 | 0, 0, 36); t[n + (i << 2) >> 2] = 2143289344, i = i + 1 | 0, (i | 0) != 9; )
                ;
              for (i = 0, n = T2(e + 80 | 0, 0, 36); t[n + (i << 2) >> 2] = 2143289344, i = i + 1 | 0, (i | 0) != 9; )
                ;
              for (i = 0, n = T2(e + 116 | 0, 0, 36); t[n + (i << 2) >> 2] = 2143289344, i = i + 1 | 0, (i | 0) != 9; )
                ;
              for (i = 0, n = T2(e + 152 | 0, 0, 36); t[n + (i << 2) >> 2] = 2143289344, i = i + 1 | 0, (i | 0) != 9; )
                ;
              for (i = 0, t[e + 196 >> 2] = 0, n = e + 188 | 0, t[n >> 2] = 0, t[n + 4 >> 2] = 0; t[n + (i << 2) >> 2] = 2143289344, i = i + 1 | 0, (i | 0) != 3; )
                ;
              for (t[e + 24 >> 2] = 4224, t[e + 224 >> 2] = 2143289344, t[e + 216 >> 2] = 2143289344, t[e + 220 >> 2] = 2143289344, t[e + 208 >> 2] = 2143289344, t[e + 212 >> 2] = 2143289344, t[e + 200 >> 2] = 2141891242, t[e + 204 >> 2] = 2141891242, T2(e + 228 | 0, 0, 288), t[e + 244 >> 2] = 2143289344, t[e + 248 >> 2] = 2143289344, T2(e + 252 | 0, 0, 49), t[e + 308 >> 2] = 2143289344, n = e + 516 | 0, i = e + 324 | 0; t[i + 16 >> 2] = -1082130432, t[i + 20 >> 2] = -1082130432, t[i + 8 >> 2] = 0, t[i + 12 >> 2] = 0, t[i >> 2] = -1082130432, t[i + 4 >> 2] = -1082130432, i = i + 24 | 0, (n | 0) != (i | 0); )
                ;
              return t[e + 548 >> 2] = 0, t[e + 552 >> 2] = 0, t[e + 516 >> 2] = 2143289344, t[e + 520 >> 2] = 2143289344, t[e + 572 >> 2] = 2143289344, t[e + 576 >> 2] = 0, t[e + 568 >> 2] = r, t[e + 540 >> 2] = -1082130432, t[e + 544 >> 2] = -1082130432, t[e + 532 >> 2] = 0, t[e + 536 >> 2] = 0, t[e + 524 >> 2] = -1082130432, t[e + 528 >> 2] = -1082130432, t[e + 556 >> 2] = 0, t[e + 560 >> 2] = 0, t[e + 564 >> 2] = 0, t[e + 580 >> 2] = 2143289344, t[e + 584 >> 2] = 0, Li((r | 0) != 0, 2760), P[e + 4 | 0] = X[e + 4 | 0] | 1, P[r + 8 | 0] & 1 && (t[e + 24 >> 2] = t[e + 24 >> 2] & -909 | 520), e;
            }
            function K0(e, r, i, n) {
              var o = f(0), u = f(0), a = 0, l = f(0);
              e: {
                i: {
                  t: {
                    r: {
                      n: {
                        f: {
                          if (r >>> 0 <= 1) {
                            u = A[e + 212 >> 2], r = t[e + 212 >> 2];
                            o: {
                              if ((r | 0) == 2139156720)
                                break o;
                              if ((r | 0) == 2140081935)
                                break f;
                              a = 4336;
                              u: {
                                if ((r | 0) != 2141891242) {
                                  if (u == u)
                                    break u;
                                  a = 4344;
                                }
                                switch (o = A[a >> 2], u = f(s0), t[a + 4 >> 2] - 1 | 0) {
                                  case 0:
                                    break f;
                                  case 1:
                                    break o;
                                  default:
                                    break n;
                                }
                              }
                              if (o = (J(2, (r & -1073741825) + 536870912 | 0), n0()), !(r & 1073741824))
                                break f;
                            }
                            u = f(f(o * n) * f(0.009999999776482582));
                            break n;
                          }
                          u = A[e + 208 >> 2];
                          o: {
                            u: {
                              r = t[e + 208 >> 2];
                              s: {
                                if ((r | 0) == 2139156720)
                                  break s;
                                if ((r | 0) == 2140081935)
                                  break u;
                                a = 4336;
                                a: {
                                  if ((r | 0) != 2141891242) {
                                    if (u == u)
                                      break a;
                                    a = 4344;
                                  }
                                  switch (o = A[a >> 2], u = f(s0), t[a + 4 >> 2] - 1 | 0) {
                                    case 0:
                                      break u;
                                    case 1:
                                      break s;
                                    default:
                                      break o;
                                  }
                                }
                                if (o = (J(2, (r & -1073741825) + 536870912 | 0), n0()), !(r & 1073741824))
                                  break u;
                              }
                              u = f(f(o * n) * f(0.009999999776482582));
                              break o;
                            }
                            u = o;
                          }
                          o = f(0), l = A[e + 216 >> 2], e = t[e + 216 >> 2];
                          o: {
                            if ((e | 0) == 2139156720)
                              break o;
                            if ((e | 0) == 2140081935)
                              break t;
                            r = 4336;
                            u: {
                              if ((e | 0) != 2141891242) {
                                if (l == l)
                                  break u;
                                r = 4344;
                              }
                              switch (o = A[r >> 2], t[r + 4 >> 2] - 1 | 0) {
                                case 1:
                                  break o;
                                case 0:
                                  break r;
                                default:
                                  break i;
                              }
                            }
                            if (o = (J(2, (e & -1073741825) + 536870912 | 0), n0()), !(e & 1073741824))
                              break r;
                          }
                          o = f(f(o * n) * f(0.009999999776482582));
                          break r;
                        }
                        u = o;
                      }
                      o = f(0), l = A[e + 220 >> 2], e = t[e + 220 >> 2];
                      n: {
                        if ((e | 0) == 2139156720)
                          break n;
                        if ((e | 0) == 2140081935)
                          break t;
                        r = 4336;
                        f: {
                          if ((e | 0) != 2141891242) {
                            if (l == l)
                              break f;
                            r = 4344;
                          }
                          switch (o = A[r >> 2], t[r + 4 >> 2] - 1 | 0) {
                            case 1:
                              break n;
                            case 0:
                              break r;
                            default:
                              break i;
                          }
                        }
                        if (o = (J(2, (e & -1073741825) + 536870912 | 0), n0()), !(e & 1073741824))
                          break r;
                      }
                      o = f(f(o * n) * f(0.009999999776482582));
                    }
                    if (!(o >= f(0)))
                      break i;
                  }
                  if (i > o)
                    break e;
                }
                if (!(u >= f(0)))
                  return i;
                o = i < u ? u : i;
              }
              return o;
            }
            function oi(e) {
              var r = 0, i = 0, n = f(0), o = f(0), u = f(0), a = 0, l = 0, h = 0, g = 0, S = 0, F = 0, Z = 0, T = 0, p = 0;
              for (a = H - 16 | 0, t[a + 8 >> 2] = 0, t[a + 12 >> 2] = 1, S = e + 200 | 0, F = e + 572 | 0, Z = e + 208 | 0, T = e + 216 | 0, e = 0; ; ) {
                p = e, g = t[(a + 8 | 0) + (e << 2) >> 2], l = g << 2, e = T + l | 0, n = A[e >> 2];
                e: {
                  i: {
                    t: {
                      r: {
                        n: {
                          f: {
                            if (r = t[e >> 2], h = (r | 0) == 2139156720, !(h | (r | 0) == 2140081935 | (r | 0) == 2141891242) & n != n)
                              break f;
                            e = l + Z | 0, o = A[e >> 2], i = t[e >> 2];
                            o: {
                              u: {
                                if ((i | 0) != 2139156720) {
                                  if (u = f(s0), e = 3, (i | 0) == 2141891242)
                                    break o;
                                  if ((i | 0) != 2140081935)
                                    break u;
                                  u = f(0), e = 1;
                                  break o;
                                }
                                u = f(0), e = 2;
                                break o;
                              }
                              if (e = 0, o != o)
                                break o;
                              u = (J(2, (i & -1073741825) + 536870912 | 0), n0()), e = i & 1073741824 ? 2 : 1;
                            }
                            i = e;
                            o: {
                              u: {
                                if (!h) {
                                  if (o = f(s0), e = 3, (r | 0) == 2141891242)
                                    break o;
                                  if ((r | 0) != 2140081935)
                                    break u;
                                  o = f(0), e = 1;
                                  break o;
                                }
                                o = f(0), e = 2;
                                break o;
                              }
                              if (e = 0, n != n)
                                break o;
                              o = (J(2, (r & -1073741825) + 536870912 | 0), n0()), e = r & 1073741824 ? 2 : 1;
                            }
                            if ((i | 0) != (e | 0) | !(!e | o != o & u != u | f($0(f(o - u))) < f(9999999747378752e-20)))
                              break f;
                            if (e = 0, h)
                              break n;
                            if ((r | 0) == 2140081935)
                              break i;
                            if ((r | 0) == 2141891242)
                              break t;
                            if (n != n)
                              break r;
                            e = (r & -1073741825) + 536870912 | 0, r = r & 1073741824 ? 2 : 1;
                            break e;
                          }
                          if (e = 0, r = l + S | 0, n = A[r >> 2], r = t[r >> 2], (r | 0) == 2139156720)
                            break n;
                          if ((r | 0) == 2140081935)
                            break i;
                          if ((r | 0) == 2141891242)
                            break t;
                          if (n != n)
                            break r;
                          e = (r & -1073741825) + 536870912 | 0, r = r & 1073741824 ? 2 : 1;
                          break e;
                        }
                        r = 2;
                        break e;
                      }
                      e = 2143289344, r = 0;
                      break e;
                    }
                    e = 2143289344, r = 3;
                    break e;
                  }
                  r = 1;
                }
                if (i = (g << 3) + F | 0, t[i + 4 >> 2] = r, t[i >> 2] = e, e = 1, !!(p & 1))
                  break;
              }
            }
            function S2(e, r, i) {
              var n = 0, o = 0, u = 0;
              if (i >>> 0 >= 512)
                return n1(e | 0, r | 0, i | 0), e;
              o = e + i | 0;
              e: {
                if (!((e ^ r) & 3)) {
                  i: {
                    if (!(e & 3)) {
                      i = e;
                      break i;
                    }
                    if (!i) {
                      i = e;
                      break i;
                    }
                    for (i = e; ; ) {
                      if (P[i | 0] = X[r | 0], r = r + 1 | 0, i = i + 1 | 0, !(i & 3))
                        break i;
                      if (!(i >>> 0 < o >>> 0))
                        break;
                    }
                  }
                  n = o & -4;
                  i: {
                    if (n >>> 0 < 64 || (u = n + -64 | 0, u >>> 0 < i >>> 0))
                      break i;
                    for (; t[i >> 2] = t[r >> 2], t[i + 4 >> 2] = t[r + 4 >> 2], t[i + 8 >> 2] = t[r + 8 >> 2], t[i + 12 >> 2] = t[r + 12 >> 2], t[i + 16 >> 2] = t[r + 16 >> 2], t[i + 20 >> 2] = t[r + 20 >> 2], t[i + 24 >> 2] = t[r + 24 >> 2], t[i + 28 >> 2] = t[r + 28 >> 2], t[i + 32 >> 2] = t[r + 32 >> 2], t[i + 36 >> 2] = t[r + 36 >> 2], t[i + 40 >> 2] = t[r + 40 >> 2], t[i + 44 >> 2] = t[r + 44 >> 2], t[i + 48 >> 2] = t[r + 48 >> 2], t[i + 52 >> 2] = t[r + 52 >> 2], t[i + 56 >> 2] = t[r + 56 >> 2], t[i + 60 >> 2] = t[r + 60 >> 2], r = r - -64 | 0, i = i - -64 | 0, u >>> 0 >= i >>> 0; )
                      ;
                  }
                  if (i >>> 0 >= n >>> 0)
                    break e;
                  for (; t[i >> 2] = t[r >> 2], r = r + 4 | 0, i = i + 4 | 0, n >>> 0 > i >>> 0; )
                    ;
                  break e;
                }
                if (o >>> 0 < 4) {
                  i = e;
                  break e;
                }
                if (n = o - 4 | 0, n >>> 0 < e >>> 0) {
                  i = e;
                  break e;
                }
                for (i = e; P[i | 0] = X[r | 0], P[i + 1 | 0] = X[r + 1 | 0], P[i + 2 | 0] = X[r + 2 | 0], P[i + 3 | 0] = X[r + 3 | 0], r = r + 4 | 0, i = i + 4 | 0, n >>> 0 >= i >>> 0; )
                  ;
              }
              if (i >>> 0 < o >>> 0)
                for (; P[i | 0] = X[r | 0], r = r + 1 | 0, i = i + 1 | 0, (o | 0) != (i | 0); )
                  ;
              return e;
            }
            function ui(e, r, i, n, o) {
              var u = f(0), a = 0, l = f(0), h = f(0), g = 0, S = 0, F = f(0), Z = f(0), T = 0;
              if (l = f(i - n), S = l != l, !S) {
                i = f(0), a = (r << 2) + e | 0, u = A[a + 208 >> 2];
                e: {
                  i: {
                    a = t[a + 208 >> 2];
                    t: {
                      r: {
                        if ((a | 0) == 2139156720)
                          break r;
                        if ((a | 0) == 2140081935)
                          break i;
                        g = 4336;
                        n: {
                          if ((a | 0) != 2141891242) {
                            if (u == u)
                              break n;
                            g = 4344;
                          }
                          switch (i = A[g >> 2], t[g + 4 >> 2] - 1 | 0) {
                            case 0:
                              break t;
                            case 1:
                              break r;
                            default:
                              break e;
                          }
                        }
                        if (i = (J(2, (a & -1073741825) + 536870912 | 0), n0()), !(a & 1073741824))
                          break t;
                      }
                      i = f(f(i * o) * f(0.009999999776482582));
                    }
                    if (i == i)
                      break i;
                    break e;
                  }
                  h = f(i - n);
                }
                i = f(0), e = (r << 2) + e | 0, u = A[e + 216 >> 2];
                e: {
                  i: {
                    r = t[e + 216 >> 2];
                    t: {
                      r: {
                        if ((r | 0) == 2139156720)
                          break r;
                        if ((r | 0) == 2140081935)
                          break i;
                        e = 4336;
                        n: {
                          if ((r | 0) != 2141891242) {
                            if (u == u)
                              break n;
                            e = 4344;
                          }
                          switch (i = A[e >> 2], u = f(34028234663852886e22), t[e + 4 >> 2] - 1 | 0) {
                            case 0:
                              break t;
                            case 1:
                              break r;
                            default:
                              break e;
                          }
                        }
                        if (i = (J(2, (r & -1073741825) + 536870912 | 0), n0()), !(r & 1073741824))
                          break t;
                      }
                      i = f(f(i * o) * f(0.009999999776482582));
                    }
                    if (i == i)
                      break i;
                    u = f(34028234663852886e22);
                    break e;
                  }
                  u = f(i - n);
                }
                if (i = (F = l, Z = wt(l, u), T = u != u | S, T ? F : Z), e = i != i, !(e | h != h))
                  return g0(i, h);
                l = e ? h : i;
              }
              return l;
            }
            function si(e, r, i, n, o, u, a, l, h, g, S, F, Z) {
              var T = f(0), p = f(0), m = 0, d = 0, W = f(0), V = f(0), C = f(0), L = 0, M = 0;
              if (h < f(0) | g < f(0))
                e = 0;
              else {
                W = u, V = r, C = n, p = l;
                e: {
                  if (!Z || (T = A[Z + 20 >> 2], p = l, T == f(0)))
                    break e;
                  L = +T, V = ee(+r, L, 0, 0), C = ee(+n, L, 0, 0), W = ee(+u, L, 0, 0), p = ee(+l, L, 0, 0);
                }
                T = p, Z = 0;
                e: {
                  if ((e | 0) != (o | 0))
                    break e;
                  if (M = W != W, Z = V != V, M | Z) {
                    Z = Z & M;
                    break e;
                  }
                  Z = f($0(f(W - V))) < f(9999999747378752e-20);
                }
                M = Z;
                e: {
                  if ((i | 0) != (a | 0))
                    break e;
                  if (m = T != T, Z = C != C, m | Z) {
                    m = Z & m;
                    break e;
                  }
                  m = f($0(f(T - C))) < f(9999999747378752e-20);
                }
                d = 1, Z = 1;
                e: {
                  if (M)
                    break e;
                  r = f(r - S);
                  i: {
                    if ((e | 0) == 1)
                      break i;
                    if (e = (e | 0) != 2, !(e | o)) {
                      if (!(r >= h))
                        break i;
                      break e;
                    }
                    if (Z = 0, !(r < u) | (e | (o | 0) != 2 | (r != r | u != u | h != h)) || (Z = 1, r >= h))
                      break e;
                  }
                  if (o = r != r, e = h != h, o | e) {
                    Z = e & o;
                    break e;
                  }
                  Z = f($0(f(r - h))) < f(9999999747378752e-20);
                }
                e: {
                  if (m)
                    break e;
                  r = f(n - F);
                  i: {
                    if ((i | 0) == 1)
                      break i;
                    if (e = (i | 0) != 2, !(e | a)) {
                      if (!(r >= g))
                        break i;
                      break e;
                    }
                    if (d = 0, !(r < l) | (e | (a | 0) != 2 | (r != r | l != l | g != g)) || (d = 1, r >= g))
                      break e;
                  }
                  if (i = r != r, e = g != g, i | e) {
                    d = e & i;
                    break e;
                  }
                  d = f($0(f(r - g))) < f(9999999747378752e-20);
                }
                e = Z & d;
              }
              return e;
            }
            function at(e) {
              var r = 0, i = 0, n = 0, o = 0, u = 0, a = 0, l = 0, h = 0;
              if (R2(+e), u = R0(1) | 0, n = R0(0) | 0, o = u >>> 20 & 2047, (o | 0) == 2047)
                return e = e * 1, e / e;
              if (r = n << 1, a = u << 1 | n >>> 31, !r & (a | 0) == 2145386496 | a >>> 0 < 2145386496)
                return !r & (a | 0) == 2145386496 ? e * 0 : e;
              e: {
                if (!o) {
                  if (o = 0, i = n << 12, r = u << 12 | n >>> 20, (r | 0) > 0 | (r | 0) >= 0)
                    for (; o = o - 1 | 0, r = r << 1 | i >>> 31, i = i << 1, !!((r | 0) > 0 | (r | 0) >= 0); )
                      ;
                  r = 1 - o | 0, i = r & 31, (r & 63) >>> 0 >= 32 ? (r = n << i, n = 0) : (r = (1 << i) - 1 & n >>> 32 - i | u << i, n = n << i);
                  break e;
                }
                r = u & 1048575 | 1048576;
              }
              if (i = n, (o | 0) > 1023) {
                for (; ; ) {
                  e: {
                    if (n = r + -1048576 | 0, (n | 0) < 0 || (r = n, r | i))
                      break e;
                    return e * 0;
                  }
                  if (r = r << 1 | i >>> 31, i = i << 1, o = o - 1 | 0, !((o | 0) > 1023))
                    break;
                }
                o = 1023;
              }
              e: {
                if (n = r + -1048576 | 0, (n | 0) < 0 || (r = n, r | i))
                  break e;
                return e * 0;
              }
              if ((r | 0) == 1048575 | r >>> 0 < 1048575)
                for (; o = o - 1 | 0, n = r >>> 0 < 524288, a = r << 1 | i >>> 31, i = i << 1, r = a, !!n; )
                  ;
              return h = u & -2147483648, a = r + -1048576 | o << 20, l = i, u = r, l = i, n = 1 - o | 0, i = n & 31, (n & 63) >>> 0 >= 32 ? (r = 0, n = u >>> i | 0) : (r = u >>> i | 0, n = ((1 << i) - 1 & u) << 32 - i | l >>> i), i = (o | 0) > 0, J(0, (i ? l : n) | 0), J(1, (i ? a : r) | h), +g2();
            }
            function lt(e) {
              var r = 0, i = 0, n = 0, o = 0, u = 0;
              n = t[1416], r = e + 7 & -8, i = n + r | 0;
              e: {
                i: {
                  if (i >>> 0 <= n >>> 0 && r || i >>> 0 > Ki() << 16 >>> 0 && !(i1(i | 0) | 0))
                    break i;
                  t[1416] = i;
                  break e;
                }
                t[1781] = 48, n = -1;
              }
              if ((n | 0) != -1) {
                r = e + n | 0, i = r - 16 | 0, t[i + 12 >> 2] = 16, t[i >> 2] = 16, e = t[1748], e ? u = t[e + 8 >> 2] : u = 0;
                e: {
                  i: {
                    if ((u | 0) == (n | 0)) {
                      if (o = n - (t[n - 4 >> 2] & -2) | 0, u = t[o - 4 >> 2], t[e + 8 >> 2] = r, e = o - (u & -2) | 0, r = -16, !(P[(e + t[e >> 2] | 0) - 4 | 0] & 1))
                        break i;
                      r = t[e + 4 >> 2], t[r + 8 >> 2] = t[e + 8 >> 2], t[t[e + 8 >> 2] + 4 >> 2] = r, i = i - e | 0, t[e >> 2] = i;
                      break e;
                    }
                    t[n + 12 >> 2] = 16, t[n >> 2] = 16, t[n + 8 >> 2] = r, t[n + 4 >> 2] = e, t[1748] = n, r = 16;
                  }
                  e = r + n | 0, i = i - e | 0, t[e >> 2] = i;
                }
                t[((i & -4) + e | 0) - 4 >> 2] = i | 1, r = t[e >> 2] - 8 | 0;
                e: {
                  if (r >>> 0 <= 127) {
                    i = (r >>> 3 | 0) - 1 | 0;
                    break e;
                  }
                  if (o = H2(r), i = ((r >>> 29 - o ^ 4) - (o << 2) | 0) + 110 | 0, r >>> 0 <= 4095)
                    break e;
                  i = ((r >>> 30 - o ^ 2) - (o << 1) | 0) + 71 | 0, i = i >>> 0 >= 63 ? 63 : i;
                }
                r = i << 4, t[e + 4 >> 2] = r + 5968, r = r + 5976 | 0, t[e + 8 >> 2] = t[r >> 2], t[r >> 2] = e, t[t[e + 8 >> 2] + 4 >> 2] = e, r = t[1750], o = t[1751], e = i & 31, (i & 63) >>> 0 >= 32 ? (i = 1 << e, u = 0) : (u = 1 << e, i = u - 1 & 1 >>> 32 - e), t[1750] = u | r, t[1751] = i | o;
              }
              return (n | 0) != -1;
            }
            function ai(e, r, i) {
              var n = 0, o = 0, u = 0, a = 0, l = 0, h = 0, g = 0, S = 0, F = 0;
              e: {
                i: {
                  t: {
                    r: {
                      n: {
                        f: {
                          o: {
                            u: {
                              s: {
                                a: {
                                  if (r) {
                                    if (!i)
                                      break a;
                                    break s;
                                  }
                                  e = (e >>> 0) / (i >>> 0) | 0, G2 = 0;
                                  break e;
                                }
                                if (!e)
                                  break u;
                                break o;
                              }
                              if (!(i - 1 & i))
                                break f;
                              u = (H2(i) + 33 | 0) - H2(r) | 0, a = 0 - u | 0;
                              break r;
                            }
                            e = (r >>> 0) / 0 | 0, G2 = 0;
                            break e;
                          }
                          if (n = 32 - H2(r) | 0, n >>> 0 < 31)
                            break n;
                          break t;
                        }
                        if ((i | 0) == 1)
                          break i;
                        u = i ? 31 - H2(i - 1 ^ i) | 0 : 32, i = u & 31, (u & 63) >>> 0 >= 32 ? e = r >>> i | 0 : (n = r >>> i | 0, e = ((1 << i) - 1 & r) << 32 - i | e >>> i), G2 = n;
                        break e;
                      }
                      u = n + 1 | 0, a = 63 - n | 0;
                    }
                    if (n = u & 63, o = n & 31, n >>> 0 >= 32 ? (n = 0, l = r >>> o | 0) : (n = r >>> o | 0, l = ((1 << o) - 1 & r) << 32 - o | e >>> o), a = a & 63, o = a & 31, a >>> 0 >= 32 ? (r = e << o, e = 0) : (r = (1 << o) - 1 & e >>> 32 - o | r << o, e = e << o), u)
                      for (a = i - 1 | 0, F = (a | 0) == -1 ? -1 : 0; h = n << 1 | l >>> 31, n = l << 1 | r >>> 31, o = F - (h + (n >>> 0 > a >>> 0) | 0) >> 31, g = i & o, l = n - g | 0, n = h - (n >>> 0 < g >>> 0) | 0, r = r << 1 | e >>> 31, e = S | e << 1, S = o & 1, u = u - 1 | 0, !!u; )
                        ;
                    G2 = r << 1 | e >>> 31, e = S | e << 1;
                    break e;
                  }
                  e = 0, r = 0;
                }
                G2 = r;
              }
              return e;
            }
            function Or(e, r, i) {
              var n = f(0), o = f(0);
              e: {
                i: {
                  t: {
                    if ((r & -2) == 2) {
                      if (r = t[e + 188 >> 2], n = A[e + 188 >> 2], (r | 0) == 2139156720 | (r | 0) == 2140081935 | (r | 0) == 2141891242 | n == n || (r = t[e + 196 >> 2], n = A[e + 196 >> 2], (r | 0) == 2139156720 | (r | 0) == 2140081935 | (r | 0) == 2141891242 | n == n))
                        break t;
                      break i;
                    }
                    if (r = t[e + 192 >> 2], n = A[e + 192 >> 2], (r | 0) == 2139156720 | (r | 0) == 2140081935 | (r | 0) == 2141891242 | n == n || (n = A[e + 196 >> 2], r = t[e + 196 >> 2], (r | 0) == 2139156720 | (r | 0) == 2140081935 | (r | 0) == 2141891242))
                      break t;
                    if (n != n)
                      break i;
                  }
                  n = f(0);
                  t: {
                    r: {
                      if ((r | 0) == 2139156720)
                        break r;
                      if ((r | 0) == 2140081935)
                        break e;
                      e = 4336;
                      n: {
                        if ((r | 0) != 2141891242) {
                          if (n = (J(2, r), n0()), n == n)
                            break n;
                          e = 4344;
                        }
                        switch (n = A[e >> 2], o = f(s0), t[e + 4 >> 2] - 1 | 0) {
                          case 0:
                            break e;
                          case 1:
                            break r;
                          default:
                            break t;
                        }
                      }
                      if (n = (J(2, (r & -1073741825) + 536870912 | 0), n0()), !(r & 1073741824))
                        break e;
                    }
                    o = f(f(n * i) * f(0.009999999776482582));
                  }
                  return o;
                }
                n = f(0);
              }
              return n;
            }
            function li(e, r) {
              var i = 0, n = 0, o = 0, u = 0, a = 0, l = 0;
              for (i = H - 320 | 0, H = i, n = T2(i, 0, 288), i = n, t[i + 16 >> 2] = 2143289344, t[i + 20 >> 2] = 2143289344, T2(i + 24 | 0, 0, 49), t[i + 80 >> 2] = 2143289344, u = i + 288 | 0, o = i + 96 | 0; i = o, t[i + 16 >> 2] = -1082130432, t[i + 20 >> 2] = -1082130432, t[i + 8 >> 2] = 0, t[i + 12 >> 2] = 0, t[i >> 2] = -1082130432, t[i + 4 >> 2] = -1082130432, o = i + 24 | 0, (u | 0) != (o | 0); )
                ;
              if (t[n + 312 >> 2] = -1082130432, t[n + 316 >> 2] = -1082130432, t[n + 304 >> 2] = 0, t[n + 308 >> 2] = 0, t[n + 296 >> 2] = -1082130432, t[n + 300 >> 2] = -1082130432, t[n + 288 >> 2] = 2143289344, t[n + 292 >> 2] = 2143289344, S2(e + 228 | 0, n, 320), t[e + 244 >> 2] = 0, t[e + 248 >> 2] = 0, P[e + 4 | 0] = X[e + 4 | 0] | 1, o = t[e + 556 >> 2], a = t[e + 560 >> 2], (o | 0) != (a | 0))
                for (; i = t[o >> 2], t[i + 552 >> 2] != (e | 0) && (u = t[e + 568 >> 2], i = wi(t[u >> 2], X[u + 8 | 0], i, e, l, r), t[o >> 2] = i, t[i + 552 >> 2] = e, i = t[o >> 2]), li(i, r), l = l + 1 | 0, o = o + 4 | 0, (a | 0) != (o | 0); )
                  ;
              H = n + 320 | 0;
            }
            function kt(e, r, i) {
              var n = 0, o = 0, u = 0, a = 0;
              if (n = e + 4 | 0, o = (n + r | 0) - 1 & 0 - r, r = t[e >> 2], o + i >>> 0 <= (r + e | 0) - 4 >>> 0) {
                u = t[e + 4 >> 2], t[u + 8 >> 2] = t[e + 8 >> 2], t[t[e + 8 >> 2] + 4 >> 2] = u, (n | 0) != (o | 0) && (o = o - n | 0, u = e - (t[e - 4 >> 2] & -2) | 0, n = o + t[u >> 2] | 0, t[u >> 2] = n, t[(u + (n & -4) | 0) - 4 >> 2] = n, e = e + o | 0, r = r - o | 0, t[e >> 2] = r);
                e: {
                  if (i + 24 >>> 0 <= r >>> 0) {
                    n = (e + i | 0) + 8 | 0, r = (r - i | 0) - 8 | 0, t[n >> 2] = r, t[(n + (r & -4) | 0) - 4 >> 2] = r | 1, o = t[n >> 2] - 8 | 0;
                    i: {
                      if (o >>> 0 <= 127) {
                        r = (o >>> 3 | 0) - 1 | 0;
                        break i;
                      }
                      if (u = H2(o), r = ((o >>> 29 - u ^ 4) - (u << 2) | 0) + 110 | 0, o >>> 0 <= 4095)
                        break i;
                      r = ((o >>> 30 - u ^ 2) - (u << 1) | 0) + 71 | 0, r = r >>> 0 >= 63 ? 63 : r;
                    }
                    o = r << 4, t[n + 4 >> 2] = o + 5968, o = o + 5976 | 0, t[n + 8 >> 2] = t[o >> 2], t[o >> 2] = n, t[t[n + 8 >> 2] + 4 >> 2] = n, o = t[1750], u = t[1751], n = r & 31, (r & 63) >>> 0 >= 32 ? (r = 1 << n, n = 0) : (a = 1 << n, r = a - 1 & 1 >>> 32 - n, n = a), t[1750] = n | o, t[1751] = r | u, r = i + 8 | 0, t[e >> 2] = r, t[((r & -4) + e | 0) - 4 >> 2] = r;
                    break e;
                  }
                  t[(e + r | 0) - 4 >> 2] = r;
                }
                e = e + 4 | 0;
              } else
                e = 0;
              return e;
            }
            function p1(e, r) {
              e = e | 0, r = r | 0;
              var i = 0, n = 0, o = 0, u = 0;
              o = H - 320 | 0, H = o, e = t[e >> 2];
              e: {
                if (t[e + 560 >> 2] == t[e + 556 >> 2] || (n = t[r >> 2], r = t[n + 552 >> 2], !di(e, n)))
                  break e;
                if ((e | 0) == (r | 0)) {
                  for (i = T2(o, 0, 288), r = i, t[r + 16 >> 2] = 2143289344, t[r + 20 >> 2] = 2143289344, T2(r + 24 | 0, 0, 49), t[r + 80 >> 2] = 2143289344, u = r + 288 | 0, r = r + 96 | 0; t[r + 16 >> 2] = -1082130432, t[r + 20 >> 2] = -1082130432, t[r + 8 >> 2] = 0, t[r + 12 >> 2] = 0, t[r >> 2] = -1082130432, t[r + 4 >> 2] = -1082130432, r = r + 24 | 0, (u | 0) != (r | 0); )
                    ;
                  t[i + 312 >> 2] = -1082130432, t[i + 316 >> 2] = -1082130432, t[i + 304 >> 2] = 0, t[i + 308 >> 2] = 0, t[i + 296 >> 2] = -1082130432, t[i + 300 >> 2] = -1082130432, t[i + 288 >> 2] = 2143289344, t[i + 292 >> 2] = 2143289344, S2(n + 228 | 0, i, 320), t[n + 552 >> 2] = 0;
                }
                for (; ; ) {
                  if (r = X[e + 4 | 0], r & 4)
                    break e;
                  if (P[e + 4 | 0] = r | 4, r = t[e + 20 >> 2], r && e0[r | 0](e), t[e + 308 >> 2] = 2143289344, e = t[e + 552 >> 2], !e)
                    break;
                }
              }
              H = o + 320 | 0;
            }
            function ki(e) {
              e = e | 0;
              var r = 0, i = 0, n = 0, o = 0, u = 0, a = 0, l = 0;
              if (e) {
                if (a = H - 32 | 0, H = a, r = t[e >> 2], n = t[r + 552 >> 2], n && (di(n, r), t[r + 552 >> 2] = 0), n = t[r + 556 >> 2], i = t[r + 560 >> 2], (n | 0) != (i | 0))
                  for (i = i - n >> 2, o = i >>> 0 <= 1 ? 1 : i, i = 0; t[t[(i << 2) + n >> 2] + 552 >> 2] = 0, i = i + 1 | 0, (o | 0) != (i | 0); )
                    ;
                t[r + 560 >> 2] = n, i = r + 564 | 0;
                e: {
                  if (t[i >> 2] == (n | 0) || (i = ur(a + 8 | 0, 0, 0, i), o = t[r + 556 >> 2], u = t[r + 560 >> 2] - o | 0, n = t[i + 4 >> 2] - u | 0, u = Ge(n, o, u), o = t[r + 556 >> 2], t[r + 556 >> 2] = u, t[i + 4 >> 2] = o, u = t[r + 560 >> 2], t[r + 560 >> 2] = t[i + 8 >> 2], t[i + 8 >> 2] = u, l = t[r + 564 >> 2], t[r + 564 >> 2] = t[i + 12 >> 2], t[i >> 2] = o, t[i + 12 >> 2] = l, (o | 0) != (u | 0) && (t[i + 8 >> 2] = u + ((o - u | 0) + 3 & -4)), !o))
                    break e;
                  p2(o), n = t[r + 556 >> 2];
                }
                n && (t[r + 560 >> 2] = n, p2(n)), p2(r), r = t[e + 8 >> 2], t[e + 8 >> 2] = 0, r && e0[t[t[r >> 2] + 4 >> 2]](r), r = t[e + 4 >> 2], t[e + 4 >> 2] = 0, r && e0[t[t[r >> 2] + 4 >> 2]](r), H = a + 32 | 0, p2(e);
              }
            }
            function w1(e) {
              e = e | 0;
              var r = 0, i = 0, n = 0;
              n = H - 624 | 0, H = n, r = t[e + 4 >> 2], t[e + 4 >> 2] = 0, r && e0[t[t[r >> 2] + 4 >> 2]](r), r = t[e + 8 >> 2], t[e + 8 >> 2] = 0, r && e0[t[t[r >> 2] + 4 >> 2]](r);
              e: {
                if (e = t[e >> 2], t[e + 560 >> 2] == t[e + 556 >> 2]) {
                  if (t[e + 552 >> 2])
                    break e;
                  r = fi(n + 32 | 0, t[e + 568 >> 2]), i = t[r + 4 >> 2], t[e >> 2] = t[r >> 2], t[e + 4 >> 2] = i, i = t[r + 20 >> 2], t[e + 16 >> 2] = t[r + 16 >> 2], t[e + 20 >> 2] = i, i = t[r + 12 >> 2], t[e + 8 >> 2] = t[r + 8 >> 2], t[e + 12 >> 2] = i, S2(e + 24 | 0, r + 24 | 0, 204), S2(e + 228 | 0, r + 228 | 0, 328), i = t[e + 556 >> 2], i && (t[e + 560 >> 2] = i, p2(i)), t[e + 556 >> 2] = t[r + 556 >> 2], t[e + 560 >> 2] = t[r + 560 >> 2], t[e + 564 >> 2] = t[r + 564 >> 2], t[e + 584 >> 2] = t[r + 584 >> 2], i = t[r + 580 >> 2], t[e + 576 >> 2] = t[r + 576 >> 2], t[e + 580 >> 2] = i, i = t[r + 572 >> 2], t[e + 568 >> 2] = t[r + 568 >> 2], t[e + 572 >> 2] = i, H = n + 624 | 0;
                  return;
                }
                t[n + 16 >> 2] = 3301, L2(e, n + 16 | 0), B2(), V0();
              }
              t[n >> 2] = 2047, L2(e, n), B2(), V0();
            }
            function ci() {
              a1(7084, 3067), s1(7085, 2480, 1, 1, 0), ce(7086, 2140, 1, -128, 127), ce(7087, 2133, 1, -128, 127), ce(7088, 2131, 1, 0, 255), ce(7089, 1287, 2, -32768, 32767), ce(7090, 1278, 2, 0, 65535), ce(7091, 1316, 4, -2147483648, 2147483647), ce(7092, 1307, 4, 0, -1), ce(7093, 2659, 4, -2147483648, 2147483647), ce(7094, 2650, 4, 0, -1), zi(7095, 1777, -2147483648, 2147483647), zi(7096, 1776, 0, -1), qt(7097, 1770, 4), qt(7098, 3015, 8), bt(7099, 2677), bt(7100, 3904), ft(7101, 4, 2664), ft(7102, 2, 2689), ft(7103, 4, 2704), u1(7104, 2485), y2(7105, 0, 3835), y2(7106, 0, 3937), y2(7107, 1, 3865), y2(7108, 2, 3467), y2(7109, 3, 3498), y2(7110, 4, 3538), y2(7111, 5, 3567), y2(7112, 4, 3974), y2(7113, 5, 4004), y2(7106, 0, 3669), y2(7107, 1, 3636), y2(7108, 2, 3735), y2(7109, 3, 3701), y2(7110, 4, 3802), y2(7111, 5, 3768), y2(7114, 6, 3605), y2(7115, 7, 4043);
            }
            function Ge(e, r, i) {
              var n = 0, o = 0;
              e: {
                if ((e | 0) == (r | 0))
                  break e;
                if (o = e + i | 0, r - o >>> 0 <= 0 - (i << 1) >>> 0)
                  return S2(e, r, i);
                n = (e ^ r) & 3;
                i: {
                  t: {
                    if (e >>> 0 < r >>> 0) {
                      if (n) {
                        n = e;
                        break i;
                      }
                      if (!(e & 3)) {
                        n = e;
                        break t;
                      }
                      for (n = e; ; ) {
                        if (!i)
                          break e;
                        if (P[n | 0] = X[r | 0], r = r + 1 | 0, i = i - 1 | 0, n = n + 1 | 0, !(n & 3))
                          break;
                      }
                      break t;
                    }
                    r: {
                      if (n)
                        break r;
                      if (o & 3)
                        for (; ; ) {
                          if (!i)
                            break e;
                          if (i = i - 1 | 0, n = i + e | 0, P[n | 0] = X[r + i | 0], !(n & 3))
                            break;
                        }
                      if (i >>> 0 <= 3)
                        break r;
                      for (; i = i - 4 | 0, t[i + e >> 2] = t[r + i >> 2], i >>> 0 > 3; )
                        ;
                    }
                    if (!i)
                      break e;
                    for (; i = i - 1 | 0, P[i + e | 0] = X[r + i | 0], !!i; )
                      ;
                    break e;
                  }
                  if (i >>> 0 <= 3)
                    break i;
                  for (; t[n >> 2] = t[r >> 2], r = r + 4 | 0, n = n + 4 | 0, i = i - 4 | 0, i >>> 0 > 3; )
                    ;
                }
                if (!i)
                  break e;
                for (; P[n | 0] = X[r | 0], n = n + 1 | 0, r = r + 1 | 0, i = i - 1 | 0, !!i; )
                  ;
              }
              return e;
            }
            function Ai(e, r, i, n) {
              e:
                switch (r - 9 | 0) {
                  case 0:
                    r = t[i >> 2], t[i >> 2] = r + 4, t[e >> 2] = t[r >> 2];
                    return;
                  case 6:
                    r = t[i >> 2], t[i >> 2] = r + 4, r = K2[r >> 1], t[e >> 2] = r, t[e + 4 >> 2] = r >> 31;
                    return;
                  case 7:
                    r = t[i >> 2], t[i >> 2] = r + 4, t[e >> 2] = je[r >> 1], t[e + 4 >> 2] = 0;
                    return;
                  case 8:
                    r = t[i >> 2], t[i >> 2] = r + 4, r = P[r | 0], t[e >> 2] = r, t[e + 4 >> 2] = r >> 31;
                    return;
                  case 9:
                    r = t[i >> 2], t[i >> 2] = r + 4, t[e >> 2] = X[r | 0], t[e + 4 >> 2] = 0;
                    return;
                  case 16:
                    r = t[i >> 2] + 7 & -8, t[i >> 2] = r + 8, Q0[e >> 3] = Q0[r >> 3];
                    return;
                  case 17:
                    e0[n | 0](e, i);
                  default:
                    return;
                  case 1:
                  case 4:
                  case 14:
                    r = t[i >> 2], t[i >> 2] = r + 4, r = t[r >> 2], t[e >> 2] = r, t[e + 4 >> 2] = r >> 31;
                    return;
                  case 2:
                  case 5:
                  case 11:
                  case 15:
                    r = t[i >> 2], t[i >> 2] = r + 4, t[e >> 2] = t[r >> 2], t[e + 4 >> 2] = 0;
                    return;
                  case 3:
                  case 10:
                  case 12:
                  case 13:
                    break e;
                }
              r = t[i >> 2] + 7 & -8, t[i >> 2] = r + 8, i = t[r + 4 >> 2], t[e >> 2] = t[r >> 2], t[e + 4 >> 2] = i;
            }
            function hi(e, r, i, n) {
              var o = 0, u = 0, a = 0, l = 0, h = 0, g = 0, S = 0, F = 0, Z = 0, T = f(0), p = f(0), m = f(0), d = 0, W = f(0);
              e: {
                if (r == 0 || (T = A[e + 248 >> 2], p = A[e + 244 >> 2], m = A[e + 232 >> 2], h = +A[e + 228 >> 2], o = X[e + 4 | 0] & 8, u = o >>> 3 | 0, d = e, W = ee(h, r, 0, u), A[d + 228 >> 2] = W, g = +m, d = e, W = ee(g, r, 0, u), A[d + 232 >> 2] = W, S = +p, a = at(S * r), u = a == a & $0(a) < 1e-4, l = !(u | a != a ? u : $0(a + -1) < 1e-4), F = +T, a = at(F * r), u = a == a & $0(a) < 1e-4, Z = !(u | a != a ? u : $0(a + -1) < 1e-4), u = 0, i = h + i, o = (o | 0) != 0, d = e, W = f(ee(i + S, r, o & l, o & !l) - ee(i, r, 0, o)), A[d + 244 >> 2] = W, n = g + n, d = e, W = f(ee(n + F, r, o & Z, o & !Z) - ee(n, r, 0, o)), A[d + 248 >> 2] = W, o = t[e + 560 >> 2], l = t[e + 556 >> 2], (o | 0) == (l | 0)))
                  break e;
                for (o = o - l >> 2, l = o >>> 0 <= 1 ? 1 : o; o = t[e + 556 >> 2], t[e + 560 >> 2] - o >> 2 >>> 0 > u >>> 0 ? o = t[o + (u << 2) >> 2] : o = 0, hi(o, r, i, n), u = u + 1 | 0, (l | 0) != (u | 0); )
                  ;
              }
            }
            function T2(e, r, i) {
              var n = 0, o = 0, u = 0, a = 0;
              e: {
                if (!i || (P[e | 0] = r, n = e + i | 0, P[n - 1 | 0] = r, i >>> 0 < 3) || (P[e + 2 | 0] = r, P[e + 1 | 0] = r, P[n - 3 | 0] = r, P[n - 2 | 0] = r, i >>> 0 < 7) || (P[e + 3 | 0] = r, P[n - 4 | 0] = r, i >>> 0 < 9) || (n = 0 - e & 3, o = n + e | 0, r = J0(r & 255, 16843009), t[o >> 2] = r, n = i - n & -4, i = n + o | 0, t[i - 4 >> 2] = r, n >>> 0 < 9) || (t[o + 8 >> 2] = r, t[o + 4 >> 2] = r, t[i - 8 >> 2] = r, t[i - 12 >> 2] = r, n >>> 0 < 25) || (t[o + 24 >> 2] = r, t[o + 20 >> 2] = r, t[o + 16 >> 2] = r, t[o + 12 >> 2] = r, t[i - 16 >> 2] = r, t[i - 20 >> 2] = r, t[i - 24 >> 2] = r, t[i - 28 >> 2] = r, a = o & 4 | 24, i = n - a | 0, i >>> 0 < 32))
                  break e;
                for (n = pt(r, 0, 1, 1), u = G2, r = o + a | 0; t[r + 24 >> 2] = n, t[r + 28 >> 2] = u, t[r + 16 >> 2] = n, t[r + 20 >> 2] = u, t[r + 8 >> 2] = n, t[r + 12 >> 2] = u, t[r >> 2] = n, t[r + 4 >> 2] = u, r = r + 32 | 0, i = i - 32 | 0, i >>> 0 > 31; )
                  ;
              }
              return e;
            }
            function p2(e) {
              e = e | 0;
              var r = 0, i = 0, n = 0, o = 0, u = 0;
              if (e) {
                r = e - 4 | 0, o = t[r >> 2], i = o, n = r, u = t[e - 8 >> 2], e = u & -2, (e | 0) != (u | 0) && (n = r - e | 0, i = t[n + 4 >> 2], t[i + 8 >> 2] = t[n + 8 >> 2], t[t[n + 8 >> 2] + 4 >> 2] = i, i = e + o | 0), e = r + o | 0, r = t[e >> 2], (r | 0) != t[(e + r | 0) - 4 >> 2] && (o = t[e + 4 >> 2], t[o + 8 >> 2] = t[e + 8 >> 2], t[t[e + 8 >> 2] + 4 >> 2] = o, i = r + i | 0), t[n >> 2] = i, t[((i & -4) + n | 0) - 4 >> 2] = i | 1, r = t[n >> 2] - 8 | 0;
                e: {
                  if (r >>> 0 <= 127) {
                    e = (r >>> 3 | 0) - 1 | 0;
                    break e;
                  }
                  if (i = H2(r), e = ((r >>> 29 - i ^ 4) - (i << 2) | 0) + 110 | 0, r >>> 0 <= 4095)
                    break e;
                  e = ((r >>> 30 - i ^ 2) - (i << 1) | 0) + 71 | 0, e = e >>> 0 >= 63 ? 63 : e;
                }
                r = e << 4, t[n + 4 >> 2] = r + 5968, r = r + 5976 | 0, t[n + 8 >> 2] = t[r >> 2], t[r >> 2] = n, t[t[n + 8 >> 2] + 4 >> 2] = n, r = t[1750], i = t[1751], n = e & 31, (e & 63) >>> 0 >= 32 ? (e = 1 << n, o = 0) : (o = 1 << n, e = o - 1 & 1 >>> 32 - n), t[1750] = o | r, t[1751] = e | i;
              }
            }
            function v1(e, r, i) {
              e = e | 0, r = r | 0, i = i | 0;
              var n = 0, o = 0, u = 0, a = 0, l = 0, h = 0, g = 0;
              n = H - 32 | 0, H = n, o = t[e + 28 >> 2], t[n + 16 >> 2] = o, u = t[e + 20 >> 2], t[n + 28 >> 2] = i, t[n + 24 >> 2] = r, r = u - o | 0, t[n + 20 >> 2] = r, u = r + i | 0, h = 2, r = n + 16 | 0;
              e: {
                for (; ; ) {
                  i: {
                    t: {
                      r: {
                        if (!Xi(f1(t[e + 60 >> 2], r | 0, h | 0, n + 12 | 0) | 0)) {
                          if (a = t[n + 12 >> 2], (a | 0) == (u | 0))
                            break r;
                          if ((a | 0) >= 0)
                            break t;
                          break i;
                        }
                        if ((u | 0) != -1)
                          break i;
                      }
                      r = t[e + 44 >> 2], t[e + 28 >> 2] = r, t[e + 20 >> 2] = r, t[e + 16 >> 2] = r + t[e + 48 >> 2], e = i;
                      break e;
                    }
                    l = t[r + 4 >> 2], g = l >>> 0 < a >>> 0, o = (g << 3) + r | 0, l = a - (g ? l : 0) | 0, t[o >> 2] = l + t[o >> 2], r = (g ? 12 : 4) + r | 0, t[r >> 2] = t[r >> 2] - l, u = u - a | 0, h = h - g | 0, r = o;
                    continue;
                  }
                  break;
                }
                if (t[e + 28 >> 2] = 0, t[e + 16 >> 2] = 0, t[e + 20 >> 2] = 0, t[e >> 2] = t[e >> 2] | 32, e = 0, (h | 0) == 2)
                  break e;
                e = i - t[r + 4 >> 2] | 0;
              }
              return H = n + 32 | 0, e | 0;
            }
            function m1(e) {
              e = e | 0;
              var r = 0, i = 0, n = 0, o = 0, u = 0;
              i = H - 96 | 0, H = i, t[i >> 2] = e, n = H - 16 | 0, H = n, t[n + 12 >> 2] = i, e = H - 144 | 0, H = e, e = S2(e, 5520, 144), u = i + 16 | 0, r = u, t[e + 44 >> 2] = r, t[e + 20 >> 2] = r, o = -2 - r | 0, o = o >>> 0 >= 2147483647 ? 2147483647 : o, t[e + 48 >> 2] = o, r = r + o | 0, t[e + 28 >> 2] = r, t[e + 16 >> 2] = r, pi(e, 2202, i, 0, 0), o && (r = t[e + 20 >> 2], P[r - ((r | 0) == t[e + 16 >> 2]) | 0] = 0), H = e + 144 | 0, H = n + 16 | 0, e = u;
              e: {
                if (e & 3)
                  for (; ; ) {
                    if (!X[e | 0])
                      break e;
                    if (e = e + 1 | 0, !(e & 3))
                      break;
                  }
                for (; r = e, e = e + 4 | 0, n = t[r >> 2], !((n ^ -1) & n - 16843009 & -2139062144); )
                  ;
                for (; e = r, r = e + 1 | 0, !!X[e | 0]; )
                  ;
              }
              return e = (e - u | 0) + 1 | 0, r = st(e), r ? e = S2(r, u, e) : e = 0, H = i + 96 | 0, e | 0;
            }
            function pi(e, r, i, n, o) {
              var u = 0, a = 0, l = 0, h = 0;
              u = H - 208 | 0, H = u, t[u + 204 >> 2] = i, i = u + 160 | 0, T2(i, 0, 40), t[u + 200 >> 2] = t[u + 204 >> 2];
              e: {
                if ((ni(0, r, u + 200 | 0, u + 80 | 0, i, n, o) | 0) < 0) {
                  o = -1;
                  break e;
                }
                h = t[e + 76 >> 2] >= 0, a = t[e >> 2], t[e + 72 >> 2] <= 0 && (t[e >> 2] = a & -33);
                i: {
                  t: {
                    r: {
                      if (!t[e + 48 >> 2]) {
                        t[e + 48 >> 2] = 80, t[e + 28 >> 2] = 0, t[e + 16 >> 2] = 0, t[e + 20 >> 2] = 0, l = t[e + 44 >> 2], t[e + 44 >> 2] = u;
                        break r;
                      }
                      if (t[e + 16 >> 2])
                        break t;
                    }
                    if (i = -1, Si(e))
                      break i;
                  }
                  i = ni(e, r, u + 200 | 0, u + 80 | 0, u + 160 | 0, n, o);
                }
                if (l && (e0[t[e + 36 >> 2]](e, 0, 0) | 0, t[e + 48 >> 2] = 0, t[e + 44 >> 2] = l, t[e + 28 >> 2] = 0, r = t[e + 20 >> 2], t[e + 16 >> 2] = 0, t[e + 20 >> 2] = 0, i = r ? i : -1), r = e, e = t[e >> 2], t[r >> 2] = e | a & 32, o = e & 32 ? -1 : i, !h)
                  break e;
              }
              return H = u + 208 | 0, o;
            }
            function Vr(e) {
              var r = 0, i = f(0), n = 0, o = 0, u = 0, a = 0, l = 0, h = f(0), g = 0;
              u = H - 16 | 0, H = u, r = t[e + 12 >> 2];
              e: {
                if (r) {
                  h = A[e + 520 >> 2], i = A[e + 516 >> 2];
                  i: {
                    if (X[e + 4 | 0] & 32) {
                      i = f(e0[r | 0](e, i, h, 0));
                      break i;
                    }
                    i = f(e0[r | 0](e, i, h));
                  }
                  if (i == i)
                    break e;
                  t[u >> 2] = 3409, L2(e, u), B2(), V0();
                }
                i: {
                  t: {
                    if (a = t[e + 556 >> 2], r = t[e + 560 >> 2], (a | 0) != (r | 0)) {
                      for (r = r - a >> 2, g = r >>> 0 <= 1 ? 1 : r; ; ) {
                        if (o = t[(l << 2) + a >> 2], !t[o + 548 >> 2]) {
                          if (r = t[o + 24 >> 2], (r & 196608) != 131072) {
                            if (r = r >>> 13 & 7, r || (r = t[e + 24 >> 2] >>> 10 & 7), X[o + 4 | 0] & 2 | (X[e + 24 | 0] & 8 ? (r | 0) == 5 : 0))
                              break t;
                            n = n || o;
                          }
                          if (l = l + 1 | 0, (g | 0) != (l | 0))
                            continue;
                        }
                        break;
                      }
                      if (n)
                        break i;
                    }
                    i = A[e + 520 >> 2];
                    break e;
                  }
                  n = o;
                }
                i = f(Vr(n) + A[n + 232 >> 2]);
              }
              return H = u + 16 | 0, i;
            }
            function Ke(e, r, i, n, o, u) {
              var a = 0, l = f(0), h = 0, g = f(0);
              a = (t[(r << 2) + 4320 >> 2] << 2) + e | 0, l = A[a + 216 >> 2];
              e: {
                i: {
                  a = t[a + 216 >> 2];
                  t: {
                    if ((a | 0) == 2139156720)
                      break t;
                    if ((a | 0) == 2140081935)
                      break i;
                    h = 4336;
                    r: {
                      if ((a | 0) != 2141891242) {
                        if (l == l)
                          break r;
                        h = 4344;
                      }
                      switch (g = A[h >> 2], l = f(s0), t[h + 4 >> 2] - 1 | 0) {
                        case 0:
                          break i;
                        case 1:
                          break t;
                        default:
                          break e;
                      }
                    }
                    if (g = (J(2, (a & -1073741825) + 536870912 | 0), n0()), !(a & 1073741824))
                      break i;
                  }
                  l = f(f(g * i) * f(0.009999999776482582));
                  break e;
                }
                l = g;
              }
              n = f(l + f(d0(e, r, n) + C0(e, r, n)));
              e: {
                i: {
                  t:
                    switch (t[o >> 2]) {
                      case 1:
                      case 2:
                        i = A[u >> 2], n = n != n || i < n ? i : n;
                        break i;
                      case 0:
                        break t;
                      default:
                        break e;
                    }
                  if (n != n)
                    break e;
                  t[o >> 2] = 2;
                }
                A[u >> 2] = n;
              }
            }
            function X0(e, r, i) {
              var n = f(0), o = f(0), u = 0, a = f(0);
              e = e + 116 | 0, u = t[(r << 2) + 4288 >> 2];
              e: {
                if ((r & -2) == 2) {
                  r = q2(e, 4, u, 2140081935);
                  break e;
                }
                r = b2(e, u, 2140081935);
              }
              e: {
                i: {
                  t: {
                    r: {
                      if ((r | 0) == 2139156720)
                        break r;
                      if ((r | 0) == 2140081935)
                        break e;
                      e = 4336;
                      n: {
                        if ((r | 0) != 2141891242) {
                          if (n = (J(2, r), n0()), n == n)
                            break n;
                          e = 4344;
                        }
                        switch (n = A[e >> 2], o = f(s0), t[e + 4 >> 2] - 1 | 0) {
                          case 0:
                            break t;
                          case 1:
                            break r;
                          default:
                            break i;
                        }
                      }
                      if (n = (J(2, (r & -1073741825) + 536870912 | 0), n0()), !(r & 1073741824))
                        break t;
                    }
                    n = f(f(n * i) * f(0.009999999776482582));
                  }
                  if (n >= f(0))
                    return n;
                  if (o = n, n < f(0))
                    break e;
                }
                a = o == o ? o : f(0);
              }
              return a;
            }
            function H0(e, r, i) {
              var n = f(0), o = f(0), u = 0, a = f(0);
              e = e + 116 | 0, u = t[(r << 2) + 4304 >> 2];
              e: {
                if ((r & -2) == 2) {
                  r = q2(e, 5, u, 2140081935);
                  break e;
                }
                r = b2(e, u, 2140081935);
              }
              e: {
                i: {
                  t: {
                    r: {
                      if ((r | 0) == 2139156720)
                        break r;
                      if ((r | 0) == 2140081935)
                        break e;
                      e = 4336;
                      n: {
                        if ((r | 0) != 2141891242) {
                          if (n = (J(2, r), n0()), n == n)
                            break n;
                          e = 4344;
                        }
                        switch (n = A[e >> 2], o = f(s0), t[e + 4 >> 2] - 1 | 0) {
                          case 0:
                            break t;
                          case 1:
                            break r;
                          default:
                            break i;
                        }
                      }
                      if (n = (J(2, (r & -1073741825) + 536870912 | 0), n0()), !(r & 1073741824))
                        break t;
                    }
                    n = f(f(n * i) * f(0.009999999776482582));
                  }
                  if (n >= f(0))
                    return n;
                  if (o = n, n < f(0))
                    break e;
                }
                a = o == o ? o : f(0);
              }
              return a;
            }
            function wi(e, r, i, n, o, u) {
              var a = 0;
              e: {
                i: {
                  if (e) {
                    t: {
                      if (r & 4) {
                        u = e0[e | 0](i, n, o, u) | 0;
                        break t;
                      }
                      u = e0[e | 0](i, n, o) | 0;
                    }
                    if (u)
                      break i;
                  }
                  if (u = B(588), r = S2(u, i, 552), t[r + 564 >> 2] = 0, t[r + 556 >> 2] = 0, t[r + 560 >> 2] = 0, o = t[i + 556 >> 2], n = t[i + 560 >> 2], (o | 0) != (n | 0)) {
                    if (a = n - o | 0, (a | 0) < 0)
                      break e;
                    for (e = B(a), t[r + 556 >> 2] = e, t[r + 564 >> 2] = e + a; t[e >> 2] = t[o >> 2], e = e + 4 | 0, o = o + 4 | 0, (n | 0) != (o | 0); )
                      ;
                    t[r + 560 >> 2] = e;
                  }
                  e = t[i + 572 >> 2], t[r + 568 >> 2] = t[i + 568 >> 2], t[r + 572 >> 2] = e, t[r + 584 >> 2] = t[i + 584 >> 2], e = t[i + 580 >> 2], t[r + 576 >> 2] = t[i + 576 >> 2], t[r + 580 >> 2] = e, t[r + 552 >> 2] = 0;
                }
                return u;
              }
              Ze(), V0();
            }
            function L2(e, r) {
              var i = 0, n = 0, o = 0;
              o = H - 16 | 0, H = o, t[o + 12 >> 2] = r;
              e: {
                i: {
                  if (!e) {
                    r = t[o + 12 >> 2];
                    break i;
                  }
                  if (r = t[o + 12 >> 2], i = t[e + 568 >> 2], !i)
                    break i;
                  if (n = t[i + 4 >> 2], X[i + 8 | 0] & 8) {
                    e0[n | 0](i, e, 5, 0, 4284, r) | 0;
                    break e;
                  }
                  e0[n | 0](i, e, 5, 4284, r) | 0;
                  break e;
                }
                i: {
                  if (!X[7016]) {
                    i = B(28), t[i + 20 >> 2] = 1065353216, t[i + 24 >> 2] = 0, t[i + 12 >> 2] = 0, t[i + 16 >> 2] = 0, t[i >> 2] = 0, P[i + 8 | 0] = 0, n = 1, t[i + 4 >> 2] = 1, t[1753] = i, P[7016] = 1, t[1752] = t[1752] + 1;
                    break i;
                  }
                  if (i = t[1753], n = t[i + 4 >> 2], !(X[i + 8 | 0] & 8))
                    break i;
                  e0[n | 0](i, e, 5, 0, 4284, r) | 0;
                  break e;
                }
                e0[n | 0](i, e, 5, 4284, r) | 0;
              }
              H = o + 16 | 0;
            }
            function or(e, r, i) {
              var n = f(0), o = 0, u = f(0);
              e = e + 80 | 0, o = t[(r << 2) + 4304 >> 2];
              e: {
                i: {
                  if ((r & -2) == 2) {
                    r = q2(e, 5, o, 2140081935);
                    break i;
                  }
                  r = b2(e, o, 2140081935);
                }
                i: {
                  t: {
                    if ((r | 0) == 2139156720)
                      break t;
                    if ((r | 0) == 2140081935)
                      break e;
                    e = 4336;
                    r: {
                      if ((r | 0) != 2141891242) {
                        if (n = (J(2, r), n0()), n == n)
                          break r;
                        e = 4344;
                      }
                      switch (n = A[e >> 2], u = f(s0), t[e + 4 >> 2] - 1 | 0) {
                        case 0:
                          break e;
                        case 1:
                          break t;
                        default:
                          break i;
                      }
                    }
                    if (n = (J(2, (r & -1073741825) + 536870912 | 0), n0()), !(r & 1073741824))
                      break e;
                  }
                  u = f(f(n * i) * f(0.009999999776482582));
                }
                return u;
              }
              return n;
            }
            function Se(e, r, i) {
              var n = f(0), o = 0, u = f(0);
              e = e + 80 | 0, o = t[(r << 2) + 4288 >> 2];
              e: {
                i: {
                  if ((r & -2) == 2) {
                    r = q2(e, 4, o, 2140081935);
                    break i;
                  }
                  r = b2(e, o, 2140081935);
                }
                i: {
                  t: {
                    if ((r | 0) == 2139156720)
                      break t;
                    if ((r | 0) == 2140081935)
                      break e;
                    e = 4336;
                    r: {
                      if ((r | 0) != 2141891242) {
                        if (n = (J(2, r), n0()), n == n)
                          break r;
                        e = 4344;
                      }
                      switch (n = A[e >> 2], u = f(s0), t[e + 4 >> 2] - 1 | 0) {
                        case 0:
                          break e;
                        case 1:
                          break t;
                        default:
                          break i;
                      }
                    }
                    if (n = (J(2, (r & -1073741825) + 536870912 | 0), n0()), !(r & 1073741824))
                      break e;
                  }
                  u = f(f(n * i) * f(0.009999999776482582));
                }
                return u;
              }
              return n;
            }
            function q2(e, r, i, n) {
              var o = f(0);
              r = (r << 2) + e | 0, o = A[r >> 2], r = t[r >> 2];
              e: {
                if ((r | 0) == 2139156720 | (r | 0) == 2140081935 | (r | 0) == 2141891242 | o == o || (r = (i << 2) + e | 0, o = A[r >> 2], r = t[r >> 2], (r | 0) == 2139156720 | (r | 0) == 2140081935 | (r | 0) == 2141891242 | o == o) || (r = t[e + 24 >> 2], o = A[e + 24 >> 2], (r | 0) == 2139156720 | (r | 0) == 2140081935 | (r | 0) == 2141891242 | o == o) || (o = A[e + 32 >> 2], e = t[e + 32 >> 2], !((e | 0) == 2139156720 | (e | 0) == 2140081935 | (e | 0) == 2141891242) && (r = n, o != o)))
                  break e;
                r = e;
              }
              return r;
            }
            function g1(e, r) {
              e = e | 0, r = f(r);
              var i = 0, n = 0, o = 0;
              if (i = H - 16 | 0, H = i, e = t[e >> 2], !(r >= f(0))) {
                t[i >> 2] = 2263, n = H - 16 | 0, H = n, t[n + 12 >> 2] = i;
                e: {
                  if (e)
                    break e;
                  if (X[7016]) {
                    e = t[1753];
                    break e;
                  }
                  e = B(28), t[e + 20 >> 2] = 1065353216, t[e + 24 >> 2] = 0, t[e + 12 >> 2] = 0, t[e + 16 >> 2] = 0, t[e >> 2] = 0, P[e + 8 | 0] = 0, t[e + 4 >> 2] = 1, t[1753] = e, P[7016] = 1, t[1752] = t[1752] + 1;
                }
                o = t[e + 4 >> 2];
                e: {
                  if (X[e + 8 | 0] & 8) {
                    e0[o | 0](e, 0, 5, 0, 4284, i) | 0;
                    break e;
                  }
                  e0[o | 0](e, 0, 5, 4284, i) | 0;
                }
                H = n + 16 | 0, B2(), V0();
              }
              A[e + 20 >> 2] = r == f(0) ? f(0) : r, H = i + 16 | 0;
            }
            function vi(e, r, i, n, o) {
              var u = 0, a = 0, l = f(0), h = 0;
              u = 2, a = t[e + 24 >> 2] >>> 2 & 3;
              e: {
                i: {
                  t: {
                    if (!(!t[e + 552 >> 2] | (r | 0) != 2)) {
                      r = 0, u = 3;
                      r:
                        switch (a - 2 | 0) {
                          case 0:
                            break e;
                          case 1:
                            break r;
                          default:
                            break t;
                        }
                      u = 2;
                      break e;
                    }
                    if (r = 0, a >>> 0 > 1)
                      break i;
                  }
                  r = u;
                }
                u = a;
              }
              i = _i(e, u, i), n = _i(e, r, n), l = d0(e, u, o), a = e + 228 | 0, h = u << 2, A[a + (t[h + 4288 >> 2] << 2) >> 2] = i + l, l = C0(e, u, o), A[a + (t[h + 4304 >> 2] << 2) >> 2] = i + l, i = d0(e, r, o), u = r << 2, A[a + (t[u + 4288 >> 2] << 2) >> 2] = n + i, i = C0(e, r, o), A[a + (t[u + 4304 >> 2] << 2) >> 2] = n + i;
            }
            function y1(e, r, i, n, o, u) {
              e = e | 0, r = r | 0, i = f(i), n = n | 0, o = f(o), u = u | 0;
              var a = 0, l = 0, h = 0;
              a = H - 48 | 0, H = a, h = t[r + 8 >> 2];
              e: {
                if (P[7052] & 1) {
                  r = t[1762];
                  break e;
                }
                r = Kt(5, 4480) | 0, P[7052] = 1, t[1762] = r;
              }
              t[a + 40 >> 2] = u, A[a + 32 >> 2] = o, t[a + 24 >> 2] = n, A[a + 16 >> 2] = i, l = +bn(r | 0, h | 0, 2922, a + 12 | 0, a + 16 | 0);
              e: {
                if (l < 4294967296 & l >= 0) {
                  r = ~~l >>> 0;
                  break e;
                }
                r = 0;
              }
              n = t[a + 12 >> 2], u = t[r + 4 >> 2], t[e >> 2] = t[r >> 2], t[e + 4 >> 2] = u, u = t[r + 12 >> 2], t[e + 8 >> 2] = t[r + 8 >> 2], t[e + 12 >> 2] = u, qn(n | 0), H = a + 48 | 0;
            }
            function d1(e, r, i) {
              e = e | 0, r = r | 0, i = i | 0;
              var n = 0, o = 0, u = 0, a = 0;
              if (n = H - 32 | 0, H = n, o = t[r >> 2], o >>> 0 < 2147483632) {
                e: {
                  i: {
                    if (o >>> 0 >= 11) {
                      u = (o | 15) + 1 | 0, a = B(u), t[n + 16 >> 2] = u | -2147483648, t[n + 8 >> 2] = a, t[n + 12 >> 2] = o, u = o + a | 0;
                      break i;
                    }
                    if (P[n + 19 | 0] = o, a = n + 8 | 0, u = a + o | 0, !o)
                      break e;
                  }
                  S2(a, r + 4 | 0, o);
                }
                return P[u | 0] = 0, t[n >> 2] = i, e0[e | 0](n + 24 | 0, n + 8 | 0, n), Kn(t[n + 24 >> 2]), e = t[n + 24 >> 2], fr(e | 0), fr(t[n >> 2]), P[n + 19 | 0] < 0 && p2(t[n + 8 >> 2]), H = n + 32 | 0, e | 0;
              }
              Ze(), V0();
            }
            function l2(e, r, i) {
              var n = 0, o = 0, u = 0;
              if (!(X[e | 0] & 32))
                e: {
                  n = r, r = e, e = t[r + 16 >> 2];
                  i: {
                    if (!e) {
                      if (Si(r))
                        break i;
                      e = t[r + 16 >> 2];
                    }
                    if (u = t[r + 20 >> 2], e - u >>> 0 < i >>> 0) {
                      e0[t[r + 36 >> 2]](r, n, i) | 0;
                      break e;
                    }
                    t: {
                      if (t[r + 80 >> 2] < 0)
                        break t;
                      for (e = i; ; ) {
                        if (o = e, !e)
                          break t;
                        if (e = o - 1 | 0, X[n + e | 0] == 10)
                          break;
                      }
                      if (e0[t[r + 36 >> 2]](r, n, o) >>> 0 < o >>> 0)
                        break i;
                      n = n + o | 0, i = i - o | 0, u = t[r + 20 >> 2];
                    }
                    S2(u, n, i), t[r + 20 >> 2] = t[r + 20 >> 2] + i;
                  }
                }
            }
            function ct(e, r, i) {
              var n = 0, o = 0, u = 0;
              n = H - 16 | 0, H = n, o = e + 24 | 0, e0[r | 0](n + 8 | 0, o), u = t[n + 12 >> 2];
              e: {
                if ((t[t[n + 8 >> 2] >> 2] & 7 << u) >> u == (i | 0))
                  break e;
                for (e0[r | 0](n + 8 | 0, o), r = t[n + 8 >> 2], o = r, u = t[r >> 2], r = t[n + 12 >> 2], t[o >> 2] = u & (7 << r ^ -1) | (i & 7) << r; ; ) {
                  if (r = X[e + 4 | 0], r & 4)
                    break e;
                  if (P[e + 4 | 0] = r | 4, r = t[e + 20 >> 2], r && e0[r | 0](e), t[e + 308 >> 2] = 2143289344, e = t[e + 552 >> 2], !e)
                    break;
                }
              }
              H = n + 16 | 0;
            }
            function b2(e, r, i) {
              var n = f(0);
              r = (r << 2) + e | 0, n = A[r >> 2], r = t[r >> 2];
              e: {
                if ((r | 0) == 2139156720 | (r | 0) == 2140081935 | (r | 0) == 2141891242 | n == n || (r = t[e + 28 >> 2], n = A[e + 28 >> 2], (r | 0) == 2139156720 | (r | 0) == 2140081935 | (r | 0) == 2141891242 | n == n) || (n = A[e + 32 >> 2], e = t[e + 32 >> 2], !((e | 0) == 2139156720 | (e | 0) == 2140081935 | (e | 0) == 2141891242) && (r = i, n != n)))
                  break e;
                r = e;
              }
              return r;
            }
            function C0(e, r, i) {
              var n = f(0), o = 0;
              e = e + 44 | 0, o = t[(r << 2) + 4304 >> 2];
              e: {
                if ((r & -2) == 2) {
                  e = q2(e, 5, o, 2140081935);
                  break e;
                }
                e = b2(e, o, 2140081935);
              }
              e: {
                if ((e | 0) != 2139156720) {
                  if ((e | 0) == 2140081935 | (e | 0) == 2141891242)
                    break e;
                  if (n = (J(2, e), n0()), n != n)
                    return f(s0);
                  if (n = (J(2, (e & -1073741825) + 536870912 | 0), n0()), !(e & 1073741824))
                    break e;
                }
                n = f(f(n * i) * f(0.009999999776482582));
              }
              return n;
            }
            function d0(e, r, i) {
              var n = f(0), o = 0;
              e = e + 44 | 0, o = t[(r << 2) + 4288 >> 2];
              e: {
                if ((r & -2) == 2) {
                  e = q2(e, 4, o, 2140081935);
                  break e;
                }
                e = b2(e, o, 2140081935);
              }
              e: {
                if ((e | 0) != 2139156720) {
                  if ((e | 0) == 2140081935 | (e | 0) == 2141891242)
                    break e;
                  if (n = (J(2, e), n0()), n != n)
                    return f(s0);
                  if (n = (J(2, (e & -1073741825) + 536870912 | 0), n0()), !(e & 1073741824))
                    break e;
                }
                n = f(f(n * i) * f(0.009999999776482582));
              }
              return n;
            }
            function R1(e, r, i) {
              e = e | 0, r = r | 0, i = i | 0;
              var n = 0, o = 0, u = 0, a = 0, l = 0;
              return o = t[e + 84 >> 2], u = t[o >> 2], n = t[o + 4 >> 2], l = t[e + 28 >> 2], a = t[e + 20 >> 2] - l | 0, a = n >>> 0 < a >>> 0 ? n : a, a && (S2(u, l, a), u = a + t[o >> 2] | 0, t[o >> 2] = u, n = t[o + 4 >> 2] - a | 0, t[o + 4 >> 2] = n), n = i >>> 0 > n >>> 0 ? n : i, n && (S2(u, r, n), u = n + t[o >> 2] | 0, t[o >> 2] = u, t[o + 4 >> 2] = t[o + 4 >> 2] - n), P[u | 0] = 0, r = t[e + 44 >> 2], t[e + 28 >> 2] = r, t[e + 20 >> 2] = r, i | 0;
            }
            function I0(e, r) {
              var i = f(0), n = 0;
              e = e + 152 | 0, n = t[(r << 2) + 4304 >> 2];
              e: {
                if ((r & -2) == 2) {
                  e = q2(e, 5, n, 2140081935);
                  break e;
                }
                e = b2(e, n, 2140081935);
              }
              i = f(0);
              e: {
                if ((e | 0) == 2139156720 || (i = f(0), (e | 0) == 2140081935))
                  break e;
                i: {
                  if ((e | 0) == 2141891242 || (i = (J(2, e), n0()), i != i))
                    break i;
                  i = (J(2, (e & -1073741825) + 536870912 | 0), n0());
                  break e;
                }
                i = f(s0);
              }
              return g0(i, f(0));
            }
            function W0(e, r) {
              var i = f(0), n = 0;
              e = e + 152 | 0, n = t[(r << 2) + 4288 >> 2];
              e: {
                if ((r & -2) == 2) {
                  e = q2(e, 4, n, 2140081935);
                  break e;
                }
                e = b2(e, n, 2140081935);
              }
              i = f(0);
              e: {
                if ((e | 0) == 2139156720 || (i = f(0), (e | 0) == 2140081935))
                  break e;
                i: {
                  if ((e | 0) == 2141891242 || (i = (J(2, e), n0()), i != i))
                    break i;
                  i = (J(2, (e & -1073741825) + 536870912 | 0), n0());
                  break e;
                }
                i = f(s0);
              }
              return g0(i, f(0));
            }
            function E1(e, r, i) {
              e = e | 0, r = r | 0, i = i | 0;
              var n = 0, o = 0, u = f(0);
              n = 2, r = t[r >> 2] + (i << 2) | 0, u = A[r + 116 >> 2];
              e: {
                i: {
                  if (r = t[r + 116 >> 2], (r | 0) != 2139156720) {
                    if (o = s0, (r | 0) == 2141891242) {
                      n = 3;
                      break e;
                    }
                    if ((r | 0) != 2140081935)
                      break i;
                    o = 0, n = 1;
                    break e;
                  }
                  break e;
                }
                if (u != u) {
                  n = 0;
                  break e;
                }
                n = r & 1073741824 ? 2 : 1, o = (J(2, (r & -1073741825) + 536870912 | 0), +n0());
              }
              Q0[e + 8 >> 3] = o, t[e >> 2] = n;
            }
            function W1(e, r, i) {
              e = e | 0, r = r | 0, i = i | 0;
              var n = 0, o = 0, u = f(0);
              n = 2, r = t[r >> 2] + (i << 2) | 0, u = A[r + 80 >> 2];
              e: {
                i: {
                  if (r = t[r + 80 >> 2], (r | 0) != 2139156720) {
                    if (o = s0, (r | 0) == 2141891242) {
                      n = 3;
                      break e;
                    }
                    if ((r | 0) != 2140081935)
                      break i;
                    o = 0, n = 1;
                    break e;
                  }
                  break e;
                }
                if (u != u) {
                  n = 0;
                  break e;
                }
                n = r & 1073741824 ? 2 : 1, o = (J(2, (r & -1073741825) + 536870912 | 0), +n0());
              }
              Q0[e + 8 >> 3] = o, t[e >> 2] = n;
            }
            function N1(e, r, i) {
              e = e | 0, r = r | 0, i = i | 0;
              var n = 0, o = 0, u = f(0);
              n = 2, r = t[r >> 2] + (i << 2) | 0, u = A[r + 44 >> 2];
              e: {
                i: {
                  if (r = t[r + 44 >> 2], (r | 0) != 2139156720) {
                    if (o = s0, (r | 0) == 2141891242) {
                      n = 3;
                      break e;
                    }
                    if ((r | 0) != 2140081935)
                      break i;
                    o = 0, n = 1;
                    break e;
                  }
                  break e;
                }
                if (u != u) {
                  n = 0;
                  break e;
                }
                n = r & 1073741824 ? 2 : 1, o = (J(2, (r & -1073741825) + 536870912 | 0), +n0());
              }
              Q0[e + 8 >> 3] = o, t[e >> 2] = n;
            }
            function ee(e, r, i, n) {
              var o = 0, u = 0, a = 0;
              e = e * r, o = at(e), o = o < 0 ? o + 1 : o, a = o != o;
              e: {
                if (!(a | !($0(o) < 1e-4))) {
                  e = e - o;
                  break e;
                }
                i: {
                  if (o != o) {
                    e = e - o;
                    break i;
                  }
                  if (e = e - o, !($0(o + -1) < 1e-4))
                    break i;
                  e = e + 1;
                  break e;
                }
                if (i) {
                  e = e + 1;
                  break e;
                }
                if (n)
                  break e;
                u = 0;
                i: {
                  if (a || (u = 1, o > 0.5))
                    break i;
                  u = $0(o + -0.5) < 1e-4 ? 1 : 0;
                }
                e = e + u;
              }
              return e != e | r != r ? f(s0) : f(e / r);
            }
            function mi(e, r) {
              var i = f(0);
              e: {
                if ((r | 0) != 2139156720) {
                  if ((r | 0) != 2140081935) {
                    if ((r | 0) != 2141891242)
                      break e;
                    t[e >> 2] = 2143289344, t[e + 4 >> 2] = 3;
                    return;
                  }
                  t[e >> 2] = 0, t[e + 4 >> 2] = 1;
                  return;
                }
                t[e >> 2] = 0, t[e + 4 >> 2] = 2;
                return;
              }
              if (i = (J(2, r), n0()), i != i) {
                t[e >> 2] = 2143289344, t[e + 4 >> 2] = 0;
                return;
              }
              t[e + 4 >> 2] = r & 1073741824 ? 2 : 1, t[e >> 2] = (r & -1073741825) + 536870912;
            }
            function gi(e) {
              var r = 0, i = 0, n = 0;
              i = t[e + 24 >> 2];
              e: {
                if (!(i & 8) || (r = 1, (i & 7168) == 5120) || (r = 0, n = t[e + 560 >> 2], i = t[e + 556 >> 2], (n | 0) == (i | 0)))
                  break e;
                for (e = n - i >> 2, n = e >>> 0 <= 1 ? 1 : e, e = 0; ; ) {
                  if (r = t[t[i + (e << 2) >> 2] + 24 >> 2], r = (r & 196608) != 131072 & (r & 57344) == 40960, r)
                    break e;
                  if (e = e + 1 | 0, (n | 0) == (e | 0))
                    break;
                }
              }
              return r;
            }
            function Z1(e, r) {
              e = e | 0, r = r | 0;
              var i = 0, n = 0, o = f(0);
              r = t[r >> 2], o = A[r + 220 >> 2];
              e: {
                i: {
                  if (r = t[r + 220 >> 2], (r | 0) != 2139156720) {
                    if (n = s0, i = 3, (r | 0) == 2141891242)
                      break e;
                    if ((r | 0) != 2140081935)
                      break i;
                    n = 0, i = 1;
                    break e;
                  }
                  i = 2;
                  break e;
                }
                if (i = 0, o != o)
                  break e;
                n = (J(2, (r & -1073741825) + 536870912 | 0), +n0()), i = r & 1073741824 ? 2 : 1;
              }
              r = i, Q0[e + 8 >> 3] = n, t[e >> 2] = r;
            }
            function G1(e, r) {
              e = e | 0, r = r | 0;
              var i = 0, n = 0, o = f(0);
              r = t[r >> 2], o = A[r + 200 >> 2];
              e: {
                i: {
                  if (r = t[r + 200 >> 2], (r | 0) != 2139156720) {
                    if (n = s0, i = 3, (r | 0) == 2141891242)
                      break e;
                    if ((r | 0) != 2140081935)
                      break i;
                    n = 0, i = 1;
                    break e;
                  }
                  i = 2;
                  break e;
                }
                if (i = 0, o != o)
                  break e;
                n = (J(2, (r & -1073741825) + 536870912 | 0), +n0()), i = r & 1073741824 ? 2 : 1;
              }
              r = i, Q0[e + 8 >> 3] = n, t[e >> 2] = r;
            }
            function S1(e, r) {
              e = e | 0, r = r | 0;
              var i = 0, n = 0, o = f(0);
              r = t[r >> 2], o = A[r + 204 >> 2];
              e: {
                i: {
                  if (r = t[r + 204 >> 2], (r | 0) != 2139156720) {
                    if (n = s0, i = 3, (r | 0) == 2141891242)
                      break e;
                    if ((r | 0) != 2140081935)
                      break i;
                    n = 0, i = 1;
                    break e;
                  }
                  i = 2;
                  break e;
                }
                if (i = 0, o != o)
                  break e;
                n = (J(2, (r & -1073741825) + 536870912 | 0), +n0()), i = r & 1073741824 ? 2 : 1;
              }
              r = i, Q0[e + 8 >> 3] = n, t[e >> 2] = r;
            }
            function T1(e, r) {
              e = e | 0, r = r | 0;
              var i = 0, n = 0, o = f(0);
              r = t[r >> 2], o = A[r + 208 >> 2];
              e: {
                i: {
                  if (r = t[r + 208 >> 2], (r | 0) != 2139156720) {
                    if (n = s0, i = 3, (r | 0) == 2141891242)
                      break e;
                    if ((r | 0) != 2140081935)
                      break i;
                    n = 0, i = 1;
                    break e;
                  }
                  i = 2;
                  break e;
                }
                if (i = 0, o != o)
                  break e;
                n = (J(2, (r & -1073741825) + 536870912 | 0), +n0()), i = r & 1073741824 ? 2 : 1;
              }
              r = i, Q0[e + 8 >> 3] = n, t[e >> 2] = r;
            }
            function O1(e, r) {
              e = e | 0, r = r | 0;
              var i = 0, n = 0, o = f(0);
              r = t[r >> 2], o = A[r + 212 >> 2];
              e: {
                i: {
                  if (r = t[r + 212 >> 2], (r | 0) != 2139156720) {
                    if (n = s0, i = 3, (r | 0) == 2141891242)
                      break e;
                    if ((r | 0) != 2140081935)
                      break i;
                    n = 0, i = 1;
                    break e;
                  }
                  i = 2;
                  break e;
                }
                if (i = 0, o != o)
                  break e;
                n = (J(2, (r & -1073741825) + 536870912 | 0), +n0()), i = r & 1073741824 ? 2 : 1;
              }
              r = i, Q0[e + 8 >> 3] = n, t[e >> 2] = r;
            }
            function V1(e, r) {
              e = e | 0, r = r | 0;
              var i = 0, n = 0, o = f(0);
              r = t[r >> 2], o = A[r + 216 >> 2];
              e: {
                i: {
                  if (r = t[r + 216 >> 2], (r | 0) != 2139156720) {
                    if (n = s0, i = 3, (r | 0) == 2141891242)
                      break e;
                    if ((r | 0) != 2140081935)
                      break i;
                    n = 0, i = 1;
                    break e;
                  }
                  i = 2;
                  break e;
                }
                if (i = 0, o != o)
                  break e;
                n = (J(2, (r & -1073741825) + 536870912 | 0), +n0()), i = r & 1073741824 ? 2 : 1;
              }
              r = i, Q0[e + 8 >> 3] = n, t[e >> 2] = r;
            }
            function C1(e, r) {
              e = e | 0, r = r | 0;
              var i = 0;
              if (i = H - 16 | 0, H = i, e = t[e >> 2], (r | 0) < 6) {
                H = i + 16 | 0;
                e: {
                  i:
                    switch (r - 4 | 0) {
                      case 0:
                        if (r = e + 260 | 0, (X[e + 300 | 0] & 3) == 2)
                          break e;
                        r = e + 252 | 0;
                        break e;
                      case 1:
                        if (r = e + 252 | 0, (X[e + 300 | 0] & 3) == 2)
                          break e;
                        r = e + 260 | 0;
                        break e;
                      default:
                        break i;
                    }
                  r = (e + (r << 2) | 0) + 252 | 0;
                }
                return +A[r >> 2];
              }
              t[i >> 2] = 1872, L2(e, i), B2(), V0();
            }
            function I1(e, r) {
              e = e | 0, r = r | 0;
              var i = 0;
              if (i = H - 16 | 0, H = i, e = t[e >> 2], (r | 0) < 6) {
                H = i + 16 | 0;
                e: {
                  i:
                    switch (r - 4 | 0) {
                      case 0:
                        if (r = e + 276 | 0, (X[e + 300 | 0] & 3) == 2)
                          break e;
                        r = e + 268 | 0;
                        break e;
                      case 1:
                        if (r = e + 268 | 0, (X[e + 300 | 0] & 3) == 2)
                          break e;
                        r = e + 276 | 0;
                        break e;
                      default:
                        break i;
                    }
                  r = (e + (r << 2) | 0) + 268 | 0;
                }
                return +A[r >> 2];
              }
              t[i >> 2] = 1872, L2(e, i), B2(), V0();
            }
            function B1(e, r) {
              e = e | 0, r = r | 0;
              var i = 0;
              if (i = H - 16 | 0, H = i, e = t[e >> 2], (r | 0) < 6) {
                H = i + 16 | 0;
                e: {
                  i:
                    switch (r - 4 | 0) {
                      case 0:
                        if (r = e + 292 | 0, (X[e + 300 | 0] & 3) == 2)
                          break e;
                        r = e + 284 | 0;
                        break e;
                      case 1:
                        if (r = e + 284 | 0, (X[e + 300 | 0] & 3) == 2)
                          break e;
                        r = e + 292 | 0;
                        break e;
                      default:
                        break i;
                    }
                  r = (e + (r << 2) | 0) + 284 | 0;
                }
                return +A[r >> 2];
              }
              t[i >> 2] = 1872, L2(e, i), B2(), V0();
            }
            function F1(e, r) {
              e = e | 0, r = r | 0;
              var i = 0, n = f(0), o = f(0);
              n = f(s0), r = t[r >> 2], o = A[r + 40 >> 2], r = t[r + 40 >> 2], i = 3;
              e: {
                if ((r | 0) == 2141891242)
                  break e;
                if ((r | 0) == 2140081935) {
                  n = f(0), i = 1;
                  break e;
                }
                if ((r | 0) == 2139156720) {
                  n = f(0), i = 2;
                  break e;
                }
                if (i = 0, o != o)
                  break e;
                n = (J(2, (r & -1073741825) + 536870912 | 0), n0()), i = r & 1073741824 ? 2 : 1;
              }
              t[e >> 2] = i, Q0[e + 8 >> 3] = n;
            }
            function re(e) {
              var r = 0, i = f(0);
              r = 2143289344;
              e: {
                if (f($0(e)) == f($t) | e != e || (r = 2139156720, e < f(10842021724855044e-35) & e > f(-10842021724855044e-35) | e == f(0)))
                  break e;
                i = (J(2, (A2(e), R0(2) & -2147483648 | 1602224127)), n0()), r = (A2(e > f(18446742974197924e3) || e < f(-18446742974197924e3) ? i : e), R0(2) - 536870912 | 1073741824);
              }
              return r;
            }
            function z2(e) {
              var r = 0, i = f(0);
              r = 2143289344;
              e: {
                if (f($0(e)) == f($t) | e != e || (r = 2140081935, e < f(10842021724855044e-35) & e > f(-10842021724855044e-35) | e == f(0)))
                  break e;
                i = (J(2, (A2(e), R0(2) & -2147483648 | 1610612735)), n0()), r = (A2(e > f(36893485948395848e3) || e < f(-36893485948395848e3) ? i : e), R0(2) - 536870912 | 0);
              }
              return r;
            }
            function P1(e, r) {
              e = e | 0, r = r | 0;
              var i = f(0), n = f(0);
              e = t[e >> 2] + (r << 2) | 0, n = A[e + 188 >> 2];
              e: {
                i: {
                  if (e = t[e + 188 >> 2], (e | 0) == 2139156720 | (e | 0) == 2140081935)
                    break i;
                  if (i = f(s0), (e | 0) == 2141891242 | n != n)
                    break e;
                  if ((e | 0) == 2139156720)
                    break i;
                  return f((J(2, (e & -1073741825) + 536870912 | 0), n0()));
                }
                i = f(0);
              }
              return f(i);
            }
            function _1(e, r, i, n, o, u) {
              e = e | 0, r = r | 0, i = f(i), n = n | 0, o = f(o), u = u | 0;
              var a = 0, l = 0;
              return a = H - 16 | 0, H = a, l = t[e >> 2], e = t[e + 4 >> 2], r = (e >> 1) + r | 0, e & 1 && (l = t[l + t[r >> 2] >> 2]), e0[l | 0](a, r, i, n, o, u), e = B(16), r = t[a + 12 >> 2], t[e + 8 >> 2] = t[a + 8 >> 2], t[e + 12 >> 2] = r, r = t[a + 4 >> 2], t[e >> 2] = t[a >> 2], t[e + 4 >> 2] = r, H = a + 16 | 0, e | 0;
            }
            function yi(e, r) {
              e: {
                if (r) {
                  r = Mi(t[r >> 2]);
                  break e;
                }
                i: {
                  if (X[7016]) {
                    r = t[1753];
                    break i;
                  }
                  r = B(28), t[r + 20 >> 2] = 1065353216, t[r + 24 >> 2] = 0, t[r + 12 >> 2] = 0, t[r + 16 >> 2] = 0, t[r >> 2] = 0, P[r + 8 | 0] = 0, t[r + 4 >> 2] = 1, t[1753] = r, P[7016] = 1, t[1752] = t[1752] + 1;
                }
                r = Mi(r);
              }
              return t[e + 4 >> 2] = 0, t[e + 8 >> 2] = 0, t[e >> 2] = r, t[r >> 2] = e, e;
            }
            function L1(e, r, i) {
              e = e | 0, r = r | 0, i = +i;
              var n = 0, o = 0;
              e: {
                if (e = t[e >> 2], r = e + (r << 2) | 0, o = t[r + 152 >> 2], n = z2(f(i)), (o | 0) == (n | 0))
                  break e;
                for (t[r + 152 >> 2] = n; ; ) {
                  if (r = X[e + 4 | 0], r & 4)
                    break e;
                  if (P[e + 4 | 0] = r | 4, r = t[e + 20 >> 2], r && e0[r | 0](e), t[e + 308 >> 2] = 2143289344, e = t[e + 552 >> 2], !e)
                    break;
                }
              }
            }
            function x1(e, r, i) {
              e = e | 0, r = r | 0, i = +i;
              var n = 0, o = 0;
              e: {
                if (e = t[e >> 2], r = e + (r << 2) | 0, o = t[r + 188 >> 2], n = z2(f(i)), (o | 0) == (n | 0))
                  break e;
                for (t[r + 188 >> 2] = n; ; ) {
                  if (r = X[e + 4 | 0], r & 4)
                    break e;
                  if (P[e + 4 | 0] = r | 4, r = t[e + 20 >> 2], r && e0[r | 0](e), t[e + 308 >> 2] = 2143289344, e = t[e + 552 >> 2], !e)
                    break;
                }
              }
            }
            function M1(e, r) {
              e = e | 0, r = r | 0;
              var i = 0, n = f(0);
              e = t[e >> 2] + (r << 2) | 0, n = A[e + 152 >> 2];
              e: {
                i: {
                  if (e = t[e + 152 >> 2], (e | 0) == 2139156720 | (e | 0) == 2140081935)
                    break i;
                  if (i = s0, (e | 0) == 2141891242 | n != n)
                    break e;
                  if ((e | 0) == 2139156720)
                    break i;
                  return J(2, (e & -1073741825) + 536870912 | 0), +n0();
                }
                i = 0;
              }
              return +i;
            }
            function X1(e, r) {
              e = e | 0, r = r | 0;
              var i = 0;
              e: {
                if (e = t[e >> 2], i = t[e + 24 >> 2], (i >>> 20 & 3) == (r | 0))
                  break e;
                for (t[e + 24 >> 2] = i & -3145729 | r << 20 & 3145728; ; ) {
                  if (r = X[e + 4 | 0], r & 4)
                    break e;
                  if (P[e + 4 | 0] = r | 4, r = t[e + 20 >> 2], r && e0[r | 0](e), t[e + 308 >> 2] = 2143289344, e = t[e + 552 >> 2], !e)
                    break;
                }
              }
            }
            function qe(e, r, i) {
              var n = 0, o = 0, u = 0;
              e: {
                if (!r) {
                  n = e;
                  break e;
                }
                for (; n = ai(e, r, 10), o = G2, e = pt(n, o, 246, 0) + e | 0, i = i - 1 | 0, P[i | 0] = e | 48, u = r >>> 0 > 9, e = n, r = o, !!u; )
                  ;
              }
              if (n)
                for (; i = i - 1 | 0, e = (n >>> 0) / 10 | 0, P[i | 0] = J0(e, 246) + n | 48, r = n >>> 0 > 9, n = e, !!r; )
                  ;
              return i;
            }
            function H1(e, r) {
              e = e | 0, r = r | 0;
              var i = 0;
              e: {
                if (e = t[e >> 2], i = t[e + 24 >> 2], (i >>> 22 & 1) == (r | 0))
                  break e;
                for (t[e + 24 >> 2] = i & -4194305 | r << 22 & 4194304; ; ) {
                  if (r = X[e + 4 | 0], r & 4)
                    break e;
                  if (P[e + 4 | 0] = r | 4, r = t[e + 20 >> 2], r && e0[r | 0](e), t[e + 308 >> 2] = 2143289344, e = t[e + 552 >> 2], !e)
                    break;
                }
              }
            }
            function z1(e, r) {
              e = e | 0, r = r | 0;
              var i = 0;
              e: {
                if (e = t[e >> 2], i = t[e + 24 >> 2], (i >>> 18 & 3) == (r | 0))
                  break e;
                for (t[e + 24 >> 2] = i & -786433 | r << 18 & 786432; ; ) {
                  if (r = X[e + 4 | 0], r & 4)
                    break e;
                  if (P[e + 4 | 0] = r | 4, r = t[e + 20 >> 2], r && e0[r | 0](e), t[e + 308 >> 2] = 2143289344, e = t[e + 552 >> 2], !e)
                    break;
                }
              }
            }
            function U1(e, r) {
              e = e | 0, r = r | 0;
              var i = 0;
              e: {
                if (e = t[e >> 2], i = t[e + 24 >> 2], (i >>> 16 & 3) == (r | 0))
                  break e;
                for (t[e + 24 >> 2] = i & -196609 | r << 16 & 196608; ; ) {
                  if (r = X[e + 4 | 0], r & 4)
                    break e;
                  if (P[e + 4 | 0] = r | 4, r = t[e + 20 >> 2], r && e0[r | 0](e), t[e + 308 >> 2] = 2143289344, e = t[e + 552 >> 2], !e)
                    break;
                }
              }
            }
            function Y1(e, r) {
              e = e | 0, r = +r;
              var i = 0, n = f(0), o = f(0);
              e: {
                if (n = f(r), e = t[e >> 2], o = A[e + 224 >> 2], n == o | n != n & o != o)
                  break e;
                for (A[e + 224 >> 2] = n; ; ) {
                  if (i = X[e + 4 | 0], i & 4)
                    break e;
                  if (P[e + 4 | 0] = i | 4, i = t[e + 20 >> 2], i && e0[i | 0](e), t[e + 308 >> 2] = 2143289344, e = t[e + 552 >> 2], !e)
                    break;
                }
              }
            }
            function D1(e, r) {
              e = e | 0, r = +r;
              var i = 0, n = f(0), o = f(0);
              e: {
                if (n = f(r), e = t[e >> 2], o = A[e + 28 >> 2], n == o | n != n & o != o)
                  break e;
                for (A[e + 28 >> 2] = n; ; ) {
                  if (i = X[e + 4 | 0], i & 4)
                    break e;
                  if (P[e + 4 | 0] = i | 4, i = t[e + 20 >> 2], i && e0[i | 0](e), t[e + 308 >> 2] = 2143289344, e = t[e + 552 >> 2], !e)
                    break;
                }
              }
            }
            function Q1(e, r) {
              e = e | 0, r = +r;
              var i = 0, n = f(0), o = f(0);
              e: {
                if (n = f(r), e = t[e >> 2], o = A[e + 32 >> 2], n == o | n != n & o != o)
                  break e;
                for (A[e + 32 >> 2] = n; ; ) {
                  if (i = X[e + 4 | 0], i & 4)
                    break e;
                  if (P[e + 4 | 0] = i | 4, i = t[e + 20 >> 2], i && e0[i | 0](e), t[e + 308 >> 2] = 2143289344, e = t[e + 552 >> 2], !e)
                    break;
                }
              }
            }
            function J1(e, r) {
              e = e | 0, r = +r;
              var i = 0, n = f(0), o = f(0);
              e: {
                if (n = f(r), e = t[e >> 2], o = A[e + 36 >> 2], n == o | n != n & o != o)
                  break e;
                for (A[e + 36 >> 2] = n; ; ) {
                  if (i = X[e + 4 | 0], i & 4)
                    break e;
                  if (P[e + 4 | 0] = i | 4, i = t[e + 20 >> 2], i && e0[i | 0](e), t[e + 308 >> 2] = 2143289344, e = t[e + 552 >> 2], !e)
                    break;
                }
              }
            }
            function j1(e, r) {
              e = e | 0, r = r | 0;
              var i = 0;
              e: {
                if (e = t[e >> 2], i = t[e + 24 >> 2], (i >>> 4 & 7) == (r | 0))
                  break e;
                for (t[e + 24 >> 2] = i & -113 | r << 4 & 112; ; ) {
                  if (r = X[e + 4 | 0], r & 4)
                    break e;
                  if (P[e + 4 | 0] = r | 4, r = t[e + 20 >> 2], r && e0[r | 0](e), t[e + 308 >> 2] = 2143289344, e = t[e + 552 >> 2], !e)
                    break;
                }
              }
            }
            function $1(e, r) {
              e = e | 0, r = r | 0;
              var i = 0;
              e: {
                if (e = t[e >> 2], i = t[e + 24 >> 2], (i >>> 2 & 3) == (r | 0))
                  break e;
                for (t[e + 24 >> 2] = i & -13 | r << 2 & 12; ; ) {
                  if (r = X[e + 4 | 0], r & 4)
                    break e;
                  if (P[e + 4 | 0] = r | 4, r = t[e + 20 >> 2], r && e0[r | 0](e), t[e + 308 >> 2] = 2143289344, e = t[e + 552 >> 2], !e)
                    break;
                }
              }
            }
            function K1(e, r) {
              e = e | 0, r = r | 0;
              var i = 0;
              e: {
                if (e = t[e >> 2], i = X[e + 4 | 0], ((i & 2) >>> 1 | 0) == (r | 0))
                  break e;
                for (P[e + 4 | 0] = i & 253 | (r ? 2 : 0); ; ) {
                  if (r = X[e + 4 | 0], r & 4)
                    break e;
                  if (P[e + 4 | 0] = r | 4, r = t[e + 20 >> 2], r && e0[r | 0](e), t[e + 308 >> 2] = 2143289344, e = t[e + 552 >> 2], !e)
                    break;
                }
              }
            }
            function q1(e, r, i) {
              e = e | 0, r = r | 0, i = i | 0;
              var n = 0, o = 0;
              return n = H - 16 | 0, H = n, o = t[e >> 2], e = t[e + 4 >> 2], r = (e >> 1) + r | 0, e & 1 && (o = t[o + t[r >> 2] >> 2]), e0[o | 0](n, r, i), e = B(16), r = t[n + 12 >> 2], t[e + 8 >> 2] = t[n + 8 >> 2], t[e + 12 >> 2] = r, r = t[n + 4 >> 2], t[e >> 2] = t[n >> 2], t[e + 4 >> 2] = r, H = n + 16 | 0, e | 0;
            }
            function di(e, r) {
              var i = 0, n = 0;
              e: {
                i: {
                  if (i = t[e + 556 >> 2], n = t[e + 560 >> 2], (i | 0) == (n | 0))
                    break i;
                  for (; ; ) {
                    if (t[i >> 2] == (r | 0))
                      break i;
                    if (i = i + 4 | 0, (n | 0) == (i | 0))
                      break;
                  }
                  break e;
                }
                if ((i | 0) == (n | 0))
                  break e;
                return r = i + 4 | 0, Ge(i, r, n - r | 0), t[e + 560 >> 2] = n - 4, 1;
              }
              return 0;
            }
            function b1(e) {
              e = e | 0;
              var r = 0, i = 0;
              if (i = H - 16 | 0, H = i, e = t[e >> 2], t[e + 8 >> 2]) {
                for (; r = X[e + 4 | 0], !!(!(r & 4) && (P[e + 4 | 0] = r | 4, r = t[e + 20 >> 2], r && e0[r | 0](e), t[e + 308 >> 2] = 2143289344, e = t[e + 552 >> 2], e)); )
                  ;
                H = i + 16 | 0;
                return;
              }
              t[i >> 2] = 1024, L2(e, i), B2(), V0();
            }
            function Ri(e, r) {
              var i = 0, n = 0, o = 0;
              if (R2(+e), n = R0(1) | 0, o = R0(0) | 0, i = n >>> 20 & 2047, (i | 0) != 2047) {
                if (!i)
                  return e == 0 ? i = 0 : (e = Ri(e * 18446744073709552e3, r), i = t[r >> 2] + -64 | 0), t[r >> 2] = i, e;
                t[r >> 2] = i - 1022, J(0, o | 0), J(1, n & -2146435073 | 1071644672), e = +g2();
              }
              return e;
            }
            function e4(e, r) {
              e = e | 0, r = r | 0;
              var i = 0, n = 0;
              return i = H - 16 | 0, H = i, n = t[e >> 2], e = t[e + 4 >> 2], r = (e >> 1) + r | 0, e & 1 && (n = t[n + t[r >> 2] >> 2]), e0[n | 0](i, r), e = B(16), r = t[i + 12 >> 2], t[e + 8 >> 2] = t[i + 8 >> 2], t[e + 12 >> 2] = r, r = t[i + 4 >> 2], t[e >> 2] = t[i >> 2], t[e + 4 >> 2] = r, H = i + 16 | 0, e | 0;
            }
            function Cr(e, r, i) {
              var n = 0;
              e: {
                if (n = e + 24 | 0, t[(n + (r << 2) | 0) + 184 >> 2] == (i | 0))
                  break e;
                for (t[((r << 2) + n | 0) + 184 >> 2] = i; ; ) {
                  if (r = X[e + 4 | 0], r & 4)
                    break e;
                  if (P[e + 4 | 0] = r | 4, r = t[e + 20 >> 2], r && e0[r | 0](e), t[e + 308 >> 2] = 2143289344, e = t[e + 552 >> 2], !e)
                    break;
                }
              }
            }
            function Ir(e, r, i) {
              var n = 0;
              e: {
                if (n = e + 24 | 0, t[(n + (r << 2) | 0) + 192 >> 2] == (i | 0))
                  break e;
                for (t[((r << 2) + n | 0) + 192 >> 2] = i; ; ) {
                  if (r = X[e + 4 | 0], r & 4)
                    break e;
                  if (P[e + 4 | 0] = r | 4, r = t[e + 20 >> 2], r && e0[r | 0](e), t[e + 308 >> 2] = 2143289344, e = t[e + 552 >> 2], !e)
                    break;
                }
              }
            }
            function be(e, r, i) {
              var n = 0;
              e: {
                if (n = e + 24 | 0, t[(n + (r << 2) | 0) + 176 >> 2] == (i | 0))
                  break e;
                for (t[((r << 2) + n | 0) + 176 >> 2] = i; ; ) {
                  if (r = X[e + 4 | 0], r & 4)
                    break e;
                  if (P[e + 4 | 0] = r | 4, r = t[e + 20 >> 2], r && e0[r | 0](e), t[e + 308 >> 2] = 2143289344, e = t[e + 552 >> 2], !e)
                    break;
                }
              }
            }
            function At(e, r) {
              var i = 0, n = 0, o = 0;
              e: {
                if (i = e + 24 | 0, t[i + 16 >> 2] == (r | 0))
                  break e;
                for (n = e0[9](i) | 0, o = r, t[n + 16 >> 2] = o; ; ) {
                  if (r = X[e + 4 | 0], r & 4)
                    break e;
                  if (P[e + 4 | 0] = r | 4, r = t[e + 20 >> 2], r && e0[r | 0](e), t[e + 308 >> 2] = 2143289344, e = t[e + 552 >> 2], !e)
                    break;
                }
              }
            }
            function Ei(e, r, i) {
              var n = 0;
              e: {
                if (n = e + 24 | 0, t[(n + (r << 2) | 0) + 92 >> 2] == (i | 0))
                  break e;
                for (t[((r << 2) + n | 0) + 92 >> 2] = i; ; ) {
                  if (r = X[e + 4 | 0], r & 4)
                    break e;
                  if (P[e + 4 | 0] = r | 4, r = t[e + 20 >> 2], r && e0[r | 0](e), t[e + 308 >> 2] = 2143289344, e = t[e + 552 >> 2], !e)
                    break;
                }
              }
            }
            function ht(e, r, i) {
              var n = 0;
              e: {
                if (n = e + 24 | 0, t[(n + (r << 2) | 0) + 20 >> 2] == (i | 0))
                  break e;
                for (t[((r << 2) + n | 0) + 20 >> 2] = i; ; ) {
                  if (r = X[e + 4 | 0], r & 4)
                    break e;
                  if (P[e + 4 | 0] = r | 4, r = t[e + 20 >> 2], r && e0[r | 0](e), t[e + 308 >> 2] = 2143289344, e = t[e + 552 >> 2], !e)
                    break;
                }
              }
            }
            function Wi(e, r, i) {
              var n = 0;
              e: {
                if (n = e + 24 | 0, t[(n + (r << 2) | 0) + 56 >> 2] == (i | 0))
                  break e;
                for (t[((r << 2) + n | 0) + 56 >> 2] = i; ; ) {
                  if (r = X[e + 4 | 0], r & 4)
                    break e;
                  if (P[e + 4 | 0] = r | 4, r = t[e + 20 >> 2], r && e0[r | 0](e), t[e + 308 >> 2] = 2143289344, e = t[e + 552 >> 2], !e)
                    break;
                }
              }
            }
            function r4() {
              for (var e = 0, r = 0, i = 0; r = e << 4, i = r + 5968 | 0, t[r + 5972 >> 2] = i, t[r + 5976 >> 2] = i, e = e + 1 | 0, (e | 0) != 64; )
                ;
              lt(48), t[1756] = 16, t[1757] = 0, ii(), t[1757] = t[1768], t[1768] = 7024, t[1769] = 198, t[1770] = 0, ci(), t[1770] = t[1768], t[1768] = 7076;
            }
            function x2(e, r) {
              var i = 0, n = f(0);
              e = e + 80 | 0, i = t[(r << 2) + 4288 >> 2];
              e: {
                if ((r & -2) == 2) {
                  e = q2(e, 4, i, 2143289344);
                  break e;
                }
                e = b2(e, i, 2143289344);
              }
              return (e | 0) == 2139156720 | (e | 0) == 2140081935 | (e | 0) == 2141891242 ? e = 1 : (n = (J(2, e), n0()), e = n == n), e;
            }
            function Br(e, r) {
              var i = 0, n = f(0);
              e = e + 80 | 0, i = t[(r << 2) + 4304 >> 2];
              e: {
                if ((r & -2) == 2) {
                  e = q2(e, 5, i, 2143289344);
                  break e;
                }
                e = b2(e, i, 2143289344);
              }
              return (e | 0) == 2139156720 | (e | 0) == 2140081935 | (e | 0) == 2141891242 ? e = 1 : (n = (J(2, e), n0()), e = n == n), e;
            }
            function pt(e, r, i, n) {
              var o = 0, u = 0, a = 0, l = 0, h = 0, g = 0;
              return o = i >>> 16 | 0, u = e >>> 16 | 0, g = J0(o, u), a = i & 65535, l = e & 65535, h = J0(a, l), u = (h >>> 16 | 0) + J0(u, a) | 0, o = (u & 65535) + J0(o, l) | 0, G2 = (J0(r, i) + g | 0) + J0(e, n) + (u >>> 16) + (o >>> 16) | 0, h & 65535 | o << 16;
            }
            function Ni(e, r) {
              var i = 0, n = 0, o = 0;
              n = H - 16 | 0, H = n, i = X[e + 4 | 0], o = i & -17, P[e + 4 | 0] = o;
              e: {
                if (r) {
                  if (t[e + 560 >> 2] != t[e + 556 >> 2])
                    break e;
                  i = o | 8;
                } else
                  i = i & 231;
                t[e + 8 >> 2] = r, P[e + 4 | 0] = i, H = n + 16 | 0;
                return;
              }
              t[n >> 2] = 4128, L2(e, n), B2(), V0();
            }
            function Zi(e) {
              var r = 0, i = f(0);
              r = 0;
              e: {
                if ((t[e + 24 >> 2] & 196608) == 131072)
                  break e;
                i: {
                  if (!t[e + 552 >> 2] || (i = A[e + 32 >> 2], i != i && (i = A[e + 28 >> 2], !(i > f(0)))))
                    break i;
                  if (r = 1, i != f(0))
                    break e;
                }
                r = er(e) != f(0);
              }
              return r;
            }
            function w2(e, r, i, n, o) {
              var u = 0;
              if (u = H - 256 | 0, H = u, !(o & 73728 | (i | 0) <= (n | 0))) {
                if (n = i - n | 0, i = n >>> 0 < 256, T2(u, r & 255, i ? n : 256), !i)
                  for (; l2(e, u, 256), n = n - 256 | 0, n >>> 0 > 255; )
                    ;
                l2(e, u, n);
              }
              H = u + 256 | 0;
            }
            function xe(e, r, i) {
              var n = 0, o = f(0);
              e: {
                if ((i & -2) == 2 && (n = r - -64 | 0, o = A[n >> 2], n = t[n >> 2], (n | 0) == 2139156720 | (n | 0) == 2140081935 | (n | 0) == 2141891242 | o == o))
                  break e;
                n = t[((t[(i << 2) + 4304 >> 2] << 2) + r | 0) + 44 >> 2];
              }
              mi(e, n);
            }
            function Me(e, r, i) {
              var n = 0, o = f(0);
              e: {
                if ((i & -2) == 2 && (n = t[r + 60 >> 2], o = A[r + 60 >> 2], (n | 0) == 2139156720 | (n | 0) == 2140081935 | (n | 0) == 2141891242 | o == o))
                  break e;
                n = t[((t[(i << 2) + 4288 >> 2] << 2) + r | 0) + 44 >> 2];
              }
              mi(e, n);
            }
            function er(e) {
              var r = f(0), i = f(0);
              if (!t[e + 552 >> 2])
                return f(0);
              r = A[e + 36 >> 2];
              e: {
                if (r == r || (r = f(1), P[t[e + 568 >> 2] + 8 | 0] & 1) || (r = f(0), i = A[e + 28 >> 2], !(i < f(0))))
                  break e;
                r = f(-i);
              }
              return r;
            }
            function Gi(e) {
              var r = 0, i = 0, n = 0;
              for (n = t[e >> 2]; ; ) {
                if (i = P[n | 0], Pr(i)) {
                  n = n + 1 | 0, t[e >> 2] = n, r >>> 0 <= 214748364 ? (i = i - 48 | 0, r = J0(r, 10), r = (i | 0) > (r ^ 2147483647) ? -1 : i + r | 0) : r = -1;
                  continue;
                }
                break;
              }
              return r;
            }
            function ur(e, r, i, n) {
              var o = 0;
              t[e + 12 >> 2] = 0, t[e + 16 >> 2] = n;
              e: {
                if (r) {
                  if (r >>> 0 >= 1073741824)
                    break e;
                  o = B(r << 2);
                }
                return t[e >> 2] = o, i = (i << 2) + o | 0, t[e + 8 >> 2] = i, t[e + 12 >> 2] = (r << 2) + o, t[e + 4 >> 2] = i, e;
              }
              dt(), V0();
            }
            function Si(e) {
              var r = 0;
              return r = t[e + 72 >> 2], t[e + 72 >> 2] = r - 1 | r, r = t[e >> 2], r & 8 ? (t[e >> 2] = r | 32, -1) : (t[e + 4 >> 2] = 0, t[e + 8 >> 2] = 0, r = t[e + 44 >> 2], t[e + 28 >> 2] = r, t[e + 20 >> 2] = r, t[e + 16 >> 2] = r + t[e + 48 >> 2], 0);
            }
            function t4(e, r, i, n, o, u) {
              e = e | 0, r = r | 0, i = f(i), n = n | 0, o = f(o), u = u | 0;
              var a = 0;
              a = H - 16 | 0, H = a, r = t[t[r >> 2] + 4 >> 2], e0[t[t[r >> 2] + 8 >> 2]](a, r, i, n, o, u), A[e >> 2] = Q0[a >> 3], A[e + 4 >> 2] = Q0[a + 8 >> 3], H = a + 16 | 0;
            }
            function i4() {
              var e = 0, r = 0;
              return r = B(4), e = B(28), t[e + 20 >> 2] = 1065353216, t[e + 24 >> 2] = 0, t[e + 12 >> 2] = 0, t[e + 16 >> 2] = 0, t[e >> 2] = 0, P[e + 8 | 0] = 0, t[e + 4 >> 2] = 1, t[1752] = t[1752] + 1, t[r >> 2] = e, r | 0;
            }
            function n4(e, r) {
              e = e | 0, r = r | 0, r = t[r >> 2], Q0[e >> 3] = A[r + 228 >> 2], Q0[e + 8 >> 3] = A[r + 236 >> 2], Q0[e + 16 >> 3] = A[r + 232 >> 2], Q0[e + 24 >> 3] = A[r + 240 >> 2], Q0[e + 32 >> 3] = A[r + 244 >> 2], Q0[e + 40 >> 3] = A[r + 248 >> 2];
            }
            function f4(e, r) {
              e = e | 0, r = r | 0;
              var i = 0, n = 0;
              return i = H - 48 | 0, H = i, n = t[e >> 2], e = t[e + 4 >> 2], r = (e >> 1) + r | 0, e & 1 && (n = t[n + t[r >> 2] >> 2]), e0[n | 0](i, r), e = S2(B(48), i, 48), H = i + 48 | 0, e | 0;
            }
            function o4(e, r, i, n) {
              e = e | 0, r = r | 0, i = i | 0, n = n | 0;
              var o = 0;
              return o = H - 16 | 0, H = o, e = Xi(r1(t[e + 60 >> 2], r | 0, i | 0, n & 255, o + 8 | 0) | 0), H = o + 16 | 0, G2 = e ? -1 : t[o + 12 >> 2], (e ? -1 : t[o + 8 >> 2]) | 0;
            }
            function u4(e, r) {
              e = e | 0, r = r | 0;
              var i = 0, n = 0;
              i = t[e >> 2], e = t[i + 556 >> 2];
              e: {
                if (t[i + 560 >> 2] - e >> 2 >>> 0 <= r >>> 0 || (e = t[e + (r << 2) >> 2], !e))
                  break e;
                n = t[e >> 2];
              }
              return n | 0;
            }
            function s4(e, r, i) {
              if (e = e | 0, r = r | 0, i = i | 0, r >>> 0 < 3) {
                r = 1 << r, e = t[e >> 2], i ? r = r | t[e + 12 >> 2] : r = t[e + 12 >> 2] & (r ^ -1), t[e + 12 >> 2] = r;
                return;
              }
              Ze(), V0();
            }
            function a4(e, r, i, n, o) {
              e = e | 0, r = r | 0, i = +i, n = +n, o = o | 0;
              var u = 0;
              u = t[e >> 2], e = t[e + 4 >> 2], r = (e >> 1) + r | 0, e & 1 && (u = t[u + t[r >> 2] >> 2]), e0[u | 0](r, i, n, o);
            }
            function l4(e, r, i) {
              e = e | 0, r = r | 0, i = i | 0;
              var n = 0;
              return n = t[e >> 2], e = t[e + 4 >> 2], r = (e >> 1) + r | 0, e & 1 && (n = t[n + t[r >> 2] >> 2]), f(f(e0[n | 0](r, i)));
            }
            function Ti(e, r, i, n) {
              e = e | 0, r = r | 0, i = i | 0, n = n | 0;
              var o = 0;
              o = t[e >> 2], e = t[e + 4 >> 2], r = (e >> 1) + r | 0, e & 1 && (o = t[o + t[r >> 2] >> 2]), e0[o | 0](r, i, n);
            }
            function Oi(e, r, i) {
              e = e | 0, r = r | 0, i = i | 0;
              var n = 0;
              return n = t[e >> 2], e = t[e + 4 >> 2], r = (e >> 1) + r | 0, e & 1 && (n = t[n + t[r >> 2] >> 2]), e0[n | 0](r, i) | 0;
            }
            function k4(e, r, i, n) {
              e = e | 0, r = r | 0, i = i | 0, n = +n;
              var o = 0;
              o = t[e >> 2], e = t[e + 4 >> 2], r = (e >> 1) + r | 0, e & 1 && (o = t[o + t[r >> 2] >> 2]), e0[o | 0](r, i, n);
            }
            function c4(e, r, i) {
              e = e | 0, r = r | 0, i = i | 0;
              var n = 0;
              return n = t[e >> 2], e = t[e + 4 >> 2], r = (e >> 1) + r | 0, e & 1 && (n = t[n + t[r >> 2] >> 2]), +e0[n | 0](r, i);
            }
            function B(e) {
              var r = 0;
              e = e || 1;
              e: {
                for (; ; ) {
                  if (r = st(e), r)
                    break e;
                  if (r = t[2042], r) {
                    e0[r | 0]();
                    continue;
                  }
                  break;
                }
                Ze(), V0();
              }
              return r;
            }
            function A4(e, r, i) {
              e = e | 0, r = r | 0, i = f(i);
              var n = 0;
              n = t[e >> 2], e = t[e + 4 >> 2], r = (e >> 1) + r | 0, e & 1 && (n = t[n + t[r >> 2] >> 2]), e0[n | 0](r, i);
            }
            function Te(e, r, i) {
              e = e | 0, r = r | 0, i = i | 0;
              var n = 0;
              n = t[e >> 2], e = t[e + 4 >> 2], r = (e >> 1) + r | 0, e & 1 && (n = t[n + t[r >> 2] >> 2]), e0[n | 0](r, i);
            }
            function Xe(e, r) {
              e = e | 0, r = r | 0;
              var i = 0;
              return i = t[e >> 2], e = t[e + 4 >> 2], r = (e >> 1) + r | 0, e & 1 && (i = t[i + t[r >> 2] >> 2]), e0[i | 0](r) | 0;
            }
            function wt(e, r) {
              return A2(e), (R0(2) & 2147483647) >>> 0 <= 2139095040 ? (A2(r), (R0(2) & 2147483647) >>> 0 > 2139095040 ? e : f(jn(e, r))) : r;
            }
            function g0(e, r) {
              return A2(e), (R0(2) & 2147483647) >>> 0 <= 2139095040 ? (A2(r), (R0(2) & 2147483647) >>> 0 > 2139095040 ? e : f($n(e, r))) : r;
            }
            function Vi(e, r) {
              e = e | 0, r = r | 0;
              var i = 0;
              return i = H - 16 | 0, H = i, t[i + 8 >> 2] = r, e = e0[e | 0](i + 8 | 0) | 0, fr(t[i + 8 >> 2]), H = i + 16 | 0, e | 0;
            }
            function h4(e, r, i) {
              e = e | 0, r = r | 0, i = +i;
              var n = 0;
              n = t[e >> 2], e = t[e + 4 >> 2], r = (e >> 1) + r | 0, e & 1 && (n = t[n + t[r >> 2] >> 2]), e0[n | 0](r, i);
            }
            function p4(e, r, i, n, o) {
              return i = i | 0, n = n | 0, o = o | 0, i && (i | 0) != 5 ? Yi(5816, n, o) | 0 : Yi(5672, n, o) | 0;
            }
            function Ci(e, r) {
              if (!e)
                return 0;
              e: {
                if (!((r & -128) == 57216 | r >>> 0 <= 127)) {
                  t[1781] = 25, e = -1;
                  break e;
                }
                P[e | 0] = r, e = 1;
              }
              return e;
            }
            function w4(e, r) {
              e = e | 0, r = r | 0;
              var i = 0;
              return i = t[e >> 2], e = t[e + 4 >> 2], r = (e >> 1) + r | 0, e & 1 && (i = t[i + t[r >> 2] >> 2]), +e0[i | 0](r);
            }
            function Ii(e, r) {
              var i = 0, n = 0;
              i = B(4), t[i >> 2] = r, n = B(4), t[n >> 2] = r, Tr(7035, e | 0, 7098, 4714, 196, i | 0, 7098, 4718, 197, n | 0);
            }
            function rr(e, r) {
              var i = 0, n = 0;
              i = B(4), t[i >> 2] = r, n = B(4), t[n >> 2] = r, Tr(7065, e | 0, 7098, 4714, 194, i | 0, 7098, 4718, 195, n | 0);
            }
            function vt(e, r) {
              var i = 0;
              e: {
                if (P[7044] & 1) {
                  i = t[1760];
                  break e;
                }
                i = Kt(1, 4464) | 0, P[7044] = 1, t[1760] = i;
              }
              e1(i | 0, e | 0, r | 0, 0);
            }
            function v4(e, r) {
              e = e | 0, r = r | 0;
              var i = 0;
              i = t[e + 8 >> 2], t[e + 8 >> 2] = r, i && e0[t[t[i >> 2] + 4 >> 2]](i), t[t[e >> 2] + 20 >> 2] = 15;
            }
            function m4(e, r, i) {
              e = e | 0, r = r | 0, i = i | 0;
              var n = 0, o = 0;
              n = e, o = ri((P[r + 11 | 0] < 0 ? t[r >> 2] : r) | 0, 7036, t[i >> 2]) | 0, t[n >> 2] = o;
            }
            function g4(e, r, i) {
              e = e | 0, r = r | 0, i = i | 0;
              var n = 0, o = 0;
              n = e, o = ri((P[r + 11 | 0] < 0 ? t[r >> 2] : r) | 0, 7059, t[i >> 2]) | 0, t[n >> 2] = o;
            }
            function Bi(e, r) {
              e = e | 0, r = r | 0;
              var i = 0;
              i = t[e >> 2], e = t[e + 4 >> 2], r = (e >> 1) + r | 0, e & 1 && (i = t[i + t[r >> 2] >> 2]), e0[i | 0](r);
            }
            function y4(e) {
              e = e | 0;
              var r = f(0);
              return e = t[e >> 2], r = A[e + 36 >> 2], r != r && (r = P[t[e + 568 >> 2] + 8 | 0] & 1 ? f(1) : f(0)), +r;
            }
            function d4(e, r) {
              e = e | 0, r = r | 0;
              var i = 0;
              i = t[e + 4 >> 2], t[e + 4 >> 2] = r, i && e0[t[t[i >> 2] + 4 >> 2]](i), Ni(t[e >> 2], 14);
            }
            function R4(e) {
              e = e | 0;
              var r = 0;
              r = t[e + 8 >> 2], t[e + 8 >> 2] = 0, r && e0[t[t[r >> 2] + 4 >> 2]](r), t[t[e >> 2] + 20 >> 2] = 0;
            }
            function E4(e) {
              e = e | 0;
              var r = 0;
              return r = B(12), P[r + 4 | 0] = 0, t[r + 8 >> 2] = t[e >> 2], t[e >> 2] = 0, t[r >> 2] = 4432, r | 0;
            }
            function W4(e) {
              e = e | 0;
              var r = 0;
              return r = B(12), P[r + 4 | 0] = 0, t[r + 8 >> 2] = t[e >> 2], t[e >> 2] = 0, t[r >> 2] = 4552, r | 0;
            }
            function N4() {
              var e = 0;
              if (e = t[1768], e)
                for (; e0[t[e >> 2]](), e = t[e + 4 >> 2], !!e; )
                  ;
            }
            function Z4(e) {
              e = e | 0;
              var r = 0;
              r = t[e + 4 >> 2], t[e + 4 >> 2] = 0, r && e0[t[t[r >> 2] + 4 >> 2]](r), Ni(t[e >> 2], 0);
            }
            function Fi(e) {
              return e = e | 0, t[e >> 2] = 4572, X[e + 4 | 0] && vt(t[e + 8 >> 2], 1759), fr(t[e + 8 >> 2]), e | 0;
            }
            function Pi(e) {
              return e = e | 0, t[e >> 2] = 4452, X[e + 4 | 0] && vt(t[e + 8 >> 2], 1759), fr(t[e + 8 >> 2]), e | 0;
            }
            function G4() {
              var e = 0;
              return e = B(16), t[e >> 2] = 0, t[e + 4 >> 2] = 0, t[e + 8 >> 2] = 0, t[e + 12 >> 2] = 0, e | 0;
            }
            function _i(e, r, i) {
              return x2(e, r) ? Se(e, r, i) : (i = or(e, r, i), i == i && (i = f(-i)), i);
            }
            function Li(e, r) {
              var i = 0;
              i = H - 16 | 0, H = i, e || (t[i >> 2] = r, L2(0, i), B2(), V0()), H = i + 16 | 0;
            }
            function xi(e) {
              e = e | 0;
              var r = 0;
              e && (r = t[e >> 2], r && p2(r), t[1752] = t[1752] - 1, p2(e));
            }
            function S4(e, r) {
              return e = e | 0, r = r | 0, r >>> 0 >= 3 && (Ze(), V0()), t[t[e >> 2] + 12 >> 2] >>> r & 1;
            }
            function T4(e, r, i, n, o) {
              return e = e | 0, r = r | 0, i = i | 0, n = n | 0, o = o | 0, e0[e | 0](r, i, n, o) | 0;
            }
            function O4() {
              var e = 0;
              return e = B(16), t[e + 8 >> 2] = 0, t[e + 12 >> 2] = 0, t[e >> 2] = 0, e | 0;
            }
            function V4(e) {
              e = e | 0;
              var r = f(0);
              return r = A[t[e >> 2] + 224 >> 2], +(r != r ? f(s0) : r);
            }
            function C4(e) {
              return e = e | 0, e = t[t[e >> 2] + 552 >> 2], e ? t[e >> 2] : 0;
            }
            function I4(e) {
              e = e | 0;
              var r = f(0);
              return r = A[t[e >> 2] + 32 >> 2], +(r == r ? r : f(0));
            }
            function Mi(e) {
              var r = 0;
              return r = fi(B(588), e), Li((e | 0) != 0, 2808), r;
            }
            function B4(e, r) {
              e = e | 0, r = r | 0, e = t[e >> 2], t[e + 16 >> 2] = t[e + 16 >> 2] & -2 | r;
            }
            function F4(e) {
              return e = e | 0, e = t[e >> 2], t[e + 560 >> 2] - t[e + 556 >> 2] >> 2;
            }
            function P4(e, r) {
              e = e | 0, r = r | 0, e = t[e >> 2], P[e + 8 | 0] = X[e + 8 | 0] & 254 | r;
            }
            function _4(e) {
              e = e | 0, e = t[t[e >> 2] + 8 >> 2], e0[t[t[e >> 2] + 8 >> 2]](e);
            }
            function L4(e, r, i) {
              e = e | 0, r = r | 0, i = +i, ht(t[e >> 2], r, z2(f(i)));
            }
            function x4(e, r, i) {
              e = e | 0, r = r | 0, i = +i, ht(t[e >> 2], r, re(f(i)));
            }
            function M4(e, r, i, n) {
              return G2 = 0, 0;
            }
            function X4(e, r, i) {
              e = e | 0, r = r | 0, i = +i, Ei(t[e >> 2], r, z2(f(i)));
            }
            function H4(e, r, i) {
              e = e | 0, r = r | 0, i = +i, Ei(t[e >> 2], r, re(f(i)));
            }
            function z4(e, r, i) {
              e = e | 0, r = r | 0, i = +i, Wi(t[e >> 2], r, z2(f(i)));
            }
            function U4(e, r, i) {
              e = e | 0, r = r | 0, i = +i, Wi(t[e >> 2], r, re(f(i)));
            }
            function Y4(e, r, i) {
              e = e | 0, r = r | 0, i = i | 0, t[t[e >> 2] + r >> 2] = i;
            }
            function D4(e, r) {
              e = e | 0, r = r | 0, ht(t[e >> 2], r, 2141891242);
            }
            function mt(e, r, i) {
              e = e | 0, r = r | 0, i = +i, Q0[t[e >> 2] + r >> 3] = i;
            }
            function Q4(e) {
              return e = e | 0, (X[t[e >> 2] + 4 | 0] & 2) >>> 1 | 0;
            }
            function J4(e) {
              return e = e | 0, (X[t[e >> 2] + 4 | 0] & 4) >>> 2 | 0;
            }
            function j4(e, r) {
              e = e | 0, r = r | 0, t[e + 4 >> 2] = 10, t[e >> 2] = r;
            }
            function $4(e, r) {
              e = e | 0, r = r | 0, t[e + 4 >> 2] = 13, t[e >> 2] = r;
            }
            function K4(e) {
              return e = e | 0, t[t[e >> 2] + 24 >> 2] >>> 10 & 7;
            }
            function q4(e) {
              return e = e | 0, t[t[e >> 2] + 24 >> 2] >>> 13 & 7;
            }
            function gt(e, r) {
              return e = e | 0, r = r | 0, +Q0[t[e >> 2] + r >> 3];
            }
            function b4(e) {
              return e = e | 0, t[t[e >> 2] + 24 >> 2] >>> 18 & 3;
            }
            function ef(e) {
              return e = e | 0, t[t[e >> 2] + 24 >> 2] >>> 20 & 3;
            }
            function rf(e) {
              return e = e | 0, t[t[e >> 2] + 24 >> 2] >>> 22 & 1;
            }
            function tf(e, r) {
              return e = e | 0, r = r | 0, t[t[e >> 2] + r >> 2];
            }
            function nf(e, r) {
              e = e | 0, r = +r, be(t[e >> 2], 0, z2(f(r)));
            }
            function ff(e, r) {
              e = e | 0, r = +r, be(t[e >> 2], 0, re(f(r)));
            }
            function of(e, r) {
              e = e | 0, r = +r, be(t[e >> 2], 1, z2(f(r)));
            }
            function uf(e, r) {
              e = e | 0, r = +r, be(t[e >> 2], 1, re(f(r)));
            }
            function sf(e, r) {
              e = e | 0, r = r | 0, t[e + 4 >> 2] = 7, t[e >> 2] = r;
            }
            function af(e, r) {
              e = e | 0, r = +r, Cr(t[e >> 2], 0, z2(f(r)));
            }
            function lf(e, r) {
              e = e | 0, r = +r, Cr(t[e >> 2], 0, re(f(r)));
            }
            function kf(e, r) {
              e = e | 0, r = +r, Cr(t[e >> 2], 1, z2(f(r)));
            }
            function cf(e, r) {
              e = e | 0, r = +r, Cr(t[e >> 2], 1, re(f(r)));
            }
            function Af(e, r) {
              e = e | 0, r = +r, Ir(t[e >> 2], 0, z2(f(r)));
            }
            function hf(e, r) {
              e = e | 0, r = +r, Ir(t[e >> 2], 1, z2(f(r)));
            }
            function pf(e, r) {
              e = e | 0, r = +r, Ir(t[e >> 2], 1, re(f(r)));
            }
            function wf(e) {
              return e = e | 0, t[t[e >> 2] + 24 >> 2] >>> 7 & 7;
            }
            function vf(e) {
              return e = e | 0, t[t[e >> 2] + 24 >> 2] >>> 2 & 3;
            }
            function mf(e) {
              return e = e | 0, t[t[e >> 2] + 24 >> 2] >>> 4 & 7;
            }
            function Fr(e) {
              e = e | 0, e && e0[t[t[e >> 2] + 4 >> 2]](e);
            }
            function gf(e, r) {
              e = e | 0, r = +r, Ir(t[e >> 2], 0, re(f(r)));
            }
            function Xi(e) {
              return e ? (t[1781] = e, -1) : 0;
            }
            function yf(e, r) {
              e = e | 0, r = +r, At(t[e >> 2], z2(f(r)));
            }
            function df(e, r) {
              e = e | 0, r = +r, At(t[e >> 2], re(f(r)));
            }
            function Hi(e, r, i) {
              return f(d0(e, r, i) + C0(e, r, i));
            }
            function Rf(e, r) {
              return e = e | 0, r = r | 0, e0[e | 0](r) | 0;
            }
            function zi(e, r, i, n) {
              t1(e | 0, r | 0, 8, 0, i | 0, -1, n | 0);
            }
            function Ef(e, r) {
              e = e | 0, r = r | 0, t[t[e >> 2] + 16 >> 2] = r;
            }
            function Wf(e) {
              return e = e | 0, t[t[e >> 2] + 16 >> 2] & 1;
            }
            function Nf(e) {
              return e = e | 0, je[t[e >> 2] + 26 >> 1] & 3;
            }
            function Zf(e) {
              e = e | 0, be(t[e >> 2], 0, 2141891242);
            }
            function Gf(e) {
              e = e | 0, be(t[e >> 2], 1, 2141891242);
            }
            function Sf(e) {
              return e = e | 0, +A[t[e >> 2] + 228 >> 2];
            }
            function Tf(e) {
              return e = e | 0, +A[t[e >> 2] + 236 >> 2];
            }
            function Of(e) {
              return e = e | 0, +A[t[e >> 2] + 232 >> 2];
            }
            function Vf(e) {
              return e = e | 0, +A[t[e >> 2] + 240 >> 2];
            }
            function Cf(e) {
              return e = e | 0, +A[t[e >> 2] + 244 >> 2];
            }
            function If(e) {
              return e = e | 0, +A[t[e >> 2] + 248 >> 2];
            }
            function Bf(e) {
              return e = e | 0, o1(t[e + 60 >> 2]) | 0;
            }
            function Ff(e) {
              return e = e | 0, t[t[e >> 2] + 16 >> 2];
            }
            function Pf(e) {
              return e = e | 0, P[t[e >> 2] + 8 | 0] & 1;
            }
            function _f(e, r) {
              e = e | 0, r = r | 0, ct(t[e >> 2], 5, r);
            }
            function Lf(e, r) {
              e = e | 0, r = r | 0, ct(t[e >> 2], 6, r);
            }
            function xf(e, r) {
              e = e | 0, r = r | 0, ct(t[e >> 2], 7, r);
            }
            function Mf(e) {
              e = e | 0, At(t[e >> 2], 2141891242);
            }
            function Ui(e, r) {
              e = e | 0, r = r | 0, e0[t[e >> 2]](r);
            }
            function Xf(e) {
              return e = e | 0, yi(B(12), e) | 0;
            }
            function Hf(e) {
              e = e | 0, vt(t[e + 8 >> 2], 3293);
            }
            function Yi(e, r, i) {
              return pi(e, r, i, 2, 3);
            }
            function Di(e) {
              return e = e | 0, e0[e | 0]() | 0;
            }
            function Qi(e, r) {
              e = e | 0, r = r | 0, e0[e | 0](r);
            }
            function zf() {
              return T2(B(48), 0, 48) | 0;
            }
            function B2() {
              e0[t[1490]](), dt(), V0();
            }
            function Uf() {
              return yi(B(12), 0) | 0;
            }
            function yt(e) {
              e = e | 0, e && p2(e);
            }
            function Pr(e) {
              return e - 48 >>> 0 < 10;
            }
            function Yf(e) {
              return 7032;
            }
            function Df(e) {
              return 7036;
            }
            function Qf(e) {
              return 7056;
            }
            function Jf(e) {
              return 7059;
            }
            function jf(e) {
              return 7062;
            }
            function $f(e) {
              return 7067;
            }
            function Y2(e) {
              return e = e | 0, e | 0;
            }
            function Ji(e) {
              e = e | 0, P[e + 4 | 0] = 1;
            }
            function Kf(e) {
              e = e | 0, p2(Fi(e));
            }
            function qf(e) {
              e = e | 0, p2(Pi(e));
            }
            function bf(e) {
              return 0;
            }
            function ji(e) {
              V0();
            }
            function $i() {
              dt(), V0();
            }
            function dt() {
              Ze(), V0();
            }
            E = X, q();
            var e0 = R([null, p4, l1, A1, Y2, sf, j4, $4, Y2, Y2, Y2, Y2, Y2, Y2, t4, _4, ii, Yf, Fr, _1, Df, Y2, Y2, Fr, Ji, Ui, Vi, E4, d1, m4, Qf, Fr, Bi, Jf, Y2, Y2, Fr, Ji, Ui, Vi, W4, g4, jf, xi, Di, i4, Qi, xi, s4, Ti, g1, A4, B4, Te, Ef, Te, P4, S4, Oi, Wf, Xe, Ff, Xe, Pf, zf, yt, G4, yt, O4, yt, gt, mt, tf, Y4, $f, ki, Di, Uf, Rf, Xf, Qi, ki, w1, Bi, c1, Te, U1, Te, z4, k4, U4, _f, Lf, xf, $1, z1, j1, L4, x4, D4, X1, H1, D1, h4, yf, df, Mf, Q1, J1, nf, ff, Zf, of, uf, Gf, af, lf, kf, cf, Af, gf, hf, pf, Y1, L1, X4, H4, x1, Nf, Xe, W1, q1, wf, K4, q4, vf, b4, mf, N1, F1, e4, I4, w4, y4, G1, S1, T1, O1, V1, Z1, V4, M1, c4, ef, rf, E1, P1, l4, h1, Ti, p1, Te, F4, Xe, C4, Xe, u4, Oi, Q4, Xe, K1, Te, d4, Te, Z4, v4, Te, R4, b1, J4, Xe, k1, a4, Sf, Tf, Of, Vf, Cf, If, n4, f4, C1, I1, B1, gt, mt, gt, mt, ci, Pi, qf, y1, ji, $i, Fi, Kf, Hf, ji, Bf, v1, o4, bf, M4, R1, $i]);
            function Ki() {
              return Z2.byteLength / 65536 | 0;
            }
            function eo(e) {
              e = e | 0;
              var r = Ki() | 0, i = r + e | 0;
              if (r < i && i < 65536) {
                var n = new ArrayBuffer(J0(i, 65536)), o = new Int8Array(n);
                o.set(P), P = new Int8Array(n), K2 = new Int16Array(n), t = new Int32Array(n), X = new Uint8Array(n), je = new Uint16Array(n), jt = new Uint32Array(n), A = new Float32Array(n), Q0 = new Float64Array(n), Z2 = n, _2.buffer = Z2, E = X;
              }
              return r;
            }
            return { E: r4, F: m1, G: N4, H: st, I: e0, J: p2, K: T4 };
          }
          return Sr(v);
        }(k);
      }
      var k0 = Error, k2 = {};
      l0 = [], typeof k2 != "object" && t2("no native wasm support detected");
      var c0, S0 = !1;
      function n2(k, c, v) {
        v = c + v;
        for (var R = ""; !(c >= v); ) {
          var E = k[c++];
          if (!E)
            break;
          if (E & 128) {
            var x = k[c++] & 63;
            if ((E & 224) == 192)
              R += String.fromCharCode((E & 31) << 6 | x);
            else {
              var z = k[c++] & 63;
              E = (E & 240) == 224 ? (E & 15) << 12 | x << 6 | z : (E & 7) << 18 | x << 12 | z << 6 | k[c++] & 63, 65536 > E ? R += String.fromCharCode(E) : (E -= 65536, R += String.fromCharCode(55296 | E >> 10, 56320 | E & 1023));
            }
          } else
            R += String.fromCharCode(E);
        }
        return R;
      }
      var U0, _0, A0, F0, r2, L0, D0, c2, s2;
      function P0(k) {
        U0 = k, w.HEAP8 = _0 = new Int8Array(k), w.HEAP16 = F0 = new Int16Array(k), w.HEAP32 = L0 = new Int32Array(k), w.HEAPU8 = A0 = new Uint8Array(k), w.HEAPU16 = r2 = new Uint16Array(k), w.HEAPU32 = D0 = new Uint32Array(k), w.HEAPF32 = c2 = new Float32Array(k), w.HEAPF64 = s2 = new Float64Array(k);
      }
      var a2 = w.INITIAL_MEMORY || 16777216;
      w.wasmMemory ? c0 = w.wasmMemory : c0 = new Z0(), c0 && (U0 = c0.buffer), a2 = U0.byteLength, P0(U0);
      var E0, m2 = [], d2 = [], w0 = [];
      function T0() {
        var k = w.preRun.shift();
        m2.unshift(k);
      }
      var y0 = 0, O0 = null;
      function t2(k) {
        throw w.onAbort && w.onAbort(k), k = "Aborted(" + k + ")", o0(k), S0 = !0, k = new k0(k + ". Build with -sASSERTIONS for more info."), Y(k), k;
      }
      function V2(k) {
        return k.startsWith("data:application/octet-stream;base64,");
      }
      var M2;
      if (M2 = "<<< WASM_BINARY_FILE >>>", !V2(M2)) {
        var me = M2;
        M2 = w.locateFile ? w.locateFile(me, b) : b + me;
      }
      function mr(k) {
        var c = M2;
        try {
          try {
            if (c == M2 && l0)
              new Uint8Array(l0);
            else {
              if (V2(c)) {
                try {
                  var v = Dn(c.slice(37)), R = new Uint8Array(v.length);
                  for (c = 0; c < v.length; ++c)
                    R[c] = v.charCodeAt(c);
                  var E = R;
                } catch {
                  throw Error("Converting base64 string to bytes failed.");
                }
                var x = E;
              } else
                x = void 0;
              if (!x)
                throw "sync fetching of the wasm failed: you can preload it to Module['wasmBinary'] manually, or emcc.py will do that for you when generating HTML (but not JS)";
            }
          } catch (q) {
            t2(q);
          }
          var z = new j(), I = new i2(k);
        } catch (q) {
          throw k = q.toString(), o0("failed to compile wasm module: " + k), (k.includes("imported Memory") || k.includes("memory import")) && o0("Memory size incompatibility issues may be due to changing INITIAL_MEMORY at runtime to something too large. Use ALLOW_MEMORY_GROWTH to allow any size memory (and also make sure not to set INITIAL_MEMORY at runtime to something smaller than it was at compile time)."), q;
        }
        return [I, z];
      }
      function ge(k) {
        for (; 0 < k.length; )
          k.shift()(w);
      }
      function ir(k) {
        if (k === void 0)
          return "_unknown";
        k = k.replace(/[^a-zA-Z0-9_]/g, "$");
        var c = k.charCodeAt(0);
        return 48 <= c && 57 >= c ? "_" + k : k;
      }
      function Ue(k, c) {
        return k = ir(k), function() {
          return c.apply(this, arguments);
        };
      }
      var C2 = [{}, { value: void 0 }, { value: null }, { value: !0 }, { value: !1 }], Ye = [];
      function _e(k) {
        var c = Error, v = Ue(k, function(R) {
          this.name = k, this.message = R, R = Error(R).stack, R !== void 0 && (this.stack = this.toString() + `
` + R.replace(/^Error(:[^\n]*)?\n/, ""));
        });
        return v.prototype = Object.create(c.prototype), v.prototype.constructor = v, v.prototype.toString = function() {
          return this.message === void 0 ? this.name : this.name + ": " + this.message;
        }, v;
      }
      var ue = void 0;
      function v0(k) {
        throw new ue(k);
      }
      var ye = (k) => (k || v0("Cannot use deleted val. handle = " + k), C2[k].value), J2 = (k) => {
        switch (k) {
          case void 0:
            return 1;
          case null:
            return 2;
          case !0:
            return 3;
          case !1:
            return 4;
          default:
            var c = Ye.length ? Ye.pop() : C2.length;
            return C2[c] = { fa: 1, value: k }, c;
        }
      }, X2 = void 0, x0 = void 0;
      function f2(k) {
        for (var c = ""; A0[k]; )
          c += x0[A0[k++]];
        return c;
      }
      var j2 = [];
      function de() {
        for (; j2.length; ) {
          var k = j2.pop();
          k.L.Z = !1, k.delete();
        }
      }
      var $2 = void 0, I2 = {};
      function Re(k, c) {
        for (c === void 0 && v0("ptr should not be undefined"); k.P; )
          c = k.aa(c), k = k.P;
        return c;
      }
      var se = {};
      function _t(k) {
        k = Jn(k);
        var c = f2(k);
        return Ne(k), c;
      }
      function Lt(k, c) {
        var v = se[k];
        return v === void 0 && v0(c + " has unknown type " + _t(k)), v;
      }
      function gr() {
      }
      var jr = !1;
      function xt(k) {
        --k.count.value, k.count.value === 0 && (k.S ? k.T.V(k.S) : k.O.M.V(k.N));
      }
      function Mt(k, c, v) {
        return c === v ? k : v.P === void 0 ? null : (k = Mt(k, c, v.P), k === null ? null : v.ma(k));
      }
      var Xt = {};
      function Zn(k, c) {
        return c = Re(k, c), I2[c];
      }
      var Ht = void 0;
      function yr(k) {
        throw new Ht(k);
      }
      function dr(k, c) {
        return c.O && c.N || yr("makeClassHandle requires ptr and ptrType"), !!c.T != !!c.S && yr("Both smartPtrType and smartPtr must be specified"), c.count = { value: 1 }, De(Object.create(k, { L: { value: c } }));
      }
      function De(k) {
        return typeof FinalizationRegistry > "u" ? (De = (c) => c, k) : (jr = new FinalizationRegistry((c) => {
          xt(c.L);
        }), De = (c) => {
          var v = c.L;
          return v.S && jr.register(c, { L: v }, c), c;
        }, gr = (c) => {
          jr.unregister(c);
        }, De(k));
      }
      var Rr = {};
      function $r(k) {
        for (; k.length; ) {
          var c = k.pop();
          k.pop()(c);
        }
      }
      function nr(k) {
        return this.fromWireType(L0[k >> 2]);
      }
      var Qe = {}, Er = {};
      function Ee(k, c, v) {
        function R(I) {
          I = v(I), I.length !== k.length && yr("Mismatched type converter count");
          for (var q = 0; q < k.length; ++q)
            ae(k[q], I[q]);
        }
        k.forEach(function(I) {
          Er[I] = c;
        });
        var E = Array(c.length), x = [], z = 0;
        c.forEach((I, q) => {
          se.hasOwnProperty(I) ? E[q] = se[I] : (x.push(I), Qe.hasOwnProperty(I) || (Qe[I] = []), Qe[I].push(() => {
            E[q] = se[I], ++z, z === x.length && R(E);
          }));
        }), x.length === 0 && R(E);
      }
      function Kr(k) {
        switch (k) {
          case 1:
            return 0;
          case 2:
            return 1;
          case 4:
            return 2;
          case 8:
            return 3;
          default:
            throw new TypeError("Unknown type size: " + k);
        }
      }
      function ae(k, c, v = {}) {
        if (!("argPackAdvance" in c))
          throw new TypeError("registerType registeredInstance requires argPackAdvance");
        var R = c.name;
        if (k || v0('type "' + R + '" must have a positive integer typeid pointer'), se.hasOwnProperty(k)) {
          if (v.ta)
            return;
          v0("Cannot register type '" + R + "' twice");
        }
        se[k] = c, delete Er[k], Qe.hasOwnProperty(k) && (c = Qe[k], delete Qe[k], c.forEach((E) => E()));
      }
      function qr(k) {
        v0(k.L.O.M.name + " instance already deleted");
      }
      function We() {
      }
      function br(k, c, v) {
        if (k[c].R === void 0) {
          var R = k[c];
          k[c] = function() {
            return k[c].R.hasOwnProperty(arguments.length) || v0("Function '" + v + "' called with an invalid number of arguments (" + arguments.length + ") - expects one of (" + k[c].R + ")!"), k[c].R[arguments.length].apply(this, arguments);
          }, k[c].R = [], k[c].R[R.Y] = R;
        }
      }
      function Gn(k, c) {
        w.hasOwnProperty(k) ? (v0("Cannot register public name '" + k + "' twice"), br(w, k, k), w.hasOwnProperty(void 0) && v0("Cannot register multiple overloads of a function with the same number of arguments (undefined)!"), w[k].R[void 0] = c) : w[k] = c;
      }
      function Sn(k, c, v, R, E, x, z, I) {
        this.name = k, this.constructor = c, this.W = v, this.V = R, this.P = E, this.oa = x, this.aa = z, this.ma = I, this.ia = [];
      }
      function et(k, c, v) {
        for (; c !== v; )
          c.aa || v0("Expected null or instance of " + v.name + ", got an instance of " + c.name), k = c.aa(k), c = c.P;
        return k;
      }
      function Tn(k, c) {
        return c === null ? (this.da && v0("null is not a valid " + this.name), 0) : (c.L || v0('Cannot pass "' + nt(c) + '" as a ' + this.name), c.L.N || v0("Cannot pass deleted object as a pointer of type " + this.name), et(c.L.N, c.L.O.M, this.M));
      }
      function On(k, c) {
        if (c === null) {
          if (this.da && v0("null is not a valid " + this.name), this.ca) {
            var v = this.ea();
            return k !== null && k.push(this.V, v), v;
          }
          return 0;
        }
        if (c.L || v0('Cannot pass "' + nt(c) + '" as a ' + this.name), c.L.N || v0("Cannot pass deleted object as a pointer of type " + this.name), !this.ba && c.L.O.ba && v0("Cannot convert argument of type " + (c.L.T ? c.L.T.name : c.L.O.name) + " to parameter type " + this.name), v = et(c.L.N, c.L.O.M, this.M), this.ca)
          switch (c.L.S === void 0 && v0("Passing raw pointer to smart pointer is illegal"), this.Aa) {
            case 0:
              c.L.T === this ? v = c.L.S : v0("Cannot convert argument of type " + (c.L.T ? c.L.T.name : c.L.O.name) + " to parameter type " + this.name);
              break;
            case 1:
              v = c.L.S;
              break;
            case 2:
              if (c.L.T === this)
                v = c.L.S;
              else {
                var R = c.clone();
                v = this.wa(v, J2(function() {
                  R.delete();
                })), k !== null && k.push(this.V, v);
              }
              break;
            default:
              v0("Unsupporting sharing policy");
          }
        return v;
      }
      function Vn(k, c) {
        return c === null ? (this.da && v0("null is not a valid " + this.name), 0) : (c.L || v0('Cannot pass "' + nt(c) + '" as a ' + this.name), c.L.N || v0("Cannot pass deleted object as a pointer of type " + this.name), c.L.O.ba && v0("Cannot convert argument of type " + c.L.O.name + " to parameter type " + this.name), et(c.L.N, c.L.O.M, this.M));
      }
      function le(k, c, v, R) {
        this.name = k, this.M = c, this.da = v, this.ba = R, this.ca = !1, this.V = this.wa = this.ea = this.ja = this.Aa = this.va = void 0, c.P !== void 0 ? this.toWireType = On : (this.toWireType = R ? Tn : Vn, this.U = null);
      }
      function Cn(k, c) {
        w.hasOwnProperty(k) || yr("Replacing nonexistant public symbol"), w[k] = c, w[k].Y = void 0;
      }
      function In(k, c) {
        var v = [];
        return function() {
          if (v.length = 0, Object.assign(v, arguments), k.includes("j")) {
            var R = w["dynCall_" + k];
            R = v && v.length ? R.apply(null, [c].concat(v)) : R.call(null, c);
          } else
            R = E0.get(c).apply(null, v);
          return R;
        };
      }
      function U2(k, c) {
        k = f2(k);
        var v = k.includes("j") ? In(k, c) : E0.get(c);
        return typeof v != "function" && v0("unknown function pointer with signature " + k + ": " + c), v;
      }
      var zt = void 0;
      function Wr(k, c) {
        function v(x) {
          E[x] || se[x] || (Er[x] ? Er[x].forEach(v) : (R.push(x), E[x] = !0));
        }
        var R = [], E = {};
        throw c.forEach(v), new zt(k + ": " + R.map(_t).join([", "]));
      }
      function rt(k, c, v, R, E) {
        var x = c.length;
        2 > x && v0("argTypes array size mismatch! Must at least get return value and 'this' types!");
        var z = c[1] !== null && v !== null, I = !1;
        for (v = 1; v < c.length; ++v)
          if (c[v] !== null && c[v].U === void 0) {
            I = !0;
            break;
          }
        var q = c[0].name !== "void", K = x - 2, i0 = Array(K), u0 = [], G0 = [];
        return function() {
          if (arguments.length !== K && v0("function " + k + " called with " + arguments.length + " arguments, expected " + K + " args!"), G0.length = 0, u0.length = z ? 2 : 1, u0[0] = E, z) {
            var R0 = c[1].toWireType(G0, this);
            u0[1] = R0;
          }
          for (var J = 0; J < K; ++J)
            i0[J] = c[J + 2].toWireType(G0, arguments[J]), u0.push(i0[J]);
          if (J = R.apply(null, u0), I)
            $r(G0);
          else
            for (var g2 = z ? 1 : 2; g2 < c.length; g2++) {
              var R2 = g2 === 1 ? R0 : i0[g2 - 2];
              c[g2].U !== null && c[g2].U(R2);
            }
          return R0 = q ? c[0].fromWireType(J) : void 0, R0;
        };
      }
      function tt(k, c) {
        for (var v = [], R = 0; R < k; R++)
          v.push(D0[c + 4 * R >> 2]);
        return v;
      }
      function it(k) {
        4 < k && --C2[k].fa === 0 && (C2[k] = void 0, Ye.push(k));
      }
      function nt(k) {
        if (k === null)
          return "null";
        var c = typeof k;
        return c === "object" || c === "array" || c === "function" ? k.toString() : "" + k;
      }
      function Bn(k, c) {
        switch (c) {
          case 2:
            return function(v) {
              return this.fromWireType(c2[v >> 2]);
            };
          case 3:
            return function(v) {
              return this.fromWireType(s2[v >> 3]);
            };
          default:
            throw new TypeError("Unknown float type: " + k);
        }
      }
      function Fn(k, c, v) {
        switch (c) {
          case 0:
            return v ? function(R) {
              return _0[R];
            } : function(R) {
              return A0[R];
            };
          case 1:
            return v ? function(R) {
              return F0[R >> 1];
            } : function(R) {
              return r2[R >> 1];
            };
          case 2:
            return v ? function(R) {
              return L0[R >> 2];
            } : function(R) {
              return D0[R >> 2];
            };
          default:
            throw new TypeError("Unknown integer type: " + k);
        }
      }
      function Pn(k, c) {
        for (var v = "", R = 0; !(R >= c / 2); ++R) {
          var E = F0[k + 2 * R >> 1];
          if (E == 0)
            break;
          v += String.fromCharCode(E);
        }
        return v;
      }
      function _n(k, c, v) {
        if (v === void 0 && (v = 2147483647), 2 > v)
          return 0;
        v -= 2;
        var R = c;
        v = v < 2 * k.length ? v / 2 : k.length;
        for (var E = 0; E < v; ++E)
          F0[c >> 1] = k.charCodeAt(E), c += 2;
        return F0[c >> 1] = 0, c - R;
      }
      function Ln(k) {
        return 2 * k.length;
      }
      function xn(k, c) {
        for (var v = 0, R = ""; !(v >= c / 4); ) {
          var E = L0[k + 4 * v >> 2];
          if (E == 0)
            break;
          ++v, 65536 <= E ? (E -= 65536, R += String.fromCharCode(55296 | E >> 10, 56320 | E & 1023)) : R += String.fromCharCode(E);
        }
        return R;
      }
      function Mn(k, c, v) {
        if (v === void 0 && (v = 2147483647), 4 > v)
          return 0;
        var R = c;
        v = R + v - 4;
        for (var E = 0; E < k.length; ++E) {
          var x = k.charCodeAt(E);
          if (55296 <= x && 57343 >= x) {
            var z = k.charCodeAt(++E);
            x = 65536 + ((x & 1023) << 10) | z & 1023;
          }
          if (L0[c >> 2] = x, c += 4, c + 4 > v)
            break;
        }
        return L0[c >> 2] = 0, c - R;
      }
      function Xn(k) {
        for (var c = 0, v = 0; v < k.length; ++v) {
          var R = k.charCodeAt(v);
          55296 <= R && 57343 >= R && ++v, c += 4;
        }
        return c;
      }
      var Hn = {};
      function Ut(k) {
        var c = Hn[k];
        return c === void 0 ? f2(k) : c;
      }
      var Nr = [];
      function zn(k) {
        var c = Nr.length;
        return Nr.push(k), c;
      }
      function Un(k, c) {
        for (var v = Array(k), R = 0; R < k; ++R)
          v[R] = Lt(D0[c + 4 * R >> 2], "parameter " + R);
        return v;
      }
      var Yt = [], Yn = [null, [], []];
      ue = w.BindingError = _e("BindingError"), w.count_emval_handles = function() {
        for (var k = 0, c = 5; c < C2.length; ++c)
          C2[c] !== void 0 && ++k;
        return k;
      }, w.get_first_emval = function() {
        for (var k = 5; k < C2.length; ++k)
          if (C2[k] !== void 0)
            return C2[k];
        return null;
      }, X2 = w.PureVirtualError = _e("PureVirtualError");
      for (var Dt = Array(256), Zr = 0; 256 > Zr; ++Zr)
        Dt[Zr] = String.fromCharCode(Zr);
      x0 = Dt, w.getInheritedInstanceCount = function() {
        return Object.keys(I2).length;
      }, w.getLiveInheritedInstances = function() {
        var k = [], c;
        for (c in I2)
          I2.hasOwnProperty(c) && k.push(I2[c]);
        return k;
      }, w.flushPendingDeletes = de, w.setDelayFunction = function(k) {
        $2 = k, j2.length && $2 && $2(de);
      }, Ht = w.InternalError = _e("InternalError"), We.prototype.isAliasOf = function(k) {
        if (!(this instanceof We && k instanceof We))
          return !1;
        var c = this.L.O.M, v = this.L.N, R = k.L.O.M;
        for (k = k.L.N; c.P; )
          v = c.aa(v), c = c.P;
        for (; R.P; )
          k = R.aa(k), R = R.P;
        return c === R && v === k;
      }, We.prototype.clone = function() {
        if (this.L.N || qr(this), this.L.$)
          return this.L.count.value += 1, this;
        var k = De, c = Object, v = c.create, R = Object.getPrototypeOf(this), E = this.L;
        return k = k(v.call(c, R, { L: { value: { count: E.count, Z: E.Z, $: E.$, N: E.N, O: E.O, S: E.S, T: E.T } } })), k.L.count.value += 1, k.L.Z = !1, k;
      }, We.prototype.delete = function() {
        this.L.N || qr(this), this.L.Z && !this.L.$ && v0("Object already scheduled for deletion"), gr(this), xt(this.L), this.L.$ || (this.L.S = void 0, this.L.N = void 0);
      }, We.prototype.isDeleted = function() {
        return !this.L.N;
      }, We.prototype.deleteLater = function() {
        return this.L.N || qr(this), this.L.Z && !this.L.$ && v0("Object already scheduled for deletion"), j2.push(this), j2.length === 1 && $2 && $2(de), this.L.Z = !0, this;
      }, le.prototype.pa = function(k) {
        return this.ja && (k = this.ja(k)), k;
      }, le.prototype.ga = function(k) {
        this.V && this.V(k);
      }, le.prototype.argPackAdvance = 8, le.prototype.readValueFromPointer = nr, le.prototype.deleteObject = function(k) {
        k !== null && k.delete();
      }, le.prototype.fromWireType = function(k) {
        function c() {
          return this.ca ? dr(this.M.W, { O: this.va, N: v, T: this, S: k }) : dr(this.M.W, { O: this, N: k });
        }
        var v = this.pa(k);
        if (!v)
          return this.ga(k), null;
        var R = Zn(this.M, v);
        if (R !== void 0)
          return R.L.count.value === 0 ? (R.L.N = v, R.L.S = k, R.clone()) : (R = R.clone(), this.ga(k), R);
        if (R = this.M.oa(v), R = Xt[R], !R)
          return c.call(this);
        R = this.ba ? R.ka : R.pointerType;
        var E = Mt(v, this.M, R.M);
        return E === null ? c.call(this) : this.ca ? dr(R.M.W, { O: R, N: E, T: this, S: k }) : dr(R.M.W, { O: R, N: E });
      }, zt = w.UnboundTypeError = _e("UnboundTypeError");
      var Dn = typeof atob == "function" ? atob : function(k) {
        var c = "", v = 0;
        k = k.replace(/[^A-Za-z0-9\+\/=]/g, "");
        do {
          var R = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=".indexOf(k.charAt(v++)), E = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=".indexOf(k.charAt(v++)), x = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=".indexOf(k.charAt(v++)), z = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=".indexOf(k.charAt(v++));
          R = R << 2 | E >> 4, E = (E & 15) << 4 | x >> 2;
          var I = (x & 3) << 6 | z;
          c += String.fromCharCode(R), x !== 64 && (c += String.fromCharCode(E)), z !== 64 && (c += String.fromCharCode(I));
        } while (v < k.length);
        return c;
      }, Qn = {
        q: function(k, c, v) {
          k = f2(k), c = Lt(c, "wrapper"), v = ye(v);
          var R = [].slice, E = c.M, x = E.W, z = E.P.W, I = E.P.constructor;
          k = Ue(k, function() {
            E.P.ia.forEach(function(K) {
              if (this[K] === z[K])
                throw new X2("Pure virtual function " + K + " must be implemented in JavaScript");
            }.bind(this)), Object.defineProperty(this, "__parent", { value: x }), this.__construct.apply(this, R.call(arguments));
          }), x.__construct = function() {
            this === x && v0("Pass correct 'this' to __construct");
            var K = I.implement.apply(void 0, [this].concat(R.call(arguments)));
            gr(K);
            var i0 = K.L;
            K.notifyOnDestruction(), i0.$ = !0, Object.defineProperties(this, { L: { value: i0 } }), De(this), K = i0.N, K = Re(E, K), I2.hasOwnProperty(K) ? v0("Tried to register registered instance: " + K) : I2[K] = this;
          }, x.__destruct = function() {
            this === x && v0("Pass correct 'this' to __destruct"), gr(this);
            var K = this.L.N;
            K = Re(E, K), I2.hasOwnProperty(K) ? delete I2[K] : v0("Tried to unregister unregistered instance: " + K);
          }, k.prototype = Object.create(x);
          for (var q in v)
            k.prototype[q] = v[q];
          return J2(k);
        },
        k: function(k) {
          var c = Rr[k];
          delete Rr[k];
          var v = c.ea, R = c.V, E = c.ha, x = E.map((z) => z.sa).concat(E.map((z) => z.ya));
          Ee([k], x, (z) => {
            var I = {};
            return E.forEach((q, K) => {
              var i0 = z[K], u0 = q.qa, G0 = q.ra, R0 = z[K + E.length], J = q.xa, g2 = q.za;
              I[q.na] = { read: (R2) => i0.fromWireType(u0(G0, R2)), write: (R2, V0) => {
                var A2 = [];
                J(g2, R2, R0.toWireType(A2, V0)), $r(A2);
              } };
            }), [{ name: c.name, fromWireType: function(q) {
              var K = {}, i0;
              for (i0 in I)
                K[i0] = I[i0].read(q);
              return R(q), K;
            }, toWireType: function(q, K) {
              for (var i0 in I)
                if (!(i0 in K))
                  throw new TypeError('Missing field:  "' + i0 + '"');
              var u0 = v();
              for (i0 in I)
                I[i0].write(u0, K[i0]);
              return q !== null && q.push(R, u0), u0;
            }, argPackAdvance: 8, readValueFromPointer: nr, U: R }];
          });
        },
        w: function() {
        },
        C: function(k, c, v, R, E) {
          var x = Kr(v);
          c = f2(c), ae(k, { name: c, fromWireType: function(z) {
            return !!z;
          }, toWireType: function(z, I) {
            return I ? R : E;
          }, argPackAdvance: 8, readValueFromPointer: function(z) {
            if (v === 1)
              var I = _0;
            else if (v === 2)
              I = F0;
            else if (v === 4)
              I = L0;
            else
              throw new TypeError("Unknown boolean type size: " + c);
            return this.fromWireType(I[z >> x]);
          }, U: null });
        },
        g: function(k, c, v, R, E, x, z, I, q, K, i0, u0, G0) {
          i0 = f2(i0), x = U2(E, x), I && (I = U2(z, I)), K && (K = U2(q, K)), G0 = U2(u0, G0);
          var R0 = ir(i0);
          Gn(R0, function() {
            Wr("Cannot construct " + i0 + " due to unbound types", [R]);
          }), Ee([k, c, v], R ? [R] : [], function(J) {
            if (J = J[0], R)
              var g2 = J.M, R2 = g2.W;
            else
              R2 = We.prototype;
            J = Ue(R0, function() {
              if (Object.getPrototypeOf(this) !== V0)
                throw new ue("Use 'new' to construct " + i0);
              if (A2.X === void 0)
                throw new ue(i0 + " has no accessible constructor");
              var Sr = A2.X[arguments.length];
              if (Sr === void 0)
                throw new ue("Tried to invoke ctor of " + i0 + " with invalid number of parameters (" + arguments.length + ") - expected (" + Object.keys(A2.X).toString() + ") parameters instead!");
              return Sr.apply(this, arguments);
            });
            var V0 = Object.create(R2, { constructor: { value: J } });
            J.prototype = V0;
            var A2 = new Sn(i0, J, V0, G0, g2, x, I, K);
            g2 = new le(i0, A2, !0, !1), R2 = new le(i0 + "*", A2, !1, !1);
            var n0 = new le(i0 + " const*", A2, !1, !0);
            return Xt[k] = { pointerType: R2, ka: n0 }, Cn(R0, J), [g2, R2, n0];
          });
        },
        d: function(k, c, v, R, E, x, z) {
          var I = tt(v, R);
          c = f2(c), x = U2(E, x), Ee([], [k], function(q) {
            function K() {
              Wr("Cannot call " + i0 + " due to unbound types", I);
            }
            q = q[0];
            var i0 = q.name + "." + c;
            c.startsWith("@@") && (c = Symbol[c.substring(2)]);
            var u0 = q.M.constructor;
            return u0[c] === void 0 ? (K.Y = v - 1, u0[c] = K) : (br(u0, c, i0), u0[c].R[v - 1] = K), Ee([], I, function(G0) {
              return G0 = rt(i0, [G0[0], null].concat(G0.slice(1)), null, x, z), u0[c].R === void 0 ? (G0.Y = v - 1, u0[c] = G0) : u0[c].R[v - 1] = G0, [];
            }), [];
          });
        },
        p: function(k, c, v, R, E, x) {
          0 < c || t2();
          var z = tt(c, v);
          E = U2(R, E), Ee([], [k], function(I) {
            I = I[0];
            var q = "constructor " + I.name;
            if (I.M.X === void 0 && (I.M.X = []), I.M.X[c - 1] !== void 0)
              throw new ue("Cannot register multiple constructors with identical number of parameters (" + (c - 1) + ") for class '" + I.name + "'! Overload resolution is currently only performed using the parameter count, not actual type info!");
            return I.M.X[c - 1] = () => {
              Wr("Cannot construct " + I.name + " due to unbound types", z);
            }, Ee([], z, function(K) {
              return K.splice(1, 0, null), I.M.X[c - 1] = rt(q, K, null, E, x), [];
            }), [];
          });
        },
        b: function(k, c, v, R, E, x, z, I) {
          var q = tt(v, R);
          c = f2(c), x = U2(E, x), Ee([], [k], function(K) {
            function i0() {
              Wr("Cannot call " + u0 + " due to unbound types", q);
            }
            K = K[0];
            var u0 = K.name + "." + c;
            c.startsWith("@@") && (c = Symbol[c.substring(2)]), I && K.M.ia.push(c);
            var G0 = K.M.W, R0 = G0[c];
            return R0 === void 0 || R0.R === void 0 && R0.className !== K.name && R0.Y === v - 2 ? (i0.Y = v - 2, i0.className = K.name, G0[c] = i0) : (br(G0, c, u0), G0[c].R[v - 2] = i0), Ee([], q, function(J) {
              return J = rt(u0, J, K, x, z), G0[c].R === void 0 ? (J.Y = v - 2, G0[c] = J) : G0[c].R[v - 2] = J, [];
            }), [];
          });
        },
        B: function(k, c) {
          c = f2(c), ae(k, { name: c, fromWireType: function(v) {
            var R = ye(v);
            return it(v), R;
          }, toWireType: function(v, R) {
            return J2(R);
          }, argPackAdvance: 8, readValueFromPointer: nr, U: null });
        },
        n: function(k, c, v) {
          v = Kr(v), c = f2(c), ae(k, {
            name: c,
            fromWireType: function(R) {
              return R;
            },
            toWireType: function(R, E) {
              return E;
            },
            argPackAdvance: 8,
            readValueFromPointer: Bn(c, v),
            U: null
          });
        },
        e: function(k, c, v, R, E) {
          c = f2(c), E === -1 && (E = 4294967295), E = Kr(v);
          var x = (I) => I;
          if (R === 0) {
            var z = 32 - 8 * v;
            x = (I) => I << z >>> z;
          }
          v = c.includes("unsigned") ? function(I, q) {
            return q >>> 0;
          } : function(I, q) {
            return q;
          }, ae(k, { name: c, fromWireType: x, toWireType: v, argPackAdvance: 8, readValueFromPointer: Fn(c, E, R !== 0), U: null });
        },
        c: function(k, c, v) {
          function R(x) {
            x >>= 2;
            var z = D0;
            return new E(U0, z[x + 1], z[x]);
          }
          var E = [
            Int8Array,
            Uint8Array,
            Int16Array,
            Uint16Array,
            Int32Array,
            Uint32Array,
            Float32Array,
            Float64Array
          ][c];
          v = f2(v), ae(k, { name: v, fromWireType: R, argPackAdvance: 8, readValueFromPointer: R }, { ta: !0 });
        },
        o: function(k, c) {
          c = f2(c);
          var v = c === "std::string";
          ae(k, { name: c, fromWireType: function(R) {
            var E = D0[R >> 2], x = R + 4;
            if (v)
              for (var z = x, I = 0; I <= E; ++I) {
                var q = x + I;
                if (I == E || A0[q] == 0) {
                  if (z = z ? n2(A0, z, q - z) : "", K === void 0)
                    var K = z;
                  else
                    K += String.fromCharCode(0), K += z;
                  z = q + 1;
                }
              }
            else {
              for (K = Array(E), I = 0; I < E; ++I)
                K[I] = String.fromCharCode(A0[x + I]);
              K = K.join("");
            }
            return Ne(R), K;
          }, toWireType: function(R, E) {
            E instanceof ArrayBuffer && (E = new Uint8Array(E));
            var x, z = typeof E == "string";
            if (z || E instanceof Uint8Array || E instanceof Uint8ClampedArray || E instanceof Int8Array || v0("Cannot pass non-string to std::string"), v && z) {
              var I = 0;
              for (x = 0; x < E.length; ++x) {
                var q = E.charCodeAt(x);
                127 >= q ? I++ : 2047 >= q ? I += 2 : 55296 <= q && 57343 >= q ? (I += 4, ++x) : I += 3;
              }
              x = I;
            } else
              x = E.length;
            if (I = Qt(4 + x + 1), q = I + 4, D0[I >> 2] = x, v && z) {
              if (z = q, q = x + 1, x = A0, 0 < q) {
                q = z + q - 1;
                for (var K = 0; K < E.length; ++K) {
                  var i0 = E.charCodeAt(K);
                  if (55296 <= i0 && 57343 >= i0) {
                    var u0 = E.charCodeAt(++K);
                    i0 = 65536 + ((i0 & 1023) << 10) | u0 & 1023;
                  }
                  if (127 >= i0) {
                    if (z >= q)
                      break;
                    x[z++] = i0;
                  } else {
                    if (2047 >= i0) {
                      if (z + 1 >= q)
                        break;
                      x[z++] = 192 | i0 >> 6;
                    } else {
                      if (65535 >= i0) {
                        if (z + 2 >= q)
                          break;
                        x[z++] = 224 | i0 >> 12;
                      } else {
                        if (z + 3 >= q)
                          break;
                        x[z++] = 240 | i0 >> 18, x[z++] = 128 | i0 >> 12 & 63;
                      }
                      x[z++] = 128 | i0 >> 6 & 63;
                    }
                    x[z++] = 128 | i0 & 63;
                  }
                }
                x[z] = 0;
              }
            } else if (z)
              for (z = 0; z < x; ++z)
                K = E.charCodeAt(z), 255 < K && (Ne(q), v0("String has UTF-16 code units that do not fit in 8 bits")), A0[q + z] = K;
            else
              for (z = 0; z < x; ++z)
                A0[q + z] = E[z];
            return R !== null && R.push(Ne, I), I;
          }, argPackAdvance: 8, readValueFromPointer: nr, U: function(R) {
            Ne(R);
          } });
        },
        j: function(k, c, v) {
          if (v = f2(v), c === 2)
            var R = Pn, E = _n, x = Ln, z = () => r2, I = 1;
          else
            c === 4 && (R = xn, E = Mn, x = Xn, z = () => D0, I = 2);
          ae(k, {
            name: v,
            fromWireType: function(q) {
              for (var K = D0[q >> 2], i0 = z(), u0, G0 = q + 4, R0 = 0; R0 <= K; ++R0) {
                var J = q + 4 + R0 * c;
                (R0 == K || i0[J >> I] == 0) && (G0 = R(G0, J - G0), u0 === void 0 ? u0 = G0 : (u0 += String.fromCharCode(0), u0 += G0), G0 = J + c);
              }
              return Ne(q), u0;
            },
            toWireType: function(q, K) {
              typeof K != "string" && v0("Cannot pass non-string to C++ string type " + v);
              var i0 = x(K), u0 = Qt(4 + i0 + c);
              return D0[u0 >> 2] = i0 >> I, E(K, u0 + 4, i0 + c), q !== null && q.push(Ne, u0), u0;
            },
            argPackAdvance: 8,
            readValueFromPointer: nr,
            U: function(q) {
              Ne(q);
            }
          });
        },
        l: function(k, c, v, R, E, x) {
          Rr[k] = { name: f2(c), ea: U2(v, R), V: U2(E, x), ha: [] };
        },
        i: function(k, c, v, R, E, x, z, I, q, K) {
          Rr[k].ha.push({ na: f2(c), sa: v, qa: U2(R, E), ra: x, ya: z, xa: U2(I, q), za: K });
        },
        D: function(k, c) {
          c = f2(c), ae(k, { ua: !0, name: c, argPackAdvance: 0, fromWireType: function() {
          }, toWireType: function() {
          } });
        },
        t: function(k, c, v, R, E) {
          k = Nr[k], c = ye(c), v = Ut(v);
          var x = [];
          return D0[R >> 2] = J2(x), k(c, v, x, E);
        },
        u: function(k, c, v, R) {
          k = Nr[k], c = ye(c), v = Ut(v), k(c, v, null, R);
        },
        h: it,
        m: function(k, c) {
          var v = Un(
            k,
            c
          ), R = v[0];
          c = R.name + "_$" + v.slice(1).map(function(z) {
            return z.name;
          }).join("_") + "$";
          var E = Yt[c];
          if (E !== void 0)
            return E;
          var x = Array(k - 1);
          return E = zn((z, I, q, K) => {
            for (var i0 = 0, u0 = 0; u0 < k - 1; ++u0)
              x[u0] = v[u0 + 1].readValueFromPointer(K + i0), i0 += v[u0 + 1].argPackAdvance;
            for (z = z[I].apply(z, x), u0 = 0; u0 < k - 1; ++u0)
              v[u0 + 1].la && v[u0 + 1].la(x[u0]);
            if (!R.ua)
              return R.toWireType(q, z);
          }), Yt[c] = E;
        },
        r: function(k) {
          4 < k && (C2[k].fa += 1);
        },
        s: function(k) {
          var c = ye(k);
          $r(c), it(k);
        },
        f: function() {
          t2("");
        },
        y: function(k, c, v) {
          A0.copyWithin(k, c, c + v);
        },
        x: function(k) {
          var c = A0.length;
          if (k >>>= 0, 2147483648 < k)
            return !1;
          for (var v = 1; 4 >= v; v *= 2) {
            var R = c * (1 + 0.2 / v);
            R = Math.min(R, k + 100663296);
            var E = Math;
            R = Math.max(k, R), E = E.min.call(E, 2147483648, R + (65536 - R % 65536) % 65536);
            e: {
              try {
                c0.grow(E - U0.byteLength + 65535 >>> 16), P0(c0.buffer);
                var x = 1;
                break e;
              } catch {
              }
              x = void 0;
            }
            if (x)
              return !0;
          }
          return !1;
        },
        A: function() {
          return 52;
        },
        v: function() {
          return 70;
        },
        z: function(k, c, v, R) {
          for (var E = 0, x = 0; x < v; x++) {
            var z = D0[c >> 2], I = D0[c + 4 >> 2];
            c += 8;
            for (var q = 0; q < I; q++) {
              var K = A0[z + q], i0 = Yn[k];
              K === 0 || K === 10 ? ((k === 1 ? Q : o0)(n2(i0, 0)), i0.length = 0) : i0.push(K);
            }
            E += I;
          }
          return D0[R >> 2] = E, 0;
        },
        a: c0
      }, Je = function() {
        function k(v) {
          w.asm = v.exports, E0 = w.asm.I, d2.unshift(w.asm.E), y0--, w.monitorRunDependencies && w.monitorRunDependencies(y0), y0 == 0 && O0 && (v = O0, O0 = null, v());
        }
        var c = { a: Qn };
        if (y0++, w.monitorRunDependencies && w.monitorRunDependencies(y0), w.instantiateWasm)
          try {
            return w.instantiateWasm(c, k);
          } catch (v) {
            o0("Module.instantiateWasm callback failed with error: " + v), Y(v);
          }
        return c = mr(c), k(c[0]), w.asm;
      }();
      w.___wasm_call_ctors = Je.E;
      var Jn = w.___getTypeName = Je.F;
      w.__embind_initialize_bindings = Je.G;
      var Qt = w._malloc = Je.H, Ne = w._free = Je.J;
      w.dynCall_jiji = Je.K;
      var Gr;
      O0 = function k() {
        Gr || Jt(), Gr || (O0 = k);
      };
      function Jt() {
        function k() {
          if (!Gr && (Gr = !0, w.calledRun = !0, !S0)) {
            if (ge(d2), _(w), w.onRuntimeInitialized && w.onRuntimeInitialized(), w.postRun)
              for (typeof w.postRun == "function" && (w.postRun = [w.postRun]); w.postRun.length; ) {
                var c = w.postRun.shift();
                w0.unshift(c);
              }
            ge(w0);
          }
        }
        if (!(0 < y0)) {
          if (w.preRun)
            for (typeof w.preRun == "function" && (w.preRun = [w.preRun]); w.preRun.length; )
              T0();
          ge(m2), 0 < y0 || (w.setStatus ? (w.setStatus("Running..."), setTimeout(function() {
            setTimeout(function() {
              w.setStatus("");
            }, 1), k();
          }, 1)) : k());
        }
      }
      if (w.preInit)
        for (typeof w.preInit == "function" && (w.preInit = [w.preInit]); 0 < w.preInit.length; )
          w.preInit.pop()();
      return Jt(), N;
    };
  })();
  s.exports = G;
})(vn);
var No = vn.exports;
(function(s) {
  Object.defineProperty(s, "__esModule", {
    value: !0
  });
  var y = {};
  s.default = void 0;
  var G = N(Pt), O = p0;
  Object.keys(O).forEach(function(U) {
    U === "default" || U === "__esModule" || Object.prototype.hasOwnProperty.call(y, U) || U in s && s[U] === O[U] || Object.defineProperty(s, U, {
      enumerable: !0,
      get: function() {
        return O[U];
      }
    });
  });
  function N(U) {
    return U && U.__esModule ? U : { default: U };
  }
  const w = No;
  var Y = (0, G.default)(w());
  s.default = Y;
})(B0);
const mn = /* @__PURE__ */ go(B0), we = 1.8;
function Zo(s, y) {
  return typeof s == "number" ? {
    top: s * y,
    right: s * y,
    bottom: s * y,
    left: s * y
  } : {
    top: typeof s.top == "number" ? s.top * y : s.top,
    right: typeof s.right == "number" ? s.right * y : s.right,
    bottom: typeof s.bottom == "number" ? s.bottom * y : s.bottom,
    left: typeof s.left == "number" ? s.left * y : s.left
  };
}
function ln(s, y) {
  return typeof s == "number" ? {
    top: s * y,
    right: s * y,
    bottom: s * y,
    left: s * y
  } : {
    top: (typeof s.top == "number" ? s.top * y : s.top) ?? 0,
    right: (typeof s.right == "number" ? s.right * y : s.right) ?? 0,
    bottom: (typeof s.bottom == "number" ? s.bottom * y : s.bottom) ?? 0,
    left: (typeof s.left == "number" ? s.left * y : s.left) ?? 0
  };
}
function Go(s, y = 1) {
  return typeof s == "number" ? {
    topLeft: s * y,
    topRight: s * y,
    bottomRight: s * y,
    bottomLeft: s * y
  } : {
    topLeft: ((s == null ? void 0 : s.topLeft) ?? 0) * y,
    topRight: ((s == null ? void 0 : s.topRight) ?? 0) * y,
    bottomRight: ((s == null ? void 0 : s.bottomRight) ?? 0) * y,
    bottomLeft: ((s == null ? void 0 : s.bottomLeft) ?? 0) * y
  };
}
function gn(s, { layout: y, scale: G = 1 }) {
  const {
    position: O = "static",
    inset: N,
    width: w,
    height: _,
    minWidth: Y,
    minHeight: U,
    maxWidth: b,
    maxHeight: Q,
    flex: o0,
    gap: l0,
    margin: Z0,
    padding: j,
    // Not technically CSS defaults but I prefer column as default
    direction: i2 = "column",
    align: k0 = "start",
    alignSelf: k2,
    justify: c0 = "start"
  } = y, S0 = {
    static: B0.PositionType.Static,
    relative: B0.PositionType.Relative,
    absolute: B0.PositionType.Absolute
  };
  if (s.setPositionType(S0[O]), N) {
    const { top: A0, right: F0, bottom: r2, left: L0 } = Zo(N, G);
    A0 && s.setPosition(B0.Edge.Top, A0), F0 && s.setPosition(B0.Edge.Right, F0), r2 && s.setPosition(B0.Edge.Bottom, r2), L0 && s.setPosition(B0.Edge.Left, L0);
  }
  const n2 = {
    row: B0.FlexDirection.Row,
    column: B0.FlexDirection.Column,
    "row-reverse": B0.FlexDirection.RowReverse,
    "column-reverse": B0.FlexDirection.ColumnReverse
  };
  s.setFlexDirection(n2[i2]);
  const U0 = {
    start: B0.Align.FlexStart,
    end: B0.Align.FlexEnd,
    center: B0.Align.Center,
    stretch: B0.Align.Stretch
  };
  s.setAlignItems(U0[k0]), k2 && s.setAlignSelf(U0[k2]);
  const _0 = {
    start: B0.Justify.FlexStart,
    end: B0.Justify.FlexEnd,
    center: B0.Justify.Center,
    "space-between": B0.Justify.SpaceBetween,
    "space-around": B0.Justify.SpaceAround,
    "space-evenly": B0.Justify.SpaceEvenly
  };
  if (s.setJustifyContent(_0[c0]), Z0) {
    const { top: A0, right: F0, bottom: r2, left: L0 } = ln(Z0, G);
    s.setMargin(B0.Edge.Top, A0), s.setMargin(B0.Edge.Right, F0), s.setMargin(B0.Edge.Bottom, r2), s.setMargin(B0.Edge.Left, L0);
  }
  if (j) {
    const { top: A0, right: F0, bottom: r2, left: L0 } = ln(j, G);
    s.setPadding(B0.Edge.Top, A0), s.setPadding(B0.Edge.Right, F0), s.setPadding(B0.Edge.Bottom, r2), s.setPadding(B0.Edge.Left, L0);
  }
  o0 && s.setFlex(o0), s.setGap(B0.Gutter.All, (l0 ?? 0) * G), w && s.setWidth(typeof w == "number" ? w * G : w), _ && (typeof _ == "function" ? s.setHeight("100%") : s.setHeight(typeof _ == "number" ? _ * G : _)), Y && s.setMinWidth(typeof Y == "number" ? Y * G : Y), U && s.setMinHeight(typeof U == "number" ? U * G : U), b && s.setMaxWidth(typeof b == "number" ? b * G : b), Q && s.setMaxHeight(typeof Q == "number" ? Q * G : Q);
}
function yn({ canvas: s, debug: y = !1, scale: G = 1, position: O = [] }) {
  O.forEach(({ x: N, y: w, width: _, height: Y, childNodes: U, element: b }) => {
    const Q = s.getContext("2d", { alpha: !1 });
    if (Q) {
      const { radius: o0, draw: l0 } = b;
      if (l0) {
        if (Q.save(), o0) {
          const { topLeft: Z0, topRight: j, bottomRight: i2, bottomLeft: k0 } = Go(o0, G);
          Q.beginPath(), Q.moveTo(N + Math.min(Y / we, Z0), w), Q.lineTo(N + _ - Math.min(Y / we, j), w), Q.quadraticCurveTo(N + _, w, N + _, w + Math.min(Y / we, j)), Q.lineTo(N + _, w + Y - Math.min(Y / we, i2)), Q.quadraticCurveTo(
            N + _,
            w + Y,
            N + _ - Math.min(Y / we, i2),
            w + Y
          ), Q.lineTo(N + Math.min(Y / we, k0), w + Y), Q.quadraticCurveTo(N, w + Y, N, w + Y - Math.min(Y / we, k0)), Q.lineTo(N, w + Math.min(Y / we, Z0)), Q.quadraticCurveTo(N, w, N + Math.min(Y / we, Z0), w), Q.closePath(), y && (Q.strokeStyle = "blue", Q.stroke()), Q.clip();
        }
        l0({ scale: G, dx: N, dy: w, dw: _, dh: Y }), y && (Q.strokeStyle = "red", Q.strokeRect(N, w, _, Y)), Q.restore();
      }
    }
    yn({
      canvas: s,
      debug: y,
      scale: G,
      position: U
    });
  });
}
function dn(s, y, G) {
  const O = y.map((N, w) => {
    const _ = mn.Node.create(), { radius: Y, elements: U = [], draw: b, ...Q } = N;
    return gn(_, { layout: Q, scale: G }), s.insertChild(_, w), {
      node: _,
      element: N,
      childNodes: dn(_, U, G)
    };
  });
  return s.calculateLayout(), O;
}
function Rn(s, y, G = 0, O = 0) {
  const { top: N, left: w } = s.getComputedLayout();
  return y.map(({ node: _, element: Y, childNodes: U }) => {
    const { top: b, left: Q, width: o0, height: l0 } = _.getComputedLayout(), Z0 = G + Q, j = O + b;
    return {
      x: w + Z0,
      y: N + j,
      width: o0,
      height: l0,
      element: Y,
      childNodes: Rn(s, U, Z0, j)
    };
  });
}
function En(s, y) {
  s.forEach(({ node: G, element: O, childNodes: N }) => {
    const { height: w } = O;
    if (w && typeof w == "function") {
      const _ = G.getComputedWidth(), Y = G.getComputedHeight(), U = w({ width: _, maxHeight: Y, scale: y });
      G.setHeight(U);
    }
    En(N, y);
  });
}
function So({ canvas: s, origin: y, elements: G, ...O }) {
  const N = { inset: { top: 0, left: 0 }, width: s.width, height: s.height, ...y }, w = mn.Node.create();
  gn(w, { layout: N }), w.calculateLayout();
  const { width: _, height: Y } = w.getComputedLayout(), U = Math.min(_, Y) / 1080, b = dn(w, G, U);
  En(b, U), w.calculateLayout();
  const Q = Rn(w, b);
  return yn({ ...O, scale: U, canvas: s, position: Q });
}
const To = [
  {
    family: "Noto Arabic",
    regex: /\p{Script=Arabic}/u,
    url: "https://media-player-fonts.s3.ap-southeast-2.amazonaws.com/NotoSansArabic-VariableFont_wdth%2Cwght.woff2",
    style: "normal"
  },
  {
    family: "Noto Chinese",
    regex: /\p{Script=Han}/u,
    url: "https://media-player-fonts.s3.ap-southeast-2.amazonaws.com/NotoSansSC-VariableFont_wght.woff2",
    style: "normal"
  },
  {
    family: "Noto Hebrew",
    regex: /\p{Script=Hebrew}/u,
    url: "https://media-player-fonts.s3.ap-southeast-2.amazonaws.com/NotoSansHebrew-VariableFont_wdth%2Cwght.woff2",
    style: "normal"
  },
  {
    family: "Noto Hindi",
    regex: /\p{Script=Devanagari}/u,
    url: "https://media-player-fonts.s3.ap-southeast-2.amazonaws.com/NotoSansDevanagari-VariableFont_wdth%2Cwght.woff2",
    style: "normal"
  },
  {
    family: "Noto Japanese",
    regex: /\p{Script=Han}|\p{Script=Katakana}|\p{Script=Hiragana}/u,
    url: "https://media-player-fonts.s3.ap-southeast-2.amazonaws.com/NotoSansJP-VariableFont_wght.woff2",
    style: "normal"
  },
  {
    family: "Noto Korean",
    regex: /\p{Script=Hangul}/u,
    url: "https://media-player-fonts.s3.ap-southeast-2.amazonaws.com/NotoSansKR-VariableFont_wght.woff2",
    style: "normal"
  },
  {
    family: "Noto Color Emoji",
    regex: /\p{Extended_Pictographic}/u,
    url: "https://media-player-fonts.s3.ap-southeast-2.amazonaws.com/NotoColorEmoji-Regular.woff2",
    style: "normal"
  }
];
function Ct({ text: s, font: y }) {
  let G = y;
  return To.forEach(({ family: O, regex: N }) => {
    N.exec(s) && (G += `, ${O}`);
  }), G;
}
const Qr = /(?<value>\d+\.?\d*)(?=px)/;
function Wn(s) {
  const { visible: y = !0, node: G } = s, O = [...(G == null ? void 0 : G.elements) ?? [], ...(s == null ? void 0 : s.elements) ?? []];
  return y ? G && G.type !== "box" && G.type !== "gradient" ? !!G.value : O == null ? void 0 : O.some((N) => Wn(N)) : !1;
}
function Nn({
  debug: s = !1,
  canvas: y,
  cropCanvas: G,
  posterCanvas: O,
  letterboxCanvas: N,
  elements: w = [],
  currentTime: _,
  contentTime: Y,
  sceneTime: U,
  totalDuration: b,
  contentDuration: Q,
  sceneDuration: o0,
  parentAlpha: l0
}) {
  return w.map((Z0) => {
    var n2, U0, _0, A0, F0, r2, L0, D0;
    const { node: j, transient: i2 = [{ from: 0, duration: 1 / 0 }] } = Z0, k0 = y.getContext("2d"), k2 = {
      total: _,
      content: Y,
      scene: U
    }, c0 = {
      total: b,
      content: Q,
      scene: o0
    }, S0 = i2.reduce(
      (c2, { type: s2 = "scene", from: P0, duration: a2, animation: E0 }) => {
        const m2 = P0 < 0 ? c0[s2] + P0 : P0;
        return k2[s2] >= m2 && k2[s2] <= m2 + a2 && (c2 = {
          type: s2,
          animation: E0,
          duration: a2,
          from: m2
        }), c2;
      },
      null
    );
    if (k0 && S0 && Wn(Z0)) {
      let c2 = Z0.width, s2 = Z0.height, P0 = l0 ?? 1;
      const {
        type: a2 = "scene",
        from: E0,
        duration: m2,
        animation: d2 = { type: "fade", duration: 1 / 3 }
      } = S0;
      if (d2) {
        const { type: w0, duration: T0 } = d2;
        w0 === "fade" && (E0 > 0 && k2[a2] <= E0 + T0 && (P0 = Math.max(0, Math.min(1, (k2[a2] - E0) / T0))), // Don't fade out if we hit the end of the video as the fade ends
        E0 + m2 < c0[a2] && E0 + m2 - T0 <= k2[a2] && (P0 = Math.max(0, Math.min(1, (E0 + m2 - k2[a2]) / T0))));
      }
      if ((j == null ? void 0 : j.type) === "text" && j.value) {
        const w0 = Ct({ text: j.value, font: j.font });
        k0.save(), j.wrap ? s2 = ({ width: T0, maxHeight: y0, scale: O0 }) => {
          var M2, me;
          const t2 = an({
            font: w0,
            scale: O0,
            context: k0,
            maxW: T0,
            maxH: y0,
            text: j.value ?? "",
            minSize: (M2 = j.fill) == null ? void 0 : M2.minSize,
            maxSize: (me = j.fill) == null ? void 0 : me.maxSize
          });
          return Jr({ context: k0, font: w0, fontSize: t2, text: j.value ?? "", maxW: T0 }).length * t2;
        } : (k0.font = w0, c2 = k0.measureText(j.value).width, s2 = parseFloat(((U0 = (n2 = w0.match(Qr)) == null ? void 0 : n2.groups) == null ? void 0 : U0.value) ?? "0")), k0.restore();
      }
      if ((j == null ? void 0 : j.type) === "image" && j.image && j.size) {
        const w0 = ((_0 = j.image) == null ? void 0 : _0.naturalWidth) ?? ((A0 = j.image) == null ? void 0 : A0.width), T0 = ((F0 = j.image) == null ? void 0 : F0.naturalHeight) ?? ((r2 = j.image) == null ? void 0 : r2.height), y0 = w0 / T0, O0 = (L0 = j.size) == null ? void 0 : L0.width, t2 = (D0 = j.size) == null ? void 0 : D0.height;
        c2 = O0 ?? (y0 >= 1 ? (t2 ?? 0) * y0 : (t2 ?? 0) / y0), s2 = t2 ?? (y0 < 1 ? (O0 ?? 0) * y0 : (O0 ?? 0) / y0);
      }
      return {
        ...Z0,
        width: c2,
        height: s2,
        elements: Nn({
          debug: s,
          canvas: y,
          cropCanvas: G,
          posterCanvas: O,
          letterboxCanvas: N,
          elements: Z0.elements,
          currentTime: _,
          contentTime: Y,
          sceneTime: U,
          totalDuration: b,
          contentDuration: Q,
          sceneDuration: o0,
          parentAlpha: P0
        }),
        draw: ({ dx: w0, dy: T0, dw: y0, dh: O0, scale: t2 }) => {
          var V2, M2, me, mr, ge, ir, Ue, C2, Ye, _e, ue, v0, ye;
          if (k0.globalAlpha = P0, j) {
            const { type: J2 } = j;
            if (J2 === "box" && (k0.fillStyle = j.background, k0.fillRect(w0, T0, y0, O0)), J2 === "text" && j.value) {
              const X2 = Ct({ text: j.value, font: j.font }), x0 = an({
                font: X2,
                scale: t2,
                context: k0,
                maxW: y0,
                maxH: O0,
                text: j.value ?? "",
                minSize: (V2 = j.fill) == null ? void 0 : V2.minSize,
                maxSize: (M2 = j.fill) == null ? void 0 : M2.maxSize
              });
              k0.font = X2.replace(Qr, x0.toString()), k0.textBaseline = "top", k0.fillStyle = j.color, j.wrap ? Jr({ context: k0, font: X2, fontSize: x0, text: j.value, maxW: y0 }).forEach((j2, de) => {
                k0.fillText(j2.text, w0, T0 + x0 * de);
              }) : k0.fillText(j.value, w0, T0);
            }
            if (J2 === "image" && j.image && k0.drawImage(j.image, w0, T0, y0, O0), J2 === "video" && ((me = j.video) != null && me.node || (mr = j.video) != null && mr.getSource)) {
              const X2 = j.format ?? "letterbox", x0 = ((ir = (ge = j.video) == null ? void 0 : ge.getSource) == null ? void 0 : ir.call(ge, U)) ?? j.video.node, f2 = (x0 == null ? void 0 : x0.videoWidth) ?? (x0 == null ? void 0 : x0.naturalWidth) ?? (x0 == null ? void 0 : x0.width), j2 = (x0 == null ? void 0 : x0.videoHeight) ?? (x0 == null ? void 0 : x0.naturalHeight) ?? (x0 == null ? void 0 : x0.height);
              if (f2 && j2) {
                const {
                  dx: $2,
                  dy: I2,
                  dw: Re,
                  dh: se
                } = on({
                  context: k0,
                  cropCanvas: G,
                  letterboxCanvas: N,
                  source: x0,
                  format: X2,
                  crop: (Ue = j == null ? void 0 : j.value) == null ? void 0 : Ue.crop,
                  sourceWidth: f2,
                  sourceHeight: j2,
                  posX: w0,
                  posY: T0,
                  drawAreaWidth: y0,
                  drawAreaHeight: O0
                });
                j.elements && It({
                  debug: s,
                  canvas: y,
                  cropCanvas: G,
                  posterCanvas: O,
                  letterboxCanvas: N,
                  elements: j.elements,
                  currentTime: _,
                  contentTime: Y,
                  sceneTime: U,
                  totalDuration: b,
                  contentDuration: Q,
                  sceneDuration: o0,
                  origin: {
                    inset: {
                      top: Math.max(T0, T0 + I2),
                      left: Math.max(w0, w0 + $2)
                    },
                    width: Math.min(y0, Re),
                    height: Math.min(O0, se)
                  }
                });
              }
              const de = 1 / 3;
              if (j.poster && _ >= 0 && _ <= de) {
                k0.save(), k0.globalAlpha = 1 - _ / de;
                const $2 = ((C2 = j.poster) == null ? void 0 : C2.naturalWidth) ?? ((Ye = j.poster) == null ? void 0 : Ye.width), I2 = ((_e = j.poster) == null ? void 0 : _e.naturalHeight) ?? ((ue = j.poster) == null ? void 0 : ue.height);
                O.width = O.height = 0, O.width = y0, O.height = O0;
                const Re = O.getContext("2d");
                Re && $2 && I2 && (on({
                  context: Re,
                  cropCanvas: G,
                  letterboxCanvas: N,
                  source: j.poster,
                  format: X2,
                  crop: (v0 = j == null ? void 0 : j.value) == null ? void 0 : v0.crop,
                  sourceWidth: $2,
                  sourceHeight: I2,
                  posX: 0,
                  posY: 0,
                  drawAreaWidth: y0,
                  drawAreaHeight: O0
                }), j.elements && It({
                  debug: s,
                  canvas: O,
                  cropCanvas: G,
                  posterCanvas: O,
                  letterboxCanvas: N,
                  elements: j.elements,
                  currentTime: _,
                  contentTime: Y,
                  sceneTime: U,
                  totalDuration: b,
                  contentDuration: Q,
                  sceneDuration: o0
                }), k0.drawImage(O, w0, T0, y0, O0), k0.restore());
              }
            }
            if (J2 === "gradient" && j.value) {
              const X2 = k0.createLinearGradient(w0 + y0, T0, w0 + y0, T0 + O0);
              (ye = j.value) == null || ye.forEach((x0) => {
                X2.addColorStop(x0.percent, x0.color);
              }), k0.fillStyle = X2, k0.fillRect(w0, T0, y0, O0);
            }
          }
        }
      };
    }
  }).filter(Boolean);
}
function It({
  debug: s,
  canvas: y,
  cropCanvas: G,
  posterCanvas: O,
  letterboxCanvas: N,
  elements: w,
  currentTime: _,
  contentTime: Y,
  sceneTime: U,
  totalDuration: b,
  contentDuration: Q,
  sceneDuration: o0,
  ...l0
}) {
  return So({
    ...l0,
    debug: s,
    canvas: y,
    elements: Nn({
      debug: s,
      canvas: y,
      cropCanvas: G,
      posterCanvas: O,
      letterboxCanvas: N,
      elements: w,
      currentTime: _,
      contentTime: Y,
      sceneTime: U,
      totalDuration: b,
      contentDuration: Q,
      sceneDuration: o0
    })
  });
}
const Jr = pn(
  ({ context: s, font: y, fontSize: G, text: O, maxW: N = 1 / 0 }) => {
    try {
      return s.save(), s.font = y.replace(Qr, G.toString()), O.split(`
`).flatMap((_) => {
        const Y = _.split(" ").filter(Boolean);
        return Y.length ? Y.slice(1).reduce((U, b) => {
          const o0 = `${U[U.length - 1].text} ${b}`.trim(), l0 = s.measureText(o0);
          return l0.width > N ? U = [...U, ...sn({ context: s, word: b, maxW: N })] : U[U.length - 1] = {
            text: o0,
            metrics: l0
          }, U;
        }, sn({ context: s, word: Y[0], maxW: N })) : { text: "", metrics: s.measureText("") };
      });
    } finally {
      s.restore();
    }
  },
  {
    cacheKey: ([{ font: s, fontSize: y, text: G, maxW: O }]) => `${s}_${y}_${G}_${O}`
  }
), Oo = /\d{0,2}:?\d{2}:\d{2}\.\d{3}\s-->\s\d{0,2}:?\d{2}:\d{2}\.\d{3}\s{1,2}.*/g, Vo = /\d{0,2}:?\d{2}:\d{2}\.\d{3}/g;
function Co(s) {
  if (!s)
    return [];
  const y = s.match(Oo);
  return y ? y == null ? void 0 : y.map((G) => {
    const [O, N] = G.replace(`\r
`, `
`).split(`
`), [w, _] = O.match(Vo) || [];
    return { start: w, end: _, text: N };
  }) : [];
}
function kn(s) {
  const [y, G, O] = s.split(":");
  return O ? parseInt(y) * 60 * 60 + parseInt(G) * 60 + parseFloat(O) : parseInt(y) * 60 + parseInt(G);
}
function Io({ canvas: s, dx: y, dy: G, dw: O, dh: N, sceneTime: w, vttCaptions: _ }) {
  if (_) {
    const U = Co(_).find(({ start: b, end: Q }) => b && Q && w >= kn(b) && w < kn(Q));
    if (U) {
      const b = s.getContext("2d");
      if (b) {
        const Q = Math.min(O, N), o0 = Q * 0.04, l0 = Ct({
          text: _,
          font: `400 ${o0}px Roobert Captions`
        });
        b.font = l0, b.textBaseline = "middle";
        const Z0 = O * 0.9, j = Jr({ context: b, font: l0, fontSize: o0, text: U.text, maxW: Z0 });
        j.forEach(({ text: i2, metrics: k0 }, k2) => {
          const c0 = y + (O - k0.width) / 2, S0 = G + (N * 0.85 - (o0 + Q * 0.03) * (j.length - 1 - k2)), n2 = o0 * 0.8, U0 = o0 / 1.5, _0 = y + (O - k0.width - U0) / 2, A0 = S0 - n2, F0 = k0.width + U0, r2 = n2 * 2, L0 = b.globalAlpha;
          b.save(), b.globalAlpha = 0.8 * L0, b.fillStyle = "#000000", b.beginPath(), b.roundRect(_0, A0, F0, r2, Q * 0.01), b.fill(), b.closePath(), b.globalAlpha = L0, b.fillStyle = "#FFFFFF", b.fillText(i2, c0, S0), b.restore();
        });
      }
    }
  }
}
const Bo = {
  id: "default",
  name: "None",
  templates: [
    {
      id: "basic",
      version: "2",
      name: "Basic",
      layouts: [
        {
          name: "basic",
          tree: `[
          {
            "width": "100%",
            "height": "100%",
            "node": {
              "type": "video",
              "format": {{ it.videoFormat }},
              "value": {
                "id": {{ it.id }},
                "key": {{ it.key }},
                "src": {{@async resolve-source({ sources: [it.mp4, it.input] }) /}},
                "playlist": {{@async resolve-source({ sources: [it.playlist] }) /}},
                "poster": {{ it.poster }},
                "captions": {{ it.captions }},
                "duration": {{ it.duration }},
                "startOffset": {{ it.startOffset }},
                "endOffset": {{ it.endOffset }},
                "crop": {
                  "x": {{ it.crop?.x }},
                  "y": {{ it.crop?.y }},
                  "width": {{ it.crop?.width }},
                  "height": {{ it.crop?.height }}
                }
              }
            }
          }
        ]`
        }
      ],
      content: [
        {
          scenes: [
            {
              layout: "basic",
              data: `{
              "id": {{ it.root?.answer?.id }},
              "key": {{ it.root?.answer?.id + '-intro' }},
              "mp4": {{ it.root?.answer?.media?.video }},
              "input": {{ it.root?.answer?.media?.input }},
              "playlist": {{ it.root?.answer?.media?.playlist }},
              "poster": {{ it.root?.answer?.media?.thumbnail }},
              "captions": {{ it.root?.answer?.captions?.current }},
              "duration": {{ it.root?.answer?.metadata?.duration }},
              "startOffset": {{ it.root?.answer?.settings?.startOffset }},
              "endOffset": {{ it.root?.answer?.settings?.endOffset }},
              "crop": {
                "x": {{ it.root?.answer?.settings?.crop?.x }},
                "y": {{ it.root?.answer?.settings?.crop?.y }},
                "width": {{ it.root?.answer?.settings?.crop?.width }},
                "height": {{ it.root?.answer?.settings?.crop?.height }}
              }
            }`
            }
          ],
          root: "{{ it.intro?.questions?.items }}"
        },
        {
          scenes: [
            {
              layout: "basic",
              data: `{
              "id": {{ it.root?.answer?.id }},
              "key": {{ it.root?.answer?.id + '-' + it.index }},
              "mp4": {{ it.root?.answer?.media?.video }},
              "input": {{ it.root?.answer?.media?.input }},
              "playlist": {{ it.root?.answer?.media?.playlist }},
              "poster": {{ it.root?.answer?.media?.thumbnail }},
              "captions": {{ it.root?.answer?.captions?.current }},
              "duration": {{ it.root?.answer?.metadata?.duration }},
              "startOffset": {{ it.root?.answer?.settings?.startOffset }},
              "endOffset": {{ it.root?.answer?.settings?.endOffset }},
              "crop": {
                "x": {{ it.root?.answer?.settings?.crop?.x }},
                "y": {{ it.root?.answer?.settings?.crop?.y }},
                "width": {{ it.root?.answer?.settings?.crop?.width }},
                "height": {{ it.root?.answer?.settings?.crop?.height }}
              }
            }`
            }
          ],
          root: "{{ it.questions?.items }}"
        },
        {
          scenes: [
            {
              layout: "basic",
              data: `{
              "id": {{ it.root?.answer?.id }},
              "key": {{ it.root?.answer?.id + '-outro' }},
              "mp4": {{ it.root?.answer?.media?.video }},
              "input": {{ it.root?.answer?.media?.input }},
              "playlist": {{ it.root?.answer?.media?.playlist }},
              "poster": {{ it.root?.answer?.media?.thumbnail }},
              "captions": {{ it.root?.answer?.captions?.current }},
              "duration": {{ it.root?.answer?.metadata?.duration }},
              "startOffset": {{ it.root?.answer?.settings?.startOffset }},
              "endOffset": {{ it.root?.answer?.settings?.endOffset }},
              "crop": {
                "x": {{ it.root?.answer?.settings?.crop?.x }},
                "y": {{ it.root?.answer?.settings?.crop?.y }},
                "width": {{ it.root?.answer?.settings?.crop?.width }},
                "height": {{ it.root?.answer?.settings?.crop?.height }}
              }
            }`
            }
          ],
          root: "{{ it.outro?.questions?.items }}"
        }
      ]
    }
  ],
  meta: {
    frameRate: 30,
    resolution: 720,
    transitionDuration: 1 / 3
  }
};
async function Fo() {
  if (typeof window > "u") {
    const s = await import("skia-canvas");
    return new s.Image();
  }
  return new Image();
}
const cn = hn(async function(y) {
  return y ? new Promise((G, O) => {
    Fo().then((N) => {
      N.onload = () => {
        G(N);
      }, N.onerror = (w) => {
        O(w);
      }, N.src = y;
    });
  }) : null;
});
async function Bt({ element: s }, y, G) {
  var w, _, Y;
  let O = { ...s };
  const { node: N } = s;
  if ((N == null ? void 0 : N.type) === "video" && ((w = N == null ? void 0 : N.value) != null && w.src || (_ = N == null ? void 0 : N.value) != null && _.playlist)) {
    const U = await y(N.value);
    let b;
    try {
      b = await cn(N.value.poster);
    } catch {
      b = null;
    }
    O = {
      ...O,
      node: {
        ...N,
        video: U,
        poster: b,
        meta: await G(N.value, U.node)
      }
    };
  }
  if ((N == null ? void 0 : N.type) === "image" && N.value) {
    let U;
    try {
      U = await cn(N.value);
    } catch {
      U = null;
    }
    O = {
      ...O,
      node: {
        ...N,
        image: U
      }
    };
  }
  return O.node && ((Y = s.node) != null && Y.elements) && (O.node.elements = await Promise.all(
    s.node.elements.map((U) => Bt({ element: U }, y, G))
  )), s.elements && (O.elements = await Promise.all(
    s.elements.map((U) => Bt({ element: U }, y, G))
  )), O;
}
async function Lr() {
  if (typeof window > "u") {
    const s = await import("skia-canvas"), y = new s.Canvas();
    return y.gpu = !1, y;
  }
  return document.createElement("canvas");
}
async function Po(s) {
  var y;
  try {
    if ((y = await fo(s, { method: "HEAD" })) != null && y.ok)
      return s;
  } catch {
    return;
  }
}
async function _o({ sources: s }) {
  let y = null;
  if (s) {
    const G = s.filter(Boolean).map((O) => Po(O));
    y = (await Promise.all(G)).find(Boolean);
  }
  return y;
}
function Ft(s = []) {
  var y;
  for (const G of s) {
    if (((y = G == null ? void 0 : G.node) == null ? void 0 : y.type) === "video")
      return G.node;
    const O = Ft(G == null ? void 0 : G.elements);
    if (O)
      return O;
  }
}
function St(s, y) {
  return s.reduce((G, { duration: O }) => G += O - y / 2, -y / 2);
}
function Lo(s) {
  if (s === null || typeof s != "object")
    return !1;
  if (Object.getPrototypeOf(s) === null)
    return !0;
  let y = s;
  for (; Object.getPrototypeOf(y) !== null; )
    y = Object.getPrototypeOf(y);
  return Object.getPrototypeOf(s) === y;
}
ro.define("parse", (s) => {
  if (typeof s > "u")
    return null;
  if (typeof s == "string") {
    let y = s;
    return y = y.replace(/\n/g, "\\n"), y = y.replace(/\r/g, "\\r"), y = y.replace(/"/g, '\\"'), `"${y}"`;
  }
  return Lo(s) || Array.isArray(s) ? JSON.stringify(s) : s;
});
to.define(
  "resolve-source",
  hn(
    async (s) => {
      const { sources: y } = s.params[0] ?? {}, G = y == null ? void 0 : y.filter(Boolean), O = G == null ? void 0 : G.find((_) => _.includes("blob:")), N = G == null ? void 0 : G.find((_) => !_.includes("http")), w = O ?? N ?? await _o({ sources: y });
      return w ? `"${w}"` : "null";
    },
    {
      cacheKey: ([s]) => JSON.stringify(s.params[0] ?? {})
    }
  )
);
const hr = (s, y, G) => io(
  s,
  y,
  no({
    autoEscape: !1,
    defaultFilter: "parse",
    async: !0,
    asyncHelpers: ["resolve-source"],
    ...G
  })
);
async function zo({ data: s, template: y, burnCaptions: G = !1, debug: O = !1 }, N, w) {
  var j, i2, k0, k2;
  const _ = y ?? Bo;
  if (!((j = _.templates) != null && j.length))
    throw new Error(`No templates found for template instance: ${_.id}`);
  let Y = _.templates.find(({ version: c0 }) => c0 === An);
  if (!Y) {
    const c0 = _.templates.map(({ version: S0 }) => `"${S0}"`).join(", ");
    console.warn(`Template renderer expects template version "${An}" but got ${c0}`), Y = _.templates[_.templates.length - 1];
  }
  const U = (await Promise.all(
    Y.content.map(async ({ scenes: c0, root: S0 }) => {
      const n2 = {
        ..._.options,
        ...s,
        intro: _.intro,
        outro: _.outro
      };
      async function U0(_0, A0) {
        return Promise.all(
          c0.map(async ({ layout: F0, duration: r2, data: L0, options: D0 }) => {
            var y0, O0, t2;
            const c2 = { ...n2, index: A0, root: _0 }, s2 = L0 ? JSON.parse(await hr(L0, c2)) : {}, P0 = D0 ? JSON.parse(await hr(D0, c2)) : {}, a2 = r2 ? parseFloat(await hr(r2, c2)) : NaN, E0 = (y0 = Y.layouts.find((V2) => V2.name === F0)) == null ? void 0 : y0.tree;
            if (!E0)
              throw new Error(`Layout tree "${F0}" not found in template "${Y.id}" layouts.`);
            const m2 = JSON.parse(
              await hr(E0, {
                ...s2,
                ...P0
              })
            ), d2 = await Promise.all(
              m2.flatMap((V2) => Bt({ element: V2 }, N, w))
            ), w0 = Ft(d2);
            return {
              duration: (isNaN(a2) ? null : a2) ?? ((O0 = w0 == null ? void 0 : w0.meta) == null ? void 0 : O0.duration) ?? 0,
              captions: (t2 = w0 == null ? void 0 : w0.meta) == null ? void 0 : t2.captions,
              elements: d2
            };
          })
        );
      }
      if (S0) {
        const _0 = JSON.parse(await hr(S0, n2));
        return Array.isArray(_0) ? (await Promise.all(_0.map(async (A0, F0) => U0(A0, F0)))).flatMap((A0) => A0) : U0(_0, null);
      }
      return U0(s, null);
    })
  )).reduce((c0, S0) => {
    const n2 = S0.filter((U0) => U0.duration > 0);
    return n2.length > 0 && (c0 = [...c0, n2]), c0;
  }, []), b = ((i2 = _.meta) == null ? void 0 : i2.frameRate) ?? 30, Q = ((k0 = _.meta) == null ? void 0 : k0.resolution) ?? 720, o0 = ((k2 = _.meta) == null ? void 0 : k2.transitionDuration) ?? 1 / 3, l0 = Math.floor(
    U.reduce((c0, S0) => c0 += St(S0, o0), 0) * 100
  ) / 100;
  return {
    scenes: (await Promise.all(
      U.map((c0, S0) => {
        const n2 = St(c0, o0), U0 = U.reduce((_0, A0, F0) => (F0 < S0 && (_0 += St(A0, o0)), _0), 0);
        return Promise.all(
          c0.map(async ({ duration: _0, captions: A0, elements: F0 }, r2) => {
            var m2, d2;
            const L0 = await Lr(), D0 = await Lr(), c2 = await Lr(), s2 = await Lr(), P0 = Ft(F0), a2 = c0.reduce((w0, { duration: T0 }, y0) => (y0 < r2 && (w0 += T0 - o0 / 2), w0), U0);
            return {
              draw: ({ canvas: w0, currentTime: T0 }) => {
                const y0 = Math.max(0, T0 - U0), O0 = Math.max(0, T0 - a2);
                It({
                  debug: O,
                  canvas: w0,
                  cropCanvas: L0,
                  posterCanvas: s2,
                  letterboxCanvas: D0,
                  elements: F0,
                  currentTime: T0,
                  contentTime: y0,
                  sceneTime: O0,
                  totalDuration: l0,
                  contentDuration: n2,
                  sceneDuration: _0
                }), A0 && G && Io({
                  canvas: w0,
                  dx: 0,
                  dy: 0,
                  dw: w0.width,
                  dh: w0.height,
                  vttCaptions: A0,
                  sceneTime: O0 + ((P0 == null ? void 0 : P0.meta.start) ?? 0)
                });
              },
              duration: _0,
              transitionCanvas: c2,
              start: a2,
              video: P0 == null ? void 0 : P0.video,
              videoMeta: P0 == null ? void 0 : P0.meta,
              audio: {
                duration: _0,
                src: (m2 = P0 == null ? void 0 : P0.value) == null ? void 0 : m2.src,
                start: (d2 = P0 == null ? void 0 : P0.meta) == null ? void 0 : d2.start
              }
            };
          })
        );
      })
    )).flatMap((c0) => c0),
    frameRate: b,
    resolution: Q,
    transitionDuration: o0,
    fonts: Y.fonts ?? [],
    duration: l0
  };
}
const An = "2";
export {
  An as TEMPLATE_VERSION,
  Ct as appendFontFamilies,
  Ho as crossFade,
  Io as drawCaptions,
  It as drawElements,
  on as drawVideoFormat,
  so as getSizeDetails,
  uo as normaliseAspectRatio,
  oo as normaliseResolution,
  kn as parseTimestamp,
  To as supportedFonts,
  zo as templateToScenes,
  Co as vttToLines
};
//# sourceMappingURL=canvas-video.js.map
